<template>
    <div>
        <!-- transparent loading div -->
        <div v-if="completeSubprocess.buttonProcessing" id="transparentLoadingDiv"></div>

        <!-- loading spinner -->
        <div v-if="loading" id="blockchain-data-loading">
            <div class="lds-facebook"><div></div><div></div><div></div></div>
            <div>{{ loadingText }}</div>
        </div>

        <!-- loading error -->
        <div v-if="error" id="blockchain-data-loading-error" style="color: red; text-align: center; margin-top: 225px;">
            <font-awesome-icon icon="fa-solid fa-exclamation-circle" style="font-size: 40px; padding-bottom: 20px;"/>
            <div><strong>Error</strong> - Unable to connect to Blockchain (test network)</div> <br />
            <!-- {{ errorDetails }} -->
        </div>
        
        <!-- container -->
        <div v-if="!loading && !error" id="blockchain-container">
            <!-- header -->
            <div id="blockchain-header-container">
                <div id="blockchain-heading">
                    <h4>Smart Contracts</h4>
                </div>
                <div id="blockchain-button-container">
                    <button id="create-new-contract-button" type="button" @click="openNewContractModal" class="btn btn-primary btn-sm action-button" v-b-modal="'new-contract-modal'" :disabled="(userInfo.user_additional_info.huon_user)">
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-plus">
                            <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" class=""></path>
                        </svg>
                        <span style="padding-left: 10px;">Create New BioContract</span>
                    </button>
                    <br /><br />
                    <a v-if="subtype == 'Human'" href="http://3.27.199.18:8080/" target="_blank">Blockchain Explorer</a>
                </div> 
            </div>

            <!-- tabs -->
            <div style="width: 100%; float: left; padding-top: 30px;">
                <b-tabs content-class="mt-3" justify align="left">

                    <!-- Summary -->
                    <b-tab v-if="subtype == 'Aquaculture' || subtype=='Bovine'" title="Summary" :active="(subtype == 'Aquaculture' || subtype=='Bovine')">

                        <!-- Human -->
                        <div v-if="subtype == 'Human'" >

                        </div>

                        <!-- Bovine -->
                        <div v-else-if="subtype == 'Bovine'" >

                            <!-- location map -->
                            <div style="float: left; width: 50%;">

                                <div style="position: relative; padding-left:20px; float: left;">
                                    <span style="color:red; font-weight: bold;">LIVE DATA</span>
                                    <svg height="50" width="50" class="blinking" style="position:absolute; top:-9px; left:-11px;">
                                        <circle cx="20" cy="20" r="5" fill="red" />
                                    </svg> 
                                </div>
                                <span style="color: white;">x</span>

                                <div style="margin-top: -15px;">
                                    <PackagingTracking_dynamic ref="PackagingTracking_dynamic" :item="{location: 'OvaSem Reproductive Solutions', coords: {lat: -36.3555161, lng: 144.9540513}}" :zoom_level="10" />
                                </div>
                            </div>

                            <!-- summary data -->
                            <div class="summary-data-container">
                                <div style="width: 100%; float: left; padding-bottom: 16px; padding-top: 30px;">
                                    <div style="float: left; padding-left: 30px;">
                                        <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200;">
                                            <strong> {{ blockchainInProgress.length + blockchainCompleted.length }} </strong>
                                        </div>
                                        <div style="margin-top: -7px; color: grey; height: 55px;">
                                            CONTRACTS
                                        </div>
                                    </div>
                                    <div style="float: left; padding-left: 30px;">
                                        <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200;">
                                            <strong>{{ssi_masterIDs.length}}</strong>
                                        </div>
                                        <div style="margin-top: -7px; color: grey; height: 55px;">
                                            BULLS
                                        </div>
                                    </div>
                                    <div style="float: left; padding-left: 30px;">
                                        <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200;">
                                            <strong> {{ blockchainInProgress.length - blockchainBovineStackeds.length }} </strong>
                                        </div>
                                        <div style="margin-top: -7px; color: grey; height: 55px;">
                                            SAMPLES
                                        </div>
                                    </div>
                                    <div style="float: left; padding-left: 30px;">
                                        <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200;">
                                            <strong> {{ blockchainBovineStackeds.length }} </strong>
                                        </div>
                                        <div style="margin-top: -7px; color: grey; height: 55px;">
                                            PACKAGES
                                        </div>
                                    </div>

                                    <br />

                                    <div style="float: left; padding-left: 30px; padding-top: 25px;">
                                        <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200;">
                                            {{ blockchainInProgress.length}}
                                        </div>
                                        <div style="margin-top: -7px; color: grey; height: 55px;">
                                            IN PROGRESS
                                        </div>
                                    </div>

                                    <br />

                                    <div style="float: left; padding-left: 30px; padding-top: 25px;">
                                        <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200;">
                                            {{ blockchainCompleted.length }}
                                        </div>
                                        <div style="margin-top: -7px; color: grey; height: 55px;">
                                            COMPLETED
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                        <!-- Aquaculture -->
                        <div v-else stlye="display: block;">

                            <!-- location map -->
                            <div style="float: left; width: 45%;">

                                <!-- TODO: temporary hidden -->
                                <!-- <div style="position: relative; padding-left:20px; float: left;">
                                    <span style="color:red; font-weight: bold;">LIVE DATA</span>
                                    <svg height="50" width="50" class="blinking" style="position:absolute; top:-9px; left:-11px;">
                                        <circle cx="20" cy="20" r="5" fill="red" />
                                    </svg> 
                                </div> -->
                                <span style="color: white;">x</span>

                                <div style="margin-top: -15px;">
                                    <PackagingTracking_HuonTas_summary_summary ref="PackagingTracking_HuonTas_summary_summary"/>
                                </div>
                            </div>

                            <!-- summary data -->
                            <div class="summary-data-container" style="padding-left: 30px; float: left;">
                                <div style="display: flexbox; width: 100%; float: left; padding-bottom: 20px; padding-top: 30px; left: 0px;">
                                    <div class="aquaculture-summary-board">
                                        <b-container>
                                            <b-row style="padding-bottom: 15px;">
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        <strong>{{ fishMaleSummary }}</strong>
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        <strong>FISH (MALE)</strong>
                                                    </div>
                                                </b-col>
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        <strong>{{ fishMaleSamples }}</strong>
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        <strong>SAMPLES</strong>
                                                    </div>
                                                </b-col>
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        <strong>{{ fishMaleCryoBatches }}</strong>
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        <strong>CRYO-BATCHES</strong>
                                                    </div>
                                                </b-col>
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        <strong>{{ fishMalePackages }}</strong>
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        <strong>PACKAGES</strong>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                            <b-row style="padding-bottom: 15px;">
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        {{ fishMaleInProgress }}
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        IN PROGRESS
                                                    </div>
                                                </b-col>
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        {{ fishMaleSamplesInProgress }}
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        IN PROGRESS
                                                    </div>
                                                </b-col>
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        {{ fishMaleCryoBatchesInProgress }}
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        IN PROGRESS
                                                    </div>
                                                </b-col>
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        {{ fishMalePackagesInProgress }}
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        IN PROGRESS
                                                    </div>
                                                </b-col>
                                            </b-row>
                                            <b-row style="padding-bottom: 15px;">
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        {{ fishMaleCompleted }}
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        COMPLETED
                                                    </div>
                                                </b-col>
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        {{ fishMaleSamplesCompleted }}
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        COMPLETED
                                                    </div>
                                                </b-col>
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        {{ fishMaleCryoBatchesCompleted }}
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        COMPLETED
                                                    </div>
                                                </b-col>
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        {{ fishMalePackagesCompleted }}
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        COMPLETED
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </b-container>
                                    </div>
                                    <br />
                                    <div class="aquaculture-summary-board">
                                        <b-container>
                                            <b-row style="padding-bottom: 15px;">
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        <strong>{{ fishFemaleSummary }}</strong>
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        <strong>FISH (FEMALE)</strong>
                                                    </div>
                                                </b-col>
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        <strong>{{ fishFemaleEggBatches }}</strong>
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        <strong>EGG BATCHES</strong>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                            <b-row style="padding-bottom: 15px;">
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        {{ fishFemaleInProgress }}
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        IN PROGRESS
                                                    </div>
                                                </b-col>
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        {{ fishFemaleEggBatchesInProgress }}
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        IN PROGRESS
                                                    </div>
                                                </b-col>
                                            </b-row>
                                            <b-row style="padding-bottom: 15px;">
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        {{ fishFemaleCompleted }}
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        COMPLETED
                                                    </div>
                                                </b-col>
                                                <b-col>
                                                    <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200; text-wrap: nowrap;">
                                                        {{ fishFemaleEggBatchesCompleted }}
                                                    </div>
                                                    <div style="margin-top: -7px; color: grey; height: 55px; text-wrap: nowrap;">
                                                        COMPLETED
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </b-container>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </b-tab>                    

                    <!-- In Progress - Aquaculture -->
                    <b-tab v-if="subtype == 'Aquaculture'" :title="blockchainInProgressCountText">
                        <div class="table-search">
                            <div style="padding-right: 10px;">
                                <b-input-group size="sm"><template #prepend><b-input-group-text>Show</b-input-group-text></template>
                                    <b-form-select v-model="aquaculturePerPage">
                                        <option value="5">5 Items</option>
                                        <option value="10">10 Items (Default)</option>
                                        <option value="20">20 Items</option>
                                        <option value="50">50 Items</option>
                                    </b-form-select>
                                </b-input-group>
                            </div>
                            <div v-if="!exportingFullFishData" style="padding-right: 5px;"><b-button size="sm" variant="success" @click.stop="downloadFullFishData"><i class="fa-solid fa-download" style="padding-right: 5px;"></i>Export Full Data</b-button></div>
                            <div v-else style="padding-right: 5px;"><b-button size="sm" variant="success" disabled><i class="fa-solid fa-download fa-bounce" style="padding-right: 5px;"></i>Exporting...</b-button></div>
                            <div v-if="!exportingFishData" style="padding-right: 5px;"><b-button size="sm" variant="success" @click.stop="downloadFishData"><i class="fa-solid fa-download" style="padding-right: 5px;"></i>Export Data</b-button></div>
                            <div v-else style="padding-right: 5px;"><b-button size="sm" variant="success" disabled><i class="fa-solid fa-download fa-bounce" style="padding-right: 5px;"></i>Exporting...</b-button></div>
                        </div>
                        <br />
                        <br />
                        <h5>Females</h5>
                        <b-table id="aquacultureMasterFemaleContractsTable"
                            responsive="md"
                            head-variant="dark"
                            :filter="aquacultureFemaleFishTableFilter"
                            :per-page="aquaculturePerPage"
                            :total-rows="totalRowsAquacultureFemalesFish"
                            :current-page="currentPageAquacultureFemalesFish"
                            :fields="aquacultureMasterFemaleFishTableFields"
                            :items="aquacultureMasterFemaleFish"
                            @filtered="aquacultureFemaleTableFiltered"
                        >
                            <template #cell(expand)="row">
                                <div @click.stop="toggleDetails(row)" class="clickable" style="padding: 8px;">
                                    <i :class="'fa-solid fa-' + (row.item._showDetails ? 'chevron-up' : 'chevron-right')" style="padding-left: 5px;"></i>
                                </div>
                            </template>
                             <template #cell(tag_id)="cell"><i class='fa-solid fa-fish-fins' style="padding-right: 10px; font-size: 1.3em; position: absolute; top: 10px;"></i><a href="" style="padding-left: 30px;" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{(cell.item.State == '0' ? cell.item.name : cell.item.TempData.ProcessData.tag_id)}}</a></template>
                            <template #cell(egg_batches)="cell"><b-badge pill variant="secondary" style="position: relative; top: -2px;">{{(cell.item.stackedItems ? cell.item.stackedItems.length : 0)}}</b-badge></template>
                            <template #cell(contractstate)="cell" style="vertical-align: top;"><b-badge pill variant="primary">{{ cell.item.nextState }} {{ cell.item.nextStateName }} </b-badge></template>
                            <template #cell(contractprogress)="cell" class="chart" Style="width:30%; vertical-align: middle;">
                                <div class="progress">
                                    <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: cell.item.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                    </div>
                                </div>
                                <div style="font-size: 10px; color: grey;">{{ cell.item.stateProgress }} %</div>
                            </template>
                            <template #row-details="masterFishRow">
                                <div style="padding-left: 90px; padding-top: .5px;">
                                    <b-table id="aquaculturEggBatchContractsTable"
                                        responsive="md"
                                        head-variant="light"
                                        :total-rows="( masterFishRow.item.stackedItems ? masterFishRow.item.stackedItems.length : 0)"
                                        :items="masterFishRow.item.stackedItems"
                                        :fields="aquacultureFishEggBatchTableFields"
                                    >
                                        <template #cell(expand)="row">
                                            <div @click.stop="toggleDetails(row)" class="clickable" style="position: relative; padding-left: 10px; padding-top: 7px;">
                                                <div :style="{'position': 'absolute', 'top': '-40px', 'left': '-34px', 'width': '34px', 'height': '58px', 'border-left': '1px solid grey', 'border-bottom': '1px solid grey'}"></div>
                                                <!-- <i :class="'fa-solid fa-' + (row.item._showDetails ? 'chevron-up' : 'chevron-right')"></i> -->
                                            </div>
                                        </template>
                                        <template #cell(egg_batch)="cell"><img src="../../assets/images/templateIcons/testIcons/sample.png" style="width: 25px; margin-top: -2px;" /> <a href="" style="padding-left: 5px;" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{cell.item.name.substring(cell.item.name.indexOf("_") + 1, cell.item.name.length)}}</a></template>
                                        <template #cell(contractstate)="cell" style="vertical-align: top;"><b-badge pill variant="primary">{{ cell.item.nextState }} {{ cell.item.nextStateName }} </b-badge></template>
                                        <template #cell(contractprogress)="cell" class="chart" Style="width:30%; vertical-align: middle;">
                                            <div class="progress">
                                                <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: cell.item.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                </div>
                                            </div>
                                            <div style="font-size: 10px; color: grey;">{{ cell.item.stateProgress }} %</div>
                                        </template>
                                    </b-table>
                                </div>
                            </template>
                        </b-table>

                        <!-- Pagination for the Females Fish table -->
                        <div id="aquaculture-females-table-navigation" class="pagination-table">
                            <div style="padding-right: 10px;">
                                <b-input-group size="sm" style="padding-right: 10px;"><template #prepend><b-input-group-text>Search</b-input-group-text></template> <b-input v-model="aquacultureFemaleFishTableFilter" placeholder="Search for a contract..."></b-input></b-input-group>
                            </div>
                            <div class="pagination-element">
                                <!-- Pagination for the table -->
                                <b-pagination
                                    aria-controls="aquaculturePackageContractsTable"
                                    v-model="currentPageAquacultureFemalesFish"
                                    :per-page="aquaculturePerPage"
                                    :total-rows="totalRowsAquacultureFemalesFish"
                                    align="right"
                                    size="sm"
                                ></b-pagination>
                            </div>
                        </div>
                        <br />
                        
                        <hr />
                        <br />

                        <h5>Fertilisation</h5>
                        <b-table id="aquacultureFertilisationContractsTable"
                            responsive="md"
                            head-variant="dark"
                            :filter="aquacultureFertilisationTableFilter"
                            :per-page="aquaculturePerPage"
                            :total-rows="totalRowsAquacultureFertilisation"
                            :current-page="currentPageAquacultureFertilisation"
                            :fields="aquacultureFertilisationMastersTableFields"
                            :items="aquacultureFertilisationMasters.filter(contract => contract.ID != '4d80e309-cabc-46ee-8d43-97e454abef1e:1742267759730:Feb 2025 Fert')"
                            @filtered="aquacultureFertilisationTableFiltered"
                        >
                            <template #cell(expand)="row">
                                <!-- <div @click.stop="toggleDetails(row)" class="clickable" style="padding: 8px;">
                                    <i :class="'fa-solid fa-' + (row.item._showDetails ? 'chevron-up' : 'chevron-right')" style="padding-left: 5px;"></i>
                                </div> -->
                            </template>
                            <template #cell(fertilisation)="cell"><i class='fa-solid fa-shuffle' style="padding-right: 10px; font-size: 1.3em; position: absolute; top: 10px;"></i><a href="" style="padding-left: 30px;" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{/*(cell.item.State == '0' ?*/cell.item.name/* : cell.item.TempData.ProcessData.fertilisation_run_id)*/}}</a></template>
                            <template #cell(facility)="cell">{{(cell.item.TempData.ProcessData == undefined ? '' : cell.item.TempData.ProcessData.facility)}}</template>
                            <template #cell(contractstate)="cell" style="vertical-align: top;"><b-badge pill variant="primary">{{ cell.item.nextState }} {{ cell.item.nextStateName }} </b-badge></template>
                            <template #cell(contractprogress)="cell" class="chart" Style="width:30%; vertical-align: middle;">
                                <div class="progress">
                                    <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: cell.item.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                    </div>
                                </div>
                                <div style="font-size: 10px; color: grey;">{{ cell.item.stateProgress }} %</div>
                            </template>
                        </b-table>
                        
                        <!-- Pagination for the Fertilisation Fish table -->
                        <div id="aquaculture-fertilisation-table-navigation" class="pagination-table">
                            <div style="padding-right: 10px;">
                                <b-input-group size="sm" style="padding-right: 10px;"><template #prepend><b-input-group-text>Search</b-input-group-text></template> <b-input v-model="aquacultureFertilisationTableFilter" placeholder="Search for a contract..."></b-input></b-input-group>
                            </div>
                            <div class="pagination-element">
                                <!-- Pagination for the table -->
                                <b-pagination
                                    aria-controls="aquaculturePackageContractsTable"
                                    v-model="currentPageAquacultureFertilisation"
                                    :per-page="aquaculturePerPage"
                                    :total-rows="totalRowsAquacultureFertilisation"
                                    align="right"
                                    size="sm"
                                ></b-pagination>
                            </div>
                        </div>
                        <br />                        
                        <hr />
                        <br />
                            
                        <h5>Males and Neomales</h5>
                        <b-table id="aquacultureMasterMaleContractsTable"
                            responsive="md"
                            head-variant="dark"
                            :filter="aquacultureMaleFishTableFilter"
                            :per-page="aquaculturePerPage"
                            :total-rows="totalRowsAquacultureMalesFish"
                            :current-page="currentPageAquacultureMalesFish"
                            :fields="aquacultureMasterMaleFishTableFields"
                            :items="aquacultureMasterMaleFish"
                            @filtered="aquacultureMaleFishTableFiltered"
                        >
                            <template #cell(expand)="row">
                                <div @click.stop="toggleDetails(row)" class="clickable" style="padding: 8px;">
                                    <i :class="'fa-solid fa-' + (row.item._showDetails ? 'chevron-up' : 'chevron-right')" style="padding-left: 5px;"></i>
                                </div>
                            </template>
                            <template #cell(tag_id)="cell"><i class='fa-solid fa-fish-fins' style="padding-right: 10px; font-size: 1.3em; position: absolute; top: 10px;"></i><a href="" style="padding-left: 30px;" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{(cell.item.State == '0' ? cell.item.name : cell.item.TempData.ProcessData.tag_id)}}</a></template>
                            <template #cell(samples)="cell"><b-badge pill variant="secondary" style="position: relative; top: -2px;">{{(cell.item.stackedItems ? cell.item.stackedItems.length : 0)}}</b-badge></template>
                            <template #cell(facility)="cell">{{(cell.item.TempData.ProcessData == undefined ? '' : cell.item.TempData.ProcessData.facility)}}</template>
                            <template #cell(genetic_rank)="cell">{{(cell.item.TempData.ProcessData == undefined ? '' : cell.item.TempData.ProcessData.genetic_rank)}}</template>
                            <!-- <template #cell(tank)="cell">{{(cell.item.TempData.ProcessData == undefined ? '' : cell.item.TempData.ProcessData.tank)}}</template> -->
                            <template #cell(is_neo)="cell">{{(cell.item.TempData.ProcessData == undefined ? '' : (cell.item.TempData.ProcessData.is_neo == 'accepted' ? 'Yes' : 'No'))}}</template>
                            <template #row-details="masterFishRow">
                                <div style="padding-left: 90px; padding-top: .5px;">
                                    <b-table id="aquacultureSampleContractsTable"
                                        responsive="md"
                                        head-variant="light"
                                        :total-rows="masterFishRow.item.stackedItems.length"
                                        :items="masterFishRow.item.stackedItems"
                                        :fields="aquacultureSampleTableFields"
                                    >
                                        <template #cell(expand)="row">
                                            <div @click.stop="toggleDetails(row)" class="clickable" style="position: relative; padding-left: 10px; padding-top: 7px;">
                                                <div :style="{'position': 'absolute', 'top': '-40px', 'left': '-34px', 'width': '34px', 'height': '58px', 'border-left': '1px solid grey', 'border-bottom': '1px solid grey'}"></div>
                                                <i :class="'fa-solid fa-' + (row.item._showDetails ? 'chevron-up' : 'chevron-right')"></i>
                                            </div>
                                        </template>
                                        <template #cell(sample)="cell"><img src="../../assets/images/templateIcons/testIcons/sample.png" style="width: 25px; margin-top: -2px;" /> <a href="" style="padding-left: 5px;" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{cell.item.name.substring(cell.item.name.indexOf("_") + 1, cell.item.name.length)}}</a></template>
                                        <template #cell(batches)="cell"><b-badge pill variant="secondary" style="position: relative; top: -2px;">{{masterFishRow.item.stackedItems[cell.index].stackedItems.length}}</b-badge></template>
                                        <template #cell(grade)="cell">{{ (initialWorldState.find(contract => contract.ID == cell.item.ID && contract.State == '2.1') !== undefined ? initialWorldState.find(contract => contract.ID == cell.item.ID && contract.State == '2.1').TempData.ProcessData.grade : '')}}</template>
                                        <template #cell(motility)="cell">{{ (initialWorldState.find(contract => contract.ID == cell.item.ID && contract.State == '2.1') !== undefined ? initialWorldState.find(contract => contract.ID == cell.item.ID && contract.State == '2.1').TempData.ProcessData.motility : '') }}</template>
                                        <template #cell(concentration)="cell">{{ (initialWorldState.find(contract => contract.ID == cell.item.ID && contract.State == '2.1') !== undefined ? initialWorldState.find(contract => contract.ID == cell.item.ID && contract.State == '2.1').TempData.ProcessData.concentration : '') }}</template>
                                        <template #row-details="batchItemsRow">
                                            <div style="display: block; position: relative; padding-left: 95px;">
                                                <b-table id="aquacultureBatchesContractsTable" ref="aquacultureBatchesContractsTable"
                                                    head-variant="light"
                                                    :total-rows="batchItemsRow.item.stackedItems.length"
                                                    :items="batchItemsRow.item.stackedItems"
                                                    :fields="aquacultureBatchTableFields"
                                                >
                                                    <template #cell(expand)="row">
                                                        <div @click.stop="toggleDetails(row)" class="clickable" style="position: relative; padding-left: 10px; padding-top: 7px;">
                                                            <div style="position: absolute; top: -41px; left: -43px; width: 43px; height: 60px; border-left: 1px solid grey; border-bottom: 1px solid grey;"></div>
                                                            <i :class="'fa-solid fa-' + (row.item._showDetails ? 'chevron-up' : 'chevron-right')"></i>
                                                        </div>
                                                    </template>
                                                    <template #cell(batch_id)="cell">
                                                        <i class="fa-solid fa-snowflake" style="font-size: 1.3em; position: absolute; top: 10px;"></i><a href="" style="padding-left: 28px;" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{ (cell.item.TempData.ProcessData == undefined || cell.item.TempData.ProcessData.batch_id == undefined ? '' : cell.item.TempData.ProcessData.batch_id) }}</a>
                                                    </template>
                                                    <template #cell(packages)="cell"><b-badge pill variant="secondary" style="position: relative; top: -2px;">{{(cell.item.stackedItems != undefined && (cell.item.stackedItems ? cell.item.stackedItems.length : 0) != undefined ? (cell.item.stackedItems ? cell.item.stackedItems.length : 0) : 0)}}</b-badge></template>
                                                    <template #cell(cryopreservation_device)="cell">{{ (cell.item.TempData.ProcessData == undefined || cell.item.TempData.ProcessData.device_id == undefined ? '' : cell.item.TempData.ProcessData.device_id) }}</template>
                                                    <template #cell(started)="cell">{{ getFormattedDate(cell.item.batchStart.timestamp)}}</template>
                                                    <template #cell(ended)="cell">{{ (cell.item.batchEnd.timestamp == undefined ? '' : getFormattedDate(cell.item.batchEnd.timestamp))}}</template>
                                                    <template #row-details="packagesContractsRow">
                                                        <div style="display: block; position: relative; padding-left: 90px;">
                                                            <b-table id="aquaculturePackageContractsTable"
                                                                responive="sm"
                                                                head-variant="light"
                                                                :total-rows="packagesContractsRow.item.stackedItems.length"                            
                                                                :items="packagesContractsRow.item.stackedItems"
                                                                :fields="aquaculturePackagesTableFields"
                                                                @sort-changed="tableSortChanged"
                                                            >
                                                                <template #cell(contractname)="cell">
                                                                    <div style="position: relative;">
                                                                        <div style="position: absolute; top: -48px; left: -53px; width: 43px; height: 60px; border-left: 1px solid grey; border-bottom: 1px solid grey;"></div>
                                                                    </div>
                                                                    <a href="" @click.prevent="contractsRowClicked(cell.item, cell.index, null)"><img src="../../assets/images/templateIcons/testIcons/qr-icon.png" style="width: 16px; margin-right: 10px; top: -2px;" />{{ cell.item.name }} </a><span v-if="isNewRow(!cell.item.TimeStampEpoch ? cell.item.item.TimeStampEpoch - 1000 : cell.item.TimeStampEpoch - 1000)"><sup><b-badge pill variant="info" style="font-style: .5em;">New</b-badge></sup></span>
                                                                </template>
                                                                <template #cell(contracttype)="cell">Vitrafy Smart Packaging</template>
                                                                <template #cell(contractapplication)="cell" style="vertical-align: top;"> {{ cell.item.TempData.Application }} </template>
                                                                <template #cell(contractdatetime)="cell" style="vertical-align: top;">{{ getRelativeDate(cell.item.TimeStampEpochUpdated) }}</template>
                                                                <template #cell(contractstate)="cell" style="vertical-align: top;"><b-badge pill variant="primary">{{ cell.item.nextState }} {{ cell.item.nextStateName }} </b-badge></template>
                                                                <template #cell(contractprogress)="cell" class="chart" Style="width:30%; vertical-align: middle;">
                                                                    <div class="progress">
                                                                        <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: cell.item.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                                        </div>
                                                                    </div>
                                                                    <div style="font-size: 10px; color: grey;">{{ cell.item.stateProgress }} %</div>
                                                                </template>
                                                            </b-table> 
                                                        </div>
                                                    </template>
                                                </b-table>                                                
                                            </div>                                            
                                        </template>
                                    </b-table>
                                </div>
                            </template>
                        </b-table>
                         

                        <div id="aquaculture-males-table-navigation" class="pagination-table">
                            <div style="padding-right: 10px;">
                                <b-input-group size="sm" style="padding-right: 10px;"><template #prepend><b-input-group-text>Search</b-input-group-text></template> <b-input v-model="aquacultureMaleFishTableFilter" placeholder="Search for a contract..."></b-input></b-input-group>
                            </div>
                            <div class="pagination-element">
                                <!-- Pagination for the table -->
                                <b-pagination
                                    aria-controls="aquaculturePackageContractsTable"
                                    v-model="currentPageAquacultureMalesFish"
                                    :per-page="aquaculturePerPage"
                                    :total-rows="totalRowsAquacultureMalesFish"
                                    align="right"
                                    size="sm"
                                ></b-pagination>
                            </div>
                        </div>
                        <br />
                        <hr />

                        <!-- <b-table id="aquaculturePackageContractsTable"
                            class="clickable" style="max-width: 85%;"
                            responive="xl"
                            head-variant="light"
                            :total-rows="initialWorldState.filter(contract => contract.TempData.TemplateID == '18719e55-99bf-4137-b7bb-fefd373f60b3').length"
                            :items="initialWorldState.filter(contract => contract.TempData.TemplateID == '18719e55-99bf-4137-b7bb-fefd373f60b3' && contract.State == '3.2' /*&& parseInt(contract.name.replace('Package ID-', '')) < 500*/ )"
                            
                            :filter="aquacultureTableFilter"
                            :per-page="5"
                            :current-page="currentPageAquacultureMalesFish"
                            @row-clicked="contractsRowClicked"
                            @row-hovered="rowHovered"
                            @filtered="aquacultureTableFiltered"
                            @sort-changed="tableSortChanged"
                        >
                            <template #cell(contractname)="cell">PACAKGE: {{ cell.item.name }}<br />BATCH: {{cell.item.TempData.ProcessData.device + " - " + cell.item.TempData.ProcessData.batch_id}}<br />ROW: { "ID": "{{cell.item.ID}}" }
                                <div style="position: relative;">
                                    <div style="position: absolute; top: -48px; left: -41px; width: 32px; height: 60px; border-left: 1px solid grey; border-bottom: 1px solid grey;"></div>
                                </div>
                                <img src="../../assets/images/templateIcons/testIcons/qr-icon.png" style="width: 16px; margin-right: 10px; top: -2px;" />{{ cell.item.name }} <span v-if="isNewRow(!cell.item.TimeStampEpoch ? cell.item.item.TimeStampEpoch - 1000 : cell.item.TimeStampEpoch - 1000)"><sup><b-badge pill variant="info" style="font-style: .5em;">New</b-badge></sup></span>
                            </template>
                            <template #cell(contracttype)="cell">Vitrafy Smart Packaging</template>
                            <template #cell(contractapplication)="cell" style="vertical-align: top;"> {{ cell.item.TempData.Application }} </template>
                            <template #cell(contractdatetime)="cell" style="vertical-align: top;">{{ getRelativeDate(cell.item.TimeStampEpochUpdated) }}</template>
                            <template #cell(contractstate)="cell" style="vertical-align: top;"><b-badge pill variant="primary">{{ cell.item.nextState }} {{ cell.item.nextStateName }} </b-badge></template>
                            <template #cell(contractprogress)="cell" class="chart" Style="width:30%; vertical-align: middle;">
                                <div class="progress">
                                    <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: cell.item.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                    </div>
                                </div>
                                <div style="font-size: 10px; color: grey;">{{ cell.item.stateProgress }} %</div>
                            </template>
                        </b-table> -->
                    </b-tab>

                    <!-- Completed -->
                    <b-tab :title="blockchainCompletedCount">
                        <b-table id="blockchainCompletedTable" ref="blockchainCompletedTable"
                            :items="blockchainCompleted"
                            :total-rows="blockchainCompleted.length"
                            :fields="blockChainCompletedTableFields"
                            @sort-changed="tableSortChanged"
                        >
                            <template #cell(contractname)="cell"><a href="" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{ cell.item.name }}</a></template>
                            <template #cell(contractapplication)="cell" style="vertical-align: top;"> {{ cell.item.TempData.Application }} </template>
                            <template #cell(contractdatetime)="cell" style="vertical-align: top;">{{getFormattedDate(cell.item.datetime)}}</template>
                            <template #cell(contractstate)="cell" style="vertical-align: top;">{{ cell.item.nextState }}</template>
                            <template #cell(contractprogress)="cell" class="chart" Style="width:30%; vertical-align: middle;">
                                <div class="progress">
                                    <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: cell.item.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                    </div>
                                </div>
                                <div style="font-size: 10px; color: grey;">{{ cell.item.stateProgress }} %</div>
                            </template>
                        </b-table>
                    </b-tab>

                    <!-- Templates -->
                    <b-tab :title="blockchainTemplatesCount">

                        <b-table id="blockchainTemplatesTable" ref="blockchainTemplatesTable"
                            :items="blockchainTemplates"
                            :total-rows="blockchainTemplates.length"
                            :fields="blockChainTemplatesTableFields"
                            @sort-changed="tableSortChanged"
                        >
                            <template #cell(contractname)="cell"><a href="" @click.prevent="openTemplate(cell.item, false)">{{ cell.item.TempData.contract.name }}</a></template>
                            <template #cell(contractapplication)="cell" style="vertical-align: top;"> {{ cell.item.TempData.contract.application }} </template>
                            <template #cell(contractdatetime)="cell" style="vertical-align: top;">{{ cell.item.TimeStamp }}</template>
                            <template #cell(contractauthor)="cell" style="vertical-align: top;">{{ cell.item.User }}</template>
                            <template #cell(contractowner)="cell" style="vertical-align: top;">{{cell.item.Owner}}</template>
                            <template #cell(contractversion)="cell" style="vertical-align: top;">{{cell.item.TempData.contract.version}}</template>
                        </b-table>
                    </b-tab>
                </b-tabs>

            </div>  

            <!-- New contract modal -->
            <b-modal v-if="newContractModalShow" id="new-contract-modal" size="md" title="Create New BioContract" button-size="sm" @ok="createNewContract">
                <div>
                    <b-form-group id="input-group-2" label="Contract Name:" label-for="input-2">
                        <b-form-input
                            id="input-2"
                            v-model="contractName"
                            placeholder="Enter name for contract"
                            :state="contract_name_valid"
                        ></b-form-input>
                        <b-form-invalid-feedback :state="contract_name_valid">
                            contract name required
                        </b-form-invalid-feedback>
                    </b-form-group>                              

                    <!-- Aquaculture -->
                    <b-form-group v-if="subtype == 'Aquaculture'" id="input-group-3" label="Contract Application:" label-for="input-3">
                        <b-form-select
                            id="input-3"
                            v-model="contractApplication"
                            :options="contractApplicationOptionsAquaculture"
                            :state="contract_application_valid"
                            @change="filterTemplates"
                        ></b-form-select>
                        <b-form-invalid-feedback :state="contract_application_valid">
                            selection required
                        </b-form-invalid-feedback>
                    </b-form-group>                    

                    <b-form-group id="input-group-3" label="Contract Template:" label-for="input-3">
                        <b-form-select
                            id="input-3"
                            v-model="contractTemplate"
                            :options="contractTemplateOptions"
                            :state="contract_template_valid"
                        ></b-form-select>
                        <b-form-invalid-feedback :state="contract_template_valid">
                            selection required
                        </b-form-invalid-feedback>
                    </b-form-group>

                </div>
            </b-modal>

            <!-- contract details modal (milestsones) -->
            <b-modal id="contract-detals-modal" ref="contractDetailsModal" size="lg" :title="selectedBlock.name" ok-only ok-variant="secondary" button-size="sm" ok-title="Close" scrollable>

                <!-- loading spinner -->
                <div id="blockchain-data-loading-modal" style="display: block;">
                    <div class="lds-facebook"><div></div><div></div><div></div></div>
                    <div>Blockchain (LifeChain Private Network) processing...</div>
                </div>

                <!-- contract details -->
                <div id="blockchain-modal" style="display: none; height: calc(100vh - 230px); margin-top: -16px;">

                    <!-- tabs -->
                    <div style="margin-top: 20px;">
                        <b-tabs content-class="mt-3">

                            <!-- Summary tab -->
                            <b-tab v-if="subtype == 'Aquaculture' || subtype=='Bovine'" title="Summary" :active="(selectedBlock.TempData.TemplateID == aquaculturePackageTemplateID || selectedBlock.TempData.TemplateID == '7a976520-bae3-478e-a397-784354f79970')">
                                <!-- Summary for Huon 2023 - Template -->
                                <div v-if="template.TempData.contract.name == 'Huon 2023 - Template'" style="padding-top: 16px;">
                                    <!-- left side -->
                                    <div style="float: left; width: 50%; padding-left: 35px;">
                                        <div style="width: 300px; text-align: center;">
                                            <div style="box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); text-align: center;">
                                                <img style="width: 300px;" src="https://lc-token-testing.s3.ap-southeast-2.amazonaws.com/ID-0011.png" />
                                                <div style="padding: 15px;">
                                                    {{ selectedBlock.name }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- right side -->
                                    <div class="nft-summary" style="float: left; width: 50%;">

                                        <!-- NFT Details -->
                                        <div v-b-toggle.nft-section class="m-1 section-label" @click="summary_sections.nft_expanded = !summary_sections.nft_expanded">
                                            <div class="section-icon">
                                                <!-- <img style="height: 25px;" src="../../assets/images/nft_logo.png"/> -->
                                                <i class="fa-solid fa-fingerprint"></i>
                                            </div>
                                            <div class="section-label-details">
                                                <span><strong>Biological Token</strong></span>
                                                <br />
                                                <span>{{ selectedBlock.name }}</span>
                                            </div>
                                            <span class="section-chevron">
                                                <i class="fa-solid" :class="summary_sections.nft_expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                            </span>
                                            <b-collapse id="nft-section">
                                                <div  class="collapse-section-container" v-on:click.stop>
                                                    <table class="summary-section-table">
                                                        <!-- <tr>
                                                            <td style="width: 90px;"><strong>Name</strong></td>
                                                            <td>{{ selectedBlock.name }}</td>
                                                        </tr>                                           -->
                                                        <tr>
                                                            <td style="width: 90px;"><strong>Type</strong></td>
                                                            <td>Stacked Biological Token</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Fish ID</strong></td>
                                                            <td><a href="#" v-b-modal.master-nft-modal>5584231 (Master Biological Token)</a></td>
                                                        </tr>
                                                        <tr>
                                                            <td style="width: 90px;"><strong>Transaction</strong></td>
                                                            <td><a target="_blank" href="https://goerli.etherscan.io/tx/0xe417291dbeb45104cbd2ffe5d6fc735613c7c8b9629fab9e5b5023db5ee96408">0xe417291dbeb45104c...</a></td>
                                                        </tr>                                                                                                                                                                                                    
                                                        <tr>
                                                            <td style="width: 90px;"><strong>Description</strong></td>
                                                            <td>Package ID</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>QR Code</strong></td>
                                                            <td><a href="#">click to view</a></td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Owned By</strong></td>
                                                            <td><a href="#">lifechain</a></td>
                                                        </tr>                                                                  
                                                    </table>
                                                </div>
                                            </b-collapse>
                                        </div>                                                

                                        <!-- Status Details  -->
                                        <div v-b-toggle.contract-section class="m-1 section-label" @click="summary_sections.contract_expanded = !summary_sections.contract_expanded">
                                            <div class="section-icon"><i class="fa-solid fa-clipboard-check"></i></div>
                                            <div class="section-label-details">
                                                <span><strong>Status</strong></span>
                                                <br />
                                                <!-- <span>4.1 Liquid Nitrogen Dewar, -196°C</span> -->
                                                <b-badge pill variant="primary">{{ selectedBlock.nextState }} {{ selectedBlock.nextStateName }}</b-badge>
                                            </div>
                                            <span class="section-chevron">
                                                <i class="fa-solid" :class="summary_sections.contract_expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                            </span>
                                            <b-collapse id="contract-section">
                                                <div  class="collapse-section-container" v-on:click.stop>
                                                    <table class="summary-section-table">
                                                        <tr>
                                                            <td style="width: 90px;"><strong>Contract</strong></td>
                                                            <td>{{ selectedBlock.name }}</td>
                                                        </tr>                                                        
                                                        <tr>
                                                            <td style="width: 90px;"><strong>Template</strong></td>
                                                            <td>{{ template.TempData.contract.name }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="width: 90px;"><strong>Created</strong></td>
                                                            <td>{{ selectedBlock.TimeStamp }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="width: 90px;"><strong>Creator</strong></td>
                                                            <td>{{ selectedBlock.User }}</td>
                                                        </tr>
                                                        <!-- <tr>
                                                            <td style="width: 90px;"><strong>State</strong></td>
                                                            <td><b-badge pill variant="primary">{{selectedBlock.nextState }} {{selectedBlock.nextStateName }}</b-badge></td>
                                                        </tr> -->
                                                    </table>
                                                </div>
                                            </b-collapse>
                                        </div>                                        

                                        <!-- Location Details  -->
                                        <div v-b-toggle.location-section class="m-1 section-label" style="cursor: initial;" @click="summary_sections.location_expanded = !summary_sections.location_expanded">
                                            <div class="section-icon"><i class="fa-solid fa-location-dot"></i></div>
                                            <div class="section-label-details">
                                                <span><strong>Location</strong></span>
                                                <br />
                                                <span>17 Back River Rd, New Norfolk TAS 7140</span>
                                            </div>
                                            <div class="section-chevron" style="display: none">
                                                <i class="fa-solid" :class="summary_sections.location_expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                            </div>
                                            <b-collapse id="location-section">
                                                <div class="collapse-section-container" v-on:click.stop style="display: none;">
                                                    <div class="summary-section-table">

                                                        <div style="position: relative; padding-left:20px; float: left;">
                                                            <span style="color:red; font-weight: bold;">LIVE DATA</span>
                                                            <svg height="50" width="50" class="blinking" style="position:absolute; top:-9px; left:-11px;">
                                                                <circle cx="20" cy="20" r="5" fill="red" />
                                                            </svg> 
                                                        </div><span style="color: white;">x</span>

                                                        <div style="margin-top: -15px;">
                                                            <PackagingTracking_HuonTas_summary ref="PackagingTracking_HuonTas_summary"/>
                                                        </div>

                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </div>

                                        <!-- Financial Details  -->
                                        <div v-b-toggle.financial-section class="m-1 section-label section-label-last" @click="summary_sections.financial_expanded = !summary_sections.financial_expanded">
                                            <div class="section-icon"><i class="fa-solid fa-money-bill-trend-up"></i></div>
                                            <div class="section-label-details">
                                                <span><strong>Financial</strong></span>
                                                <br />
                                                <span>$65.00</span>
                                            </div>                                            
                                            <span class="section-chevron">
                                                <i class="fa-solid" :class="summary_sections.financial_expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                            </span>
                                            <b-collapse id="financial-section">
                                                <div  class="collapse-section-container" v-on:click.stop>
                                                    <div class="financial-section-heading"><strong>Cost Breakdown</strong></div>
                                                    <table class="table">
                                                        <thead>
                                                            <th>Item</th>
                                                            <th>Process</th>
                                                            <th></th>
                                                            <th>Cost</th>
                                                        </thead>
                                                        <tr class="hover-table" v-b-modal="'subprocess-detals-modal'" @click="transactionClick('2.3')">
                                                            <td class="nft-cost-data-key">Packaging</td>
                                                            <td class="nft-cost-link"><a href="#">Process 2.3</a></td>
                                                            <td class="nft-cost-data-currency">$</td>
                                                            <td class="nft-cost-data-currency-value">55.00</td>
                                                        </tr>
                                                        <tr class="hover-table" v-b-modal="'subprocess-detals-modal'" @click="transactionClick('2.4')">
                                                            <td class="nft-cost-data-key">Cryoprotectant</td>
                                                            <td class="nft-cost-link"><a href="#">Process 2.4</a></td>
                                                            <td class="nft-cost-data-currency">$</td>
                                                            <td class="nft-cost-data-currency-value">2.00</td>
                                                        </tr>
                                                        <tr class="hover-table" v-b-modal="'subprocess-detals-modal'" @click="transactionClick('2.5')">
                                                            <td class="nft-cost-data-key">Preparation</td>
                                                            <td class="nft-cost-link"><a href="#">Process 2.5</a></td>
                                                            <td class="nft-cost-data-currency">$</td>
                                                            <td class="nft-cost-data-currency-value">0.00</td>
                                                        </tr>                                                                                                 
                                                        <tr class="hover-table" v-b-modal="'subprocess-detals-modal'" @click="transactionClick('3.2')">
                                                            <td class="nft-cost-data-key">Preservation</td>
                                                            <td class="nft-cost-link"><a href="#">Process 3.2</a></td>
                                                            <td class="nft-cost-data-currency">$</td>
                                                            <td class="nft-cost-data-currency-value">0.00</td>
                                                        </tr>
                                                        <tr class="hover-table" v-b-modal="'subprocess-detals-modal'" @click="transactionClick('5.3')">
                                                            <td class="nft-cost-data-key">Thawing</td>
                                                            <td class="nft-cost-link"><a href="#">Process 5.3</a></td>
                                                            <td class="nft-cost-data-currency nft-cost-data-bottom-border">$</td>
                                                            <td class="nft-cost-data-currency-value nft-cost-data-bottom-border">8.00</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="nft-cost-data-key"><strong>Total</strong></td>
                                                            <td class="nft-cost-link"></td>
                                                            <td class="nft-cost-data-currency nft-cost-data-bottom-border-thick">$</td>
                                                            <td class="nft-cost-data-currency-value nft-cost-data-bottom-border-thick">65.00</td>
                                                        </tr>                                                                                                                                                                                                              
                                                    </table>
                                                </div>     
                                            </b-collapse>
                                        </div>

                                    </div>
                                </div>
                                <!-- Summary for SSI Sample - Template -->
                                <div v-if="template.TempData.contract.name == 'SSI Sample - Template'" style="padding-top: 16px;">
                                    <!-- left side -->
                                    <div style="float: left; width: 50%; padding-left: 35px;">
                                        <div style="width: 300px; text-align: center;">
                                            <div style="box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); text-align: center;">
                                                <img style="width: 300px;" src="https://lc-token-testing.s3.ap-southeast-2.amazonaws.com/ID-0011.png" />
                                                <div style="padding: 15px;">
                                                    {{ selectedBlock.name }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- right side -->
                                    <div class="nft-summary" style="float: left; width: 50%;">

                                        <!-- NFT Details -->
                                        <div v-b-toggle.nft-section class="m-1 section-label" @click="summary_sections.nft_expanded = !summary_sections.nft_expanded">
                                            <div class="section-icon">
                                                <!-- <img style="height: 25px;" src="../../assets/images/nft_logo.png"/> -->
                                                <i class="fa-solid fa-fingerprint"></i>
                                            </div>
                                            <div class="section-label-details">
                                                <span><strong>Biological Token</strong></span>
                                                <br />
                                                <span>{{ selectedBlock.name }}</span>
                                            </div>
                                            <span class="section-chevron">
                                                <i class="fa-solid" :class="summary_sections.nft_expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                            </span>
                                            <b-collapse id="nft-section">
                                                <div  class="collapse-section-container" v-on:click.stop>
                                                    <table class="summary-section-table">
                                                        <!-- <tr>
                                                            <td style="width: 90px;"><strong>Name</strong></td>
                                                            <td>{{ selectedBlock.name }}</td>
                                                        </tr>                                           -->
                                                        <tr>
                                                            <td style="width: 90px;"><strong>Type</strong></td>
                                                            <td>Stacked Biological Token</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Bull ID</strong></td>
                                                            <td><a href="#" v-b-modal.master-nft-modal>250HO16741 (Master Biological Token)</a></td>
                                                        </tr>
                                                        <tr>
                                                            <td style="width: 90px;"><strong>Transaction</strong></td>
                                                            <td><a target="_blank" href="https://goerli.etherscan.io/tx/0xe417291dbeb45104cbd2ffe5d6fc735613c7c8b9629fab9e5b5023db5ee96408">0xe417291dbeb45104c...</a></td>
                                                        </tr>                                                                                                                                                                                                    
                                                        <tr>
                                                            <td style="width: 90px;"><strong>Description</strong></td>
                                                            <td>Package ID</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>QR Code</strong></td>
                                                            <td><a href="#">click to view</a></td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Owned By</strong></td>
                                                            <td><a href="#">LifeChain</a></td>
                                                        </tr>                                                                  
                                                    </table>
                                                </div>
                                            </b-collapse>
                                        </div>                                                

                                        <!-- Status Details  -->
                                        <div v-b-toggle.contract-section class="m-1 section-label" @click="summary_sections.contract_expanded = !summary_sections.contract_expanded">
                                            <div class="section-icon"><i class="fa-solid fa-clipboard-check"></i></div>
                                            <div class="section-label-details">
                                                <span><strong>Status</strong></span>
                                                <br />
                                                <!-- <span>4.1 Liquid Nitrogen Dewar, -196°C</span> -->
                                                <b-badge pill variant="primary">{{ selectedBlock.nextState }} {{ selectedBlock.nextStateName }}</b-badge>
                                            </div>
                                            <span class="section-chevron">
                                                <i class="fa-solid" :class="summary_sections.contract_expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                            </span>
                                            <b-collapse id="contract-section">
                                                <div  class="collapse-section-container" v-on:click.stop>
                                                    <table class="summary-section-table">
                                                        <tr>
                                                            <td style="width: 90px;"><strong>Contract</strong></td>
                                                            <td>{{ selectedBlock.name }}</td>
                                                        </tr>                                                        
                                                        <tr>
                                                            <td style="width: 90px;"><strong>Template</strong></td>
                                                            <td>{{ template.TempData.contract.name }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="width: 90px;"><strong>Created</strong></td>
                                                            <td>{{ selectedBlock.TimeStamp }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="width: 90px;"><strong>Creator</strong></td>
                                                            <td>{{ selectedBlock.User }}</td>
                                                        </tr>
                                                        <!-- <tr>
                                                            <td style="width: 90px;"><strong>State</strong></td>
                                                            <td><b-badge pill variant="primary">{{selectedBlock.nextState }} {{selectedBlock.nextStateName }}</b-badge></td>
                                                        </tr> -->
                                                    </table>
                                                </div>
                                            </b-collapse>
                                        </div>                                        

                                        <!-- Location Details  -->
                                        <div v-b-toggle.location-section class="m-1 section-label" style="cursor: initial;" @click="summary_sections.location_expanded = !summary_sections.location_expanded">
                                            <div class="section-icon"><i class="fa-solid fa-location-dot"></i></div>
                                            <div class="section-label-details">
                                                <span><strong>Location</strong></span>
                                                <br />
                                                <span>709 Webb Rd, Girgarre VIC 3624</span>
                                            </div>
                                            <div class="section-chevron" style="display: none">
                                                <i class="fa-solid" :class="summary_sections.location_expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                            </div>
                                            <b-collapse id="location-section">
                                                <div class="collapse-section-container" v-on:click.stop style="display: none;">
                                                    <div class="summary-section-table">

                                                        <div style="position: relative; padding-left:20px; float: left;">
                                                            <span style="color:red; font-weight: bold;">LIVE DATA</span>
                                                            <svg height="50" width="50" class="blinking" style="position:absolute; top:-9px; left:-11px;">
                                                                <circle cx="20" cy="20" r="5" fill="red" />
                                                            </svg> 
                                                        </div><span style="color: white;">x</span>

                                                        <div style="margin-top: -15px;">
                                                            <PackagingTracking_HuonTas_summary ref="PackagingTracking_HuonTas_summary"/>
                                                        </div>

                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </div>

                                        <!-- Financial Details  -->
                                        <div v-b-toggle.financial-section class="m-1 section-label section-label-last" @click="summary_sections.financial_expanded = !summary_sections.financial_expanded">
                                            <div class="section-icon"><i class="fa-solid fa-money-bill-trend-up"></i></div>
                                            <div class="section-label-details">
                                                <span><strong>Financial</strong></span>
                                                <br />
                                                <span>$0.00</span>
                                            </div>                                            
                                            <span class="section-chevron">
                                                <i class="fa-solid" :class="summary_sections.financial_expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                            </span>
                                            <b-collapse id="financial-section">
                                                <div  class="collapse-section-container" v-on:click.stop>
                                                    <div class="financial-section-heading"><strong>Cost Breakdown</strong></div>
                                                    <table class="table">
                                                        <thead>
                                                            <th>Item</th>
                                                            <th>Process</th>
                                                            <th></th>
                                                            <th>Cost</th>
                                                        </thead>
                                                        <tr class="hover-table" v-b-modal="'subprocess-detals-modal'" @click="transactionClick('2.3')">
                                                            <td class="nft-cost-data-key">Packaging</td>
                                                            <td class="nft-cost-link"><a href="#">Process 2.3</a></td>
                                                            <td class="nft-cost-data-currency">$</td>
                                                            <td class="nft-cost-data-currency-value">0.00</td>
                                                        </tr>
                                                        <tr class="hover-table" v-b-modal="'subprocess-detals-modal'" @click="transactionClick('2.4')">
                                                            <td class="nft-cost-data-key">Cryoprotectant</td>
                                                            <td class="nft-cost-link"><a href="#">Process 2.4</a></td>
                                                            <td class="nft-cost-data-currency">$</td>
                                                            <td class="nft-cost-data-currency-value">0.00</td>
                                                        </tr>
                                                        <tr class="hover-table" v-b-modal="'subprocess-detals-modal'" @click="transactionClick('2.5')">
                                                            <td class="nft-cost-data-key">Preparation</td>
                                                            <td class="nft-cost-link"><a href="#">Process 2.5</a></td>
                                                            <td class="nft-cost-data-currency">$</td>
                                                            <td class="nft-cost-data-currency-value">0.00</td>
                                                        </tr>                                                                                                 
                                                        <tr class="hover-table" v-b-modal="'subprocess-detals-modal'" @click="transactionClick('3.2')">
                                                            <td class="nft-cost-data-key">Preservation</td>
                                                            <td class="nft-cost-link"><a href="#">Process 3.2</a></td>
                                                            <td class="nft-cost-data-currency">$</td>
                                                            <td class="nft-cost-data-currency-value">0.00</td>
                                                        </tr>
                                                        <tr class="hover-table" v-b-modal="'subprocess-detals-modal'" @click="transactionClick('5.3')">
                                                            <td class="nft-cost-data-key">Thawing</td>
                                                            <td class="nft-cost-link"><a href="#">Process 5.3</a></td>
                                                            <td class="nft-cost-data-currency nft-cost-data-bottom-border">$</td>
                                                            <td class="nft-cost-data-currency-value nft-cost-data-bottom-border">0.00</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="nft-cost-data-key"><strong>Total</strong></td>
                                                            <td class="nft-cost-link"></td>
                                                            <td class="nft-cost-data-currency nft-cost-data-bottom-border-thick">$</td>
                                                            <td class="nft-cost-data-currency-value nft-cost-data-bottom-border-thick">0.00</td>
                                                        </tr>                                                                                                                                                                                                              
                                                    </table>
                                                </div>     
                                            </b-collapse>
                                        </div>

                                    </div>
                                </div>
                                <div v-else style="padding-top: 16px;">
                                    <!-- <strong>Section under development...</strong>
                                    <div style="max-width: 500px; margin-top: 10px;"><b-progress value="100" variant="info" :striped="true" animated></b-progress></div> -->
                                    
                                    
                                </div>

                            </b-tab>

                            <!-- Contract tab -->
                            <b-tab title="Contract" :active="(
                                    type == 'Human' ||
                                    template.TempData.contract.id =='932f342a-0eeb-4c45-9bf4-816a72315278' ||
                                    template.TempData.contract.id == '932f342a-0eeb-4c45-9bf4-816a72315280' ||
                                    template.TempData.contract.id == aquacultureFertilisationTemplateID ||
                                    template.TempData.contract.id == aquacultureMasterFemaleTemplateID ||
                                    template.TempData.contract.id == aquacultureMasterMaleTemplateID ||
                                    template.TempData.contract.id == aquacultureEggBatchTemplateID
                                )">
                                <!-- expand and collapse all -->
                                <div class="expandCollapse">
                                    <a href="" @click.prevent="expandAll()">expand all</a><span></span><a href="" @click.prevent="collapseAll()">collapse all</a>
                                </div>
                                
                                <!-- dynamic template structure -->
                                <div id="template-container">
                                    <div v-for="(milestone, index) in template.TempData.contract.milestones" v-bind:key="milestone.id">

                                        <!-- milestones -->
                                        <div class="milestone" :class="[milestone.status]" @click="milestoneToggle(milestone.id)">

                                            <!-- hide top left of top boarder over image -->
                                            <div style="border-top: 1px solid #ffffff; position: absolute; top: -1px; left: 0; width: 65px;"></div>

                                            <!-- icon Images -->
                                            <span>
                                                <!-- CAR-T & ART Icons -->
                                                <img v-if="milestone.iconImage == 1" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/1.png"/>
                                                <img v-if="milestone.iconImage == 2" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/2.png"/>
                                                <img v-if="milestone.iconImage == 3" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/3.png"/>
                                                <img v-if="milestone.iconImage == 4" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/4.png"/>
                                                <img v-if="milestone.iconImage == 5" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/5.png"/>
                                                <img v-if="milestone.iconImage == 6" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/6.png"/>
                                                <img v-if="milestone.iconImage == 7" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/7.png"/>
                                                <img v-if="milestone.iconImage == 8" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/8.png"/>
                                                <img v-if="milestone.iconImage == 9" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/9.png"/>
                                                <img v-if="milestone.iconImage == 10" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/10.png"/>
                                                <img v-if="milestone.iconImage == 11" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/11.png"/>
                                                <img v-if="milestone.iconImage == 12" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/12.png"/>

                                                <!-- Sperm Use Case NFT AI Test -->
                                                <img v-if="milestone.iconImage == 'SUCT-1'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/1.png"/>
                                                <img v-if="milestone.iconImage == 'SUCT-2'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/2.png"/>
                                                <img v-if="milestone.iconImage == 'SUCT-3'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/3.png"/>
                                                <img v-if="milestone.iconImage == 'SUCT-4'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/4.png"/>
                                                <img v-if="milestone.iconImage == 'SUCT-5'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/5.png"/>
                                                <img v-if="milestone.iconImage == 'SUCT-6'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/package.png"/>
                                                <img v-if="milestone.iconImage == 'SUCT-9'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/9.png"/>

                                                <!-- CSL HSC Icons -->
                                                <img v-if="milestone.iconImage == 'CSLHSC-1'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/CSLHSC/CSLHSC-1.png"/>
                                                <img v-if="milestone.iconImage == 'CSLHSC-2'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/CSLHSC/CSLHSC-2.png"/>
                                                <img v-if="milestone.iconImage == 'CSLHSC-3'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/CSLHSC/CSLHSC-3.png"/>
                                                <img v-if="milestone.iconImage == 'CSLHSC-4'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/CSLHSC/CSLHSC-4.png"/>
                                                <img v-if="milestone.iconImage == 'CSLHSC-5'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/CSLHSC/CSLHSC-5.png"/>
                                                <img v-if="milestone.iconImage == 'CSLHSC-6'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/CSLHSC/CSLHSC-6.png"/>
                                            </span>

                                            <!-- milestone link -->
                                            <div v-if="milestone.status == 'COMPLETED' && index != template.TempData.contract.milestones.length -1" class="milestone-link" ></div>

                                            <!-- label -->
                                            <span v-if="milestone.status == 'IN PROGRESS'" class="milestone-label" style="font-weight: bold; color: #0a58ca"> {{ milestone.id }}. {{ milestone.name }} <span style="font-weight: initial; color: initial"><br />In Progress</span></span>
                                            <span v-else-if="milestone.status == 'COMPLETED'" class="milestone-label" style="font-weight: bold;"> {{ milestone.id }}. {{ milestone.name }} <span style="font-weight: initial; color: initial"><br />Completed - {{ milestone.timestamp }}</span></span>
                                            <span v-else class="milestone-label" style="color: #adb5bd"> {{ milestone.id }}. {{ milestone.name }} </span>

                                            <!-- chevron -->
                                            <i v-bind:class="[milestone.expanded ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down']"></i>

                                            <div v-if="milestone.lastMilestone && !milestone.expanded" class="milestone-link-end"></div>
                                        </div>

                                        <!-- subprocesses -->
                                        <div v-if="milestone.expanded" class="subprocess-section">
                                            
                                            <!-- links -->
                                            <div v-if="milestone.subprocesses.length > 0" :class="[milestone.status == 'COMPLETED' ? 'milestone-link-top milestone-link-top-complete' : 'milestone-link-top', milestone.status == 'IN PROGRESS' ? 'milestone-link-top milestone-link-top-complete' : 'milestone-link-top']"></div>
                                            <div v-if="milestone.subprocesses.length > 0 && !milestone.lastMilestone" :class="milestone.status == 'COMPLETED' ? 'milestone-link-bottom milestone-link-bottom-complete' : 'milestone-link-bottom'"></div>

                                            <!-- subprocess  (sl1)-->
                                            <div v-for="(s1, index) in milestone.subprocesses" v-bind:key="s1.id">
                                                <div class="subprocess-container">
                                                    <div  style="float: left;" class="template-process blank-process first-coloum-process"></div>
                                                    <div v-b-modal="'subprocess-detals-modal'" @click="sendInfo_subprocess(s1)" class="template-process" :class="[s1.status == 'COMPLETED' ? 'template-process-complete' : '', s1.status == 'IN PROGRESS' ? 'template-process-in-progress' : '']">
                                                        <div>{{ s1.id }} {{ s1.name }}</div>
                                                        <div v-if="!s1.subprocessesParallel && index != milestone.subprocesses.length - 1" :class="s1.status == 'COMPLETED' ? 'subprocess-bottom-link subprocess-bottom-link-complete' : 'subprocess-bottom-link'"></div>
                                                    </div>
                                                </div>

                                                <!-- subprocess area -->
                                                <div class="subprocess-area">

                                                    <!-- links -->
                                                    <div v-if="s1.subprocesses.length > 0" :class="s1.status == 'COMPLETED' ? 'subprocess-link-top subprocess-link-top-complete' : 'subprocess-link-top'"></div>
                                                    <div v-if="s1.subprocesses.length > 0 && !s1.linkBackToMilestone" :class="s1.status == 'COMPLETED' ? 'subprocess-link-bottom subprocess-link-bottom-complete' : 'subprocess-link-bottom'"></div>
                                                    <div v-if="s1.linkBackToMilestone" :class="milestone.status == 'COMPLETED' ? 'subprocess-link-back-to-milestone subprocess-link-back-to-milestone-complete' : 'subprocess-link-back-to-milestone'"></div>
                                                    <div v-if="s1.subprocessesParallel" :class="s1.status == 'COMPLETED' ? 'subprocesses-parallel-link subprocesses-parallel-link-complete' : 'subprocesses-parallel-link'"></div>

                                                    <!-- subprocess of subprocesses (sl2) -->
                                                    <div v-for="(s2, index) in s1.subprocesses" v-bind:key="s2.id">
                                                        <div class="subprocess-container">
                                                            <div style="float: left;" class="template-process blank-process first-coloum-process"></div>
                                                            <div style="float: left;" class="template-process blank-process"></div>

                                                            <div v-b-modal="'subprocess-detals-modal'" @click="sendInfo_subprocess(s2)" class="template-process" :class="[s2.status == 'COMPLETED' ? 'template-process-complete' : '', s2.status == 'IN PROGRESS' ? 'template-process-in-progress' : '']">
                                                                <div>{{ s2.id }} {{ s2.name }}</div>
                                                                <div v-if="!s2.isParallel && index != s1.subprocesses.length - 1" :class="s2.status == 'COMPLETED' ? 'subprocess-bottom-link subprocess-bottom-link-complete' : 'subprocess-bottom-link'"></div>
                                                            </div>
                                                        </div>
                                                        
                                                        <!-- subprocess area -->
                                                        <div class="subprocess-area">

                                                            <!-- links -->
                                                            <div v-if="s2.subprocesses.length > 0" :class="s2.status == 'COMPLETED' ? 'subprocess-subprocess-link-top subprocess-subprocess-link-top-complete' : 'subprocess-subprocess-link-top'"></div>
                                                            <div v-if="s2.subprocesses.length > 0" :class="s2.status == 'COMPLETED' ? 'subprocess-subprocess-link-bottom subprocess-subprocess-link-bottom-complete' : 'subprocess-subprocess-link-bottom'"></div>
                                                            <div v-if="s2.subprocessesParallel" :class="s2.status == 'COMPLETED' ? 'subprocesses-subprocess-parallel-link subprocesses-subprocess-parallel-link-complete' : 'subprocesses-subprocess-parallel-link'"></div>

                                                            <!-- subprocess of subprocesses of subprocesses (sl3) -->
                                                            <div v-for="s3 in s2.subprocesses" v-bind:key="s3.id">
                                                                <div class="subprocess-container">
                                                                    <div style="float: left;" class="template-process blank-process first-coloum-process"></div>
                                                                    <div style="float: left;" class="template-process blank-process"></div>
                                                                    <div style="float: left;" class="template-process blank-process"></div>
                                                                    
                                                                    <div v-b-modal="'subprocess-detals-modal'" @click="sendInfo_subprocess(s3)" class="template-process" :class="[s3.status == 'COMPLETED' ? 'template-process-complete' : '', s3.status == 'IN PROGRESS' ? 'template-process-in-progress' : '']">
                                                                        <div>{{ s3.id }} {{ s3.name }}</div>
                                                                        <div v-if="!s3.isParallel" class="subprocess-bottom-link"></div>
                                                                    </div>
                                                                </div>

                                                            </div> 

                                                        </div>

                                                    </div>

                                                </div>
                                                
                                            </div>

                                        </div>

                                    </div>
                                    <div id="hide-end-of-line"></div>
                                </div>

                            </b-tab>

                            <!-- transactions tab -->
                            <b-tab title="Transactions">
                                
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">TimeStamp</th>
                                            <th scope="col">Process</th>
                                            <!-- <th scope="col">Authoriser</th> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="transaction in block_history" v-bind:key="transaction.Timestamp" class="hover-table">
                                            <td> {{ transaction.TimeStamp }} </td>
                                            <td> 
                                                <div v-if="transaction.State == '0'">Contract Created</div>
                                                <div v-else>{{ transaction.State }} {{ transaction.Name }} - Completed</div>
                                            </td>
                                            <!-- <td> {{ transaction.User }} </td> -->
                                        </tr>
                                    </tbody>
                                </table>

                            </b-tab>

                        </b-tabs>
                    </div>

                </div>

            </b-modal>

            <!-- master NFT modal -->
            <b-modal id="master-nft-modal" size="lg" :title="(subtype == 'Aquaculture' ? '5584231 (Master NFT)' : '250HO16741 (Master Biological Token)')" ok-only ok-variant="secondary" button-size="sm" ok-title="Close" scrollable>
            
                <!-- left side (Image) -->
                <div style="float: left; width: 50%; padding-left: 35px;">
                    <div style="width: 300px; text-align: center;">
                        <div style="box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); text-align: center;">
                            <img style="width: 300px;" src="https://lc-token-testing.s3.ap-southeast-2.amazonaws.com/5548231.png" />
                            <div style="padding: 15px;">
                                {{(subtype =='Aquaculture' ? '5584231' : '250HO16741')}}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- right side (data) -->
                <div style="float: left; width: 50%;">
                    <table class="">
                        <tr>
                            <td style="padding-right: 10px;"><strong>Name</strong></td>
                            <td>{{(subtype == 'Aquaculture' ? '5584231' : '250HO16741')}}</td>
                        </tr>                                          
                        <tr>
                            <td style="padding-right: 10px;"><strong>Type</strong></td>
                            <td>Master Biological Token</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Transaction</strong></td>
                            <td><a target="_blank" href="https://goerli.etherscan.io/tx/0xe417291dbeb45104cbd2ffe5d6fc735613c7c8b9629fab9e5b5023db5ee96408">0xe417291dbeb45104c...</a></td>
                        </tr>                                                                                                                                                                                                    
                        <tr>
                            <td style="padding-right: 10px;"><strong>Description</strong></td>
                            <td>{{(subtype =='Aquaculture' ? 'FishID' : 'BullID')}}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>QR Code</strong></td>
                            <td><a href="#">click to view</a></td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Owned By</strong></td>
                            <td><a href="#">LifeChain</a></td>
                        </tr>            
                    </table>
                    
                    <hr/>

                    <!-- Master NFT Structure -->
                    <div class="master-nft-structure-container">
                        <div class="nft-row">
                            <div class="nft-master-image-container">
                                <img style="width: 50px;" src="https://lc-token-testing.s3.ap-southeast-2.amazonaws.com/5548231.png" />
                            </div>
                            <div class="nft-master-label-container">
                                <div>{{(subtype =='Aquaculture' ? '5584231' : '250HO16741')}}</div>
                                <div class="nft-sub-label">10 Packages (Stacked Tokens)</div>
                            </div>                            
                        </div>

                        <div v-for="(nft, index) in stacked_NFTs" v-bind:key="nft.name" class="nft-row">
                            <div class="nft-stacked-link-container">
                                <div class="nft-stacked-link"></div>
                                <div v-if="index != stacked_NFTs.length -1" class="nft-stacked-link-down"></div>
                            </div>
                            <div class="nft-stacked-image-container">
                                <img style="width: 50px;" src="https://lc-token-testing.s3.ap-southeast-2.amazonaws.com/ID-0011.png" />
                            </div>
                            <div class="nft-stacked-label-container">
                                <span v-if="nft.name == selectedBlock.name"><strong>{{ nft.name }}</strong></span>
                                <span v-else class="nft-not-selected">{{ nft.name }} </span>
                            </div>                            
                        </div>                        

                    </div>

                </div>

            </b-modal>

            <!-- subprocess details modal (process details)-->
            <b-modal id="subprocess-detals-modal" size="xl" title="Process Details" ok-only ok-variant="secondary" button-size="sm" ok-title="Close">

                <!-- contract details -->
                <div id="blockchain-modal">
                    <!-- contract summary -->
                    <table class="blockchain-info-table">
                        <tr>
                            
                            <td style="padding-right: 10px;"><strong>Process Name</strong></td>
                            <td>{{ selectedSubprocess.id }} {{ selectedSubprocess.name }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Contract Name</strong></td>
                            <td>{{ selectedBlock.name }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Template Name</strong></td>
                            <td>{{ template.TempData.contract.name }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Process Status</strong></td>
                            <td v-if="selectedSubprocess.status == 'IN PROGRESS'" style="color: #0a58ca; font-weight: 700;">{{ selectedSubprocess.status }} </td>
                            <td v-else-if="selectedSubprocess.status == 'COMPLETED'" style="color: #198754; font-weight: 700;">{{ selectedSubprocess.status }} </td>
                            <td v-else> {{ selectedSubprocess.status }} </td>
                        </tr>
                        <tr v-if="selectedSubprocess.status == 'COMPLETED'">
                            <td style="padding-right: 10px;"><strong>TimeStamp</strong></td>
                            <td> {{ selectedSubprocess.timestamp }} </td>
                        </tr>
                        <tr v-if="selectedSubprocess.status == 'COMPLETED'">
                            <td style="padding-right: 10px;"><strong>User</strong></td>
                            <td> {{ selectedBlock.User }} </td>
                        </tr>
                    </table>

                    <!-- CAR-T 1.1 Demo -->
                    <div v-if="template.TempData.contract.application == 'CAR-T' && selectedSubprocess.id =='1.1' && selectedSubprocess.status == 'IN PROGRESS'">
                        <div style="float:left; width:100%; margin-bottom: 10px;">
                            <hr />
                            <!-- google map (in progress) -->
                            <div v-if="!testLocationLoaded" style="display: inline-block; width: 50%; padding-right: 20px; float: left; margin-top: -10px;">
                                <BlockchainTrackingBlank ref="BlockchainTrackingBlank"/>
                            </div>

                            <!-- google map (complete) -->
                            <div v-else style="display: inline-block; width: 50%; padding-right: 20px; float: left; margin-top: -10px;">
                                <BlockchainTracking ref="BlockchainTracking"/>
                            </div>

                            <!-- data -->
                            <div style="display: inline-block; width: 50%; padding-left: 20px; float: left; margin-top: 10px;">

                                <!-- sections 1.1 (in progress) -->
                                <div class="chain infoBoxChain" style="float: left; margin-left: 20px; margin-right: 20px;">
                                    <!-- location -->
                                    <div class="chain-row chain-row-item">
                                        <!-- summary -->
                                        <div class="chain-label chain-label-complete">
                                            <!-- Icon and heading -->
                                            <img class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/location.png" />
                                            <div class="hover chain-label-complete infoBoxLabel">Location Information</div>

                                            <!-- info box -->
                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                
                                                <!-- form -->
                                                <b-form-group id="input-group-2" label="Description:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_location_description"
                                                    placeholder="Description of the location"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Location:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    style="display: inline-block; width:360px;"
                                                    v-model="process_location"
                                                    placeholder="Start typing address"
                                                    required
                                                    ></b-form-input>
                                                    <b-button v-if="!detectingLocation" variant="primary" class="btn-sm" style="float: right; height: 33.19px; width: 58.42px" @click="detectLocation()">Detect</b-button>
                                                    <b-button v-else variant="primary" class="btn-sm" style="float: right; height: 33.19px; width: 58.42px" disabled><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></b-button>
                                                </b-form-group>

                                            </div>
                                        </div>
                                    </div>

                                    <!-- doctor details -->
                                    <div class="chain-row chain-row-item">
                                        <!-- summary -->
                                        <div class="chain-label chain-label-complete">
                                            <!-- Icon and heading -->
                                            <img class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/doctor.png" />
                                            <div class="hover chain-label-complete infoBoxLabel">Doctor Details</div>

                                                <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                    
                                                    <!-- form -->
                                                    <b-form-group id="input-group-2" label="Title:" label-for="input-2">
                                                        <b-form-input
                                                        id="input-2"
                                                        v-model="process_doctor_title"
                                                        placeholder="Enter title"
                                                        required
                                                        ></b-form-input>
                                                    </b-form-group>
                                                    <b-form-group id="input-group-2" label="Surname:" label-for="input-2">
                                                        <b-form-input
                                                        id="input-2"
                                                        v-model="process_doctor_surname"
                                                        placeholder="Enter surname"
                                                        required
                                                        ></b-form-input>
                                                    </b-form-group>
                                                    <b-form-group id="input-group-2" label="Firstname:" label-for="input-2">
                                                        <b-form-input
                                                        id="input-2"
                                                        v-model="process_doctor_firstname"
                                                        placeholder="Enter firstname"
                                                        required
                                                        ></b-form-input>
                                                    </b-form-group>
                                                    <b-form-group id="input-group-2" label="Phone:" label-for="input-2">
                                                        <b-form-input
                                                        id="input-2"
                                                        v-model="process_doctor_phone"
                                                        placeholder="Enter phone number"
                                                        required
                                                        ></b-form-input>
                                                    </b-form-group>
                                                    <b-form-group id="input-group-2" label="Email:" label-for="input-2">
                                                        <b-form-input
                                                        id="input-2"
                                                        v-model="process_doctor_email"
                                                        placeholder="Enter email address"
                                                        required
                                                        ></b-form-input>
                                                    </b-form-group>
                                                    <b-form-group id="input-group-2" label="Profession:" label-for="input-2">
                                                        <b-form-input
                                                        id="input-2"
                                                        v-model="process_doctor_profession"
                                                        placeholder="Enter profession"
                                                        required
                                                        ></b-form-input>
                                                    </b-form-group>
                                                    <b-form-group id="input-group-2" label="Registration number:" label-for="input-2">
                                                        <b-form-input
                                                        id="input-2"
                                                        v-model="process_doctor_reg_number"
                                                        placeholder="Enter registration number"
                                                        required
                                                        ></b-form-input>
                                                    </b-form-group>
                                                    <b-form-group id="input-group-3" label="Registration status:" label-for="input-3">
                                                        <b-form-select
                                                        id="input-3"
                                                        v-model="process_doctor_reg_status"
                                                        :options="process_doctor_reg_status_options"
                                                        required
                                                        ></b-form-select>
                                                    </b-form-group>

                                                </div>
                                            <!-- </div> -->
                                        </div>
                                    </div>

                                    <!-- <div class="chain-row chain-row-item">
                                        <b-button variant="primary" class="btn-sm" style="float: right; height: 33.19px;" v-b-modal="'process-commit-to-blockchain-modal'">Commit to Blockchain</b-button>
                                    </div> -->

                                </div>

                            </div>
                        </div>
                    </div>

                    <!-- CAR-T 4.2 Demo -->
                    <div v-else-if="template.TempData.contract.application == 'CAR-T' && selectedSubprocess.id =='4.2' && selectedSubprocess.status == 'COMPLETED'">
                        <div style="float:left; width:100%; margin-bottom: 10px;">
                            <hr />
                            <!-- google map (complete) -->
                            <div style="display: inline-block; width: 50%; padding-right: 20px; float: left; margin-top: -10px;">
                                <BlockchainTracking ref="BlockchainTracking"/>
                            </div>

                            <!-- data -->
                            <div style="display: inline-block; width: 50%; padding-left: 20px; float: left; margin-top: 10px;">

                                <!-- sections 4.2 (completed) -->
                                <div class="chain infoBoxChain" style="float: left; margin-left: 20px; margin-right: 20px;">

                                    <!-- location -->
                                    <div class="chain-row chain-row-item">
                                        <!-- summary -->
                                        <div class="chain-label chain-label-complete">
                                            <!-- Icon and heading -->
                                            <img @click="infoBoxClosed_location = !infoBoxClosed_location" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/location.png" />
                                            <div @click="infoBoxClosed_location = !infoBoxClosed_location" class="hover chain-label-complete infoBoxLabel">Location Information</div>
                                            <div @click="infoBoxClosed_location = !infoBoxClosed_location" class="hover completedText">Vitrafy Lab</div>

                                            <!-- info box -->
                                            <i @click="infoBoxClosed_location = !infoBoxClosed_location" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_location ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                            <div v-if="!infoBoxClosed_location">
                                                <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                    <!-- Info here -->

                                                    <table class="blockchain-info-table">
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Description</strong></td>
                                                            <td>Vitrafy Lab</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px; vertical-align: top;"><strong>Address</strong></td>
                                                            <td>45 Selkirk Drive<br/>Wendouree VIC 3355 Australia</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px; vertical-align: top;"><strong>Coordinates</strong></td>
                                                            <td>latitude: -37.530854124846904<br /> longitude: 143.84331081186326</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- doctor details -->
                                    <div class="chain-row chain-row-item">
                                        <!-- summary -->
                                        <div class="chain-label chain-label-complete">
                                            <!-- Icon and heading -->
                                            <img @click="infoBoxClosed_doctor = !infoBoxClosed_doctor" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/doctor.png" />
                                            <div @click="infoBoxClosed_doctor = !infoBoxClosed_doctor" class="hover chain-label-complete infoBoxLabel">Doctor Details</div>
                                            <div @click="infoBoxClosed_doctor = !infoBoxClosed_doctor" class="hover completedText">Dr. Strange</div>

                                            <!-- info box -->
                                            <i @click="infoBoxClosed_doctor = !infoBoxClosed_doctor" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_doctor ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                            <div v-if="!infoBoxClosed_doctor">
                                                <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                    
                                                    <table class="blockchain-info-table">

                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Title:</strong></td>
                                                            <td>Dr.</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Surname</strong></td>
                                                            <td>Strange</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Firstname:</strong></td>
                                                            <td>Stephen</td>
                                                        </tr>                                                                            
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Phone:</strong></td>
                                                            <td>+61 411 343 442</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Email:</strong></td>
                                                            <td>stephen.strange@email.com</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Profession</strong></td>
                                                            <td>Medical Doctor</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Registration number:</strong></td>
                                                            <td>123456789</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Registration status:</strong></td>
                                                            <td>Registered</td>
                                                        </tr>
                                                    </table>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- patient -->
                                    <div class="chain-row chain-row-item">
                                        <!-- summary -->
                                        <div class="chain-label chain-label-complete">
                                            <!-- Icon and heading -->
                                            <img @click="infoBoxClosed_patient = !infoBoxClosed_patient" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/user.png" />
                                            <div @click="infoBoxClosed_patient = !infoBoxClosed_patient" class="hover chain-label-complete infoBoxLabel">Patient Details</div>
                                            <div @click="infoBoxClosed_patient = !infoBoxClosed_patient" class="hover completedText">Patient ID: 1</div>

                                            <!-- info box -->
                                            <i @click="infoBoxClosed_patient = !infoBoxClosed_patient" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_patient ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                            <div v-if="!infoBoxClosed_patient">
                                                <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                    
                                                    <table class="blockchain-info-table">
                                                        <!-- <tr>
                                                            <td style="padding-right: 10px;"><strong>Title:</strong></td>
                                                            <td>Mr.</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Firstname:</strong></td>
                                                            <td>Joe</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Surname</strong></td>
                                                            <td>Citizen</td>
                                                        </tr>                                                                                                                                                        
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>DOB:</strong></td>
                                                            <td>23/05/1975</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Gender:</strong></td>
                                                            <td>Male</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Address:</strong></td>
                                                            <td>5 Selkirk Drive, Wendouree VIC 3355 Australia</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Phone:</strong></td>
                                                            <td>+61 456 345 345</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Email:</strong></td>
                                                            <td>joe.citizen@email.com</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Medical Info:</strong></td>
                                                            <td><a href="#">Click to view details</a></td>
                                                        </tr> -->
                                                        <tr>
                                                            <td style="padding-right: 10px;"><strong>Patient Details:</strong></td>
                                                            <td><a href="#">Click to view details</a></td>
                                                        </tr>                                                        
                                                    </table>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- process -->
                                    <div class="chain-row chain-row-item" style="width: 100%;">
                                        <!-- summary -->
                                        <div class="chain-label chain-label-complete">
                                            <!-- Icon and heading -->
                                            <img @click="infoBoxClosed_process = !infoBoxClosed_process" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/process.png" />
                                            <div @click="infoBoxClosed_process = !infoBoxClosed_process" class="hover chain-label-complete infoBoxLabel">Process Details</div>
                                            <div @click="infoBoxClosed_process = !infoBoxClosed_process" class="hover completedText">4.2 Cryopreservation</div>

                                            <!-- info box -->
                                            <i @click="infoBoxClosed_process = !infoBoxClosed_process" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_process ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                            <div v-if="!infoBoxClosed_process">
                                                <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">

                                                        <!-- checks -->
                                                        <div class="process_heading">Prerequisite Checks</div>
                                                        <div class="chain-row chain-row-item">
                                                            <!-- summary -->
                                                            <div class="chain-label chain-label-complete">
                                                                <!-- Icon and heading -->
                                                                <img @click="infoBoxClosed_sample_checks = !infoBoxClosed_sample_checks" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/checks.png" />
                                                                <div @click="infoBoxClosed_sample_checks = !infoBoxClosed_sample_checks" class="hover chain-label-complete infoBoxLabel">Milestones</div>
                                                                <div @click="infoBoxClosed_sample_checks = !infoBoxClosed_sample_checks" class="hover completedText">3.2.5, 3.2.6, 3.2.7</div>

                                                                <!-- info box -->
                                                                <i @click="infoBoxClosed_sample_checks = !infoBoxClosed_sample_checks" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_sample_checks ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                                <div v-if="!infoBoxClosed_sample_checks">
                                                                    <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                        

                                                                        <table class="blockchain-info-table">
                                                                            <tr>
                                                                                <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <strong>3.2.5 </strong> <a href="#">MIoT cryopreservation device informed</a></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <strong>3.2.6 </strong> <a href="#">Racking system and protocol selected</a></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <strong>3.2.7 </strong> <a href="#">MIoT smart packaging device informed other devices</a></td>
                                                                            </tr>
                                                                        </table>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!-- sample -->
                                                        <div class="process_heading">Pre-Cryopreservation</div>
                                                        <div class="chain-row chain-row-item">
                                                            <!-- summary -->
                                                            <div class="chain-label chain-label-complete">
                                                                <!-- Icon and heading -->
                                                                <img @click="infoBoxClosed_sample = !infoBoxClosed_sample" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/sample.png" />
                                                                <div @click="infoBoxClosed_sample = !infoBoxClosed_sample" class="hover chain-label-complete infoBoxLabel">Sample Details</div>
                                                                <div @click="infoBoxClosed_sample = !infoBoxClosed_sample" class="hover completedText">Vitrafy 30mL Smart MIoT EVA Bag</div>

                                                                <!-- info box -->
                                                                <i @click="infoBoxClosed_sample = !infoBoxClosed_sample" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_sample ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                                <div v-if="!infoBoxClosed_sample">
                                                                    <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                        

                                                                        <table class="blockchain-info-table">
                                                                            <tr>
                                                                                <td style="padding-right: 10px; vertical-align: top;"><strong>Sample Description:</strong></td>
                                                                                <td style="white-space: break-spaces;">Human peripheral blood, isolated T-cells in 10% DMSO media</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style="padding-right: 10px;"><strong>Sample Volume:</strong></td>
                                                                                <td>20mL</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style="padding-right: 10px;"><strong>Package ID:</strong></td>
                                                                                <td>12345-67890-12345b</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style="padding-right: 10px;"><strong>Package Type:</strong></td>
                                                                                <td>Vitrafy 30mL Smart MIoT EVA Bag</td>
                                                                            </tr>
                                                                            <tr>
                                                                            <td style="padding-right: 10px;"><strong>Technical Info:</strong></td>
                                                                                <td><a href="#">Click to view details</a></td>
                                                                            </tr>
                                                                        </table>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!-- device -->
                                                        <div class="process_heading">Cryopreservation </div>
                                                        <div class="chain-row chain-row-item">
                                                            <!-- summary -->
                                                            <div class="chain-label chain-label-complete">
                                                                <!-- Icon and heading -->
                                                                <img @click="infoBoxClosed_device = !infoBoxClosed_device" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/device.png" />
                                                                <div @click="infoBoxClosed_device = !infoBoxClosed_device" class="hover chain-label-complete infoBoxLabel">Device Details</div>
                                                                <div @click="infoBoxClosed_device = !infoBoxClosed_device" class="hover completedText">Cryopreservation Apparatus</div>

                                                                <!-- info box -->
                                                                <i @click="infoBoxClosed_device = !infoBoxClosed_device" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_device ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                                <div v-if="!infoBoxClosed_device">
                                                                    <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                        

                                                                        <table class="blockchain-info-table">
                                                                            <tr>
                                                                                <td style="padding-right: 10px;"><strong>Device Name</strong></td>
                                                                                <td>Vitrafy-00004</td>
                                                                            </tr>                                                                                                        
                                                                            <tr>
                                                                                <td style="padding-right: 10px;"><strong>Device ID:</strong></td>
                                                                                <td>12345-76890-54321d</td>
                                                                            </tr>                                                                                                                                                
                                                                            <tr>
                                                                                <td style="padding-right: 10px;"><strong>Device Type:</strong></td>
                                                                                <td>Cryopreservation Apparatus</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style="padding-right: 10px;"><strong>Protocol</strong></td>
                                                                                <td><a href="#">Click to view details</a></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style="padding-right: 10px;"><strong>Schedule</strong></td>
                                                                                <td><a href="#">Click to view details</a></td>
                                                                            </tr>
                                                                        </table>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!-- reg -->
                                                        <div class="process_heading">Regulatory</div>
                                                        <div class="chain-row chain-row-item">
                                                            <!-- summary -->
                                                            <div class="chain-label chain-label-complete">
                                                                <!-- Icon and heading -->
                                                                <img @click="infoBoxClosed_sample_reg = !infoBoxClosed_sample_reg" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/checks.png" />
                                                                <div @click="infoBoxClosed_sample_reg = !infoBoxClosed_sample_reg" class="hover chain-label-complete infoBoxLabel">Regulatory compliance</div>
                                                                <div @click="infoBoxClosed_sample_reg = !infoBoxClosed_sample_reg" class="hover completedText">FDA, TGA, EMA</div>

                                                                <!-- info box -->
                                                                <i @click="infoBoxClosed_sample_reg = !infoBoxClosed_sample_reg" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_sample_reg ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                                <div v-if="!infoBoxClosed_sample_reg">
                                                                    <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                        

                                                                        <table class="blockchain-info-table">
                                                                            <tr>
                                                                                <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <strong>FDA </strong> <a href="#">click to view pdf standards</a></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <strong>TGA </strong> <a href="#">click to view pdf standards</a></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <strong>EMA </strong> <a href="#">click to view pdf standards</a></td>
                                                                            </tr>
                                                                        </table>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>

                    <!-- Sperm Use Case Test 1.1 (Donar Details)-->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='1.1' && template.TempData.contract.id =='c2968cb9-20f1-4820-9d7c-07975b39e8f6'">
                        <div style="float:left; width:100%; margin-bottom: 10px;">
                            <hr />
                            <div style="display: inline-block; width: 50%; padding-right: 20px; float: left; margin-top: -10px;">
                                <BlockchainTracking ref="BlockchainTracking"/>
                            </div>

                            <!-- data -->
                            <div style="display: inline-block; width: 50%; padding-left: 20px; float: left; margin-top: 10px;">

                                <!-- sections 1.1 (in progress) -->
                                <div class="chain infoBoxChain" style="float: left; margin-left: 20px; margin-right: 20px; width: 460px;">
                                    <!-- doctor details -->
                                    <div class="chain-row chain-row-item">
                                        <!-- summary -->
                                        <div class="chain-label chain-label-complete">
                                            <!-- Icon and heading -->
                                            <img class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/user.png" />
                                            <div class="hover chain-label-complete infoBoxLabel">Donor Details</div>

                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                
                                                <!-- form -->
                                                <b-form-group id="input-group-2" label="Surname:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="spermUseCase.donor.surname"
                                                    placeholder="Enter surname"
                                                    required
                                                    :readonly="selectedSubprocess.status != 'IN PROGRESS'"
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Firstname:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="spermUseCase.donor.firstname"
                                                    placeholder="Enter firstname"
                                                    required
                                                    :readonly="selectedSubprocess.status != 'IN PROGRESS'"
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Phone:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="spermUseCase.donor.phone"
                                                    placeholder="Enter phone number"
                                                    :readonly="selectedSubprocess.status != 'IN PROGRESS'"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Sprem Use Case Test 1.2 (1.2 Master NFT Creation)-->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='1.2' && template.TempData.contract.id =='c2968cb9-20f1-4820-9d7c-07975b39e8f6'">
                        <hr />

                        <!-- process wizard container -->
                        <div class="process-wizard-container">

                            <!-- process wizard progress summary -->
                            <div class="process-wizard-steps">
                                <table>
                                    <tbody>
                                        <tr v-for="(step, index) in NFT_wizard_steps" v-bind:key="step.id">
                                            <td class="process-wizard-step-icon-container">
                                                <div class="process-wizard-step-icon">
                                                    <div v-if="step.complete">
                                                        <span style="vertical-align: top; position: relative;">
                                                            <i class="fa-solid fa-circle" style="position: absolute; top: 5px; left: 0px; color: white;"></i>
                                                            <i class="fa-regular fa-circle-check" style="position: absolute; top: 5px; left: 0px; color: rgb(25, 135, 84);"></i>                                                            
                                                        </span>
                                                    </div>
                                                    <div v-else>
                                                        <span v-if="step.active" style="vertical-align: top; position: relative;">
                                                            <i class="fa-solid fa-circle" style="position: absolute; top: 5px; left: 0px; color: #3978d3;"></i>
                                                            <i class="fa-regular fa-circle" style="position: absolute; top: 5px; left: 0px; color: #033276;"></i>                                                            
                                                        </span>
                                                        <span v-else style="vertical-align: top; position: relative;">
                                                            <i class="fa-solid fa-circle" style="position: absolute; top: 5px; left: 0px; color: white;"></i>
                                                            <i class="fa-regular fa-circle" style="position: absolute; top: 5px; left: 0px; color: lightgrey;"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div v-if="index < NFT_wizard_steps.length -1 && step.complete" class="process-wizard-summary-link" style="border-right: 3px solid #00ad5b"></div>
                                                <div v-else-if="index < NFT_wizard_steps.length -1" class="process-wizard-summary-link"></div>
                                            </td>
                                            <td class="process-wizard-step-label" :class="step.active ? 'process-wizard-step-label-active' : ''">
                                                <span v-if="step.complete">{{  step.label }}</span> 
                                                <span v-else>{{  step.label }}</span>
                                                <br/><br/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- process wizard steps -->
                            <div class="process-wizard-step-details">
                                <div v-for="step in NFT_wizard_steps" v-bind:key="step.id">
                                    <!-- step 1 -->
                                    <div v-if="step.id == 1 && step.active" class="process-wizard-step-step">
                                        <h5>{{ step.label }}</h5>
                                        <!-- <br /><br />
                                        A Master NFT will be minted on the Ethereum public blockchain and added to your LfeChain Wallet. -->
                                        <!-- <br /><br /> -->
                                        This Master NFT will comprise of the following meta data.

                                        <br /><br />

                                        <!-- QR Code and Meta Data -->
                                        <table>
                                            <tr>
                                                <!-- <td style="vertical-align: top;">
                                                    <img style="width: 250px;" src="../../assets/images/templateIcons/testIcons/qr-code-with-icon.png" />
                                                </td> -->
                                                <td style="vertical-align: top; padding-top: 10px; padding-left: 20px;">
                                                    <table>
                                                        <tr>
                                                            <td style="padding-right: 30px">
                                                                <strong>NFT Name</strong>
                                                            </td>
                                                            <td>
                                                                {{ selectedBlock.name }} - Master NFT
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 30px">
                                                                <strong>NFT ID</strong>
                                                            </td>
                                                            <td>
                                                                4137cc47-cd5b-41a2-95cb-79f044404c13
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 30px">
                                                                <strong>Contract Name</strong>
                                                            </td>
                                                            <td>
                                                                {{ selectedBlock.name }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 30px">
                                                                <strong>Contract ID</strong>
                                                            </td>
                                                            <td>
                                                                {{ selectedBlock.displayid }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 30px">
                                                                <strong>Donor Details</strong>
                                                            </td>
                                                            <td>
                                                                {{ spermUseCase.donor.surname }}, {{ spermUseCase.donor.firstname }}
                                                            </td>
                                                        </tr>                                                        
                                                        <!-- <tr>
                                                            <td><br /></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 30px">
                                                                <strong>LifeChain Wallet ID</strong>
                                                            </td>
                                                            <td>
                                                                ecdf06e8-79ce-4403-85bd-ef45f25bd3e4
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 30px">
                                                                <strong>MetaMask Account ID (Wallet)</strong>
                                                            </td>
                                                            <td>
                                                                0x3c2322E7785B5Ee920047e171Faa7864364097C7
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td><br /></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 30px">
                                                                <strong>Hash (SHA256)</strong>
                                                            </td>
                                                            <td>
                                                                0x20bca775634af763e967dcc30d488142a713b2581e83bd1806be1dacc7366e41
                                                            </td>
                                                        </tr> -->
                                                    </table>

                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                    <!-- step 2 -->
                                    <div v-if="step.id == 2 && step.active" class="process-wizard-step-step">
                                        <h5>{{ step.label }}</h5>
                                        <!-- <br /><br /> -->
                                        A Master NFT will now be minted on the Ethereum public blockchain (testnet)

                                        <br /><br />

                                        <!-- QR Code and Meta Data -->
                                        <table>
                                            <tr>
                                                <td style="vertical-align: top;">
                                                    <img style="width: 210px;" src="../../assets/images/templateIcons/testIcons/qr-code-with-icon.png" />
                                                </td>
                                                <td style="vertical-align: top; padding-top: 10px; padding-left: 20px;">
                                                    <table>
                                                        <tr>
                                                            <td style="padding-right: 30px">
                                                                <strong>LifeChain Wallet ID</strong><br/>ecdf06e8-79ce-4403-85bd-ef45f25bd3e4
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 30px">
                                                                <strong>MetaMask Account ID (Wallet)</strong><br/>0x3c2322E7785B5Ee920047e171Faa7864364097C7
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td><br /></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding-right: 30px">
                                                                <strong>Hash (SHA256)</strong><br />0x20bca775634af763e967dcc30d488142a713b2581e83bd1806be1dacc7366e41
                                                            </td>
                                                        </tr>
                                                    </table>

                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                    <!-- step 3 -->
                                    <div v-if="step.id == 3 && step.active" class="process-wizard-step-step">
                                        <h5>{{ step.label }}</h5>
                                        <!-- <br /><br /> -->

                                        <div v-if="step.active && !step.complete">
                                            Transfer <strong>NFT & AI Test Contract 2 - Master NFT</strong> to <strong>Simon McAloon's</strong> LfeChain Wallet.
                                        </div>

                                        <div v-if="step.active && step.complete" style="text-align: center; padding-top: 40px;">
                                            <img style="width: 130px;" src="../../assets/images/templateIcons/testIcons/shield-tick.png" />
                                            <br /><br />
                                            <div>
                                                <strong>NFT & AI Test Contract 2 - Master NFT</strong> has been successfully minted on the Ethereum public blockchain <br/> and transferd to <strong>Simon McAloon's</strong> LfeChain Wallet.
                                            </div>
                                        </div>

                                        <br /><br />
                                    </div>

                                </div>

                                <br /><br />

                                <!-- process wizard footer (action buttons)-->
                                <div class="process-wizard-footer">
                                    <button type="button" @click="NFT_wizard_button('back')" class="btn btn-secondary btn-sm" style="float: left;">
                                        <i class="fa-solid fa-chevron-left"></i><span style="padding-left: 10px;">Back</span>
                                    </button> 

                                    <button v-if="!NFT_wizard_complete" type="button" @click="NFT_wizard_button('forward')" class="btn btn-primary btn-sm" style="float: right;"
                                        :disabled="NFT_wizard_loading">
                                        <span v-if="NFT_wizard_loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>                                    
                                        Next<span style="padding-left: 10px;"><i class="fa-solid fa-chevron-right"></i></span>
                                    </button>

                                    <button v-else-if="NFT_wizard_complete && current_NFT_wizard_step !==3" type="button" @click="NFT_wizard_button('forward')" class="btn btn-primary btn-sm" style="float: right;"
                                        :disabled="NFT_wizard_loading">
                                        <span v-if="NFT_wizard_loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>                                    
                                        Next<span style="padding-left: 10px;"><i class="fa-solid fa-chevron-right"></i></span>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!-- Sprem Use Case Test 4.1 (1.2 Package Selection)-->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='4.1' && template.TempData.contract.id =='c2968cb9-20f1-4820-9d7c-07975b39e8f6'">
                        <hr />

                        <ML2 ref="ml2"/>

                    </div> 

                    <!-- ----------------------- -->
                    <!-- SSI Samples Template -- -->
                    <!-- ----------------------- -->
                    <!-- 1.1 ID Generation ----- -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='1.1' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79970'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            <b-input-group prepend="Sample ID" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_sample_1_1.sampleID" size="sm" disabled="disabled"></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Master" size="sm">                                
                                <b-form-select v-model="ssi_sample_1_1.bullID" :options="ssi_masterIDs" size="sm" @input="ssiCheckSelectValue()"></b-form-select>
                            </b-input-group>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <strong style="margin-bottom: 10px;">Sample</strong>
                            <b-input-group prepend="Sample ID" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_sample_1_1.sampleID" size="sm" disabled="disabled"></b-form-input>
                            </b-input-group>

                            <div>
                                <qrcode-vue :value="ssi_sample_1_1.sampleID" :size="100" level="H"></qrcode-vue>
                            </div>
                            <br />
                            <strong style="margin-bottom: 10px;">Master</strong>
                            <b-input-group prepend="Master" size="sm">                                
                                <b-form-select v-model="ssi_sample_1_1.bullID" :options="ssi_masterIDs" size="sm" disabled="disabled"></b-form-select>
                            </b-input-group>
                            <br />
                            <strong style="margin-bottom: 10px;">Breed</strong>
                            <b-input-group prepend="Breed" size="sm">                                
                                <b-form-input v-model="ssi_sample_1_1.breed" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <br />
                            <div>
                                <qrcode-vue :value="'https://www.selectsires.com/bull-pages?naab=' + ssi_sample_1_1.bullID" :size="100" level="H"></qrcode-vue>
                            </div>
                            <a :href="'https://www.selectsires.com/bull-pages?naab=' + ssi_sample_1_1.bullID" target="_blank">Link to Original Sire</a>
                        </div>
                    </div>
                    <!-- 2.1 Register LifeLink Transport Storage Device -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='2.1' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79970'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px; ">
                            <strong style="margin-bottom: 10px;">Transport Details</strong>
                            <b-input-group size="sm" style="padding-bottom: 10px; min-width:200px !important;">
                                <b-input-group-prepend is-text>Transport Device</b-input-group-prepend>
                                <b-form-select v-model="ssi_sample_2_1.transportDeviceID" :options="transportDeviceIDs" @input="ssiCheckSelectValue()"></b-form-select>
                                <b-input-group-prepend is-text>Trip</b-input-group-prepend>
                                <date-picker v-model="ssi_sample_2_1.tripID" type="date" valueType="x" :strictMode="true" :multiple="false" :disabled-date="setTimePickerAvailableDates" @input="ssiCheckSelectValue()"></date-picker>
                            </b-input-group>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <strong style="margin-bottom: 10px;">Transport Details</strong>
                            <b-input-group size="sm" style="padding-bottom: 10px; min-width:200px !important;">
                                <b-input-group-prepend is-text>Transport Device</b-input-group-prepend>
                                <b-form-select v-model="ssi_sample_2_1.transportDeviceID" :options="transportDeviceIDs" disabled></b-form-select>
                                <b-input-group-prepend is-text>Trip</b-input-group-prepend>
                                <date-picker v-model="ssi_sample_2_1.tripID" type="date" valueType="x" :strictMode="true" :multiple="false" :disabled-date="setTimePickerAvailableDates" disabled></date-picker>
                            </b-input-group>
                        </div>
                    </div>
                    <!-- 2.2 Track and Trace -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='2.2' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79970'">
                        <hr />
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <div>
                                <h3>Transport Report</h3>
                                <iframe :src="ssi_sample_2_2_pdf_URL" width="100%" height="600px"></iframe>
                            </div>
                        </div>
                    </div>
                    <!-- 3.1 Extender -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.1' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79970'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            <b-input-group prepend="Extender Details" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_sample_3_1.extender_details" size="sm"></b-form-input>
                            </b-input-group>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <b-input-group prepend="Extender Details" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_sample_3_1.extender_details" size="sm" disabled="disabled"></b-form-input>
                            </b-input-group>
                        </div>
                    </div>
                    <!-- 3.2 Sperm Assessment -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.2' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79970'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">

                            <OCR ref="OCR" />
                            <br />
                            <b-form-checkbox
                                id="ssi_sperm_assessed_checkbox"
                                v-model="ssi_sample_3_2.ssi_sperm_assessed"
                                name="sperm-assessed-checkbox"
                                value="accepted"
                                unchecked-value="not_accepted">Sperm Assessed
                            </b-form-checkbox>
                            Assessed by
                            <b-form-input v-model="selectedBlock.User" disabled size="sm"></b-form-input>

                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">               
                            <strong style="padding-bottom: 10px;">Fresh Sperm Assessment</strong>
                            <b-table :items="ssi_sample_3_2.sperm_assessment" :fields="ssiSpermAssessmentFields"><template #cell(DateAnalysed)="cell">{{getFormattedDate(cell.item.DateAnalysed)}}</template></b-table>

                            <b-form-checkbox
                                id="ssi_sperm_assessed_checkbox"
                                v-model="ssi_sample_3_2.ssi_sperm_assessed"
                                name="sperm-assessed-checkbox"
                                value="accepted"
                                unchecked-value="not_accepted"
                                disabled="disabled"
                                style="padding-bottom: 10px;">Sperm Assessed
                            </b-form-checkbox>
                            Assessed by
                            <b-form-input v-model="selectedBlock.User" disabled size="sm"></b-form-input>
                            <br /><br />
                            <div>
                                <strong style="padding-bottom: 10px;">Fresh Sperm Assessment - Report</strong>
                                <VuePdfEmbed :source="ssi_sample_3_2_pdf_URL" style="max-width: 70%; max-height: 50%;" />
                            </div>
                        </div>
                    </div>
                    <!-- 3.3 Extender Added -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.3' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79970'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            <b-form-checkbox
                                id="ssi_extender_added_checkbox"
                                v-model="ssi_sample_3_3.ssi_extender_added"
                                name="extender-added-checkbox"
                                value="accepted"
                                unchecked-value="not_accepted">Extender added
                            </b-form-checkbox>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <b-form-checkbox
                                id="ssi_extender_added_checkbox"
                                v-model="ssi_sample_3_3.ssi_extender_added"
                                name="extender-added-checkbox"
                                value="accepted"
                                unchecked-value="not_accepted"
                                disabled="disabled">Extender added
                            </b-form-checkbox>
                        </div>
                    </div>
                    <!-- 3.4 Packaging Assignment -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.4' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79970'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">

                            <b-form-group label-cols-lg="3"
                                label="Packaging Details"
                                label-size="sm"
                                label-class="font-weight-bold pt-0"
                                class="mb-3">
                                    <b-form-group
                                        label="0.25ml Straw:"
                                        label-for="025-package-quantity-input"
                                        label-cols-sm="3"
                                        label-align-sm="right">
                                        <div style="display: block">
                                            <div style="position: relative; float: left;"><b-form-input id="025-package-quantity-input" type="number" min="0" max="1000" v-model="ssi_sample_3_4._025_packagingQuantity" style="max-width: 90%;"></b-form-input></div>
                                            <div style="position: relative; float: left;"><img src="../../assets/images/templateIcons/testIcons/package_small.png" style="width: 50px; margin-top: -4px;"></div>
                                        </div>
                                    </b-form-group>
                                    <b-form-group
                                        label="0.5ml Straw:"
                                        label-for="05-package-quantity-input"
                                        label-cols-sm="3"
                                        label-align-sm="right">
                                        <div style="display: block">
                                            <div style="position: relative; float: left;"><b-form-input id="05-package-quantity-input" type="number" min="0" max="1000" v-model="ssi_sample_3_4._05_packagingQuantity" style="max-width: 90%;"></b-form-input></div>
                                            <div style="position: relative; float: left;"><img src="../../assets/images/templateIcons/testIcons/package.png" style="width: 50px; margin-top: -4px;"></div>
                                        </div>
                                    </b-form-group>
                                    <b-form-group
                                        label="Vitrafy Smart Packaging:"
                                        label-for="smart-package-quantity-input"
                                        label-cols-sm="3"
                                        label-align-sm="right">
                                        <div style="display: block">
                                            <div style="position: relative; float: left;"><b-form-input id="smart-package-quantity-input" type="number" min="0" max="1000" v-model="ssi_sample_3_4.smart_packagingQuantity" style="max-width: 90%;"></b-form-input></div>
                                            <div style="position: relative; float: left;"><img src="../../assets/images/templateIcons/testIcons/qr-icon.png" style="width: 30px; margin-left: 10px; margin-top: 4px;"></div>
                                        </div>
                                    </b-form-group>
                            </b-form-group>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <b-form-group label-cols-lg="1"
                                label="Packaging Details"
                                label-size="sm"
                                label-class="font-weight-bold pt-0"
                                class="mb-1">
                                    <b-form-group
                                        :label="ssi_packaging_types[0] +':'"
                                        label-for="025-package-quantity-input"
                                        label-cols-sm="2"
                                        label-align-sm="right">
                                        <div style="display: block">
                                            <div style="position: relative; float: left;"><b-form-input id="025-package-quantity-input" type="number" min="0" max="1000" v-model="ssi_sample_3_4._025_packagingQuantity" style="max-width: 90%;" disabled></b-form-input></div>
                                            <div style="position: relative; float: left;"><img src="../../assets/images/templateIcons/testIcons/package_small.png" style="width: 50px; margin-top: -4px;"></div>
                                        </div>
                                    </b-form-group>
                                    <b-form-group
                                        :label="ssi_packaging_types[1] +':'"
                                        label-for="05-package-quantity-input"
                                        label-cols-sm="2"
                                        label-align-sm="right">
                                        <div style="display: block">
                                            <div style="position: relative; float: left;"><b-form-input id="05-package-quantity-input" type="number" min="0" max="1000" v-model="ssi_sample_3_4._05_packagingQuantity" style="max-width: 90%;" disabled></b-form-input></div>
                                            <div style="position: relative; float: left;"><img src="../../assets/images/templateIcons/testIcons/package.png" style="width: 50px; margin-top: -4px;"></div>
                                        </div>
                                    </b-form-group>
                                    <b-form-group
                                        :label="ssi_packaging_types[2] +':'"
                                        label-for="smart-package-quantity-input"
                                        label-cols-sm="2"
                                        label-align-sm="right">
                                        <div style="display: block">
                                            <div style="position: relative; float: left;"><b-form-input id="smart-package-quantity-input" type="number" min="0" max="1000" v-model="ssi_sample_3_4.smart_packagingQuantity" style="max-width: 90%;" disabled></b-form-input></div>
                                            <div style="position: relative; float: left;"><img src="../../assets/images/templateIcons/testIcons/qr-icon.png" style="width: 30px; margin-left: 10px; margin-top: 4px;"></div>
                                        </div>
                                    </b-form-group>
                            </b-form-group>
                        </div>
                    </div>
                    <!-- 3.5 Package Filling and Sealing -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.5' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79970'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            <b-form-checkbox
                                id="ssi_packages_filled_checkbox"
                                v-model="ssi_sample_3_5.packages_filled"
                                name="packages_filled_checkbox"
                                value="accepted"
                                unchecked-value="not_accepted">Packages Filled
                            </b-form-checkbox>
                            <b-form-checkbox
                                id="ssi_packages_sealed_checkbox"
                                v-model="ssi_sample_3_5.packages_sealed"
                                name="packages_sealed_checkbox"
                                value="accepted"
                                unchecked-value="not_accepted">Packages Sealed
                            </b-form-checkbox>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <b-form-checkbox
                                id="ssi_packages_filled_checkbox"
                                v-model="ssi_sample_3_5.packages_filled"
                                name="packages_filled_checkbox"
                                value="accepted"
                                unchecked-value="not_accepted"
                                disabled>Packages Filled
                            </b-form-checkbox>
                            <b-form-checkbox
                                id="ssi_packages_sealed_checkbox"
                                v-model="ssi_sample_3_5.packages_sealed"
                                name="packages_sealed_checkbox"
                                value="accepted"
                                unchecked-value="not_accepted"
                                disabled>Packages Sealed
                            </b-form-checkbox>
                        </div>
                    </div>
                    <!-- 4.1 Active Package Tracking -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='4.1' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79970'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            <h4 style="padding-bottom: 10px;">Active Stacked Contracts</h4>
                            <b-table id="bovineActiveStackedItemsTable" class="clickable indented-table" hover responive="sm"
                                :items="selectedBlock.stackedItems"
                                :fields="bovineStackedTrackingTableFields">
                                <!-- <template v-slot:head(select)="data"><b-form-checkbox v-model="bovineStackedContractsTrackingSelectAll" :disabled="!selectedBlock.stackedItems.some(stackedItem => stackedItem.State < parseFloat('2.2') || stackedItem.State == '1.1' || stackedItem.State == '2.1' || stackedItem.NextState == '2.2')"></b-form-checkbox></template>
                                    <template v-slot:cell(select)="data"><b-form-checkbox v-model="data.item.selected" :disabled="!selectedBlock.stackedItems.some(stackedItem => stackedItem.State < parseFloat('2.2') || stackedItem.State == '1.1' || stackedItem.State == '2.1' || stackedItem.NextState == '2.2')"></b-form-checkbox></template> -->
                                    <template v-slot:head(select)="data"><b-form-checkbox v-model="bovineStackedContractsTrackingSelectAll"></b-form-checkbox></template>
                                    <template v-slot:cell(select)="data"><b-form-checkbox v-model="data.item.selected"></b-form-checkbox></template>
                                    <template #cell(contractname)="cell">
                                        <img v-if="(initialWorldState.filter(contract => contract.ID == cell.item.ID && contract.State == '1.1')[0].TempData.ProcessData.packageType == ssi_packaging_types[0])" src="../../assets/images/templateIcons/testIcons/package_small.png" style="width: 24px; margin-right: 10px;" v-b-popover.hover.top="initialWorldState.filter(contract => contract.ID == cell.item.ID && contract.State == '1.1')[0].TempData.ProcessData.packageType">
                                        <img v-else-if="(initialWorldState.filter(contract => contract.ID == cell.item.ID && contract.State == '1.1')[0].TempData.ProcessData.packageType == ssi_packaging_types[1])" src="../../assets/images/templateIcons/testIcons/package.png" style="width: 24px; margin-right: 10px;" v-b-popover.hover.top="initialWorldState.filter(contract => contract.ID == cell.item.ID && contract.State == '1.1')[0].TempData.ProcessData.packageType">
                                        <img v-else src="../../assets/images/templateIcons/testIcons/qr-icon.png" style="width: 16px; margin-right: 10px;" v-b-popover.hover.top="initialWorldState.filter(contract => contract.ID == cell.item.ID && contract.State == '1.1')[0].TempData.ProcessData.packageType">
                                        <a href="" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{ cell.item.name.substring(cell.item.name.indexOf('Package ID-'), cell.item.name.length) }}</a> <!--<span v-if="isNewRow(!cell.item.TimeStampEpoch ? cell.item.item.TimeStampEpoch -1000: cell.item.TimeStampEpoch -1000)"><sup><b-badge pill variant="info" style="font-style: .5em;">New</b-badge></sup></span>-->
                                    </template>
                                    <template #cell(contracttype)="cell" style="vertical-align: top;"> {{ getTemplateName(cell.item.TempData.TemplateID) }} </template>
                                    <template #cell(contractapplication)="cell" style="vertical-align: top;"> {{ cell.item.TempData.Application }} </template>
                                    <!-- <template #cell(contractcreated)="cell" style="vertical-align: top;"> {{ cell.item.TimeStamp }} </template> -->
                                    <template #cell(contractdatetime)="cell" style="vertical-align: top;"> {{ getRelativeDate(cell.item.TimeStampEpochUpdated) }}</template>
                                    <template #cell(contractstate)="cell" style="vertical-align: top;"><b-badge pill variant="primary">{{ cell.item.nextState }} {{ cell.item.nextStateName }} </b-badge></template>
                                    <template #cell(contractprogress)="cell" class="chart" Style="width:30%; vertical-align: middle;">
                                        <div class="progress">
                                            <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: cell.item.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                            </div>
                                        </div>
                                        <div style="font-size: 10px; color: grey;">{{ cell.item.stateProgress }} %</div>
                                    </template>
                            </b-table>
                            
                            <b-button variant="success" size="sm" 
                                :disabled="(/*(!bovineStackedContractsTrackingSelectAll) || */(!selectedBlock.stackedItems.some(item => item.selected)))"
                                @click="showBovineCryoPacketsModal">Cryopreserve Selection
                            </b-button>

                            <b-modal ref="bovine-cryo-stacked-packets-modal" hide-footer title="Cryopreserve Selected Packets">
                                <div class="d-block" style="padding-bottom: 15px;">
                                    <b-input-group prepend="Cryopreservation Device" size="sm" style="padding-bottom: 10px;">
                                        <b-form-select v-model="ssi_package_2_2.cryopreservation_device" :options="vitrafy_devices" size="sm"></b-form-select>
                                        <b-input-group-prepend is-text>Batch ID</b-input-group-prepend>
                                        <b-form-input v-model="ssi_package_2_2.batch_id" size="sm"></b-form-input>
                                    </b-input-group>
                                    <b-form-checkbox
                                        id="ssi_package_cryo_completed_checkbox"
                                        v-model="ssi_package_2_2.cryopreservation_completed"
                                        name="ssi_package_cryo_completed_checkbox"
                                        value="accepted"
                                        unchecked-value="not_accepted"
                                        >Vitrafy Cryopreservation Completed
                                    </b-form-checkbox>
                                </div>
                                <b-button variant="success" size="sm"
                                    @click="completeCryoPreservedSelectedStackedPackets"
                                    :disabled="(ssi_package_2_2.cryopreservation_completed == 'not_accepted' || ssi_package_2_2.cryopreservation_completed == undefined)">Complete Cryopreservation
                                </b-button>
                            </b-modal>
                            <!-- <b-modal ref="bovine-thaw-stacked-packets-modal" hide-footer title="BioThaw Selected Packets">
                                <div class="d-block" style="padding-bottom: 15px;">
                                    <b-input-group prepend="BioThaw Device" size="sm" style="padding-bottom: 10px;">
                                        <b-form-select v-model="ssi_package_2_2.cryopreservation_device" :options="vitrafy_biothaw_devices" size="sm"></b-form-select>
                                        <b-input-group-prepend is-text>Batch ID</b-input-group-prepend>
                                        <b-form-input v-model="ssi_package_2_2.batch_id" size="sm"></b-form-input>
                                    </b-input-group>
                                    <b-form-checkbox
                                        id="ssi_package_cryo_completed_checkbox"
                                        v-model="ssi_package_2_2.cryopreservation_completed"
                                        name="ssi_package_cryo_completed_checkbox"
                                        value="accepted"
                                        unchecked-value="not_accepted"
                                        >Vitrafy Cryopreservation Completed
                                    </b-form-checkbox>
                                </div>
                                <b-button variant="success" size="sm"
                                    @click="completeCryoPreservedSelectedStackedPackets"
                                    :disabled="(ssi_package_2_2.cryopreservation_completed == 'not_accepted' || ssi_package_2_2.cryopreservation_completed == undefined)">Complete Cryopreservation
                                </b-button>
                            </b-modal> -->
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <h4 style="padding-bottom: 10px;">Completed Stacked Contracts</h4>
                            <b-table id="bovineActiveStackedItemsTable" class="clickable" hover responive="sm"
                                :items="selectedBlock.stackedItems"
                                :fields="bovineStackedTrackingTableFields">
                                    <template #cell(contractname)="cell">
                                        <img v-if="(initialWorldState.filter(contract => contract.ID == cell.item.ID && contract.State == '1.1')[0].TempData.ProcessData.packageType == ssi_packaging_types[0])" src="../../assets/images/templateIcons/testIcons/package_small.png" style="width: 24px; margin-right: 10px;" v-b-popover.hover.top="initialWorldState.filter(contract => contract.ID == cell.item.ID && contract.State == '1.1')[0].TempData.ProcessData.packageType">
                                        <img v-else-if="(initialWorldState.filter(contract => contract.ID == cell.item.ID && contract.State == '1.1')[0].TempData.ProcessData.packageType == ssi_packaging_types[1])" src="../../assets/images/templateIcons/testIcons/package.png" style="width: 24px; margin-right: 10px;" v-b-popover.hover.top="initialWorldState.filter(contract => contract.ID == cell.item.ID && contract.State == '1.1')[0].TempData.ProcessData.packageType">
                                        <img v-else src="../../assets/images/templateIcons/testIcons/qr-icon.png" style="width: 16px; margin-right: 10px;" v-b-popover.hover.top="initialWorldState.filter(contract => contract.ID == cell.item.ID && contract.State == '1.1')[0].TempData.ProcessData.packageType">
                                        <a href="" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{ cell.item.name.substring(cell.item.name.indexOf('Package ID-'), cell.item.name.length) }}</a><!--<span v-if="isNewRow(!cell.item.TimeStampEpoch ? cell.item.item.TimeStampEpoch -1000: cell.item.TimeStampEpoch -1000)"><sup><b-badge pill variant="info" style="font-style: .5em;">New</b-badge></sup></span>-->
                                    </template>
                                    <template #cell(contracttype)="cell" style="vertical-align: top;"> {{ getTemplateName(cell.item.TempData.TemplateID) }} </template>
                                    <template #cell(contractapplication)="cell" style="vertical-align: top;"> {{ cell.item.TempData.Application }} </template>
                                    <!-- <template #cell(contractcreated)="cell" style="vertical-align: top;"> {{ cell.item.TimeStamp }} </template> -->
                                    <template #cell(contractdatetime)="cell" style="vertical-align: top;"> {{ getRelativeDate(cell.item.TimeStampEpochUpdated) }} </template>
                                    <template #cell(contractstate)="cell" style="vertical-align: top;"><b-badge pill variant="primary">{{ cell.item.nextState }} {{ cell.item.nextStateName }} </b-badge></template>
                                    <template #cell(contractprogress)="cell" class="chart" Style="width:30%; vertical-align: middle;">
                                        <div class="progress">
                                            <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: cell.item.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                            </div>
                                        </div>
                                        <div style="font-size: 10px; color: grey;">{{ cell.item.stateProgress }} %</div>
                                    </template>
                            </b-table>
                        </div>
                    </div>

                    <!-- ----------------------- -->
                    <!-- SSI Package Template -- -->
                    <!-- ----------------------- -->
                    <!-- 1.1 ID Generation ----- -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='1.1' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79975'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <strong style="margin-bottom: 10px;">Package</strong>
                            <b-input-group prepend="Sample ID" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_1_1.packageID" size="sm" disabled="disabled"></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Master" size="sm" style="padding-bottom: 10px;">                                
                                <b-form-input v-model="ssi_package_1_1.masterID" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Package Type" size="sm" style="padding-bottom: 10px;">                                
                                <b-form-input v-model="ssi_package_1_1.packageType" size="sm" disabled></b-form-input>
                            </b-input-group>
                        </div>
                    </div>
                    <!-- 2.1 Algorithm and MOC ----- -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='2.1' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79975'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            <div style="margin-bottom: 10px;"><strong>Algorithm and Machine Operating Conditions</strong></div>
                            <b-input-group prepend="Algorithm" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_1.algorithm" size="sm"></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Machine Operating Conditions" size="sm" style="padding-bottom: 10px;">
                                <b-input-group-prepend is-text>Temperature (°C)</b-input-group-prepend>
                                <b-form-input v-model="ssi_package_2_1.moc.temp" type="number" min="-80" max="60" size="sm"></b-form-input>
                                <b-input-group-prepend is-text>Flow (L/min)</b-input-group-prepend>
                                <b-form-input v-model="ssi_package_2_1.moc.flow" type="number" min="0" max="100" size="sm"></b-form-input>
                                <b-input-group-prepend is-text>Time (Seconds)</b-input-group-prepend>
                                <b-form-input v-model="ssi_sample_2_1.moc.time" type="number" min="0" max="180" size="sm"></b-form-input>
                            </b-input-group>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <strong style="margin-bottom: 10px;">Algorithm and Machine Operating Conditions</strong>
                            <b-input-group prepend="Algorithm" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_1.algorithm" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Machine Operating Conditions" size="sm" style="padding-bottom: 10px;">
                                <b-input-group-prepend is-text>Temperature (°C)</b-input-group-prepend>
                                <b-form-input v-model="ssi_package_2_1.moc.temp" type="number" min="-80" max="60" size="sm" disabled></b-form-input>
                                <b-input-group-prepend is-text>Flow (L/min)</b-input-group-prepend>
                                <b-form-input v-model="ssi_package_2_1.moc.flow" type="number" min="0" max="100" size="sm" disabled></b-form-input>
                                <b-input-group-prepend is-text>Time (Seconds)</b-input-group-prepend>
                                <b-form-input v-model="ssi_package_2_1.moc.time" type="number" min="0" max="180" size="sm" disabled></b-form-input>
                            </b-input-group>
                        </div>
                    </div>
                    <!-- 2.2 Vitrafy Cryopreservation ----- -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='2.2' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79975'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            <b-input-group prepend="Cryopreservation Device" size="sm" style="padding-bottom: 10px;">
                                <b-form-select v-model="ssi_package_2_2.cryopreservation_device" :options="vitrafy_devices" size="sm"></b-form-select>
                                <b-input-group-prepend is-text>Batch ID</b-input-group-prepend>
                                <b-form-input v-model="ssi_package_2_2.batch_id" size="sm"></b-form-input>
                            </b-input-group>
                            <b-form-checkbox
                                id="ssi_package_cryo_completed_checkbox"
                                v-model="ssi_package_2_2.cryopreservation_completed"
                                name="ssi_package_cryo_completed_checkbox"
                                value="accepted"
                                unchecked-value="not_accepted"
                                >Vitrafy Cryopreservation Completed
                            </b-form-checkbox>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <b-input-group prepend="Cryopreservation Device" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_2.cryopreservation_device" size="sm" disabled></b-form-input>
                                <b-input-group-prepend is-text>Batch ID</b-input-group-prepend>
                                <b-form-input v-model="ssi_package_2_2.batch_id" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-form-checkbox
                                id="ssi_package_cryo_completed_checkbox"
                                v-model="ssi_package_2_2.cryopreservation_completed"
                                name="ssi_package_cryo_completed_checkbox"
                                value="accepted"
                                unchecked-value="not_accepted"
                                disabled>Vitrafy Cryopreservation Completed
                            </b-form-checkbox>
                            <hr />
                            <h3 style="padding-bottom:10px;">Cryopreservation Details</h3>
                            <b-input-group prepend="Protocol" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_2.moc.Protocol" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Product" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_2.moc['Product']" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Start Time" size="sm" style="padding-bottom: 10px;">
                                <b-form-input :value="new Date(ssi_package_2_2.moc.Started).toString()" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="End Time" size="sm" style="padding-bottom: 10px;">
                                <b-form-input :value="new Date(ssi_package_2_2.moc.Finished).toString()" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Temperature (°C)" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_2.moc.tempSetpoint" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Temp Tolerance (°C)" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_2.moc.tempTolerance" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Flow (L/min)" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_2.moc.flowSetpoint" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Flow Tolerance (L/min)" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_2.moc.flowTolerance" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Start Temp (°C)" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_2.moc.startTemp" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="End Temp (°C)" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_2.moc.endTemp" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Start Flow (L/min)" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_2.moc.startFlow" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="End Flow (L/min)" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_2.moc.endFlow" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Min Temp (°C)" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_2.moc.minTemp" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Max Temp (°C)" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_2.moc.maxTemp" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Min Flow (L/min)" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_2.moc.minFlow" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Max Flow (L/min)" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_2_2.moc.maxFlow" size="sm" disabled></b-form-input>
                            </b-input-group>
                        </div>
                    </div>
                    <!-- 3.1 Vitrafy Cryopreservation ----- -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.1' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79975'">
                        <hr />

                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            <b-form-checkbox
                                id="checkbox-1"
                                v-model="ssi_package_3_1.removed_from_storage"
                                name="checkbox-1"
                                value="accepted"
                                unchecked-value="not_accepted"
                                >
                                Removed from storage 
                            </b-form-checkbox>

                            <br />
                            Removed by
                            <b-form-input v-model="ssi_package_3_1.removed_from_storage_by" disabled size="sm"></b-form-input>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <b-form-checkbox
                                id="checkbox-1"
                                v-model="ssi_package_3_1.removed_from_storage"
                                name="checkbox-1"
                                value="accepted"
                                unchecked-value="not_accepted"
                                disabled
                                >
                                Removed from storage 
                            </b-form-checkbox>
                            
                            <br />
                            Removed by
                            <b-form-input v-model="ssi_package_3_1.removed_from_storage_by" disabled size="sm"></b-form-input>
                        </div>
                    </div>
                    <!-- 4.1 Identification Package Check ----- -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='4.1' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79975'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">                                                        
                            
                            <b-form-checkbox
                                id="ssi_package_4_1_identification_package_checked"
                                v-model="ssi_package_4_1.identification_package_checked"
                                name="ssi_package_4_1_identification_package_checked"
                                ref="ssi_package_4_1_identification_package_checked_ref"
                                value="accepted"
                                unchecked-value="not_accepted"
                                >
                                Identification package checked and matches ID
                            </b-form-checkbox>
                            <div style="display: block">
                                <div style="position: relative; float: left; max-width: 80%;">
                                    <b-form-input id="ssi_package_4_1_identification_package_id" v-model="ssi_package_4_1.identification_package_id" @input.native="checkIdentificationPackageBovine()" placeholder="Scan or enter package ID"></b-form-input>
                                </div>
                                <!-- <div style="position: relative; float: left; max-width:100px; display: none;">
                                    <StreamBarcodeReader @decode="onDecodeQR" @loaded="onLoadedQR"></StreamBarcodeReader>
                                    <p class="decode-result">Last result: <b>{{ qr_result }}</b></p>
                                </div> -->
                            </div>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <b-form-checkbox
                                id="checkbox-1"
                                v-model="ssi_package_4_1.identification_package_checked"
                                name="checkbox-1"
                                value="accepted"
                                unchecked-value="not_accepted"
                                disabled
                                >
                                Identification package checked and matches ID
                            </b-form-checkbox>
                            <b-form-input v-model="ssi_package_4_1.identification_package_id" disabled></b-form-input>
                        </div>   
                    </div>
                    <!-- 4.2 Algorithm and MOC ----- -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='4.2' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79975'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">                                                        
                            
                            <div style="margin-bottom: 10px;"><strong>Algorithm and Machine Operating Conditions</strong></div>
                            <b-input-group prepend="Algorithm" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_4_2.algorithm" size="sm"></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Machine Operating Conditions" size="sm" style="padding-bottom: 10px;">
                                <b-input-group-prepend is-text>Temperature (°C)</b-input-group-prepend>
                                <b-form-input v-model="ssi_package_4_2.moc.temp" type="number" min="-80" max="60" size="sm"></b-form-input>
                                <b-input-group-prepend is-text>Flow (L/min)</b-input-group-prepend>
                                <b-form-input v-model="ssi_package_4_2.moc.flow" type="number" min="0" max="100" size="sm"></b-form-input>
                                <b-input-group-prepend is-text>Time (Seconds)</b-input-group-prepend>
                                <b-form-input v-model="ssi_package_4_2.moc.time" type="number" min="0" max="180" size="sm"></b-form-input>
                            </b-input-group>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <div style="margin-bottom: 10px;"><strong>Algorithm and Machine Operating Conditions</strong></div>
                            <b-input-group prepend="Algorithm" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="ssi_package_4_2.algorithm" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Machine Operating Conditions" size="sm" style="padding-bottom: 10px;">
                                <b-input-group-prepend is-text>Temperature (°C)</b-input-group-prepend>
                                <b-form-input v-model="ssi_package_4_2.moc.temp" type="number" min="-80" max="60" size="sm" disabled></b-form-input>
                                <b-input-group-prepend is-text>Flow (L/min)</b-input-group-prepend>
                                <b-form-input v-model="ssi_package_4_2.moc.flow" type="number" min="0" max="100" size="sm" disabled></b-form-input>
                                <b-input-group-prepend is-text>Time (Seconds)</b-input-group-prepend>
                                <b-form-input v-model="ssi_package_4_2.moc.time" type="number" min="0" max="180" size="sm" disabled></b-form-input>
                            </b-input-group>
                        </div> 
                    </div>
                    <!-- 4.3 Vitrafy BioThaw ----- -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='4.3' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79975'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">                                                        
                            <b-form-checkbox
                                id="checkbox-1"
                                v-model="ssi_package_4_3.thawing_completed"
                                name="checkbox-1"
                                value="accepted"
                                unchecked-value="not_accepted"
                                >
                                BioThaw Completed
                            </b-form-checkbox>
                            <strong>BioThaw Device</strong><br /> <b-form-select v-model="ssi_package_4_3.thawing_device" :options="vitrafy_biothaw_devices"></b-form-select>
                            
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <b-form-checkbox
                                id="checkbox-1"
                                v-model="ssi_package_4_3.thawing_completed"
                                name="checkbox-1"
                                value="accepted"
                                unchecked-value="not_accepted"
                                disabled
                                >
                                BioThaw Completed
                            </b-form-checkbox>
                            <strong>BioThaw Device</strong><br /> <b-form-input v-model="ssi_package_4_3.thawing_device" disabled></b-form-input>
                        </div>
                    </div>
                    <!-- 5.1 Sperm assessment ----- -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='5.1' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79975'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            <b-form-checkbox
                                id="ssi_sperm_assessed_checkbox"
                                v-model="ssi_package_5_1.ssi_sperm_assessed"
                                name="sperm-assessed-checkbox"
                                value="accepted"
                                unchecked-value="not_accepted">Sperm Assessed
                            </b-form-checkbox>
                            Assessed by
                            <b-form-input v-model="selectedBlock.User" disabled size="sm"></b-form-input>

                            <OCR ref="OCR" />

                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <strong>Fresh Sperm Assessment</strong>
                            <b-table :items="ssi_sample_3_2.sperm_assessment" :fields="ssiSpermAssessmentFields"><template #cell(DateAnalysed)="cell">{{getFormattedDate(cell.item.DateAnalysed)}}</template></b-table>
                            <strong>Initial Post-Thaw Sperm Assessment</strong>
                            <b-table :items="ssi_package_5_1.sperm_assessment" :fields="ssiSpermAssessmentFields"><template #cell(DateAnalysed)="cell">{{getFormattedDate(cell.item.DateAnalysed)}}</template></b-table>
                            <b-form-checkbox
                                id="ssi_sperm_assessed_checkbox"
                                v-model="ssi_package_5_1.ssi_sperm_assessed"
                                name="sperm-assessed-checkbox"
                                value="accepted"
                                unchecked-value="not_accepted"
                                disabled="disabled"
                                style="padding-bottom: 10px;">Sperm Assessed
                            </b-form-checkbox>
                            Assessed by
                            <b-form-input v-model="selectedBlock.User" disabled size="sm"></b-form-input>
                        </div>
                    </div>
                    <!-- 5.2 3 Hour Sperm assessment ----- -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='5.2' && template.TempData.contract.id =='7a976520-bae3-478e-a397-784354f79975'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            <b-form-checkbox
                                id="ssi_sperm_assessed_checkbox"
                                v-model="ssi_package_5_2.ssi_sperm_assessed"
                                name="sperm-assessed-checkbox"
                                value="accepted"
                                unchecked-value="not_accepted">Sperm Assessed
                            </b-form-checkbox>
                            Assessed by
                            <b-form-input v-model="selectedBlock.User" disabled size="sm"></b-form-input>

                            <OCR ref="OCR" />

                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <strong>Fresh Sperm Assessment</strong>
                            <b-table :items="ssi_sample_3_2.sperm_assessment" :fields="ssiSpermAssessmentFields"><template #cell(DateAnalysed)="cell">{{getFormattedDate(cell.item.DateAnalysed)}}</template></b-table>
                            <br />
                            <strong>Initial Post-Thaw Sperm Assessment</strong>
                            <b-table :items="ssi_package_5_1.sperm_assessment" :fields="ssiSpermAssessmentFields"><template #cell(DateAnalysed)="cell">{{getFormattedDate(cell.item.DateAnalysed)}}</template></b-table>
                            <br />
                            <strong>3 Hour Post-Thaw Sperm Assessment</strong>
                            <b-table :items="ssi_package_5_2.sperm_assessment" :fields="ssiSpermAssessmentFields"><template #cell(DateAnalysed)="cell">{{getFormattedDate(cell.item.DateAnalysed)}}</template></b-table>
                            <b-form-checkbox
                                id="ssi_sperm_assessed_checkbox"
                                v-model="ssi_package_5_2.ssi_sperm_assessed"
                                name="sperm-assessed-checkbox"
                                value="accepted"
                                unchecked-value="not_accepted"
                                disabled="disabled"
                                style="padding-bottom: 10px;">Sperm Assessed
                            </b-form-checkbox>
                            Assessed by
                            <b-form-input v-model="selectedBlock.User" disabled size="sm"></b-form-input>
                        </div>
                    </div>
                    
                    <!----- -------------------------------- --------->
                    <!----- Huon Female Fish (Master) Template ------->
                    <!----- -------------------------------- --------->
                    <!----- 1.1 ID Generation -------------- --------->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='1.1' && template.TempData.contract.id == aquacultureMasterFemaleTemplateID">
                        <hr />
                        <b-form-group
                                label-cols-lg="2"
                                label="Fish Details"
                                label-size="sm"
                                label-class="font-weight-bold pt-0"
                                class="mb-3">
                                <b-form-group
                                    label="Tag ID:"
                                    label-for="tag-id-input"
                                    label-cols-sm="12"
                                    label-align-sm="left">
                                    <b-form-input id="tag-id-input" v-model="huonFemaleMasterFish_1_1.tag_id" style="max-width: 30%;" disabled></b-form-input>
                                </b-form-group>
                                <b-form-group
                                    label="Year Class:"
                                    label-for="year-class-input"
                                    label-cols-sm="12"
                                    label-align-sm="left">
                                    <b-form-input id="year-class-input" type="number" min="2020" max="2030" v-model="huonFemaleMasterFish_1_1.year_class" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-input>
                                </b-form-group>
                                <b-form-group
                                    label="Facility:"
                                    label-for="facility-input"
                                    label-cols-sm="12"
                                    label-align-sm="left">
                                    <b-form-select id="facility-input"  v-model="huonFemaleMasterFish_1_1.facility" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')">
                                        <b-form-select-option v-for="site in huonHatcheries" v-bind:key="site.id" :value="site.title">{{site.title}}</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>
                                <b-form-group
                                    label="Tank:"
                                    label-for="facility-tank-input"
                                    label-cols-sm="12"
                                    label-align-sm="left">
                                    <b-form-input id="facility-tank-input"  v-model="huonFemaleMasterFish_1_1.tank" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-input>
                                </b-form-group>
                            </b-form-group>
                    </div>
                    <!----- 2.1 Ultrasound Results ----------- ------>
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='2.1' && template.TempData.contract.id == aquacultureMasterFemaleTemplateID">
                        <hr />
                        <b-form-group
                            label-cols-lg="2"
                            label="Ultrasound Results"
                            label-size="sm"
                            label-class="font-weight-bold pt-0"
                            class="mb-3">
                            <b-form-group
                                label="Comment:"
                                label-for="comment-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="comment-input" v-model="huonFemaleMasterFish_2_1.comment" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="Spawn Comment:"
                                label-for="spawn-comment-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="spawn-comment-input" v-model="huonFemaleMasterFish_2_1.spawn_comment" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="New Comment:"
                                label-for="new-comment-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="new-comment-input" v-model="huonFemaleMasterFish_2_1.new_comment" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="Weight (kg):"
                                label-for="weight-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="weight-input" type="number" min="0" max="50" v-model="huonFemaleMasterFish_2_1.weight" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="Ovaplant Liquid:"
                                label-for="ovaplant-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="ovaplant-input" v-model="huonFemaleMasterFish_2_1.ovaplant" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-input>
                            </b-form-group>
                        </b-form-group>
                    </div>
                    <!----- 3.1 Egg Esky Allocation ----------- ------>
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.1' && template.TempData.contract.id == aquacultureMasterFemaleTemplateID">
                        <hr />
                        <b-form-group
                            label-cols-lg="2"
                            label="Egg + Esky Allocation"
                            label-size="sm"
                            label-class="font-weight-bold pt-0"
                            class="mb-3">
                            <b-form-group
                                label="Egg Count (L):"
                                label-for="egg_count-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="egg_count-input" v-model="huonFemaleMasterFish_3_1.egg_count" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')" placeholder="Enter egg count (L)..."></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="Esky Number:"
                                label-for="esky-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="esky-input" v-model="huonFemaleMasterFish_3_1.esky_id" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')" placeholder="Scan or enter Esky Number..."></b-form-input>
                            </b-form-group>
                        </b-form-group>
                    </div>                    

                    <!----- -------------------------------- ------->
                    <!----- --- Huon Egg Batch Template ---- ------->
                    <!----- -------------------------------- ------->
                    <!----- ----- 1.1 ID Generation -------- ------->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='1.1' && template.TempData.contract.id == aquacultureEggBatchTemplateID">
                        <hr />
                        <b-form-group
                                label-cols-lg="2"
                                label="Egg Batch Details"
                                label-size="sm"
                                label-class="font-weight-bold pt-0"
                                class="mb-3">
                            <b-form-group
                                label="Fish Tag ID:"
                                label-for="tag-id-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="tag-id-input" v-model="huonEggBatch_1_1.master_tag_id" style="max-width: 30%;" disabled></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="Egg Count (L):"
                                label-for="egg_count-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="egg_count-input" v-model="huonEggBatch_1_1.egg_count" style="max-width: 30%;" disabled></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="Esky ID:"
                                label-for="esky-id-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="esky-id-input" v-model="huonEggBatch_1_1.esky_id" style="max-width: 30%;" disabled></b-form-input>
                            </b-form-group>
                        </b-form-group>
                    </div>

                    <!-- 2.1 Register LifeLink Transport Storage Device -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='2.1' && template.TempData.contract.id == aquacultureEggBatchTemplateID">
                        <hr />
                        <strong style="margin-bottom: 10px;">Transport Details</strong>
                        <b-input-group size="sm" style="padding-bottom: 10px; min-width:200px !important;">
                            <b-input-group-prepend is-text>Transport Device</b-input-group-prepend>
                            <b-form-select v-model="huonEggBatch_2_1.transportDeviceID" :options="transportDeviceIDs" :disabled="selectedSubprocess.status == 'COMPLETED'"></b-form-select>
                            <b-input-group-prepend is-text>Trip</b-input-group-prepend>
                            <date-picker v-model="huonEggBatch_2_1.tripID" type="date" valueType="x" :strictMode="true" :multiple="false" :disabled="selectedSubprocess.status == 'COMPLETED'"></date-picker>
                        </b-input-group>
                    </div>
                    <!-- 2.2 Track and Trace -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='2.2' && template.TempData.contract.id == aquacultureEggBatchTemplateID">
                        <hr />
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <div>
                                <h3>Transport Report</h3>
                                <iframe :src="huonEggBatch_2_2_pdf_URL" width="100%" height="600px"></iframe>
                            </div>
                        </div>
                    </div>
                    <!-- 3.1 Fertilisation Allocation -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.1' && template.TempData.contract.id == aquacultureEggBatchTemplateID">
                        <hr />
                        <h5>Fertilisation Run</h5>
                        <b-table
                            responsive="md"
                            head-variant="dark"
                            :items="huonEggBatch_3_1.fertilisation_run"
                            :fields="aquacultureFertilisationMastersTableFields"
                        >
                            <template #cell(attach)="cell"></template>
                            <template #cell(expand)="row"></template>
                            <template #cell(fertilisation)="cell"><i class='fa-solid fa-shuffle' style="padding-right: 10px; font-size: 1.3em; position: absolute; top: 10px;"></i><a href="" style="padding-left: 30px;" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{/*(cell.item.State == '0' ?*/cell.item.name/* : cell.item.TempData.ProcessData.fertilisation_run_id)*/}}</a></template>
                            <template #cell(facility)="cell">{{(cell.item.TempData.ProcessData == undefined ? '' : cell.item.TempData.ProcessData.facility)}}</template>
                            <template #cell(contractstate)="cell" style="vertical-align: top;"><b-badge pill variant="primary">{{ cell.item.nextState }} {{ cell.item.nextStateName }} </b-badge></template>
                            <template #cell(contractprogress)="cell" class="chart" Style="width:30%; vertical-align: middle;">
                                <div class="progress">
                                    <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: cell.item.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                    </div>
                                </div>
                                <div style="font-size: 10px; color: grey;">{{ cell.item.stateProgress }} %</div>
                            </template>
                        </b-table>
                    </div>

                    <!----- -------------------------------- ------->
                    <!----- - Huon Fertilisation Template -- ------->
                    <!----- -------------------------------- ------->
                    <!----- ----- 1.1 ID Generation -------- ------->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='1.1' && template.TempData.contract.id == aquacultureFertilisationTemplateID">
                        <hr />
                        <b-form-group
                                label-cols-lg="2"
                                label="Fertilisation Details"
                                label-size="sm"
                                label-class="font-weight-bold pt-0"
                                class="mb-3">
                            <b-form-group
                                label="Facility:"
                                label-for="facility-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-select id="facility-input"  v-model="huonFertilisation_1_1.facility" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')">
                                    <b-form-select-option v-for="site in huonHatcheries" v-bind:key="site.id" :value="site.title">{{site.title}}</b-form-select-option>
                                </b-form-select>
                            </b-form-group>
                            <b-form-group
                                label="Date:"
                                label-for="date-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <date-picker  id="date-input"  v-model="huonFertilisation_1_1.date" type="date" valueType="x" :strictMode="true" :multiple="false" :disabled="selectedSubprocess.status == 'COMPLETED'"></date-picker>
                            </b-form-group>
                        </b-form-group>
                    </div>
                    <!----- - 2.1 Egg and Milt Allocation -- ------->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='2.1' && template.TempData.contract.id == aquacultureFertilisationTemplateID">
                        <hr />
                        <h3>Fertilisation</h3>
                        <b-modal
                            id="add-new-incubator-modal" ref="add-new-incubator-modal"
                            :title="'Incubator' + (huonFertilisationSelectedIncubator && huonFertilisationSelectedIncubator.incubator_fert_batch_location && huonFertilisationSelectedIncubator.incubator_fert_batch_number ? ' - ' + huonFertilisationSelectedIncubator.incubator_fert_batch_location + huonFertilisationSelectedIncubator.incubator_fert_batch_number : '')"
                            size="xl"
                            button-size="sm"
                            scrollable
                            @hidden="newIncubatorModalClosed"
                        >
                            <b-tabs v-if="huonFertilisationSelectedIncubator" content-class="mt-3">
                                <b-tab title="Incubator" :active="!huonFertilisationSelectedIncubator.finalised">
                                    <div v-if="huonFertilisationSelectedIncubator" style="display: flex; flex-direction: row; justify-content: flex-start; flex-wrap: nowrap; padding-bottom: 20px;">
                                        <div class="incubator-details-container">
                                            <div style="padding-right: 50px; min-width: 80%;">
                                                <h5>Incubator Details</h5>
                                                <div class="d-block" style="padding-bottom: 15px;">
                                                    <div class="content-row">
                                                        <b-form-group label-cols="5" label-cols-lg="4" label-size="sm" label="Batch #" label-align="right" label-for="batch-number-input" class="my-1" >
                                                            <b-input-group size="sm">
                                                                <b-form-input id="batch-number-input" size="sm" type="number" min="0" max="20" v-model="huonFertilisationSelectedIncubator.incubator_fert_batch_number" placeholder="Enter Batch number..." :disabled="huonFertilisationSelectedIncubator.finalised"></b-form-input>
                                                                <template #append>
                                                                    <label for="location-select-input" label-cols="5" label-cols-lg="4" label-size="sm" class="my-1" style=" padding-left: 10px; padding-right: 10px;">Location:</label>
                                                                    <b-form-select id="location-select-input" size="sm" required v-model="huonFertilisationSelectedIncubator.incubator_fert_batch_location" :disabled="huonFertilisationSelectedIncubator.finalised" class="my-0">
                                                                        <!-- This slot appears above the options from 'options' prop -->
                                                                        <template #first>
                                                                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                                                        </template>
                                                                        <!-- The options, built from the sites table in the database -->
                                                                        <b-form-select-option v-for="location in huonHatcheries.filter(site => site.location_code != undefined)" v-bind:key="location.id" :value="location.location_code">{{location.location_code + ' - ' + location.title}}</b-form-select-option>
                                                                    </b-form-select>
                                                                </template>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="content-row">
                                                        <b-form-group label-cols="5" label-cols-lg="4" label-size="sm" label="Activator" label-align="right" label-for="activator-input" class="my-1">
                                                            <b-input id="activator-input" required v-model="huonFertilisationSelectedIncubator.activator" size="sm" placeholder="Activator used..." :disabled="huonFertilisationSelectedIncubator.finalised"></b-input>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="content-row">
                                                        <b-form-group label-cols="5" label-cols-lg="4" label-size="sm" label="Milt Volume (ml per 2L of eggs)" label-align="right" label-for="milt-volume-input" class="my-1">
                                                            <b-input id="milt-volume-input" min="0" max="100" required v-model="huonFertilisationSelectedIncubator.milt_volume" type="number" size="sm" placeholder="Milt Volume used (ml)..." :disabled="huonFertilisationSelectedIncubator.finalised"></b-input>
                                                        </b-form-group>
                                                    </div>
                                                    <!-- <div class="content-row">
                                                        <b-form-group label-cols="5" label-cols-lg="4" label-size="sm" label="Processing Date" label-align="right" label-for="processing-date-input" class="my-1">
                                                            <b-form-datepicker id="processing-date-input" v-model="huonFertilisationSelectedIncubator.processing_date" size="sm" :disabled="huonFertilisationSelectedIncubator.finalised"></b-form-datepicker>
                                                        </b-form-group>
                                                    </div> -->
                                                    <div class="content-row">
                                                        <b-form-group label-cols="5" label-cols-lg="4" label-size="sm" label="Fertilisation Date" label-align="right" label-for="fertilisation-date-input" class="my-1">
                                                            <b-form-datepicker id="fertilisation-date-input" v-model="huonFertilisationSelectedIncubator.fertilisation_date" size="sm" :disabled="huonFertilisationSelectedIncubator.finalised"></b-form-datepicker>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="content-row">
                                                        <b-form-group label-cols="5" label-cols-lg="4" label-size="sm" label="Male Year Classes" label-align="right" label-for="male-yc-input" class="my-1">
                                                            <b-form-select  id="male-yc-input" v-model="huonFertilisationSelectedIncubator.milt_yc" size="sm" multiple :select-size="5" :options="getAquacultureYearClassOptions()" :disabled="huonFertilisationSelectedIncubator.finalised"></b-form-select>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="incubator-circle-container incubator-container-single" style="padding-left: 20px;">
                                                <div v-if="huonFertilisationSelectedIncubator">
                                                    <div class="circle-wrapper">
                                                        <div v-if="huonFertilisationSelectedIncubator.freshMilt != undefined && !huonFertilisationSelectedIncubator.freshMilt" class="incubator-circle-icon"><i class="fa-solid fa-snowflake"></i></div>
                                                        <div class="incubator-circle incubator-selected">
                                                            <div class="incubator-circle-section"><span>{{huonFertilisationSelectedIncubator.incubator_fert_batch_location}}{{huonFertilisationSelectedIncubator.incubator_fert_batch_number}}</span></div>
                                                            <div class="incubator-circle-section">
                                                                <span>
                                                                    <i class="fa-solid fa-mars" style="font-size: .8em;"></i> {{(huonFertilisationSelectedIncubator.milt_yc == undefined ? '' : huonFertilisationSelectedIncubator.milt_yc.toString())}}yc
                                                                    |
                                                                    {{(huonFertilisationSelectedIncubator.eggs_yc == undefined ? '' : huonFertilisationSelectedIncubator.eggs_yc.slice(-2))}}yc <i class="fa-solid fa-venus" style="font-size: .8em;"></i>
                                                                </span>
                                                            </div>
                                                            <div class="incubator-circle-section"><span>{{huonFertilisationSelectedIncubator.egg_count.toFixed(1)}}L</span></div>
                                                            <!-- <div class="incubator-circle-section"><span>male </span></div>
                                                            <div class="incubator-circle-section"><span>female </span></div> -->
                                                            <div class="incubator-circle-section"><span>{{huonFertilisationSelectedIncubator.incubator_number}}</span></div>
                                                        </div>
                                                        <!-- Fert % xx -->

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="huonFertilisationSelectedIncubator" id="the-content" style="padding: 10px;">
                                        <h5 style="padding-bottom: 10px;">Milt</h5>

                                        <b-form-checkbox v-model="huonFertilisationSelectedIncubator.freshMilt" switch>Fresh Milt</b-form-checkbox>
                                        <br />
                                        <div v-if="aquacultureFertAddingIncubator && huonFertilisationSelectedIncubator.freshMilt">
                                            <b-form-group label-cols="1" label-cols-lg="1" label-size="sm" label="Fish ID" label-align="right" label-for="master-fish-id-input">
                                                <b-input id="master-fish-id-input" required v-model="huonFertilisationSelectedIncubator.milt.master_fish_id" size="sm" placeholder="Enter fish ID..." :disabled="huonFertilisationSelectedIncubator.finalised"></b-input>
                                            </b-form-group>
                                            <b-form-group label-cols="1" label-cols-lg="1" label-size="sm" label="Processed" label-align="right" label-for="milt-processed-date-input">
                                                <b-form-datepicker id="milt-processed-date-input" v-model="huonFertilisationSelectedIncubator.milt.milt_processed_date" size="sm" :disabled="huonFertilisationSelectedIncubator.finalised"></b-form-datepicker>
                                            </b-form-group>
                                        </div>
                                        
                                        <div v-if="aquacultureFertAddingIncubator && !huonFertilisationSelectedIncubator.freshMilt" style="display: flex; flex-direction: row; justify-content: space-between;">
                                            <b-form-input id="fertilisation-milt-search" size="sm" placeholder="Search for Milt..." v-model="huonFertilisation_2_1.milt_search" @keydown.enter.native="aquacultureFertSearchForMilt" :disabled="searchingForMilt || huonFertilisationSelectedIncubator.finalised"></b-form-input>
                                            <i ref="miltPackage_checking_status_icon" :class="miltPackage_checking_status_icon_class" style="position: relative; padding-left: 5px; padding-right: 10px; top: 6px;" size="sm"></i>
                                            <b-button variant="primary" size="sm" @click.prevent="aquacultureFertSearchForMilt" style="margin-left: 15px;" :disabled="!huonFertilisation_2_1.milt_search || searchingForMilt || huonFertilisationSelectedIncubator.finalised">Attach</b-button>
                                        </div>
                                        <br />
                                        <div v-if="aquacultureFertAddingIncubator && !huonFertilisationSelectedIncubator.freshMilt">
                                            <b-table
                                                head-variant="dark"
                                                :items="huonFertilisationSelectedIncubator.milt"
                                                :fields="[
                                                    { key: 'contractname', label: 'Package', thStyle: {width: '350px'}, sortable: true, },
                                                    { key: 'processeddate', label: 'Processed Date', thStyle: {width: '150px'}, sortable: true, },
                                                    { key: 'contractstate', label: 'Current State', sortable: true },
                                                    { key: 'contractprogress', label: 'Progress', thStyle: {width: '300px'}},
                                                    { key: 'attach', label: '', thStyle: {width: '30px'}},
                                                ]"
                                            >
                                                <template #cell(attach)="cell">
                                                    <i v-if="!huonFertilisationSelectedIncubator.finalised" @click.stop="aquacultureDetachMiltFromIncubator(cell.item)" class="fa-solid fa-link-slash"></i>
                                                </template>
                                                <template #cell(contractname)="cell">
                                                    <img src="../../assets/images/templateIcons/testIcons/qr-icon.png" style="width: 16px; margin-right: 10px; top: -2px;" /><a href="" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{ cell.item.name }} </a>
                                                </template>
                                                <template #cell(processeddate)="cell" style="vertical-align: top;">
                                                    <b-badge pill variant="secondary" style="position: relative; top: -2px;">{{ getPackageProcessedDate(bcCache.find(contract => contract.TemplateID == aquaculturePackageTemplateID && contract.State == "3.2" && contract.ID == cell.item.ID).TempData.ProcessData.started)}}</b-badge>
                                                </template>
                                                <template #cell(contractstate)="cell" style="vertical-align: top;">
                                                    <b-badge pill variant="primary">{{ cell.item.nextState }} {{ cell.item.nextStateName }} </b-badge>
                                                </template>
                                                <template #cell(contractprogress)="cell" class="chart" Style="width:30%; vertical-align: middle;">
                                                    <div class="progress">
                                                        <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: cell.item.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                        </div>
                                                    </div>
                                                    <div style="font-size: 10px; color: grey;">{{ cell.item.stateProgress }} %</div>
                                                </template>
                                            </b-table>
                                            
                                        </div>

                                        <br />
                                        <h5 style="padding-bottom: 10px;">Eggs</h5>
                                        <div v-if="aquacultureFertAddingIncubator && !huonFertilisationSelectedIncubator.finalised" style="display: flex; flex-direction: row; justify-content: space-between;">
                                            <b-form-input id="fertilisation-egg-search" size="sm" placeholder="Search for Eggs..." v-model="huonFertilisation_2_1.egg_search" @keydown.enter.native="aquacultureFertSearchForEggs" :disabled="searchingForEggs"></b-form-input>
                                            <b-input-group size="sm" append="Vol. (L)">
                                                <b-form-input id="fertilisation-egg-count" size="sm" type="number" min="0" max="100" step=".5" v-model="huonFertilisation_2_1.egg_count_search" @keydown.enter.native="aquacultureFertSearchForEggs" style="margin-left: 10px; " :disabled="searchingForEggs"></b-form-input>
                                            </b-input-group>
                                            <i ref="egg_checking_status_icon" :class="egg_checking_status_icon_class" style="position: relative; padding-left: 5px; padding-right: 10px; top: 6px;" size="sm"></i>
                                            <b-button variant="primary" size="sm" @click.stop="aquacultureFertSearchForEggs" style="margin-left: 15px;" :disabled="!huonFertilisation_2_1.egg_search || huonFertilisation_2_1.egg_search == '' || !huonFertilisation_2_1.egg_count_search || huonFertilisation_2_1.egg_count_search <= 0  || searchingForEggs">Attach</b-button>
                                        </div>
                                        <br />
                                        <b-table
                                            head-variant="dark"
                                            :items="huonFertilisationSelectedIncubator.eggs"
                                            :fields="[
                                                { key: 'contractname', label: 'Egg Batch', thStyle: {width: '350px'}, sortable: true, },
                                                { key: 'volume', label: 'Volume', thStyle: {width: '100px'}, sortable: true, },
                                                { key: 'contractstate', label: 'Current State', sortable: true },
                                                { key: 'contractprogress', label: 'Progress', thStyle: {width: '300px'}},
                                                { key: 'attach', label: '', thStyle: {width: '30px'}},
                                            ]"
                                        >
                                            <template #cell(attach)="cell">
                                                <i v-if="!huonFertilisationSelectedIncubator.finalised" @click.stop="aquacultureDetachEggsFromIncubator(cell.item)" class="fa-solid fa-link-slash"></i>
                                            </template>
                                            <template #cell(contractname)="cell">
                                                <img src="../../assets/images/templateIcons/testIcons/qr-icon.png" style="width: 16px; margin-right: 10px; top: -2px;" /><a href="" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{ cell.item.name }} </a>
                                            </template>
                                            <template #cell(volume)="cell"><b-badge pill variant="secondary" style="position: relative; top: -2px;">{{cell.item.volume.toFixed(1)}} L</b-badge></template>
                                            <template #cell(contractstate)="cell" style="vertical-align: top;"><b-badge pill variant="primary">{{ cell.item.nextState }} {{ cell.item.nextStateName }} </b-badge></template>
                                            <template #cell(contractprogress)="cell" class="chart" style="width: 30%; vertical-align: middle;">
                                                <div class="progress">
                                                    <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: cell.item.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                    </div>
                                                </div>
                                                <div style="font-size: 10px; color: grey;">{{ cell.item.stateProgress }} %</div>
                                            </template>
                                        </b-table>                                                
                                        <br />
                                    </div>
                                </b-tab>
                                <b-tab title="Outcomes" :disabled="!huonFertilisationSelectedIncubator.finalised" :active="huonFertilisationSelectedIncubator.finalised">
                                    <h5>24 Hour Check Result</h5>
                                    <vue-editor id="24hour-result-comment-input" style="max-width: 80%;" v-model="huonFertilisationSelectedIncubator._24Hour_result_comment" :disabled="!huonFertilisationSelectedIncubator.finalised || this.huonFertilisationSelectedIncubator.results_finalised"></vue-editor>
                                    
                                    <br />
                                    
                                    <h5>Early Fertilisation Results</h5>
                                    <vue-editor id="early-result-comment-input" style="max-width: 80%;" v-model="huonFertilisationSelectedIncubator.early_result_comment" :disabled="!huonFertilisationSelectedIncubator.finalised || this.huonFertilisationSelectedIncubator.results_finalised"></vue-editor>
                                    
                                    <br />
                                    
                                    <h5>Eyed Eggs Check (SKALA Pick Results)</h5>
                                    <vue-editor id="eyed-eggs-result-comment-input" style="max-width: 80%;" v-model="huonFertilisationSelectedIncubator.eyed_eggs_result_comment" :disabled="!huonFertilisationSelectedIncubator.finalised || this.huonFertilisationSelectedIncubator.results_finalised"></vue-editor>
                                </b-tab>
                            </b-tabs>
                            
                            <template #modal-footer>
                                <b-button variant="primary" size="sm" @click="aquacultureFinaliseIncubator" :disabled="aquacultureFinaliseIncubatorButttonDisabled()">{{(finalisingAquacultureIncubator ? 'Finalising... ' : (huonFertilisationSelectedIncubator.finalised ? 'Finalise Results' : 'Finalise Incubator'))}} <i :class="'fa-solid ' + (finalisingAquacultureIncubator ? 'fa-spinner fa-spin' : 'fa-check')"></i></b-button>
                            </template>
                        </b-modal>
                        <div id="incubator-season-container" style="display: flex; flex-direction: row;">
                            <div style="position: relative; float: left; padding-left: 50px; padding-right: 20px; ">
                                <h5>Incubators</h5>
                                <div class="incubator-circle-container">
                                    <div v-for="incubator in huonFertilisation_2_1.incubators" v-bind:key="incubator.ID" @click.prevent="aquacultureFertilisationIncubatorClicked(incubator)">
                                        <div class="circle-wrapper" @click="openIncubator(incubator)">
                                            <div :class="'incubator-circle' + (incubator.selected ? ' incubator-selected' : '')">
                                                <div class="incubator-circle-section">
                                                    <span v-if="incubator.incubator_fert_batch_location != undefined && incubator.incubator_fert_batch_number != undefined">{{incubator.incubator_fert_batch_location}}{{incubator.incubator_fert_batch_number}}</span><i v-if="incubator.freshMilt != undefined && !incubator.freshMilt" class="incubator-circle-icon-group fa-solid fa-snowflake"></i>
                                                </div>
                                                <div class="incubator-circle-section">
                                                    <span v-if="incubator.egg_count != undefined && incubator.egg_count != 0">{{incubator.egg_count.toFixed(1)}}L</span>
                                                </div>
                                                <div class="incubator-circle-section">
                                                    <span v-if="(incubator.milt_yc != undefined && incubator.eggs_yc != undefined)">
                                                        <i class="fa-solid fa-mars" style="font-size: .8em;"></i> {{(incubator.milt_yc == undefined ? '' : incubator.milt_yc.toString())}}yc
                                                        |
                                                        {{(incubator.eggs_yc == undefined ? '' : incubator.eggs_yc.slice(-2))}}yc <i class="fa-solid fa-venus" style="font-size: .8em;"></i>
                                                    </span>
                                                </div>
                                                <!-- <div class="incubator-circle-section"><span>male </span></div>
                                                <div class="incubator-circle-section"><span>female </span></div> -->
                                                <div class="incubator-circle-section"><span>{{incubator.incubator_number}}</span></div>
                                            </div>
                                            <!-- Fert % xx -->
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- summary data -->
                            <div class="summary-data-container" v-if="huonFertilisation_2_1 != undefined">
                                <div style="width: 100%; float: left; padding-bottom: 16px; padding-top: 30px;">
                                    <div style="float: left; padding-left: 30px;">
                                        <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200;">
                                            <strong> {{ getFertilisationTotalFemales(huonFertilisation_2_1.incubators) }} </strong>
                                        </div>
                                        <div style="margin-top: -7px; color: grey; height: 55px;">
                                            FEMALES
                                        </div>
                                    </div>
                                    <div style="float: left; padding-left: 30px;">
                                        <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200;">
                                            <strong> {{ getFertilisationTotalMales(huonFertilisation_2_1.incubators) }} </strong>
                                        </div>
                                        <div style="margin-top: -7px; color: grey; height: 55px;">
                                            MALES
                                        </div>
                                    </div>
                                    <div style="float: left; padding-left: 30px;">
                                        <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200;">
                                            <strong> {{ huonFertilisation_2_1.incubators.filter(incubator => incubator.finalised).length }} </strong>
                                        </div>
                                        <div style="margin-top: -7px; color: grey; height: 55px;">
                                            INCUBATORS USED
                                        </div>
                                    </div>

                                    <br />

                                    <div style="float: left; padding-left: 30px; padding-top: 25px;">
                                        <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200;">
                                            {{ getFertilisationTotalEggCount(huonFertilisation_2_1.incubators).toFixed(1) }} 
                                        </div>
                                        <div style="margin-top: -7px; color: grey; height: 55px;">
                                            TOTAL EGGS (L)
                                        </div>
                                    </div>

                                    <div style="float: left; padding-left: 60px; padding-top: 25px;">
                                        <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200;">
                                            {{ getFertilisationTotalMiltVolume(huonFertilisation_2_1.incubators) }}
                                        </div>
                                        <div style="margin-top: -7px; color: grey; height: 55px;">
                                            TOTAL MILT (mL)
                                        </div>
                                    </div>

                                    <br />

                                    <div style="float: left; padding-left: 30px; padding-top: 25px;">
                                        <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200;">
                                            
                                        </div>
                                        <div style="margin-top: -7px; color: grey; height: 55px;">
                                            AVE. EGGS PER LITRE
                                        </div>
                                    </div>

                                    <br />

                                    <div style="float: left; padding-left: 30px; padding-top: 25px;">
                                        <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200;">
                                            {{ getFertilisationFemaleYearClasses(huonFertilisation_2_1.incubators) }}
                                        </div>
                                        <div style="margin-top: -7px; color: grey; height: 55px;">
                                            FEMALE YEAR CLASSES
                                        </div>
                                    </div>

                                    <br />

                                    <div style="float: left; padding-left: 30px; padding-top: 25px;">
                                        <div style="position: absolute; font-size: 39px; color: rgb(108, 117, 125); font-weight: 200;">
                                            {{ getFertilisationMaleYearClasses(huonFertilisation_2_1.incubators) }}
                                        </div>
                                        <div style="margin-top: -7px; color: grey; height: 55px;">
                                            MALE YEAR CLASSES
                                        </div>
                                    </div>
                                </div>
                            </div><!-- summary data -->
                        </div>
                    </div>
                    
                    <!----- - 3.1 24 Hour Check -- ------->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.1' && template.TempData.contract.id == aquacultureFertilisationTemplateID">
                        <hr />
                        
                        <h3>24 Hour Check Result</h3>
                        <vue-editor id="result-comment-input" v-model="huonFertilisation_3_1.result_comment" :disabled="selectedSubprocess.status == 'COMPLETED'"></vue-editor>
                            
                    </div>
                    <!----- - 3.2 Early Fertilisation Results -- ------->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.2' && template.TempData.contract.id == aquacultureFertilisationTemplateID">
                        <hr />
                        
                        <h3>Early Fertilisation Results</h3>
                        <vue-editor id="result-comment-input" v-model="huonFertilisation_3_2.result_comment" :disabled="selectedSubprocess.status == 'COMPLETED'"></vue-editor>
                            
                    </div>
                    <!----- - 3.3 Eyed Eggs Check -- ------->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.3' && template.TempData.contract.id == aquacultureFertilisationTemplateID">
                        <hr />
                        
                        <h3>Eyed Eggs Check (SKALA Pick Results)</h3>
                        <vue-editor id="result-comment-input" v-model="huonFertilisation_3_3.result_comment" :disabled="selectedSubprocess.status == 'COMPLETED'"></vue-editor>
                            
                    </div>
                    <!----- - 3.4 FishTalk Export -- ------->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.4' && template.TempData.contract.id == aquacultureFertilisationTemplateID">
                        <hr />
                        
                        <h3>FishTalk Export</h3>
                        <!-- <vue-editor id="result-comment-input" v-model="huonFertilisation_3_4.result_comment" :disabled="selectedSubprocess.status == 'COMPLETED'"></vue-editor>
                             -->
                    </div>

                    <!----- -------------------------------- ------->
                    <!----- Huon Male Fish (Master) Template ------->
                    <!----- -------------------------------- ------->
                    <!----- 1.1 ID Generation -------------- ------->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='1.1' && template.TempData.contract.id =='932f342a-0eeb-4c45-9bf4-816a72315278'">
                        <hr />
                        <!-- In Progress -->
                        <!-- <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;"> -->
                            <b-form-group
                                label-cols-lg="2"
                                label="Fish Details"
                                label-size="sm"
                                label-class="font-weight-bold pt-0"
                                class="mb-3">
                                <b-form-group
                                    label="Tag ID:"
                                    label-for="tag-id-input"
                                    label-cols-sm="12"
                                    label-align-sm="left">
                                    <b-form-input id="tag-id-input" v-model="huonMaleMasterFish_1_1.tag_id" style="max-width: 30%;" disabled></b-form-input>
                                </b-form-group>
                                <b-form-group
                                    label="Year Class:"
                                    label-for="year-class-input"
                                    label-cols-sm="12"
                                    label-align-sm="left">
                                    <b-form-input id="year-class-input" type="number" min="2020" max="2030" v-model="huonMaleMasterFish_1_1.year_class" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-input>
                                </b-form-group>
                                <b-form-group
                                    label="Facility:"
                                    label-for="facility-input"
                                    label-cols-sm="12"
                                    label-align-sm="left">
                                    <b-form-select id="facility-input"  v-model="huonMaleMasterFish_1_1.facility" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')">
                                        <b-form-select-option v-for="site in huonHatcheries" v-bind:key="site.id" :value="site.title">{{site.title}}</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>
                                <b-form-group
                                    label="Tank:"
                                    label-for="facility-tank-input"
                                    label-cols-sm="12"
                                    label-align-sm="left">
                                    <b-form-input id="facility-tank-input"  v-model="huonMaleMasterFish_1_1.tank" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-input>
                                </b-form-group>
                                <b-form-group
                                    label="Genetic Rank:"
                                    label-for="generic-rank-input"
                                    label-cols-sm="12"
                                    label-align-sm="left">
                                    <b-form-input id="generic-rank-input" v-model="huonMaleMasterFish_1_1.genetic_rank" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-input>
                                </b-form-group>
                                <b-form-group
                                    label="Neo:"
                                    label-for="is-neo-input"
                                    label-cols-sm="12"
                                    label-align-sm="left">
                                    <b-form-checkbox id="is-neo-input" v-model="huonMaleMasterFish_1_1.is_neo" value="accepted" unchecked-value="not-accepted" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-checkbox>
                                </b-form-group>
                            </b-form-group>
                        <!-- </div> -->
                    </div>
                    <!-- 2.1 Ultrasound Results -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='2.1' && template.TempData.contract.id =='932f342a-0eeb-4c45-9bf4-816a72315278'">
                        <hr />
                        <b-form-group
                            label-cols-lg="2"
                            label="Ultrasound Results"
                            label-size="sm"
                            label-class="font-weight-bold pt-0"
                            class="mb-3">
                            <b-form-group
                                label="Comment:"
                                label-for="comment-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="comment-input" v-model="huonMaleMasterFish_2_1.comment" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="Spawn Comment:"
                                label-for="spawn-comment-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="spawn-comment-input" v-model="huonMaleMasterFish_2_1.spawn_comment" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="New Comment:"
                                label-for="new-comment-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="new-comment-input" v-model="huonMaleMasterFish_2_1.new_comment" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="Weight (kg):"
                                label-for="weight-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="weight-input" type="number" min="0" max="50" v-model="huonMaleMasterFish_2_1.weight" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="Ovaplant Liquid:"
                                label-for="ovaplant-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="ovaplant-input" v-model="huonMaleMasterFish_2_1.ovaplant" style="max-width: 30%;" :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-input>
                            </b-form-group>
                        </b-form-group>
                    </div>
                    <!-- 3.1 Sample Allocation -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.1' && template.TempData.contract.id =='932f342a-0eeb-4c45-9bf4-816a72315278'">
                        <hr />
                        <b-form-group label="Sample Status">
                            <b-form-radio-group v-model="huonMaleMasterFish_3_1.fish_status" :options="['Culled', 'Milt Extracted']" plain :disabled="(selectedSubprocess.status == 'COMPLETED')"></b-form-radio-group>
                        </b-form-group>
                    </div>
                    <!-- 3.2 Active Milt Tracking -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.2' && template.TempData.contract.id =='932f342a-0eeb-4c45-9bf4-816a72315278'">
                        <hr />
                        Active Milt Tracking content...
                    </div>

                    <!-- --------------------------- -->
                    <!-- Huon Fish (Sample) Template -->
                    <!-- --------------------------- -->
                    <!-- 1.1 ID Generation --------- -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='1.1' && template.TempData.contract.id =='932f342a-0eeb-4c45-9bf4-816a72315280'">
                        <hr />
                        <b-form-group
                            label-cols-lg="2"
                            label="Sample Details"
                            label-size="sm"
                            label-class="font-weight-bold pt-0"
                            class="mb-3">
                            <b-form-group
                                label="Master (Fish) Tag ID:"
                                label-for="tag-id-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="tag-id-input" v-model="huonFishSample_1_1.master_tag_id" style="max-width: 30%;" :disabled="selectedSubprocess.status == 'COMPLETED'"></b-form-input>
                            </b-form-group>
                            
                            <b-form-group
                                label="Sample ID:"
                                label-for="sample-id-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="sample-id-input" v-model="huonFishSample_1_1.sample_id" style="max-width: 30%;" :disabled="selectedSubprocess.status == 'COMPLETED'"></b-form-input>
                            </b-form-group>
                        </b-form-group>
                    </div>
                    <!-- 2.1 Milt Assessment --------- -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='2.1' && template.TempData.contract.id =='932f342a-0eeb-4c45-9bf4-816a72315280'">
                        <hr />
                        <h3>Fresh Milt Assessment</h3>                            
                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Motility %:" label-for="input-2">                                                        
                            <b-form-input id="input-1" v-model="huonFishSample_2_1.motility" placeholder="" style="width: 250px;" size="sm" @change.native="huonFishSample_2_1_valueChanged" :disabled="selectedSubprocess.status == 'COMPLETED'"></b-form-input>
                        </b-form-group>
                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Concentration (ml):" label-for="input-2">                                                        
                            <b-form-input id="input-1" v-model="huonFishSample_2_1.concentration" placeholder="" style="width: 250px;" size="sm" @change.native="huonFishSample_2_1_valueChanged" :disabled="selectedSubprocess.status == 'COMPLETED'"></b-form-input>
                        </b-form-group>
                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Initial Grade:" label-for="input-2">                                                        
                            <b-form-input id="input-1" v-model="huonFishSample_2_1.grade" placeholder="" style="width: 250px;" size="sm" @change.native="huonFishSample_2_1_valueChanged" :disabled="selectedSubprocess.status == 'COMPLETED'"></b-form-input>
                        </b-form-group>
                    </div>
                    <!-- 3.1 Package Allocation --------- -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.1' && template.TempData.contract.id =='932f342a-0eeb-4c45-9bf4-816a72315280'">
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            <hr />
                            <b-tabs content-class="mt-3">
                                <b-tab title="Assign Packages" active>
                                    <b-form-group
                                        label-cols-lg="3"
                                        label="Package Allocation"
                                        label-size="lg"
                                        label-class="font-weight-bold pt-0"
                                        class="mb-3">
                                        <br />
                                        <b-form-group
                                            label="Attach Package:"
                                            label-for="sample-package-id-input"
                                            label-cols-sm="4"
                                            label-align-sm="right">
                                            <div style="display: block">
                                                <b-form-input id="sample-package-id-input" ref="sample-package-id-input" size="sm" autofocus
                                                    v-model="packageToAttachToHuonSample"
                                                    autocomplete="off"
                                                    style="position: inherit; float:left; max-width: 79%; "
                                                    placeholder="Scan or enter a package number"
                                                    :disabled="selectedSubprocess.status == 'COMPLETED'"
                                                    @keydown.enter.native="attachAquaculturePackageToSample">
                                                </b-form-input>
                                                <i ref="package_checking_status_icon" :class="package_checking_status_icon_class" style="position: relative; padding-left: 5px; padding-right: 10px; top: 6px;"></i>
                                                <b-button @click.stop="attachAquaculturePackageToSample"
                                                    size="sm"
                                                    variant="primary"
                                                    style="position: inherit; float: right;"
                                                    :disabled="(!packageToAttachToHuonSample) && (!loadingSamplePackaging) || (selectedSubprocess.status == 'COMPLETED')"><i :class="'fa-solid fa-' + ( loadingSamplePackaging ? 'circle-notch fa-spin' : 'link')"  style="margin-right: 5px;"></i>Attach
                                                </b-button>
                                            </div>
                                        </b-form-group>
                                    </b-form-group>
                                    <b-table id="aquaculturePackageContractsTable"
                                        responive="sm"
                                        head-variant="light"
                                        :total-rows="huonFishSample_3_1.attachedPackages.length"
                                        :items="huonFishSample_3_1.attachedPackages"
                                        :fields="aquaculturePackagesTableFields"
                                        @sort-changed="tableSortChanged"
                                    >
                                        <template #cell(attach)="cell">
                                            <i v-if="selectedSubprocess.status == 'COMPLETED'" class="fa-solid fa-lock"></i>
                                            <i v-else-if="cell.item.locked" class="fa-solid fa-snowflake"></i>
                                            <i v-else class="fa-solid fa-link-slash" @click.stop="detachAquaculturePackageFromSample(cell.item.ID)"></i>
                                        </template>
                                        <template #cell(contractname)="cell">
                                            <img src="../../assets/images/templateIcons/testIcons/qr-icon.png" style="width: 16px; margin-right: 10px; top: -2px;" /><a href="" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{ cell.item.name }} </a><!--<span v-if="isNewRow(!cell.item.TimeStampEpoch ? cell.item.item.TimeStampEpoch - 1000 : cell.item.TimeStampEpoch - 1000)"><sup><b-badge pill variant="info" style="font-style: .5em;">New</b-badge></sup></span>-->
                                        </template>
                                        <template #cell(contracttype)="cell">Vitrafy Smart Packaging</template>
                                        <template #cell(contractapplication)="cell" style="vertical-align: top;"> {{ cell.item.TempData.Application }} </template>
                                        <template #cell(contractdatetime)="cell" style="vertical-align: top;">{{ getRelativeDate(cell.item.TimeStampEpochUpdated) }}</template>
                                        <template #cell(contractstate)="cell" style="vertical-align: top;"><b-badge pill variant="primary">{{ cell.item.nextState }} {{ cell.item.nextStateName }} </b-badge></template>
                                        <template #cell(contractprogress)="cell" class="chart" Style="width: 30%; vertical-align: middle;">
                                            <div class="progress">
                                                <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: cell.item.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                </div>
                                            </div>
                                            <div style="font-size: 10px; color: grey;">{{ cell.item.stateProgress }} %</div>
                                        </template>
                                    </b-table>
                                </b-tab>
                                <b-tab title="Assign Batches">
                                    <div >
                                        <div id="aquaculturePackageToBatchSelection">
                                            <b-form-group
                                                label-cols-lg="3"
                                                label="Package to Batch Allocation"
                                                label-size="lg"
                                                label-class="font-weight-bold pt-0"
                                                class="mb-3">
                                                <br />
                                                <b-form-group
                                                    label="Choose Package:"
                                                    label-for="batch-package-id-input"
                                                    label-cols-sm="4"
                                                    label-align-sm="right">
                                                    <div style="display: block">
                                                        <b-form-input id="batch-package-id-input" ref="batch-package-id-input" size="sm" autofocus
                                                            v-model="packageToAttachToHuonBatch"
                                                            autocomplete="off"
                                                            style="position: inherit; float:left; max-width: 79%; "
                                                            placeholder="Scan or enter a package number"
                                                            :disabled="selectedSubprocess.status == 'COMPLETED'"
                                                            @keydown.enter.native="attachAquaculturePackageToBatch">
                                                        </b-form-input>
                                                        <i ref="package_checking_status_icon" :class="package_checking_status_icon_class" style="position: relative; padding-left: 5px; padding-right: 10px; top: 6px;"></i>
                                                        <b-button @click.stop="attachAquaculturePackageToBatch"
                                                            size="sm"
                                                            variant="primary"
                                                            style="position: inherit; float: right; "
                                                            :disabled="(!packageToAttachToHuonBatch) && (!loadingSamplePackaging) || (selectedSubprocess.status == 'COMPLETED')"><i :class="'fa-solid fa-' + ( loadingSamplePackaging ? 'circle-notch fa-spin' : 'link')"  style="margin-right: 5px;"></i>Attach
                                                        </b-button>
                                                    </div>
                                                </b-form-group>
                                            </b-form-group>
                                        </div>
                                        <div style="display: inline-block;">
                                            <div style="position: relative; float: left; max-width: 75%; padding-right: 10px;">
                                                <h5>Packages to Freeze</h5>
                                                <b-table id="aquaculturePackageContractsTable"
                                                    responive="sm"
                                                    head-variant="dark"
                                                    :total-rows="huonFishSample_3_1.packagesToFreeze.length"
                                                    :items="huonFishSample_3_1.packagesToFreeze"
                                                    :fields="aquaculturePackagesToFreezeTableFields"
                                                >
                                                    <template #cell(attach)="cell">
                                                        <i @click.stop="detachAquaculturePackageFromBatch(cell.item)" class="fa-solid fa-link-slash"></i>
                                                    </template>
                                                    <template #cell(contractname)="cell">
                                                        <img src="../../assets/images/templateIcons/testIcons/qr-icon.png" style="width: 16px; margin-right: 10px; top: -2px;" /><a href="" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{ cell.item.name }} </a><!--<span v-if="isNewRow(!cell.item.TimeStampEpoch ? cell.item.item.TimeStampEpoch - 1000 : cell.item.TimeStampEpoch - 1000)"><sup><b-badge pill variant="info" style="font-style: .5em;">New</b-badge></sup></span>-->
                                                    </template>
                                                    <template #cell(contracttype)="cell">Vitrafy Smart Packaging</template>
                                                    <template #cell(contractapplication)="cell" style="vertical-align: top;"> {{ cell.item.TempData.Application }} </template>
                                                    <template #cell(contractdatetime)="cell" style="vertical-align: top;">{{ getRelativeDate(cell.item.TimeStampEpochUpdated) }}</template>
                                                    <template #cell(contractstate)="cell" style="vertical-align: top;"><b-badge pill variant="primary">{{ cell.item.nextState }} {{ cell.item.nextStateName }} </b-badge></template>
                                                    <template #cell(contractprogress)="cell" class="chart" Style="width:30%; vertical-align: middle;">
                                                        <div class="progress">
                                                            <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: cell.item.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                            </div>
                                                        </div>
                                                        <div style="font-size: 10px; color: grey;">{{ cell.item.stateProgress }} %</div>
                                                    </template>
                                                </b-table>
                                            </div>
                                            <div style="position: relative; float: right; min-width: 25%;">
                                                <div style="display: inline-block;">
                                                    <h5>Choose Device</h5>
                                                    <div style="position: relative; float: left;">
                                                        <b-form-select size="sm" v-model="deviceSelected" :options="vitrafyCryopreservationDevices" style="min-width: 250px; margin-right: 10px;"></b-form-select>
                                                    </div>
                                                    <div style="position: relative; float: right; padding-left: 10px;">
                                                        <b-button v-if="!batchTrackingActive" size="sm" variant="primary" @click="startTrackingDeviceBatch" :disabled="(!deviceSelected || huonFishSample_3_1.packagesToFreeze.length == 0)">Find Batch</b-button>
                                                        <b-button v-else size="sm" variant="primary" disabled>Searching <i class="fa-solid fa-spinner fa-spin"></i></b-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="liveBatchTrackingDiv" v-if="batchTrackingActive" style="padding-bottom: 15px;">
                                            <h5>Live Batch Tracking</h5>
                                            <div v-if="!batchResultsFound">
                                                <i class="fa-solid fa-spinner fa-spin"></i> {{ batchTrackingLoaderText }}
                                                <b-progress :value="batchDetectionProgressValue" :max="100" animated></b-progress>
                                            </div>
                                            <div v-else-if="batchResultsFound">
                                                <b-table id="deviceBatchDetails" ref="deviceBatchDetails"
                                                    head-variant="light" selectable hover select-mode="single" 
                                                    :items="deviceBatchDetails"
                                                    :fields="deviceBatchDetailsFields"
                                                    @row-selected="batchRowWasSelected">
                                                    <template #cell(start_time)="cell" style="vertical-align: top;">{{ getRelativeDate(new Date(cell.item.start_time.timestamp)) }}</template>
                                                    <template #cell(end_time)="cell" style="vertical-align: top;">{{ (cell.item.end_time == undefined ? '' : getRelativeDate(new Date(cell.item.start_time.timestamp))) }}</template>                                                
                                                </b-table>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <h5>Available Packages</h5>
                                            <b-table id="aquaculturePackageContractsTable"
                                                responive="sm"
                                                head-variant="dark"
                                                :total-rows="huonFishSample_3_1.attachedPackages.length"
                                                :items="huonFishSample_3_1.attachedPackages"
                                                :fields="aquaculturePackagesTableFields"
                                                @sort-changed="tableSortChanged"
                                            >
                                                <template #cell(attach)="cell"><i v-if="cell.item.locked" class="fa-solid fa-snowflake"></i></template>
                                                <template #cell(contractname)="cell">
                                                    <img src="../../assets/images/templateIcons/testIcons/qr-icon.png" style="width: 16px; margin-right: 10px; top: -2px;" /><a href="" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{ cell.item.name }} </a><!--<span v-if="isNewRow(!cell.item.TimeStampEpoch ? cell.item.item.TimeStampEpoch - 1000 : cell.item.TimeStampEpoch - 1000)"><sup><b-badge pill variant="info" style="font-style: .5em;">New</b-badge></sup></span>-->
                                                </template>
                                                <template #cell(contracttype)="cell">Vitrafy Smart Packaging</template>
                                                <template #cell(contractapplication)="cell" style="vertical-align: top;"> {{ cell.item.TempData.Application }} </template>
                                                <template #cell(contractdatetime)="cell" style="vertical-align: top;">{{ getRelativeDate(cell.item.TimeStampEpochUpdated) }}</template>
                                                <template #cell(contractstate)="cell" style="vertical-align: top;"><b-badge pill variant="primary">{{ cell.item.nextState }} {{ cell.item.nextStateName }} </b-badge></template>
                                                <template #cell(contractprogress)="cell" class="chart" Style="width:30%; vertical-align: middle;">
                                                    <div class="progress">
                                                        <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: cell.item.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                        </div>
                                                    </div>
                                                    <div style="font-size: 10px; color: grey;">{{ cell.item.stateProgress }} %</div>
                                                </template>
                                            </b-table>
                                        </div>
                                        <div style="display: block; padding-bottom: 10px;">
                                            <b-form-input id="selectedBatchIDOverride" ref="selectedBatchIDOverride" size="sm" v-model="batchIDManualOverride" placeholder="Manually enter Batch ID..." style="position: relative; float: left; max-width: 200px; margin-right: 10px;"></b-form-input>
                                            <b-button size="sm" variant="primary" @click="finaliseBatchAndPackages" :disabled="(!deviceSelected || finalisingAquacultureBatchAndPackages) || (!isBatchRowSelected && !batchIDManualOverride)" style="position: relative; float: left; margin-bottom: 10px;"><i :class="'fa-solid ' + (finalisingAquacultureBatchAndPackages ? 'fa-spinner fa-spin' : 'fa-check')"></i> {{(finalisingAquacultureBatchAndPackages ? 'Finalising...' : 'Finalise')}}</b-button>
                                            <p>{{batchOverrideSearchTest}}</p> 
                                        </div>
                                    </div>
                                </b-tab> 
                            </b-tabs>
                        </div>
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <h5>Cryopreserved Packages</h5>
                            <b-table id="aquaculturePackageContractsTable"
                                responive="sm"
                                head-variant="dark"
                                :total-rows="huonFishSample_3_1.cryopreserved_packages.length"
                                :items="huonFishSample_3_1.cryopreserved_packages"
                                :fields="aquaculturePackagesTableFields"
                                @sort-changed="tableSortChanged"
                            >
                                <template #cell(attach)="cell"><i v-if="cell.item.locked" class="fa-solid fa-snowflake"></i></template>
                                <template #cell(contractname)="cell">
                                    <img src="../../assets/images/templateIcons/testIcons/qr-icon.png" style="width: 16px; margin-right: 10px; top: -2px;" /><a href="" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{ cell.item.name }} </a><!--<span v-if="isNewRow(!cell.item.TimeStampEpoch ? cell.item.item.TimeStampEpoch - 1000 : cell.item.TimeStampEpoch - 1000)"><sup><b-badge pill variant="info" style="font-style: .5em;">New</b-badge></sup></span>-->
                                </template>
                                <template #cell(contracttype)="cell">Vitrafy Smart Packaging</template>
                                <template #cell(contractapplication)="cell" style="vertical-align: top;"> {{ cell.item.TempData.Application }} </template>
                                <template #cell(contractdatetime)="cell" style="vertical-align: top;">{{ getRelativeDate(cell.item.TimeStampEpochUpdated) }}</template>
                                <template #cell(contractstate)="cell" style="vertical-align: top;"><b-badge pill variant="primary">{{ cell.item.nextState }} {{ cell.item.nextStateName }} </b-badge></template>
                                <template #cell(contractprogress)="cell" class="chart" Style="width:30%; vertical-align: middle;">
                                    <div class="progress">
                                        <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: cell.item.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                        </div>
                                    </div>
                                    <div style="font-size: 10px; color: grey;">{{ cell.item.stateProgress }} %</div>
                                </template>
                            </b-table>
                        </div>
                    </div>
                    <!-- 3.2 Active Batch Tracking --------- -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.2' && template.TempData.contract.id =='932f342a-0eeb-4c45-9bf4-816a72315280'">
                        <hr />
                        Active Batch content...
                    </div>

                    <!-- ------------------ -->
                    <!-- Huon 2023 Template -->
                    <!-- ------------------ -->
                    <!-- 1.1 NFT Generation -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='1.1' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">

                            <!-- process wizard container -->
                            <div class="process-wizard-container">

                                <!-- process wizard progress summary -->
                                <div class="process-wizard-steps">
                                    <table>
                                        <tbody>
                                            <tr v-for="(step, index) in NFT_wizard_steps" v-bind:key="step.id">
                                                <td class="process-wizard-step-icon-container">
                                                    <div class="process-wizard-step-icon">
                                                        <div v-if="step.complete">
                                                            <span style="vertical-align: top; position: relative;">
                                                                <i class="fa-solid fa-circle" style="position: absolute; top: 5px; left: 0px; color: white;"></i>
                                                                <i class="fa-regular fa-circle-check" style="position: absolute; top: 5px; left: 0px; color: rgb(25, 135, 84);"></i>                                                            
                                                            </span>
                                                        </div>
                                                        <div v-else>
                                                            <span v-if="step.active" style="vertical-align: top; position: relative;">
                                                                <i class="fa-solid fa-circle" style="position: absolute; top: 5px; left: 0px; color: #3978d3;"></i>
                                                                <i class="fa-regular fa-circle" style="position: absolute; top: 5px; left: 0px; color: #033276;"></i>                                                            
                                                            </span>
                                                            <span v-else style="vertical-align: top; position: relative;">
                                                                <i class="fa-solid fa-circle" style="position: absolute; top: 5px; left: 0px; color: white;"></i>
                                                                <i class="fa-regular fa-circle" style="position: absolute; top: 5px; left: 0px; color: lightgrey;"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div v-if="index < NFT_wizard_steps.length -1 && step.complete" class="process-wizard-summary-link" style="border-right: 3px solid #00ad5b"></div>
                                                    <div v-else-if="index < NFT_wizard_steps.length -1" class="process-wizard-summary-link"></div>
                                                </td>
                                                <td class="process-wizard-step-label" :class="step.active ? 'process-wizard-step-label-active' : ''">
                                                    <span v-if="step.complete">{{  step.label }}</span> 
                                                    <span v-else>{{  step.label }}</span>
                                                    <br/><br/>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- process wizard steps -->
                                <div class="process-wizard-step-details">

                                    <div v-for="step in NFT_wizard_steps" v-bind:key="step.id">

                                        <!-- Step 1 - Create NFT -->
                                        <div v-if="step.id == 1 && step.active" class="process-wizard-step-step">
                                            <h5>{{ step.label }}</h5>
                                            
                                                <!-- NFT Input -->
                                                <div style="width: 100%; float: left">

                                                    <!-- NFT Type -->
                                                    <b-form-group id="input-group-1" style="float: left; width: 100%;" label="NFT Type:" label-for="input-2">
                                                        <b-form-select v-model="NFTselected" :options="NFToptions" size="sm" style="margin-top: 0px !important; width: 250px;" class="mt-3"></b-form-select>
                                                    </b-form-group>

                                                    <div v-if="NFTselected == null"></div>
                                                    <div v-else>

                                                        <!-- NFT Type = Master NFT -->
                                                        <div v-if="NFTselected == 'master'">
                                                            
                                                            <!-- NFT ID -->
                                                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Fish ID:" label-for="input-2">                                                        
                                                                <b-form-input id="input-1" v-model="NFT.fishID" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                                                            </b-form-group>

                                                        </div>

                                                        <!-- NFT Type = Stacked NFT -->
                                                        <div v-if="NFTselected == 'stacked'">

                                                            <!-- Package ID -->
                                                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Package ID:" label-for="input-2">                                                        
                                                                <b-form-input id="input-1" v-model="NFT.packageID" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                                                            </b-form-group>                                                                   
                                                            
                                                            <!-- Select existing Master NFT -->
                                                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Select Master NFT:" label-for="input-2">                                                 
                                                                <b-form-select v-model="masterNFTselected" :options="masterNFToptions" :select-size="4" style="width: 250px;" size="sm"></b-form-select>
                                                            </b-form-group>

                                                            <div>masterNFTselected = {{  masterNFTselected }}</div>

                                                        </div>

                                                        <!-- S3 image upload -->
                                                        <div style="float: left; width: 100%">
                                                            <b-form-group id="input-group-2" label="Initial NFT Image:" label-for="input-2">
                                                                <input type="file" style="float: left;" accept="image/jpeg,image/png,.pdf" @change=set_file>
                                                            </b-form-group>        
                                                        </div>
                                                    
                                                    </div>

                                                </div>    

                                        </div>

                                        <!-- Step 2 - Publish NFT -->
                                        <div v-if="step.id == 2 && step.active" class="process-wizard-step-step">
                                            <h5>{{ step.label }}</h5>

                                            <!-- NFT Details -->
                                            <div style="width: 100%; float: left">
                                                <!-- s3 uploaded Image -->
                                                <img v-if="NFT.image != null" style="width: 100px; padding-bottom: 16px;" :src="NFT.image" />

                                                <!-- NFT JSON -->
                                                <table class="">
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Name</strong></td>
                                                        <td>{{ NFT.name }}</td>
                                                    </tr>                                                    
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Type</strong></td>
                                                        <td>{{ NFT.type }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Fish ID</strong></td>
                                                        <td>{{ NFT.fishID }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Package ID</strong></td>
                                                        <td>{{ NFT.packageID }}</td>
                                                    </tr>                                                                                                                                                          
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Description</strong></td>
                                                        <td>{{ NFT.description }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Image</strong></td>
                                                        <td>{{ NFT.image }}</td>
                                                    </tr>                                
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>QR Hash</strong></td>
                                                        <td>{{ NFT.qr_hash }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>User</strong></td>
                                                        <td>{{ NFT.user }}</td>
                                                    </tr>            
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Other</strong></td>
                                                        <td>{{ NFT.other }}</td>
                                                    </tr>                                                                       
                                                </table>
                        
                                            </div>    

                                        </div>
                                        
                                        <!-- Step 3 - Mint NFT -->
                                        <div v-if="step.id == 3 && step.active" class="process-wizard-step-step">
                                            <h5>{{ step.label }}</h5>

                                            <!-- NFT Toekn URI -->
                                            <div style="width: 100%; float: left">

                                                <!-- NFT Token URI -->
                                                <table class="">
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>NFT Token URI</strong></td>
                                                        <td>{{ tokenURI }}</td>
                                                    </tr>                                                                  
                                                </table>
                               
                                            </div>

                                        </div>
                                        
                                        <!-- Step 4 - Review & Complete -->
                                        <div v-if="step.id == 4 && step.active" class="process-wizard-step-step">
                                            <h5>{{ step.label }}</h5>
                                            
                                            <!-- NFT Mint result -->
                                            <div style="width: 100%; float: left">
                                                <table class="">
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Block Hash</strong></td>
                                                        <td>{{ mintResult.blockHash }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Block Number</strong></td>
                                                        <td><a v-bind:href="'https://goerli.etherscan.io/block/'+ mintResult.blockNumber" target="_blank">{{ mintResult.blockNumber }} <font-awesome-icon style="font-size: 10px" icon="fa-solid fa-link" /></a></td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>From</strong></td>
                                                        <td><a v-bind:href="'https://goerli.etherscan.io/address/'+ mintResult.from" target="_blank">{{ mintResult.from }} <font-awesome-icon style="font-size: 10px" icon="fa-solid fa-link" /></a></td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Gas Used</strong></td>
                                                        <td>{{ mintResult.gasUsed }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>To</strong></td>
                                                        <td>{{ mintResult.to }}</td>
                                                    </tr>            
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Transaction Hash</strong></td>
                                                        <td><a v-bind:href="'https://goerli.etherscan.io/tx/'+ mintResult.transactionHash" target="_blank">{{ mintResult.transactionHash }} <font-awesome-icon style="font-size: 10px" icon="fa-solid fa-link" /></a></td>
                                                    </tr>                                                                       
                                                </table>
                                            </div>                        

                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
    
                            <!-- Stacked NFT Details -->
                            <div style="display: none; float: left">
                                <!-- NFT JSON -->
                                <table class="">
                                    <tr>
                                        <td style="padding-right: 10px;"><strong>Name</strong></td>
                                        <td>{{ mintResult.JSON.name }}</td>
                                    </tr>                                          
                                    <tr>
                                        <td style="padding-right: 10px; vertical-align: top;"><strong>Image</strong></td>
                                        <td><img style="width: 100px; padding-bottom: 16px;" :src="mintResult.JSON.image" /></td>
                                    </tr>                                                                                                            
                                    <tr>
                                        <td style="padding-right: 10px;"><strong>Type</strong></td>
                                        <td>{{ mintResult.JSON.type }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding-right: 10px;"><strong>Package ID</strong></td>
                                        <td>{{ mintResult.JSON.packageID }}</td>
                                    </tr>                                    
                                    <tr>
                                        <td style="padding-right: 10px;"><strong>Fish ID</strong></td>
                                        <td>{{ mintResult.JSON.fishID }} (master NFT)</td>
                                    </tr>
                                    <tr>
                                        <td style="padding-right: 10px;"><strong>Transaction</strong></td>
                                        <td><a target="_blank" :href="'https://goerli.etherscan.io/tx/' + mintResult.transactionHash">{{ mintResult.transactionHashMini }}...</a></td>
                                    </tr>                                                                                                                                                                                                    
                                    <tr>
                                        <td style="padding-right: 10px;"><strong>Description</strong></td>
                                        <td>{{ mintResult.JSON.description }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding-right: 10px;"><strong>QR Hash</strong></td>
                                        <td>{{ mintResult.JSON.qr_hash }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding-right: 10px;"><strong>User</strong></td>
                                        <td>{{ mintResult.JSON.user }}</td>
                                    </tr>            
                                    <tr>
                                        <td style="padding-right: 10px;"><strong>Other</strong></td>
                                        <td>{{ mintResult.JSON.other }}</td>
                                    </tr>                                                                       
                                </table>
        
                            </div>    
                            
                            <!-- left side -->
                            <div style="float: left; padding-left: 35px; padding-right: 50px;">
                                <div style="width: 300px; text-align: center;">
                                    <div style="box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); text-align: center;">
                                        <!-- <img style="width: 300px;" src="https://lc-token-testing.s3.ap-southeast-2.amazonaws.com/ID-0011.png" /> -->
                                        <img style="width: 300px;" src="https://lc-token-testing.s3.ap-southeast-2.amazonaws.com/initial.png" />
                                        <div style="padding: 15px;">
                                            {{ selectedBlock.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- right side -->
                            <div style="float: left;">
                                <!-- NFT JSON -->
                                <table class="">
                                    <tr>
                                        <td style="width: 90px;"><strong>Name</strong></td>
                                        <td>{{ selectedBlock.name }}</td>
                                    </tr>                                          
                                    <tr>
                                        <td style="width: 90px;"><strong>Type</strong></td>
                                        <td>Stacked NFT</td>
                                    </tr>
                                    <tr>
                                        <td style="padding-right: 10px;"><strong>Fish ID</strong></td>
                                        <td><a href="#" v-b-modal.master-nft-modal>5584231 (Master NFT)</a></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 90px;"><strong>Transaction</strong></td>
                                        <td><a target="_blank" href="https://goerli.etherscan.io/tx/0xe417291dbeb45104cbd2ffe5d6fc735613c7c8b9629fab9e5b5023db5ee96408">0xe417291dbeb45104c...</a></td>
                                    </tr>                                                                                                                                                                                                    
                                    <tr>
                                        <td style="width: 90px;"><strong>Description</strong></td>
                                        <td>Package ID</td>
                                    </tr>
                                    <tr>
                                        <td style="padding-right: 10px;"><strong>QR Code</strong></td>
                                        <td><a href="#">click to view</a></td>
                                    </tr>
                                    <tr>
                                        <td style="padding-right: 10px;"><strong>Owned By</strong></td>
                                        <td><a href="#">lifechain</a></td>
                                    </tr>                                                                  
                                </table>
                            </div>                            


                        </div>                            
                    </div>

                    <!-- 1.2 LifeLink Storage Device -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='1.2' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            <b-form-checkbox
                                id="checkbox-1"
                                v-model="P_1_2.approved"
                                name="checkbox-1"
                                value="accepted"
                                unchecked-value="not_accepted"
                                >
                                Storage required at 4°C 
                            </b-form-checkbox>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <b-form-checkbox
                                id="checkbox-1"
                                v-model="P_1_2.approved"
                                name="checkbox-1"
                                value="accepted"
                                unchecked-value="not_accepted"
                                disabled
                                >
                                Storage required at 4°C 
                            </b-form-checkbox>
                        </div>                            
                    </div>                    

                    <!-- 2.1 Cryoprotectant -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='2.1' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Cryoprotectant:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_2_1.cryoprotectant" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>

                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Cryoprotectant:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_2_1.cryoprotectant" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                            </b-form-group>

                        </div>                            
                    </div>                       

                    <!-- 2.2 Milt Assessment -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='2.2' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            <h3>Fresh Milt Assessment</h3>                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Motility %:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_2_2.motility" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Concentration (ml):" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_2_2.concentration" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Initial Grade:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_2_2.grade" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>                                                        

                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <h3>Fresh Milt Assessment</h3>
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Motility %:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_2_2.motility" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                            </b-form-group>
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Concentration (ml):" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_2_2.concentration" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                            </b-form-group>
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Initial Grade:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_2_2.grade" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                            </b-form-group>    

                        </div>                            
                    </div>  

                    <!-- 2.3 Packaging Assignment -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='2.3' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">

                            <b-form-group id="input-group-2-3" style="float: left; width: 100%;" label="Packaging Cost:" label-for="input-2-3">                                                        
                                <span style="float: left; padding: 5px 5px 0 0;">
                                    $
                                </span>
                                <span style="float: left">
                                    <b-form-input id="input-2-3" v-model="P_2_3.packaging_cost" placeholder="" style="width: 100px;" size="sm"></b-form-input>
                                </span>
                            </b-form-group>

                            <div style="float: left">
                                <b-form-checkbox
                                    id="checkbox-1"
                                    v-model="P_2_3.approved"
                                    name="checkbox-1"
                                    value="accepted"
                                    unchecked-value="not_accepted"
                                    >
                                    Packaging approved
                                </b-form-checkbox>
                            </div>

                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">

                            <b-form-group id="input-group-2-3" style="float: left; width: 100%;" label="Packaging Cost:" label-for="input-2-3">                                                        
                                <span style="float: left; padding: 5px 5px 0 0;">
                                    $
                                </span>
                                <span style="float: left">
                                    <b-form-input id="input-2-3" v-model="P_2_3.packaging_cost" placeholder="" style="width: 100px;" size="sm" disabled></b-form-input>
                                </span>
                            </b-form-group>

                            <div style="float: left">
                                <b-form-checkbox
                                    id="checkbox-1"
                                    v-model="P_2_3.approved"
                                    name="checkbox-1"
                                    value="accepted"
                                    unchecked-value="not_accepted"
                                    disabled
                                    >
                                    Packaging approved 
                                </b-form-checkbox>
                            </div>

                        </div>                            
                    </div>

                    <!-- 2.4 Cryoprotectant Added -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='2.4' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">

                            <b-form-group id="input-group-2-3" style="float: left; width: 100%;" label="Cryoprotectant Cost:" label-for="input-2-3">                                                        
                                <span style="float: left; padding: 5px 5px 0 0;">
                                    $
                                </span>
                                <span style="float: left">
                                    <b-form-input id="input-2-3" v-model="P_2_4.cryoprotectant_cost" placeholder="" style="width: 100px;" size="sm"></b-form-input>
                                </span>
                            </b-form-group>

                            <div style="float: left">
                                <b-form-checkbox
                                    id="checkbox-1"
                                    v-model="P_2_4.approved"
                                    name="checkbox-1"
                                    value="accepted"
                                    unchecked-value="not_accepted"
                                    >
                                    Cryoprotectant Added
                                </b-form-checkbox>
                            </div>

                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">

                            <b-form-group id="input-group-2-3" style="float: left; width: 100%;" label="Cryoprotectant Cost:" label-for="input-2-3">                                                        
                                <span style="float: left; padding: 5px 5px 0 0;">
                                    $
                                </span>
                                <span style="float: left">
                                    <b-form-input id="input-2-3" v-model="P_2_4.cryoprotectant_cost" placeholder="" style="width: 100px;" size="sm" disabled></b-form-input>
                                </span>
                            </b-form-group>

                            <div style="float: left">
                                <b-form-checkbox
                                    id="checkbox-1"
                                    v-model="P_2_4.approved"
                                    name="checkbox-1"
                                    value="accepted"
                                    unchecked-value="not_accepted"
                                    disabled
                                    >
                                    Cryoprotectant Added
                                </b-form-checkbox>
                            </div>

                        </div>                            
                    </div>
                    
                    <!-- 2.5 Package Filling and Sealing -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='2.5' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">

                            <b-form-group id="input-group-2-3" style="float: left; width: 100%;" label="Preparation Cost:" label-for="input-2-3">                                                        
                                <span style="float: left; padding: 5px 5px 0 0;">
                                    $
                                </span>
                                <span style="float: left">
                                    <b-form-input id="input-2-3" v-model="P_2_5.preparation_cost" placeholder="" style="width: 100px;" size="sm"></b-form-input>
                                </span>
                            </b-form-group>

                            <div style="float: left">
                                <b-form-checkbox
                                    id="checkbox-1"
                                    v-model="P_2_5.approved"
                                    name="checkbox-1"
                                    value="accepted"
                                    unchecked-value="not_accepted"
                                    >
                                    Package Filling and Sealing Completed
                                </b-form-checkbox>
                            </div>

                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">

                            <b-form-group id="input-group-2-3" style="float: left; width: 100%;" label="Preparation Cost:" label-for="input-2-3">                                                        
                                <span style="float: left; padding: 5px 5px 0 0;">
                                    $
                                </span>
                                <span style="float: left">
                                    <b-form-input id="input-2-3" v-model="P_2_5.preparation_cost" placeholder="" style="width: 100px;" size="sm" disabled></b-form-input>
                                </span>
                            </b-form-group>

                            <div style="float: left">
                                <b-form-checkbox
                                    id="checkbox-1"
                                    v-model="P_2_5.approved"
                                    name="checkbox-1"
                                    value="accepted"
                                    unchecked-value="not_accepted"
                                    disabled
                                    >
                                    Package Filling and Sealing Completed
                                </b-form-checkbox>
                            </div>

                        </div>                            
                    </div>        

                    <!-- 3.1 Algorithm and MOC -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.1' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            <div style="margin-bottom: 10px;"><strong>Algorithm and Machine Operating Conditions</strong></div>
                            <b-input-group prepend="Algorithm" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="P_3_1.algorithm" size="sm"></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Machine Operating Conditions" size="sm" style="padding-bottom: 10px;">
                                <b-input-group-prepend is-text>Temperature (°C)</b-input-group-prepend>
                                <b-form-input v-model="P_3_1.moc.temp" type="number" min="-80" max="60" size="sm"></b-form-input>
                                <b-input-group-prepend is-text>Flow (L/min)</b-input-group-prepend>
                                <b-form-input v-model="P_3_1.moc.flow" type="number" min="0" max="100" size="sm"></b-form-input>
                                <b-input-group-prepend is-text>Time (Seconds)</b-input-group-prepend>
                                <b-form-input v-model="P_3_1.moc.time" type="number" min="0" max="180" size="sm"></b-form-input>
                            </b-input-group>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <div style="margin-bottom: 10px;"><strong>Algorithm and Machine Operating Conditions</strong></div>
                            <b-input-group prepend="Algorithm" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="P_3_1.algorithm" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Machine Operating Conditions" size="sm" style="padding-bottom: 10px;">
                                <b-input-group-prepend is-text>Temperature (°C)</b-input-group-prepend>
                                <b-form-input v-model="P_3_1.moc.temp" type="number" min="-80" max="60" size="sm" disabled></b-form-input>
                                <b-input-group-prepend is-text>Flow (L/min)</b-input-group-prepend>
                                <b-form-input v-model="P_3_1.moc.flow" type="number" min="0" max="100" size="sm" disabled></b-form-input>
                                <b-input-group-prepend is-text>Time (Seconds)</b-input-group-prepend>
                                <b-form-input v-model="P_3_1.moc.time" type="number" min="0" max="180" size="sm" disabled></b-form-input>
                            </b-input-group>                            
                        </div>                            
                    </div>     

                    <!-- 3.2 Vitrafy Cryopreservation -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='3.2' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">

                            <b-form-group id="input-group-2-3" style="float: left; width: 100%;" label="Preservation Cost:" label-for="input-2-3">                                                        
                                <span style="float: left; padding: 5px 5px 0 0;">
                                    $
                                </span>
                                <span style="float: left">
                                    <b-form-input id="input-2-3" v-model="P_3_2.preservation_cost" placeholder="" style="width: 100px;" size="sm"></b-form-input>
                                </span>
                            </b-form-group>                            
                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Device:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_3_2.device" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>

                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Batch ID:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_3_2.batch_id" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>

                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Fish ID:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_3_2.fish_id" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>                            
                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Started:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_3_2.started" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>
                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Finished:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_3_2.finished" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>
                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Code:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_3_2.code" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>
                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Protocol:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_3_2.protocol" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>
                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Process Time:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_3_2.processed_time" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>
                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Start Temp:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_3_2.start_temp" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>
                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="End TEmp:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_3_2.end_temp" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>
                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Min Temp:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_3_2.min_temp" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>
                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Max Temp:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_3_2.max_temp" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>
                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Start Flow:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_3_2.start_flow" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>
                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="End Flow:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_3_2.end_flow" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>
                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Min Flow:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_3_2.min_flow" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>
                            
                            <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Max Flow:" label-for="input-2">                                                        
                                <b-form-input id="input-1" v-model="P_3_2.max_flow" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                            </b-form-group>                              

                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            
                            <div>
                                <b-tabs content-class="mt-3">
                                    <b-tab title="Process Details" active>

                                        <b-form-group id="input-group-2-3" style="float: left; width: 100%;" label="Preservation Cost:" label-for="input-2-3">                                                        
                                            <span style="float: left; padding: 5px 5px 0 0;">
                                                $
                                            </span>
                                            <span style="float: left">
                                                <b-form-input id="input-2-3" v-model="P_3_2.preservation_cost" placeholder="" style="width: 100px;" size="sm" disabled></b-form-input>
                                            </span>
                                        </b-form-group>             

                                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Device:" label-for="input-2">                                                        
                                            <b-form-input id="input-1" v-model="P_3_2.device" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                                        </b-form-group>

                                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Batch ID:" label-for="input-2">                                                        
                                            <b-form-input id="input-1" v-model="P_3_2.batch_id" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                                        </b-form-group>

                                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Fish ID:" label-for="input-2">                                                        
                                            <b-form-input id="input-1" v-model="P_3_2.fish_id" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                                        </b-form-group>                                        
                                        
                                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Started:" label-for="input-2">                                                        
                                            <b-form-input id="input-1" v-model="P_3_2.started" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                                        </b-form-group>
                                        
                                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Finished:" label-for="input-2">                                                        
                                            <b-form-input id="input-1" v-model="P_3_2.finished" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                                        </b-form-group>
                                        
                                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Code:" label-for="input-2">                                                        
                                            <b-form-input id="input-1" v-model="P_3_2.code" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                                        </b-form-group>
                                        
                                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Protocol:" label-for="input-2">                                                        
                                            <b-form-input id="input-1" v-model="P_3_2.protocol" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                                        </b-form-group>
                                        
                                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Process Time:" label-for="input-2">                                                        
                                            <b-form-input id="input-1" v-model="P_3_2.processed_time" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                                        </b-form-group>
                                        
                                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Start Temp:" label-for="input-2">                                                        
                                            <b-form-input id="input-1" v-model="P_3_2.start_temp" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                                        </b-form-group>
                                        
                                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="End TEmp:" label-for="input-2">                                                        
                                            <b-form-input id="input-1" v-model="P_3_2.end_temp" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                                        </b-form-group>
                                        
                                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Min Temp:" label-for="input-2">                                                        
                                            <b-form-input id="input-1" v-model="P_3_2.min_temp" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                                        </b-form-group>
                                        
                                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Max Temp:" label-for="input-2">                                                        
                                            <b-form-input id="input-1" v-model="P_3_2.max_temp" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                                        </b-form-group>
                                        
                                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Start Flow:" label-for="input-2">                                                        
                                            <b-form-input id="input-1" v-model="P_3_2.start_flow" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                                        </b-form-group>
                                        
                                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="End Flow:" label-for="input-2">                                                        
                                            <b-form-input id="input-1" v-model="P_3_2.end_flow" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                                        </b-form-group>
                                        
                                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Min Flow:" label-for="input-2">                                                        
                                            <b-form-input id="input-1" v-model="P_3_2.min_flow" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                                        </b-form-group>
                                        
                                        <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Max Flow:" label-for="input-2">                                                        
                                            <b-form-input id="input-1" v-model="P_3_2.max_flow" placeholder="" style="width: 250px;" size="sm" disabled></b-form-input>
                                        </b-form-group>   
                                    </b-tab>
                                    <b-tab title="NFT Transition">

                                        <!-- initial -->
                                        <div style="float: left; padding-left: 100px; padding-right: 50px;">
                                            <div style="width: 300px; text-align: center;">
                                                <div style="box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); text-align: center;">
                                                    <img style="width: 300px;" src="https://lc-token-testing.s3.ap-southeast-2.amazonaws.com/initial.png" />
                                                    <div style="padding: 15px;">
                                                        {{ selectedBlock.name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- transition -->
                                        <div style="float: left; padding-left: 35px; padding-right: 50px; padding-top: 150px;">
                                            <NFTVideoModal ref="NFTVideoModal"/>
                                        </div>    

                                        <!-- current -->
                                        <div style="float: left; padding-left: 35px; padding-right: 50px;">
                                            <div style="width: 300px; text-align: center;">
                                                <div style="box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); text-align: center;">
                                                    <img style="width: 300px;" src="https://lc-token-testing.s3.ap-southeast-2.amazonaws.com/ID-0011.png" />
                                                    <div style="padding: 15px;">
                                                        {{ selectedBlock.name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                        

                                    </b-tab>
                                </b-tabs>
                            </div>

                        </div>                            
                    </div>    

                    <!-- 4.1 Allocate LifeLink Storage Device -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='4.1' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        <hr />
                        <b-form-group
                            label-cols-lg="2"
                            label="Storage Details"
                            label-size="sm"
                            label-class="font-weight-bold pt-0"
                            class="mb-3">
                            <b-form-group
                                label="Liquid Nitrogen Dewar:"
                                label-for="dewar-id-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="dewar-id-input" autofocus v-model="P_4_1.dewar_id" style="max-width: 30%;" :disabled="selectedSubprocess.status == 'COMPLETED'" @change.native="P_4_1_valueChanged"></b-form-input>
                            </b-form-group>
                            
                            <b-form-group
                                label="Cannister #:"
                                label-for="cannister-number-input"
                                label-cols-sm="12"
                                label-align-sm="left">
                                <b-form-input id="cannister-number-input" v-model="P_4_1.cannister_number" style="max-width: 30%;" :disabled="selectedSubprocess.status == 'COMPLETED'" @change.native="P_4_1_valueChanged"></b-form-input>
                            </b-form-group>
                        </b-form-group>
                    </div>
                    <!-- 4.2 LifeLink Storage Device -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='4.2' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">                                                        
                            <b-form-checkbox
                                id="checkbox-1"
                                v-model="P_4_2.removed"
                                @change="P_4_2_changed"
                                name="checkbox-1"
                                value="accepted"
                                unchecked-value="not_accepted"
                                >
                                Removed from storage 
                            </b-form-checkbox>

                            <br />
                            Removed by
                            <b-form-input v-model="P_4_2.removed_by" disabled size="sm"></b-form-input>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <b-form-checkbox
                                id="checkbox-1"
                                v-model="P_4_2.removed"
                                name="checkbox-1"
                                value="accepted"
                                unchecked-value="not_accepted"
                                disabled
                                >
                                Removed from storage 
                            </b-form-checkbox>
                            
                            <br />
                            Removed by
                            <b-form-input v-model="P_4_2.removed_by" disabled size="sm"></b-form-input>
                        </div>                            
                    </div>
                    
                    <!-- 5.1 Identification Package Check -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='5.1' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">                                                        
                            
                            <b-form-checkbox
                                id="P_5_1_identification_package_checked"
                                v-model="P_5_1.identification_package_checked"
                                name="P_5_1_identification_package_checked"
                                ref="P_5_1_identification_package_checked_ref"
                                value="accepted"
                                unchecked-value="not_accepted"
                                >
                                Identification package checked and matches ID
                            </b-form-checkbox>
                            <div style="display: block">
                                <div style="position: relative; float: left; max-width: 80%;">
                                    <b-form-input id="P_5_1_identification_package_id" v-model="P_5_1.identification_package_id" @input.native="checkIdentificationPackageAquaculture()" placeholder="Scan or enter package ID"></b-form-input>
                                </div>
                                <!-- <div style="position: relative; float: left; max-width:100px; display: none;">
                                    <StreamBarcodeReader @decode="onDecodeQR" @loaded="onLoadedQR"></StreamBarcodeReader>
                                    <p class="decode-result">Last result: <b>{{ qr_result }}</b></p>
                                </div> -->
                            </div>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <b-form-checkbox
                                id="checkbox-1"
                                v-model="P_5_1.identification_package_checked"
                                name="checkbox-1"
                                value="accepted"
                                unchecked-value="not_accepted"
                                disabled
                                >
                                Identification package checked and matches ID
                            </b-form-checkbox>
                            <b-form-input v-model="P_5_1.identification_package_id" disabled></b-form-input>
                        </div>                            
                    </div>

                    <!-- 5.2 Algorithm and MOC -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='5.2' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">                                                        
                            
                            <div style="margin-bottom: 10px;"><strong>Algorithm and Machine Operating Conditions</strong></div>
                            <b-input-group prepend="Algorithm" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="P_5_2.algorithm" size="sm"></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Machine Operating Conditions" size="sm" style="padding-bottom: 10px;">
                                <b-input-group-prepend is-text>Temperature (°C)</b-input-group-prepend>
                                <b-form-input v-model="P_5_2.moc.temp" type="number" min="-80" max="60" size="sm"></b-form-input>
                                <b-input-group-prepend is-text>Flow (L/min)</b-input-group-prepend>
                                <b-form-input v-model="P_5_2.moc.flow" type="number" min="0" max="100" size="sm"></b-form-input>
                                <b-input-group-prepend is-text>Time (Seconds)</b-input-group-prepend>
                                <b-form-input v-model="P_5_2.moc.time" type="number" min="0" max="180" size="sm"></b-form-input>
                            </b-input-group>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <div style="margin-bottom: 10px;"><strong>Algorithm and Machine Operating Conditions</strong></div>
                            <b-input-group prepend="Algorithm" size="sm" style="padding-bottom: 10px;">
                                <b-form-input v-model="P_5_2.algorithm" size="sm" disabled></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Machine Operating Conditions" size="sm" style="padding-bottom: 10px;">
                                <b-input-group-prepend is-text>Temperature (°C)</b-input-group-prepend>
                                <b-form-input v-model="P_5_2.moc.temp" type="number" min="-80" max="60" size="sm" disabled></b-form-input>
                                <b-input-group-prepend is-text>Flow (L/min)</b-input-group-prepend>
                                <b-form-input v-model="P_5_2.moc.flow" type="number" min="0" max="100" size="sm" disabled></b-form-input>
                                <b-input-group-prepend is-text>Time (Seconds)</b-input-group-prepend>
                                <b-form-input v-model="P_5_2.moc.time" type="number" min="0" max="180" size="sm" disabled></b-form-input>
                            </b-input-group>
                        </div>                            
                    </div>

                    <!-- 5.3 Vitrafy BioThaw -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='5.3' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">                                                        
                            <b-form-checkbox
                                id="checkbox-1"
                                v-model="P_5_3.thawing_completed"
                                name="checkbox-1"
                                value="accepted"
                                unchecked-value="not_accepted"
                                >
                                BioThaw Completed
                            </b-form-checkbox>
                            <strong>BioThaw Device</strong><br /> <b-form-select v-model="P_5_3.thawing_device" :options="vitrafy_biothaw_devices"></b-form-select>
                            
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <b-form-checkbox
                                id="checkbox-1"
                                v-model="P_5_3.thawing_completed"
                                name="checkbox-1"
                                value="accepted"
                                unchecked-value="not_accepted"
                                disabled
                                >
                                BioThaw Completed
                            </b-form-checkbox>
                            <strong>BioThaw Device</strong><br /> <b-form-input v-model="P_5_3.thawing_device" disabled></b-form-input>
                        </div>                            
                    </div>

                    <!-- 6.1 Milt assessment -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='6.1' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        <hr />
                        <!-- In Progress -->
                        <div v-if="selectedSubprocess.status == 'IN PROGRESS'" style="padding-bottom: 15px;">
                            <div style="display: flex;">
                                <div style="position: relative; float: left; padding-left: 5%;">
                                <h3>Fresh Milt Assessment</h3>
                                    <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Motility %:" label-for="input-2">                                                        
                                        <b-form-input id="input-1" v-model="P_2_2.motility" style="width: 250px;" size="sm" disabled></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Concentration (ml):" label-for="input-2">                                                        
                                        <b-form-input id="input-1" v-model="P_2_2.concentration" style="width: 250px;" size="sm" disabled></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Initial Grade:" label-for="input-2">                                                        
                                        <b-form-input id="input-1" v-model="P_2_2.grade" style="width: 250px;" size="sm" disabled></b-form-input>
                                    </b-form-group>
                                </div>
                                <div style="position: relative; float: right; top: 0px;">
                                    <h3>Post-Thaw Milt Assessment</h3>
                                    <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Motility %:" label-for="input-2">                                                        
                                        <b-form-input id="input-P_6_1.motility" v-model="P_6_1.motility" @input="validate_P_6_1()" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Concentration (ml):" label-for="input-2">                                                        
                                        <b-form-input id="input-P_6_1.concentration" v-model="P_6_1.concentration" @input="validate_P_6_1()" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Post-Thaw Grade:" label-for="input-2">                                                        
                                        <b-form-input id="input-P_6_1.grade" v-model="P_6_1.grade" @input="validate_P_6_1()" placeholder="" style="width: 250px;" size="sm"></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                        <!-- Completed -->
                        <div v-if="selectedSubprocess.status == 'COMPLETED'">
                            <div style="display: flex;">
                                <div style="position: relative; float: left; padding-left: 5%;">
                                <h3>Fresh Milt Assessment</h3>
                                    <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Motility %:" label-for="input-2">                                                        
                                        <b-form-input id="input-1" v-model="P_2_2.motility" style="width: 250px;" size="sm" disabled></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Concentration (ml):" label-for="input-2">                                                        
                                        <b-form-input id="input-1" v-model="P_2_2.concentration" style="width: 250px;" size="sm" disabled></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Initial Grade:" label-for="input-2">                                                        
                                        <b-form-input id="input-1" v-model="P_2_2.grade" style="width: 250px;" size="sm" disabled></b-form-input>
                                    </b-form-group>
                                </div>
                                <div style="position: relative; float: right; top: 0px;">
                                    <h3>Post-Thaw Milt Assessment</h3>
                                    <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Motility %:" label-for="input-2">                                                        
                                        <b-form-input id="input-P_6_1.motility" v-model="P_6_1.motility" disabled style="width: 250px;" size="sm"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Concentration (ml):" label-for="input-2">                                                        
                                        <b-form-input id="input-P_6_1.concentration" v-model="P_6_1.concentration" disabled style="width: 250px;" size="sm"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="input-group-1" style="float: left; width: 100%;" label="Post-Thaw Grade:" label-for="input-2">                                                        
                                        <b-form-input id="input-P_6_1.grade" v-model="P_6_1.grade" disabled style="width: 250px;" size="sm"></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>                            
                    </div>
                    <!-- 7.1 FErtilisation Allocation -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='7.1' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        <hr />
                        <h5>Fertilisation Run</h5>
                        <b-table
                            responsive="md"
                            head-variant="dark"
                            :items="P_7_1.fertilisation_run"
                            :fields="aquacultureFertilisationMastersTableFields"
                        >
                            <template #cell(attach)="cell"></template>
                            <template #cell(expand)="row">
                                <!-- <div @click.stop="toggleDetails(row)" class="clickable" style="padding: 8px;">
                                    <i :class="'fa-solid fa-' + (row.item._showDetails ? 'chevron-up' : 'chevron-right')" style="padding-left: 5px;"></i>
                                </div> -->
                            </template>
                            <template #cell(fertilisation)="cell"><i class='fa-solid fa-shuffle' style="padding-right: 10px; font-size: 1.3em; position: absolute; top: 10px;"></i><a href="" style="padding-left: 30px;" @click.prevent="contractsRowClicked(cell.item, cell.index, null)">{{/*(cell.item.State == '0' ?*/cell.item.name/* : cell.item.TempData.ProcessData.fertilisation_run_id)*/}}</a></template>
                            <template #cell(facility)="cell">{{(cell.item.TempData.ProcessData == undefined ? '' : cell.item.TempData.ProcessData.facility)}}</template>
                            <template #cell(contractstate)="cell" style="vertical-align: top;"><b-badge pill variant="primary">{{ cell.item.nextState }} {{ cell.item.nextStateName }} </b-badge></template>
                            <template #cell(contractprogress)="cell" class="chart" Style="width:30%; vertical-align: middle;">
                                <div class="progress">
                                    <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: cell.item.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                    </div>
                                </div>
                                <div style="font-size: 10px; color: grey;">{{ cell.item.stateProgress }} %</div>
                            </template>
                        </b-table>
                    </div>
                    
                    <!-- --------------------- -->
                    <!-- --- CSL Template ---- -->
                    <!-- --------------------- -->
                    <!-- --- 1.2 Apheresis --- -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='1.2' && template.TempData.contract.id == this.cslContractTemplateID">
                        <hr />
                        
                        <div>
                            <h3>Apheresis Report</h3>
                            <iframe :src="csl_1_2.reportURL" width="100%" height="600px"></iframe>
                        </div>

                    </div>
                    <!-- -- 4.3 Package Selection (AI) -- -->
                    <div v-else-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='4.3' && template.TempData.contract.id == this.cslContractTemplateID">
                        <hr />

                        <CSLPackageSelectionAI ref="CSLPackageSelectionAI"/>

                    </div> 


                    <!-- All Other Subprocesses -->
                    <div v-else>
                        <!-- content here -->
                    </div>

                    <!-- 1.1 NFT Generation - Wizard action buttons -->
                    <div v-if="template.TempData.contract.application == 'ART' && selectedSubprocess.id =='1.1' && template.TempData.contract.id =='18719e55-99bf-4137-b7bb-fefd373f60b3'">
                        
                        <div v-if="selectedStep == 1 && selectedSubprocess.status != 'COMPLETED'">
                            <b-button size="sm" style="float: right;" variant="primary" :disabled="uploading_image" @click="s3ImageUpload()">
                                <span v-if="uploading_image" class="spinner-border spinner-border-sm" style="margin-right: 10px;" role="status" aria-hidden="true"></span> 
                                <span>Create NFT</span>
                            </b-button>
                        </div>

                        <div v-if="selectedStep == 2 && selectedSubprocess.status != 'COMPLETED'">
                            <b-button size="sm" style="float: right;" variant="primary" :disabled="uploading_json" @click="s3JSONDataUpload()">
                                <span v-if="uploading_json" class="spinner-border spinner-border-sm" style="margin-right: 10px;" role="status" aria-hidden="true"></span> 
                                <span>Publish NFT</span>
                            </b-button>    
                        </div>
                        
                        <div v-if="selectedStep == 3 && selectedSubprocess.status != 'COMPLETED'">
                            <b-button size="sm" style="float: right;" variant="primary" :disabled="creating_nft" @click="createNFT()">
                                <span v-if="creating_nft" class="spinner-border spinner-border-sm" style="margin-right: 10px;" role="status" aria-hidden="true"></span> 
                                <span>Mint NFT</span>
                            </b-button>     
                        </div>
                        
                        <div v-if="selectedStep == 4 && selectedSubprocess.status != 'COMPLETED'">
                            <button type="button" class="btn btn-primary btn-sm" @click="subprocessComplete(selectedSubprocess)" style="float: right;">
                                <font-awesome-icon icon="fa-solid fa-check" /><span style="padding-left: 10px;">Complete Process</span>
                            </button> 
                        </div>                        
                    </div>

                    <!-- standard complete process button -->
                    <div v-else>
                        <!-- complete process button (hide for 1.2 NFT and 4.1)-->
                        <div :class="[
                            (selectedSubprocess.id =='1.2' && template.TempData.contract.id =='c2968cb9-20f1-4820-9d7c-07975b39e8f6') ? 'hideAction' : '', 
                            (selectedSubprocess.id =='4.1' && template.TempData.contract.id =='c2968cb9-20f1-4820-9d7c-07975b39e8f6') ? 'hideAction' : '',
                            (selectedSubprocess.id =='4.3' && template.TempData.contract.id =='acdfebc3-8cfe-417e-be82-1d8b429113ce') ? 'hideAction' : ''
                            ]" >
                            <button v-if="selectedSubprocess.id == selectedBlock.nextState " type="button" class="btn btn-primary btn-sm" @click="subprocessComplete(selectedSubprocess)" style="float: right;" :disabled="completeSubprocess.buttonDisabled">
                                <span v-if="completeSubprocess.buttonProcessing" >
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    <span style="padding-left: 10px;">Processing</span>
                                </span>
                                <span v-else>
                                    <font-awesome-icon icon="fa-solid fa-check" />
                                    <span style="padding-left: 10px;">Complete Process</span>
                                </span>
                            </button> 
                        </div>
                    </div>

                </div>
            </b-modal>

            <!-- template details modal -->
            <b-modal id="template-details-modal" ref="template-details-modal" size="lg" title="Template Details" ok-only ok-variant="secondary" button-size="sm" ok-title="Close">
                <div id="blockchain-modal">

                    <!-- template summary -->
                    <table class="blockchain-info-table">
                        <tr>
                            <td style="padding-right: 10px;"><strong>Template Name</strong></td>
                            <td>{{template.TempData.contract.name }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Template ID</strong></td>
                            <td>{{template.TempData.contract.id }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Application</strong></td>
                            <td>{{template.TempData.contract.application }}</td>
                        </tr>                        
                        <tr>
                            <td style="padding-right: 10px;"><strong>Created</strong></td>
                            <td>{{template.TimeStamp }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Created by</strong></td>
                            <td>{{template.User }}</td>
                        </tr>   
                        <tr>
                            <td style="padding-right: 10px;"><strong>Template Owner</strong></td>
                            <td>{{template.Owner }}</td>
                        </tr>     
                        <tr>
                            <td style="padding-right: 10px;"><strong>Current State</strong></td>
                            <td>{{template.State }}</td>
                        </tr>
                    </table>

                    <br />

                    <!-- tabs -->
                    <b-tabs content-class="mt-3">

                        <!-- milestones view -->
                        <b-tab title="Process Flow" active>

                            <!-- expand and collapse all -->
                            <div class="expandCollapse">
                                <a href="" @click.prevent="expandAll()">expand all</a><span></span><a href="" @click.prevent="collapseAll()">collapse all</a>
                            </div>
                            
                            <!-- dynamic template structure -->
                            <div id="template-container">
                                <div v-for="milestone in template.TempData.contract.milestones" v-bind:key="milestone.id">

                                    <!-- milestones -->
                                    <div class="milestone" :class="[milestone.status]" @click="milestoneToggle(milestone.id)">
                                        
                                        <!-- icon Images -->
                                        <span>
                                            <!-- CAR-T & ART Icons -->
                                            <img v-if="milestone.iconImage == 1" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/1.png"/>
                                            <img v-if="milestone.iconImage == 2" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/2.png"/>
                                            <img v-if="milestone.iconImage == 3" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/3.png"/>
                                            <img v-if="milestone.iconImage == 4" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/4.png"/>
                                            <img v-if="milestone.iconImage == 5" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/5.png"/>
                                            <img v-if="milestone.iconImage == 6" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/6.png"/>
                                            <img v-if="milestone.iconImage == 7" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/7.png"/>
                                            <img v-if="milestone.iconImage == 8" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/8.png"/>
                                            <img v-if="milestone.iconImage == 9" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/9.png"/>
                                            <img v-if="milestone.iconImage == 10" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/10.png"/>
                                            <img v-if="milestone.iconImage == 11" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/11.png"/>
                                            <img v-if="milestone.iconImage == 12" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/12.png"/>

                                            <!-- Sperm Use Case NFT AI Test -->
                                            <img v-if="milestone.iconImage == 'SUCT-1'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/1.png"/>
                                            <img v-if="milestone.iconImage == 'SUCT-2'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/2.png"/>
                                            <img v-if="milestone.iconImage == 'SUCT-3'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/3.png"/>
                                            <img v-if="milestone.iconImage == 'SUCT-4'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/4.png"/>
                                            <img v-if="milestone.iconImage == 'SUCT-5'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/5.png"/>
                                            <img v-if="milestone.iconImage == 'SUCT-9'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/9.png"/>

                                            <!-- CSL HSC Icons -->
                                            <img v-if="milestone.iconImage == 'CSLHSC-1'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/CSLHSC/CSLHSC-1.png"/>
                                            <img v-if="milestone.iconImage == 'CSLHSC-2'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/CSLHSC/CSLHSC-2.png"/>
                                            <img v-if="milestone.iconImage == 'CSLHSC-3'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/CSLHSC/CSLHSC-3.png"/>
                                            <img v-if="milestone.iconImage == 'CSLHSC-4'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/CSLHSC/CSLHSC-4.png"/>
                                            <img v-if="milestone.iconImage == 'CSLHSC-5'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/CSLHSC/CSLHSC-5.png"/>
                                            <img v-if="milestone.iconImage == 'CSLHSC-6'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/CSLHSC/CSLHSC-6.png"/>

                                        </span>

                                        <!-- label -->
                                        <span class="milestone-label"> {{ milestone.id }}. {{ milestone.name }} </span>

                                        <!-- chevron -->
                                        <i v-bind:class="[milestone.expanded ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down']"></i>

                                        <div v-if="milestone.lastMilestone && !milestone.expanded" class="milestone-link-end"></div>
                                    </div>

                                    <!-- subprocesses -->
                                    <div v-if="milestone.expanded" class="subprocess-section">
                                        
                                        <!-- links -->
                                        <div v-if="milestone.subprocesses.length > 0" class="milestone-link-top"></div>
                                        <div v-if="milestone.subprocesses.length > 0 && !milestone.lastMilestone" class="milestone-link-bottom"></div>

                                        <!-- subprocess -->
                                        <div v-for="(subprocess, index) in milestone.subprocesses" v-bind:key="subprocess.id">
                                            <div class="subprocess-container">
                                                <div style="float: left;" class="template-process blank-process first-coloum-process"></div>

                                                <div class="template-process" :class="[subprocess.status]">
                                                    {{ subprocess.id }} {{ subprocess.name }}
                                                    <!-- <div class="subprocess-bottom-link"></div> -->
                                                    <div v-if="!subprocess.subprocessesParallel && index != milestone.subprocesses.length - 1" class=subprocess-bottom-link></div>
                                                </div>
                                            </div>

                                            <!-- subprocess area -->
                                            <div class="subprocess-area">

                                                <!-- links -->
                                                <div v-if="subprocess.subprocesses.length > 0" class="subprocess-link-top"></div>
                                                <div v-if="subprocess.subprocesses.length > 0 && !subprocess.linkBackToMilestone" class="subprocess-link-bottom"></div>
                                                <div v-if="subprocess.linkBackToMilestone" class="subprocess-link-back-to-milestone"></div>
                                                <div v-if="subprocess.subprocessesParallel" class="subprocesses-parallel-link"></div>

                                                <!-- subprocess -->
                                                <div v-for="subprocess in subprocess.subprocesses" v-bind:key="subprocess.id">
                                                    <div class="subprocess-container">
                                                        <div style="float: left;" class="template-process blank-process first-coloum-process"></div>
                                                        <div style="float: left;" class="template-process blank-process"></div>

                                                        <div class="template-process" :class="[subprocess.status]">
                                                            {{ subprocess.id }} {{ subprocess.name }}
                                                            <div v-if="!subprocess.isParallel" class="subprocess-bottom-link"></div>
                                                        </div>
                                                    </div>
                                                    
                                                    <!-- subprocess area -->
                                                    <div class="subprocess-area">

                                                        <!-- links -->
                                                        <div v-if="subprocess.subprocesses.length > 0" class="subprocess-subprocess-link-top"></div>
                                                        <div v-if="subprocess.subprocesses.length > 0" class="subprocess-subprocess-link-bottom"></div>
                                                        <div v-if="subprocess.subprocessesParallel" class="subprocesses-subprocess-parallel-link"></div>

                                                        <!-- subprocess of subprocesses-->
                                                        <div v-for="subprocess in subprocess.subprocesses" v-bind:key="subprocess.id">
                                                            <div class="subprocess-container">
                                                                <div style="float: left;" class="template-process blank-process first-coloum-process"></div>
                                                                <div style="float: left;" class="template-process blank-process"></div>
                                                                <div style="float: left;" class="template-process blank-process"></div>
                                                                
                                                                <div class="template-process" :class="[subprocess.status]">
                                                                    {{ subprocess.id }} {{ subprocess.name }}
                                                                    <div v-if="!subprocess.isParallel" class="subprocess-bottom-link"></div>
                                                                </div>
                                                            </div>

                                                        </div> 
                                                        <div v-if="subprocess.subprocesses.length > 0" class="subprocess-subprocess-subprocess-bottom-link-blank"></div>

                                                    </div>

                                                </div>
                                                <div v-if="subprocess.subprocesses.length > 0" class="subprocess-subprocess-bottom-link-blank"></div>

                                            </div>
                                            
                                        </div>
                                        <div class="subprocess-bottom-link-blank"></div>

                                    </div>

                                </div>
                                <div id="hide-end-of-line"></div>
                            </div>

                        </b-tab>

                        <!-- code view -->
                        <b-tab title="Code (JSON) View">
                            <pre><code>{{  template }}</code></pre>
                        </b-tab>

                    </b-tabs>

                </div>
            </b-modal>

            <!-- milestone modal (OLD CAN BE REMOVED)-->
            <b-modal id="milestone-modal" size="xl" v-bind:title="selectedMilestoneText" ok-only ok-variant="secondary" button-size="sm" ok-title="Close">
                <div>
                    <table class="blockchain-info-table">
                        <tr>
                            <td style="padding-right: 10px;"><strong>Process Type</strong></td>
                            <td>{{ selectedMilestoneType }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Process ID</strong></td>
                            <td>{{selectedBlock.displayid }}-{{ selectedMilestoneID }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Action Owner</strong></td>
                            <td>Authorised User</td>
                        </tr>     
                        <tr>
                            <td style="padding-right: 10px;"><strong>Status</strong></td>
                            <td v-if="processInProgress" class="milestoneS-status in-progres-status">IN PROGRESS</td>
                            <td v-else class="milestoneS-status">COMPLETED</td>
                        </tr>
                        <tr v-if="!processInProgress">
                            <td style="padding-right: 10px;"><strong>Completion Data</strong></td>
                            <td>{{ selectedMilestoneTimestamp }}</td>
                        </tr>
                    </table>

                    <div style="float:left; width:100%; margin-bottom: 10px;">
                        <hr />
                        <!-- google map (in progress) -->
                        <div v-if="processInProgress && locationMotSet" style="display: inline-block; width: 50%; padding-right: 20px; /*float: left;*/">
                            <BlockchainTrackingBlank ref="BlockchainTrackingBlank"/>
                        </div>

                        <!-- google map (complete) -->
                        <div v-else style="display: inline-block; width: 50%; padding-right: 20px; /*float: left;*/">
                            <BlockchainTracking ref="BlockchainTracking"/>
                        </div>

                        <!-- data -->
                        <div style="display: inline-block; width: 50%; padding-left: 20px; /*float: left;*/">

                            <!-- sections 1.1 (in progress) -->
                            <div v-if="processInProgress" class="chain infoBoxChain" style="float: left; margin-left: 20px; margin-right: 20px;">
                                <!-- location -->
                                <div class="chain-row chain-row-item">
                                    <!-- summary -->
                                    <div class="chain-label chain-label-complete">
                                        <!-- Icon and heading -->
                                        <img class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/location.png" />
                                        <div class="hover chain-label-complete infoBoxLabel">Location Information</div>
                                        <!-- <div class="hover completedText">Vitrafy Lab</div> -->

                                        <!-- info box -->
                                        <!-- <i @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_location ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i> -->
                                        <!-- <div v-if="!infoBoxClosed_location"> -->
                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                
                                                <!-- form -->
                                                <b-form-group id="input-group-2" label="Description:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_location_description"
                                                    placeholder="Description of the location"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Location:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    style="display: inline-block; width:360px;"
                                                    v-model="process_location"
                                                    placeholder="Start typing address"
                                                    required
                                                    ></b-form-input>
                                                    <b-button v-if="!detectingLocation" variant="primary" class="btn-sm" style="float: right; height: 33.19px; width: 58.42px" @click="detectLocation()">Detect</b-button>
                                                    <b-button v-else variant="primary" class="btn-sm" style="float: right; height: 33.19px; width: 58.42px" disabled><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></b-button>
                                                </b-form-group>

                                            </div>
                                        <!-- </div> -->
                                    </div>
                                </div>

                                <!-- doctor details -->
                                <div class="chain-row chain-row-item">
                                    <!-- summary -->
                                    <div class="chain-label chain-label-complete">
                                        <!-- Icon and heading -->
                                        <img class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/doctor.png" />
                                        <div class="hover chain-label-complete infoBoxLabel">Doctor Details</div>

                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                
                                                <!-- form -->
                                                <b-form-group id="input-group-2" label="Title:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_doctor_title"
                                                    placeholder="Enter title"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Surname:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_doctor_surname"
                                                    placeholder="Enter surname"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Firstname:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_doctor_firstname"
                                                    placeholder="Enter firstname"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Phone:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_doctor_phone"
                                                    placeholder="Enter phone number"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Email:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_doctor_email"
                                                    placeholder="Enter email address"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Profession:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_doctor_profession"
                                                    placeholder="Enter profession"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Registration number:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_doctor_reg_number"
                                                    placeholder="Enter registration number"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-3" label="Registration status:" label-for="input-3">
                                                    <b-form-select
                                                    id="input-3"
                                                    v-model="process_doctor_reg_status"
                                                    :options="process_doctor_reg_status_options"
                                                    required
                                                    ></b-form-select>
                                                </b-form-group>

                                            </div>
                                        <!-- </div> -->
                                    </div>
                                </div>

                                <div class="chain-row chain-row-item">
                                    <b-button variant="primary" class="btn-sm" style="float: right; height: 33.19px;" v-b-modal="'process-commit-to-blockchain-modal'">Commit to Blockchain</b-button>
                                </div>

                            </div>

                            <!-- sections 4.2 (completed) -->
                            <div v-else class="chain infoBoxChain" style="float: left; margin-left: 20px; margin-right: 20px;">

                                <!-- location -->
                                <div class="chain-row chain-row-item">
                                    <!-- summary -->
                                    <div class="chain-label chain-label-complete">
                                        <!-- Icon and heading -->
                                        <img @click="infoBoxClosed_location = !infoBoxClosed_location" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/location.png" />
                                        <div @click="infoBoxClosed_location = !infoBoxClosed_location" class="hover chain-label-complete infoBoxLabel">Location Information</div>
                                        <div @click="infoBoxClosed_location = !infoBoxClosed_location" class="hover completedText">Vitrafy Lab</div>

                                        <!-- info box -->
                                        <i @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_location ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                        <div v-if="!infoBoxClosed_location">
                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                <!-- Info here -->

                                                <table class="blockchain-info-table">
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Description</strong></td>
                                                        <td>Vitrafy Lab</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Address</strong></td>
                                                        <td>45 Selkirk Drive, Wendouree VIC 3355 Australia</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px; vertical-align: top;"><strong>Coordinates</strong></td>
                                                        <td>latitude: -37.530854124846904<br /> longitude: 143.84331081186326</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- doctor details -->
                                <div class="chain-row chain-row-item">
                                    <!-- summary -->
                                    <div class="chain-label chain-label-complete">
                                        <!-- Icon and heading -->
                                        <img @click="infoBoxClosed_doctor = !infoBoxClosed_doctor" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/doctor.png" />
                                        <div @click="infoBoxClosed_doctor = !infoBoxClosed_doctor" class="hover chain-label-complete infoBoxLabel">Doctor Details</div>
                                        <div @click="infoBoxClosed_doctor = !infoBoxClosed_doctor" class="hover completedText">Dr. Strange</div>

                                        <!-- info box -->
                                        <i @click="infoBoxClosed_doctor = !infoBoxClosed_doctor" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_doctor ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                        <div v-if="!infoBoxClosed_doctor">
                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                
                                                <table class="blockchain-info-table">

                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Title:</strong></td>
                                                        <td>Dr.</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Surname</strong></td>
                                                        <td>Strange</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Firstname:</strong></td>
                                                        <td>Stephen</td>
                                                    </tr>                                                                            
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Phone:</strong></td>
                                                        <td>+61 411 343 442</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Email:</strong></td>
                                                        <td>stephen.strange@email.com</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Profession</strong></td>
                                                        <td>Medical Doctor</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Registration number:</strong></td>
                                                        <td>123456789</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Registration status:</strong></td>
                                                        <td>Registered</td>
                                                    </tr>
                                                </table>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- patient -->
                                <div class="chain-row chain-row-item">
                                    <!-- summary -->
                                    <div class="chain-label chain-label-complete">
                                        <!-- Icon and heading -->
                                        <img @click="infoBoxClosed_patient = !infoBoxClosed_patient" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/user.png" />
                                        <div @click="infoBoxClosed_patient = !infoBoxClosed_patient" class="hover chain-label-complete infoBoxLabel">Patient Details</div>
                                        <div @click="infoBoxClosed_patient = !infoBoxClosed_patient" class="hover completedText">Joe Citizen</div>

                                        <!-- info box -->
                                        <i @click="infoBoxClosed_patient = !infoBoxClosed_patient" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_patient ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                        <div v-if="!infoBoxClosed_patient">
                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                
                                                <table class="blockchain-info-table">
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Title:</strong></td>
                                                        <td>Mr.</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Firstname:</strong></td>
                                                        <td>Joe</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Surname</strong></td>
                                                        <td>Citizen</td>
                                                    </tr>                                                                                                                                                        
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>DOB:</strong></td>
                                                        <td>23/05/1975</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Gender:</strong></td>
                                                        <td>Male</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Address:</strong></td>
                                                        <td>5 Selkirk Drive, Wendouree VIC 3355 Australia</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Phone:</strong></td>
                                                        <td>+61 456 345 345</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Email:</strong></td>
                                                        <td>joe.citizen@email.com</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><strong>Medical Info:</strong></td>
                                                        <td><a href="#">Click to view details</a></td>
                                                    </tr>
                                                </table>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- process -->
                                <div class="chain-row chain-row-item" style="width: 100%;">
                                    <!-- summary -->
                                    <div class="chain-label chain-label-complete">
                                        <!-- Icon and heading -->
                                        <img @click="infoBoxClosed_process = !infoBoxClosed_process" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/process.png" />
                                        <div @click="infoBoxClosed_process = !infoBoxClosed_process" class="hover chain-label-complete infoBoxLabel">Process Details</div>
                                        <div @click="infoBoxClosed_process = !infoBoxClosed_process" class="hover completedText">4.2 Cryopreservation</div>

                                        <!-- info box -->
                                        <i @click="infoBoxClosed_process = !infoBoxClosed_process" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_process ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                        <div v-if="!infoBoxClosed_process">
                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">

                                                    <!-- checks -->
                                                    <div class="process_heading">Prerequisite Checks</div>
                                                    <div class="chain-row chain-row-item">
                                                        <!-- summary -->
                                                        <div class="chain-label chain-label-complete">
                                                            <!-- Icon and heading -->
                                                            <img @click="infoBoxClosed_sample_checks = !infoBoxClosed_sample_checks" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/checks.png" />
                                                            <div @click="infoBoxClosed_sample_checks = !infoBoxClosed_sample_checks" class="hover chain-label-complete infoBoxLabel">Milestones</div>
                                                            <div @click="infoBoxClosed_sample_checks = !infoBoxClosed_sample_checks" class="hover completedText">3.2.5, 3.2.6, 3.2.7</div>

                                                            <!-- info box -->
                                                            <i @click="infoBoxClosed_sample_checks = !infoBoxClosed_sample_checks" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_sample_checks ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_sample_checks">
                                                                <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                    

                                                                    <table class="blockchain-info-table">
                                                                        <tr>
                                                                            <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <strong>3.2.5 </strong> <a href="#">MIoT cryopreservation device informed</a></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <strong>3.2.6 </strong> <a href="#">Racking system and protocol selected</a></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <strong>3.2.7 </strong> <a href="#">MIoT smart packaging device informed other devices</a></td>
                                                                        </tr>
                                                                    </table>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- sample -->
                                                    <div class="process_heading">Pre-Cryopreservation</div>
                                                    <div class="chain-row chain-row-item">
                                                        <!-- summary -->
                                                        <div class="chain-label chain-label-complete">
                                                            <!-- Icon and heading -->
                                                            <img @click="infoBoxClosed_sample = !infoBoxClosed_sample" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/sample.png" />
                                                            <div @click="infoBoxClosed_sample = !infoBoxClosed_sample" class="hover chain-label-complete infoBoxLabel">Sample Details</div>
                                                            <div @click="infoBoxClosed_sample = !infoBoxClosed_sample" class="hover completedText">Vitrafy 30mL Smart MIoT EVA Bag</div>

                                                            <!-- info box -->
                                                            <i @click="infoBoxClosed_sample = !infoBoxClosed_sample" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_sample ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_sample">
                                                                <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                    

                                                                    <table class="blockchain-info-table">
                                                                        <tr>
                                                                            <td style="padding-right: 10px; vertical-align: top;"><strong>Sample Description:</strong></td>
                                                                            <td style="white-space: break-spaces;">Human peripheral blood, isolated T-cells in 10% DMSO media</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style="padding-right: 10px;"><strong>Sample Volume:</strong></td>
                                                                            <td>20mL</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style="padding-right: 10px;"><strong>Package ID:</strong></td>
                                                                            <td>12345-67890-12345b</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style="padding-right: 10px;"><strong>Package Type:</strong></td>
                                                                            <td>Vitrafy 30mL Smart MIoT EVA Bag</td>
                                                                        </tr>
                                                                        <tr>
                                                                        <td style="padding-right: 10px;"><strong>Technical Info:</strong></td>
                                                                            <td><a href="#">Click to view details</a></td>
                                                                        </tr>
                                                                    </table>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- device -->
                                                    <div class="process_heading">Cryopreservation </div>
                                                    <div class="chain-row chain-row-item">
                                                        <!-- summary -->
                                                        <div class="chain-label chain-label-complete">
                                                            <!-- Icon and heading -->
                                                            <img @click="infoBoxClosed_device = !infoBoxClosed_device" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/device.png" />
                                                            <div @click="infoBoxClosed_device = !infoBoxClosed_device" class="hover chain-label-complete infoBoxLabel">Device Details</div>
                                                            <div @click="infoBoxClosed_device = !infoBoxClosed_device" class="hover completedText">Cryopreservation Apparatus</div>

                                                            <!-- info box -->
                                                            <i @click="infoBoxClosed_device = !infoBoxClosed_device" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_device ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_device">
                                                                <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                    

                                                                    <table class="blockchain-info-table">
                                                                        <tr>
                                                                            <td style="padding-right: 10px;"><strong>Device Name</strong></td>
                                                                            <td>Vitrafy-00004</td>
                                                                        </tr>                                                                                                        
                                                                        <tr>
                                                                            <td style="padding-right: 10px;"><strong>Device ID:</strong></td>
                                                                            <td>12345-76890-54321d</td>
                                                                        </tr>                                                                                                                                                
                                                                        <tr>
                                                                            <td style="padding-right: 10px;"><strong>Device Type:</strong></td>
                                                                            <td>Cryopreservation Apparatus</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style="padding-right: 10px;"><strong>Protocol</strong></td>
                                                                            <td><a href="#">Click to view details</a></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style="padding-right: 10px;"><strong>Schedule</strong></td>
                                                                            <td><a href="#">Click to view details</a></td>
                                                                        </tr>
                                                                    </table>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- reg -->
                                                    <div class="process_heading">Regulatory</div>
                                                    <div class="chain-row chain-row-item">
                                                        <!-- summary -->
                                                        <div class="chain-label chain-label-complete">
                                                            <!-- Icon and heading -->
                                                            <img @click="infoBoxClosed_sample_reg = !infoBoxClosed_sample_reg" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/checks.png" />
                                                            <div @click="infoBoxClosed_sample_reg = !infoBoxClosed_sample_reg" class="hover chain-label-complete infoBoxLabel">Regulatory compliance</div>
                                                            <div @click="infoBoxClosed_sample_reg = !infoBoxClosed_sample_reg" class="hover completedText">FDA, TGA, EMA</div>

                                                            <!-- info box -->
                                                            <i @click="infoBoxClosed_sample_reg = !infoBoxClosed_sample_reg" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_sample_reg ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_sample_reg">
                                                                <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                    

                                                                    <table class="blockchain-info-table">
                                                                        <tr>
                                                                            <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <strong>FDA </strong> <a href="#">click to view pdf standards</a></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <strong>TGA </strong> <a href="#">click to view pdf standards</a></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <strong>EMA </strong> <a href="#">click to view pdf standards</a></td>
                                                                        </tr>
                                                                    </table>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>  
                    </div>
                </div>
            </b-modal>

            <!-- Commit to blockchain modal -->
            <b-modal id="process-commit-to-blockchain-modal" title="Commit to Blockchain" @ok="processCommitToBlockchain">
                <div>
                    <b-alert show variant="warning"><font-awesome-icon icon="fa-solid fa-exclamation-circle" /><span style="padding-left: 10px;"><strong>Warning Alert</strong></span><br />This process is irreversible and will add an immutable record for this contract to the blockchain (test-network)</b-alert>
                    Are you sure you want to commit the following data to the blockchain?
                </div>

                <div style="margin-top: 15px">
                    <table class="blockchain-info-table">
                        <tr>
                            <td colspan="2">
                                <strong>LOCATION INFORMATION</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Description</strong></td>
                            <td>{{ process_location_description }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Address</strong></td>
                            <td>{{ process_location }}</td>
                        </tr>
                        <tr>
                            <td>
                                <br />
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <strong>DOCTOR DETAILS</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Title</strong></td>
                            <td>{{ process_doctor_title }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Surname</strong></td>
                            <td>{{ process_doctor_surname }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Firstname</strong></td>
                            <td>{{ process_doctor_firstname }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Phone</strong></td>
                            <td>{{ process_doctor_phone }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Email</strong></td>
                            <td>{{ process_doctor_email }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Profession</strong></td>
                            <td>{{ process_doctor_profession }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Registration number</strong></td>
                            <td>{{ process_doctor_reg_number }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><strong>Registration status</strong></td>
                            <td>{{ process_doctor_reg_status }}</td>
                        </tr>
                    </table> 
                </div>

                <template #modal-footer="{ cancel, ok }">
                    <b-button size="sm" variant="secondary" @click="cancel()">
                        Cancel
                    </b-button>                    
                    <b-button size="sm" variant="warning" @click="ok()">
                        Commit
                    </b-button>
                </template>
            </b-modal>

        </div>

    </div>
</template>

<script>
    import BlockchainTracking from '@/components/BlockchainTracking.vue';
    import BlockchainTrackingBlank from '@/components/BlockchainTrackingBlank.vue';
    import ML2 from '@/components/ML/ML2.vue';
    import CSLPackageSelectionAI from '@/components/CSL/CSLPackageSelectionAI.vue';
    import AWS from 'aws-sdk';
    import NFTVideoModal from '@/components/Blockchain/NFTVideoModal.vue';
    import PackagingTracking_dynamic from '@/components/PackagingTracking_dynamic.vue'; 
    import PackagingTracking_HuonTas_summary from '@/components/PackagingTracking_HuonTas_summary.vue'; 
    import PackagingTracking_HuonTas_summary_summary from '@/components/PackagingTracking_HuonTas_summary_summary.vue';
    import OCR from '@/components/ML/OCR.vue';
    
    import UserInfoStore from '@/app/user-info-store';

    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import QrcodeVue from 'qrcode.vue';
    import moment from 'moment';
    import { saveExcel } from '@progress/kendo-vue-excel-export';
    
    /* PDF Viewer */
    import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
    import { VueEditor } from "vue2-editor";


    // import QrcodeStream from 'vue-qrcode-reader';
    // import { StreamBarcodeReader } from "vue-barcode-reader";


    export default {
        name: 'blockchainDashboard',
        components: {
            BlockchainTracking,
            BlockchainTrackingBlank,
            ML2,
            CSLPackageSelectionAI,
            NFTVideoModal,
            PackagingTracking_dynamic,
            PackagingTracking_HuonTas_summary,
            PackagingTracking_HuonTas_summary_summary,
            OCR,
            QrcodeVue,
            DatePicker,
            VuePdfEmbed,
            VueEditor,
            // QrcodeStream,
            // StreamBarcodeReader,
        },
        data: function () {
            return {
                bcCache: [],

                aquacultureBlockChainTableName: '',

                aquacultureMasterMaleTemplateID: '932f342a-0eeb-4c45-9bf4-816a72315278',
                aquacultureMiltSampleTemplateID: '932f342a-0eeb-4c45-9bf4-816a72315280',
                aquaculturePackageTemplateID: '18719e55-99bf-4137-b7bb-fefd373f60b3',
                aquacultureMasterFemaleTemplateID: '932f342a-0eeb-5d69-9bf4-816a72315278',
                aquacultureEggBatchTemplateID: 'd6af0b83-0a59-48e4-84e0-5801e879acb9',
                aquacultureFertilisationTemplateID: '2fffff11-51f4-4fa8-980f-c9015e00aba4',
                cryopreservationBatchTemplateID: '37ee37ea-1572-471c-a6d2-4ceb9d42fc15',

                bovineMasterTemplateID: '',
                bovineSamplesTemplateID: '7a976520-bae3-478e-a397-784354f79970',
                bovinePackagesTemplateID: '7a976520-bae3-478e-a397-784354f79975',

                cslContractTemplateID: 'acdfebc3-8cfe-417e-be82-1d8b429113ce',

                fishMaleSummary: null,
                fishMaleInProgress: null,
                fishMaleCompleted: null,
                fishMaleSamples: null,
                fishMaleSamplesInProgress: null,
                fishMaleSamplesCompleted: null,
                fishMaleCryoBatches: null,
                fishMaleCryoBatchesInProgress: null,
                fishMaleCryoBatchesCompleted: null,
                fishMalePackages: null,
                fishMalePackagesInProgress: null,
                fishMalePackagesCompleted: null,
                
                fishFemaleSummary: null,
                fishFemaleInProgress: null,
                fishFemaleCompleted: null,
                fishFemaleEggBatches: null,
                fishFemaleEggBatchesInProgress: null,
                fishFemaleEggBatchesCompleted: null,

                deviceBatchData: [],

                initialWorldState: [],
                initialAquacultureSamples: [],
                completeSubprocess: {
                    buttonDisabled: true,
                    buttonProcessing: false,
                    cacheItem: null,
                },                     
                subprocess_input_validated: true,
                userInfo: UserInfoStore.state.cognitoInfo,
                current_user: null,
                firstLoad: true,
                loading: true,
                error: false,
                errorDetails: null,
                blockchain: [],
                blockchainInProgress: [],
                blockchainCompleted: [],
                blockchainTemplates: [],
                blockchainInProgressCountText: '',
                blockchainInProgressHuman: [],
                blockchainInProgressAquaculture: [],
                blockchainInProgressBovine: [],
                blockchainAquacultureFish: [],
                blockchainBovineBulls: [],
                blockchainBovineStackeds: [],
                contractName: null,
                contractApplication: null,
                contractApplicationOptionsHuman: [{ text: 'Select Application', value: null }, 'ART', 'CAR-T'],
                contractApplicationOptionsBovine: [{ text: 'Select Application', value: null }, 'ART'],
                contractApplicationOptionsAquaculture: [{ text: 'Select Application', value: null }, 'ART'],
                contractTemplate: null,
                contractTemplateOptions: [{ text: 'Select Template', value: null }],
                contractTemplateOptionsART: [{ text: 'Select Template', value: null,}],
                contractTemplateOptionsCART: [{ text: 'Select Template', value: null}],
                infoBoxClosed_1: true,
                infoBoxClosed_2: true,
                infoBoxClosed_3: true,
                infoBoxClosed_4: true,
                infoBoxClosed_5: true,
                infoBoxClosed_6: true,
                infoBoxClosed_7: true,
                infoBoxClosed_8: true,
                infoBoxClosed_9: true,
                infoBoxClosed_10: true,
                infoBoxClosed_11: true,
                infoBoxClosed_12: true,
                selectedBlock: {
                    TempData: {
                        stages: {},
                    }
                },
                selectedSubprocess: {
                    id: null,
                    name: null,
                    status: null,
                },
                template: {
                    TempData: {
                        contract: {
                            name: null,
                            id: null,
                        }
                    }
                },
                selectedMilestoneText: null,
                selectedMilestoneID: null,
                selectedMilestoneType: null,
                selectedMilestoneTimestamp: null,
                processInProgress: false,        
                process_1_1: true,
                process_1_2: false,
                infoBoxClosed_location: true,
                infoBoxClosed_patient: true,
                infoBoxClosed_doctor: true,
                infoBoxClosed_sample: true,
                infoBoxClosed_sample_checks: true,
                infoBoxClosed_sample_reg: true,
                infoBoxClosed_device: true,
                infoBoxClosed_process: true,
                locationMotSet: true,
                detectingLocation: false,
                process_location_description: null,
                process_location: null,
                process_doctor_name: null,
                process_doctor_title: null,
                process_doctor_firstname: null,
                process_doctor_surname: null,
                process_doctor_phone: null,
                process_doctor_email: null,
                process_doctor_profession: null,
                process_doctor_reg_number: null,
                process_doctor_reg_status: null,
                process_doctor_reg_status_options: [{ text: 'Select One', value: null }, 'Registered', 'Not registered'],
                contract_name_valid: null,
                contract_application_valid: null,
                contract_template_valid: null,
                newContractModalShow: false,
                block_template_ID: null,
                block_history: [],
                contractAllExpanded: false,
                testLocationLoaded: false,
                spermUseCase: {
                    donor: {
                        surname: null,
                        firstname: null,
                        phone: null,
                    }
                },
                NFTselected: null,
                NFToptions: [
                    { value: null, text: 'Select NFT Type' },
                    { value: 'master', text: 'Master (Fish ID)' },
                    { value: 'stacked', text: 'Stacked (Package ID)' },
                ],
                masterNFTselected: null,
                masterNFToptions: [
                    { value: '5584231', text: '5584231' },
                    { value: '7420081', text: '7420081' },
                ],                            
                NFT_wizard_steps: [
                    {
                        id: 1,
                        label: '1. Create NFT',
                        active: true,
                        complete: false
                    },
                    {
                        id: 2,
                        label: '2. Publish NFT',
                        active: false,
                        complete: false
                    },
                    {
                        id: 3,
                        label: '3. Mint NFT',
                        active: false,
                        complete: false
                    },
                    {
                        id: 4,
                        label: '4. Review & Complete',
                        active: false,
                        complete: false                            
                    }
                ],
                selectedStep: 1,
                NFT_wizard_loading: false,
                current_NFT_wizard_step: 1,
                NFT_wizard_complete: false,
                NFT: {
                    name: null,
                    type: null,
                    fishID: null,
                    packageID: null,
                    description: null,
                    image: null,
                    qr_hash: null,
                    user: null,
                    other:  null,
                },
                creating_nft: false,
                previewFileURL: null,
                fileToUpload: null,  
                imageData: null,
                tokenURI: null,
                uploading_json: false,
                uploading_image: false,
                mintResult: {
                    blockHash: null,
                    blockNumber: null,
                    from: null,
                    gasUsed: null,
                    to: null,
                    transactionHash: null,
                },
                mintResultMaster: {
                    blockHash: null,
                    blockNumber: null,
                    from: null,
                    gasUsed: null,
                    to: null,
                    transactionHash: null,
                },
                P_1_2: {
                    approved: "not_accepted"
                },
                P_2_1: {
                    cryoprotectant: null
                },
                P_2_2: {
                    motility: null,
                    concentration: null,
                    grade: null
                },
                P_2_3: {
                    packaging_cost: "55.00",
                    approved: "not_accepted"
                },       
                P_2_4: {
                    cryoprotectant_cost: "2.00",
                    approved: "not_accepted"
                },    
                P_2_5: {
                    preparation_cost: "0.00",
                    approved: "not_accepted"
                },
                P_3_1: {algorithm: null, moc: { temp: null, flow: null, time: null }},           
                P_3_2: {
                    preservation_cost: "0.00",
                    device: null,
                    batch_id: null,
                    fish_id: null,
                    started: null,
                    finished: null,
                    code: null,
                    protocol: null,                                                                                                                               
                    processed_time: null,
                    start_temp: null,
                    end_temp: null,
                    min_temp: null,
                    max_temp: null,
                    start_flow: null,
                    end_flow: null,
                    min_flow: null,
                    max_flow: null,
                },
                P_4_1: { dewar_id: null, cannister_number: null },
                P_4_2: {
                    removed: "not_accepted", removed_by: this.current_user
                },
                P_5_1: {
                    identification_package_checked: "not_accepted",
                    identification_package_id: null
                },
                P_5_1_identification_package_id_ref: null,
                qr_result: null,
                P_5_2: {algorithm: 'Vitrafy Aquaculture Bio-Thaw', moc: { temp: 25, flow: 30, time: 30 }},
                vitrafy_biothaw_devices: ['BioThaw-00001','BioThaw-00004'],
                P_5_3: {thawing_complete: 'not_accepted', thawing_device: null},
                P_6_1: {
                    motility: null,
                    concentration: null,
                    grade: null
                },
                P_7_1: { fertilisation_run_id: null },
                stacked_NFTs: [
                    { name: "Package ID-0011" },
                    { name: "Package ID-0008" },
                    { name: "Package ID-0007" },
                    { name: "Package ID-0005" },
                    { name: "Package ID-0006" },
                    { name: "Package ID-0003" },
                    { name: "Package ID-0098" },
                    { name: "Package ID-0004" },
                    { name: "Package ID-0002" },
                    { name: "Package ID-0001" },
                ],
                summary_sections: {
                    nft_expanded: false,
                    contract_expanded: false,
                    location_expanded: false,
                    financial_expanded: false,
                },

                /* CSL */
                csl_1_2: {reportURL: ''},
                /* Huon Fish (Master) Female */
                aquacultureMasterFemaleFish: [],
                huonFemaleMasterFish_1_1: { tag_id: null, year_class: null, facility: null, tank: null },
                huonFemaleMasterFish_2_1: { comment: null, spawn_comment: null, new_comment: null, weight: null, ovaplant: null, culled: null },
                huonFemaleMasterFish_3_1: { esky_id: null, egg_count: null },
                
                /* Huon Egg Batch */
                huonEggBatch_1_1: { master_tag_id: null, esky_id: null, egg_count: null },
                huonEggBatch_2_1: { transportDeviceID: null, tripID: null },
                huonEggBatch_2_2_pdf_URL: "",
                huonEggBatch_3_1: { fertilisation_run_id: null, incubators: [] },

                /* Fertilisation */
                aquacultureFertilisationMasters: [],
                huonFertilisation_1_1: { facility: null, date: null },
                huonFertilisation_2_1: { milt: [], egg_batch: [], milt_search: '', egg_search: '', egg_count_search: '', incubators: [] },
                huonFertilisationSelectedIncubator: null,
                aquacultureFertAddingIncubator: false,
                searchingForMilt: false,
                searchingForEggs: false,
                huonFertilisation_3_1: { result_comment: null },
                huonFertilisation_3_2: { result_comment: null },
                huonFertilisation_3_3: { result_comment: null },
                huonFertilisation_3_4: { result_comment: null },

                /* Huon Fish (Master) Male */
                aquacultureMasterMaleFish: [],
                huonMaleMasterFish_1_1: { tag_id: null, year_class: null, facility: null, tank: null, genetic_rank: null, is_neo: null },
                huonMaleMasterFish_2_1: { comment: null, spawn_comment: null, new_comment: null, weight: null, ovaplant: null, culled: null },
                huonMaleMasterFish_3_1: { fish_status: null },
                huonMaleMasterFish_3_2: {},
                /* Huon Sample (Stacked) */
                huonFishSample_1_1: { master_tag_id: null, sample_id: null },
                huonFishSample_2_1: { motility: null, concentration: null, grade: null },
                huonFishSample_3_1: { attachedPackages: [], packagesToFreeze: [], batches: [], cryopreserved_packages: [] },
                huonFishSample_3_2: { },
                huonFishSample_4_1: null,
                huonFishSample_4_2: null,
                deviceSelected: null,
                deviceConnectionIntervalID: null,
                batchTrackingActive: false,
                finalisingAquacultureBatchAndPackages: false,
                finalisingAquacultureIncubator: false,
                batchResultsFound: false,
                batchTrackingLoaderText: 'Looking for Batch Details...',
                batchDetectionProgressValue: null,
                packageToAttachToHuonSample: null,
                packageToAttachToHuonBatch: null,
                deviceBatchDetails: [],
                batchIDManualOverride: null,
                batchOverrideSearchTest: null,
                isBatchRowSelected: false,
                loadingSamplePackaging: false,
                package_checking_status_icon_class: 'fa-solid fa-qrcode',
                miltPackage_checking_status_icon_class: 'fa-solid fa-qrcode',
                egg_checking_status_icon_class: 'fa-solid fa-qrcode',
                vitrafyCryopreservationDevices :[{value: null, text: 'Choose device'}, {value: 5, text: 'Vitrafy-00005'}, {value: 7, text:  'Vitrafy-00007'}],
                huonHatcheries: [],
                exportingFishData: false,
                exportingFullFishData: false,

                /* SSI Smart Contract Template Props */
                ssi_sample_1_1: {sampleID: null, masterID: null, breed: 'Holstein'},
                ssi_sample_2_1: {transportDeviceID: null, tripID: null},
                ssi_masterIDs: [
                    {
                        value: '250HO16741', text: 'Bull 1', traits: [
                            { description: 'Mastitis ResistantPRO', link: 'https://bull.selectsires.com/assets/SSI-SharedImages/designations/MASTITIS_RESISTANCE_PRO.svg' },
                            { description: 'gender SELECTED Ultraplus', link: 'https://bull.selectsires.com/assets/SSI-SharedImages/designations/GENDER_SELECTED.svg' },      
                        ],
                        stackedItems: null,
                    },
                    {value: '7HO16276', text: 'Bull E'},
                    {value: '7HO16570', text: 'Bull 3'},
                    {value: '7HO16950', text: 'Bull 4'},
                    {value: '250HO16775', text: 'Bull 5'},
                ],
                transportDeviceIDs: ['Packaging Device 2'],
                time3: null,
                ssi_packaging_types: ['.25ml Straw', '.5ml Straw', 'Vitrafy Smart Packaging'],
                ssi_sample_2_2: {},
                ssi_sample_2_2_pdf_URL: null,
                ssi_sample_3_1: {},
                ssi_sample_3_2: {ssi_sperm_assessed: null, sperm_assessment: []},
                ssi_sample_3_2_pdf_URL: null,
                ssi_sample_3_3: {ssi_extender_added: null},
                ssi_sample_3_4: { _025_packagingQuantity: 0, _05_packagingQuantity: 0, smart_packagingQuantity: 0 },
                ssi_sample_3_5: {packages_filled: null, packages_sealed: null},
                ssi_sample_4_1: { stacked_packages: [], },

                ssi_package_1_1: {sampleID: null, masterID: null, packageType: null},
                ssi_package_2_1: {algorithm: null, moc: { temp: null, flow: null, time: null }},
                ssi_package_2_2: { cryopreservation_completed: null, cryopreservation_device: null, batch_id: null, moc: {batch_id: null, flow: null, temp: null, start_time: null, end_time: null} },
                ssi_package_3_1: { removed_from_storage: null, removed_from_storage_by: null },
                ssi_package_4_1: {
                    identification_package_checked: "not_accepted",
                    identification_package_id: null
                },
                ssi_package_4_1_identification_package_id_ref: null,

                ssi_package_4_2: {algorithm: 'Vitrafy Bovine Bio-Thaw', moc: { temp: 25, flow: 30, time: 30 } },
                ssi_package_4_3: {thawing_complete: 'not_accepted', thawing_device: null},
                ssi_package_5_1: {ssi_sperm_assessed: null, sperm_assessment: []},
                ssi_package_5_2: {ssi_sperm_assessed: null, sperm_assessment: []},

                vitrafy_devices: ['Vitrafy-00001', 'Vitrafy-00002', 'Vitrafy-00004', 'Vitrafy-00005', 'Vitrafy-00006', 'Vitrafy-00007', 'Vitrafy-00009'],

                /* Set-up of In Progress Tables and Fields */
                blockChainTableFields: [
                    { key: 'expand', label: '', thStyle: {width: '20px', 'max-width': '20px'}},
                    { key: 'contractname', label: 'Name', thStyle: {width: '250px'}, sortable: true, },
                    // { key: 'packages', label: 'Packages', sortable: true },
                    // { key: 'contracttype', label: 'Contract Type', thStyle: {width: '200px'}},
                    // { key: 'contractapplication', label: 'Application' },
                    { key: 'contractdatetime', label: 'Updated', sortable: true },   
                    { key: 'contractstate', label: 'Current State', sortable: true },
                    { key: 'contractprogress', label: 'Progress', thStyle: {width: '300px'}},
                ],
                blockChainCompletedTableFields: [
                    { key: 'contractname', label: 'Name', sortable: false, thStyle: {'min-width': '250px', 'vertical-align': 'middle', 'white-space': 'nowrap'}},
                    { key: 'contractapplication', label: 'Application', sortable: false, thStyle: {'min-width': '200px;','vertical-align': 'middle'}},
                    { key: 'contractdatetime', label: 'Created',  sortable: false, thStyle: {'min-width': '350px', 'vertical-align': 'middle', 'white-space': 'nowrap'}},   
                    { key: 'contractstate', label: 'Current State', sortable: false, thStyle: {'min-width': '200px', 'vertical-align': 'middle'} },
                    { key: 'contractprogress', label: 'Progress', sortable: false, thStyle: {'min-width': '500px;', width: '45%', 'vertical-align': 'middle'}},
                ],
                blockChainTemplatesTableFields: [
                    { key: 'contractname', label: 'Name', sortable: false, thStyle: {'min-width': '250px', 'vertical-align': 'middle', 'white-space': 'nowrap'} },
                    { key: 'contractapplication', label: 'Application', sortable: false },
                    { key: 'contractdatetime', label: 'Created',  sortable: false },
                    { key: 'contractauthor', label: 'Author', sortable: false },
                    { key: 'contractowner', label: 'Owner', sortable: false },
                    { key: 'contractversion', label: 'Version', sortable: false },
                ],
                blockChainSamplesTableFields: [
                    { key: 'expand', label: '', thStyle: {width: '20px', 'max-width': '20px'}, tdClass: 'sampleExpand'},
                    { key: 'contractname', label: 'Name', sortable: false, thStyle: {}},
                    { key: 'packages', label: 'Packages', sortable: false },
                    { key: 'contracttype', label: 'Contract Type', sortable: false, thStyle: {}},
                    { key: 'contractapplication', label: 'Application', sortable: false,},
                    { key: 'contractdatetime', label: 'Updated',  sortable: false, thStyle: {width: '120px'}},   
                    { key: 'contractstate', label: 'Current State', sortable: false, thStyle: {width: '220px'} },
                    { key: 'contractprogress', label: 'Progress', sortable: false, thStyle: {width: '200px'}},
                ],
                blockChainPackagesTableFields: [
                    { key: 'contractname', label: 'Name', thStyle: {}},
                    { key: 'contracttype', label: 'Type', thStyle: {}},
                    { key: 'contractdatetime', label: 'Updated', thStyle: {width: '120px'}}, 
                    { key: 'contractstate', label: 'Current State', thStyle: {width: '220px'}},
                    { key: 'contractprogress', label: 'Progress', thStyle: {width: '200px'}},
                ],
                bovineMasterBullTableFields: [
                    { key: 'expand', label: '', sortable: false, thStyle: {width: '20px', 'max-width': '20px'}, tdClass: 'tableExpand'},
                    { key: 'text', label: 'Bull', sortable: false, thStyle: {width: '130px'} },
                    { key: 'samples', label: 'Samples', sortable: false,thStyle: {width: '100px'}},
                    { key: 'value', label: 'External ID', sortable: false, thStyle: {}},
                    { key: 'traits', label: 'Traits', sortable: false, thStyle: {} , },
                ],
                aquacultureMasterFemaleFishTableFields: [
                    { key: 'expand', label: '', sortable: false, thStyle: {width: '20px', 'max-width': '20px', 'min-width': '20px'}, tdClass: 'tableExpand' },
                    { key: 'tag_id', tdClass: 'tdnowrap', label: 'Fish', sortable: false, thStyle: {width: '120px'} },
                    { key: 'egg_batches', label: 'Egg Batches', sortable: false, thStyle: {width: '220px'} },
                    { key: 'contractstate', label: 'Current State', thStyle: {width: '220px'}},
                    { key: 'contractprogress', label: 'Progress', thStyle: {width: '300px'}},
                ],
                aquacultureFishEggBatchTableFields: [
                    { key: 'expand', label: '', sortable: false, thStyle: {width: '20px', 'max-width': '20px', 'min-width': '20px'}, tdClass: 'tableExpand' },
                    { key: 'egg_batch', tdClass:'tdnowrap', label: 'Egg Batch', sortable: false, thStyle: {width: '300px'} },
                    { key: 'contractstate', label: 'Current State', thStyle: {width: '180px'}},
                    { key: 'contractprogress', label: 'Progress', thStyle: {width: '300px'}},
                ],
                aquacultureFertilisationMastersTableFields: [
                    { key: 'expand', label: '', sortable: false, thStyle: {width: '20px', 'max-width': '20px', 'min-width': '20px'}, tdClass: 'tableExpand' },
                    { key: 'fertilisation', tdClass:'tdnowrap', label: 'Fertilisation Season', sortable: false, thStyle: {width: '150px', 'min-width': '150px'} },
                    { key: 'facility', label: 'Facility', sortable: false, thStyle: {width: '200px'}  },
                    { key: 'contractstate', label: 'Current State', thStyle: {width: '200px'}},
                    { key: 'contractprogress', label: 'Progress', thStyle: {width: '280px'}},
                ],
                aquacultureMasterMaleFishTableFields: [
                    { key: 'expand', label: '', sortable: false, thStyle: {width: '20px', 'max-width': '20px'}, tdClass: 'tableExpand' },
                    { key: 'tag_id', tdClass:"tdnowrap", label: 'Fish', sortable: false, thStyle: {width: '100px'} },
                    { key: 'samples', label: 'Samples', sortable: false, thStyle: {width: '80px'} },
                    { key: 'facility', label: 'Facility', sortable: false, thStyle: {width: '80px'}  },
                    { key: 'genetic_rank', label: 'Genetic Rank', sortable: false, thStyle: {width: '150px'}  },
                    // { key: 'tank', label: 'Tank', sortable: false, thStyle: {width: '60px'} },
                    { key: 'is_neo', label: 'Neo?', sortable: false, thStyle: { width: '40%' } },
                ],
                aquacultureSampleTableFields: [
                    { key: 'expand', label: '', sortable: false, thStyle: {width: '20px', 'max-width': '20px'}, tdClass: 'tableExpand' },
                    { key: 'sample', tdClass:"tdnowrap", label: 'Sample', sortable: false, thStyle: {width: '80px'} },
                    { key: 'batches', label: 'Batches', sortable: false, thStyle: {width: '80px'} },
                    { key: 'grade', label: 'Grade', sortable: false, thStyle: {width: '100px'} },
                    { key: 'motility', label: 'Motility %', sortable: false, thStyle: {width: '100px'} },
                    { key: 'concentration', label: 'Concentration', sortable: false, thStyle: {width: '40%'} },
                ],
                aquacultureBatchTableFields: [
                    { key: 'expand', label: '', sortable: false, thStyle: {width: '20px', 'max-width': '20px'}, tdClass: 'tableExpand' },
                    { key: 'batch_id', tdClass:"tdnowrap", label: 'Batch', sortable: false, thStyle: {width: '60px'} },
                    { key: 'packages', label: 'Packages', sortable: false,thStyle: {width: '80px'} },
                    { key: 'cryopreservation_device', label: 'Device', sortable: false,thStyle: {width: '100px'} },
                    { key: 'started', tdClass:"tdnowrap", label: 'Started', sortable: false, thStyle: {width: '100px'} },
                    { key: 'ended', tdClass:"tdnowrap", label: 'Ended', sortable: false, thStyle: {width: '40%'} },
                ],
                aquaculturePackagesTableFields: [
                    { key: 'contractname', label: 'Package', tdClass:"tdnowrap", thStyle: {width: '150px'}, sortable: true, },
                    { key: 'contracttype', label: 'Type', thStyle: {width: '200px'}},
                    // { key: 'contractapplication', label: 'Application' },
                    { key: 'contractdatetime', label: 'Updated', sortable: true },   
                    { key: 'contractstate', label: 'Current State', sortable: true },
                    { key: 'contractprogress', label: 'Progress', thStyle: {width: '200px'}},
                    { key: 'attach', label: '', thStyle: {width: '30px'}},
                ],
                aquaculturePackagesToFreezeTableFields: [
                    { key: 'contractname', label: 'Package', thStyle: {width: '150px'}, sortable: true, },
                    { key: 'contractstate', label: 'Current State', sortable: true },
                    { key: 'contractprogress', label: 'Progress', thStyle: {width: '300px'}},
                    { key: 'attach', label: '', thStyle: {width: '30px'}},
                ],
                deviceBatchDetailsFields: [
                    { key: 'device_id', label: 'Device ID', thStyle: {width: '150px'}, sortable: true, },
                    { key: 'batch_id', label: 'Batch ID', sortable: true },
                    { key: 'start_time', label: 'Start Time', thStyle: {width: '300px'}},
                    { key: 'end_time', label: 'End Time', thStyle: {width: '300px'}},
                    { key: 'protocol', label: 'Protocol', thStyle: {width: '300px'}},
                ],
                ssiSpermAssessmentFields: [
                    { key: 'Concentration', label: 'Concentration' },
                    { key: 'Total_Motility', label: 'Motility' },
                    { key: 'Tot_No_Sperm_Analysed', label: '# Sperm Analysed' },
                    { key: 'DateAnalysed', label: 'Date Analysed' },
                    { key: 'AverageConfidence', label: 'Ave. Confidence' },
                    { key: 'Operator', label: 'Operator' },
                ],


                // Aquaculture
                currentPageAquacultureMalesFish: 1,
                currentPageAquacultureFemalesFish: 1,
                currentPageAquacultureFertilisation: 1,
                totalRowsAquacultureMalesFish: 0,
                totalRowsAquacultureFemalesFish: 0,
                totalRowsAquacultureFertilisation: 0,
                aquacultureMaleFishTableFilter: '',
                aquacultureFemaleFishTableFilter: '',
                aquacultureFertilisationTableFilter: '',
                aquaculturePerPage: 10,

                loadingText: null,
                loadingTextPhrases: [
                    "Loading... please wait.",
                    "Fetching data...",
                    "Processing your request...",
                    "Almost there...",
                    "Hang tight, we're working on it...",
                    "Just a moment...",
                    "Loading content...",
                    "Please be patient...",
                    "Gathering information...",
                    "This won't take long...",
                    "Loading resources...",
                    "Hold on, we're almost done...",
                    "Please wait while we load...",
                    "Loading data, please wait...",
                    "Preparing your experience...",
                    "Stay tuned...",
                    "We're getting things ready...",
                    "Just a bit more loading...",
                    "Thank you for your patience...",
                    "Loading, thank you for waiting...",
                    "Connecting to the blockchain...",
                    "Verifying transactions...",
                    "Syncing with the network...",
                    "Fetching blockchain data...",
                    "Processing blockchain requests...",
                    "Loading blockchain ledger...",
                    "Validating blocks...",
                    "Updating blockchain state...",
                    "Connecting to blockchain nodes...",
                    "Loading smart contracts...",
                    "Interacting with the blockchain...",
                    "Waiting for blockchain confirmation...",
                    "Loading decentralized data...",
                    "Fetching blockchain transactions...",
                    "Retrieving blockchain records...",
                    "Checking blockchain integrity...",
                    "Updating blockchain ledger...",
                    "Connecting to the decentralized network...",
                    "Loading blockchain information...",
                    "Ensuring blockchain security..."                    
                ]
            }
        },
        computed: { },
        props: ['showNFT','type','subtype','incomingBlockchainCache', 'year'],
        watch: {
            // type(newValue) {
            //     this.getBlockchain(newValue);
            // },
            async loading(newValue) {
                // setInterval(this.updateLoadingText, 3000);
                if (newValue){
                    this.timer = await setInterval(() => {
                        if(this.loading) {
                            this.loadingText = this.getRandomLoadingText(this.loadingTextPhrases);
                        }
                    }, 3000) // 3 sec
                }
                else clearInterval(this.timer);
            },
            async subtype(newValue) {
                console.log("Changed value to: ", newValue);
                this.loading = true;
                this.firstLoad = false;
                
                // Arbitrariliy sleeping for 100ms before sending the 'getBlockchain' request so as to not clog the CSS rendering process...
                setTimeout(()=>{this.getBlockchain(this.type);}, 100);
            },
            selectedBlock(newValue){
                this.ssi_sample_1_1.sampleID = newValue.name;
            },
            // Toggle 'select all'
            bovineStackedContractsTrackingSelectAll(newVal) {
                this.selectedBlock.stackedItems.forEach((item) => {item.selected = newVal;});
            }
        },
        methods: {
            transactionClick(process) {
                // find process and load modal with process data                
                for(let i = 0; i < this.template.TempData.contract.milestones.length; i++) {
                    let milestone = this.template.TempData.contract.milestones[i];
                    for(let x = 0; x < milestone.subprocesses.length; x++) {
                        let subprocess = milestone.subprocesses[x];
                        if (process == subprocess.id) {
                            this.sendInfo_subprocess(subprocess);
                        }
                    }
                }
            },
            set_file(e) {
                let file = e.target.files[0];
                this.previewFileURL = URL.createObjectURL(file);
                this.fileToUpload = file;
            },
            async s3ImageUpload() {
                this.uploading_image = true;

                this.NFT.type = this.NFTselected;
                console.log("this.NFT.type = " + this.NFT.type);

                // adjust for master NFT
                if (this.NFT.type == 'master') {
                    this.NFT.name = this.NFT.fishID;
                    this.NFT.packageID = 'NA'
                }

                if (this.NFT.type == 'stacked') {
                    this.NFT.name = this.NFT.packageID;
                    this.NFT.fishID = this.masterNFTselected;
                    this.NFT.packageID = this.NFT.packageID;                
                }

                // automatically set values for the rest of the NFT properties
                this.NFT.description = "description here";
                this.NFT.qr_hash = "qr hash here";
                this.NFT.user = "user";
                this.NFT.other = "other info";

                console.log("----------");
                console.log("this.NFT.name = " + this.NFT.name);
                console.log("this.NFT.fishID  = " + this.NFT.fishID );
                console.log("this.NFT.packageID = " + this.NFT.packageID);
                console.log("this.NFT.type = " + this.NFT.type);
                console.log("this.NFT.description = " + this.NFT.description);
                console.log("this.NFT.qr_hash = " + this.NFT.qr_hash);
                console.log("this.NFT.user = " + this.NFT.user);
                console.log("this.NFT.other = " + this.NFT.other);
                console.log("----------");


                console.log("this.previewFileURL = " + this.previewFileURL);
                console.log("this.fileToUpload = " + this.fileToUpload);

                let bucket = 'lc-token-testing';
                let filename = this.fileToUpload.name;
                console.log(this.fileToUpload.name);

                // override filename with ID
                let extention = filename.split('.')[1];

                if (this.NFT.type == 'master') {
                    filename = this.NFT.fishID + '.' + extention;
                }

                if (this.NFT.type == 'stacked') {
                    filename = this.NFT.packageID + '.' + extention;
                }                

                let upload = new AWS.S3.ManagedUpload({
                    params: {
                        Bucket: bucket,
                        Key: filename,
                        Body: this.fileToUpload,
                        ACL: "public-read",
                        'Content-Type': 'image/png'
                    }
                });

                let promise = await upload.promise();
                this.imageData = promise;
                console.log(this.imageData.Location);
                this.NFT.image = this.imageData.Location;

                this.uploading_image = false;

                this.NFT_wizard_button('forward');
                this.selectedStep = 2;
            },
            async s3JSONDataUpload() {
                this.uploading_json = true;
                let JSONData = {
                    name: this.NFT.name,
                    type: this.NFT.type,
                    fishID: this.NFT.fishID,
                    packageID: this.NFT.packageID,
                    image: this.NFT.image,
                    description: this.NFT.description,
                    qr_hash: this.NFT.qr_hash,
                    user: this.NFT.user,
                    other: this.NFT.other
                }

                console.log("JSONData = " + JSONData);

                let buf = Buffer.from(JSON.stringify(JSONData));
                console.log(buf);

                let bucket = 'lc-token-testing';
                
                let filename = this.NFT.image.split("/")[3].split(".")[0] + ".json";
                console.log(filename);

                let upload = new AWS.S3.ManagedUpload({
                    params: {
                        Bucket: bucket,
                        Key: filename,
                        Body: buf,
                        ACL: "public-read",
                        'Content-Type': 'application/json'
                    }
                });

                let promise = await upload.promise();
                this.jsonData = promise;
                console.log(this.jsonData.Location);
                this.tokenURI = this.jsonData.Location;
          
                this.uploading_json = false;

                this.NFT_wizard_button('forward');
                this.selectedStep = 3;
                // min NFT
                //this.createNFT();
            },
            getPdfUrl(key, s3bucket) {
                let bucketName = s3bucket;
                // console.log("Retrieving PDF URL, KEY: " + key)
                
                // Create an S3 client instance
                const S3 = require('aws-sdk/clients/s3');
                const s3 = new S3();

                // console.log("Getting URL FROM S3")
                // Get the object using getObject method
                return new Promise((resolve, reject) => {
                    s3.getObject({ Bucket: bucketName, Key: key }, (err/*, data*/) => {
                    if (err) {
                        console.log("Errored: " + err)
                        reject(err);
                    } else {
                        // Generate a temporary object URL for the PDF
                        let objectUrl = s3.getSignedUrl('getObject', {
                            Bucket: bucketName,
                            Key: key,
                            Expires: 60 * 10 // URL expires in 10 mins
                        });
                        //console.log("Retrieved URL from S3: ")
                        console.log(objectUrl)

                        resolve(objectUrl);
                        return objectUrl;
                    }
                    });
                });
            },
            async createNFT() {
                this.creating_nft = true;
                console.log("create NFT clicked!");
                console.log("tokenURI = " + this.tokenURI);

                try {
                    let url = process.env.VUE_APP_NFT_API_URI;
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    let data = {
                        "api":"createNFT",
                        "path": this.tokenURI
                    };
                    data = JSON.stringify(data);

                    let response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    console.log(response.data);

                    this.mintResult = response.data;
                    console.log("Mint Result: ")
                    console.log(this.mintResult)

                    this.creating_nft = false;
                    //this.closeModal();

                    this.NFT_wizard_button('forward');
                    this.selectedStep = 4;
                } catch (error) {
                    console.log(error);
                }
            },
            retrieveInitialBlockchainFromDynamo(){

            },
            async retrieveBlockchainFromAPI(contract){
                let items = [];
                let lastEvaluatedKey;
                const blockChainTableName = this.aquacultureBlockChainTableName;
                
                const headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };

                if (contract) {
                    // console.log("Getting single item: ", contract, " from API...")
                    let params = new URLSearchParams({
                        TableName: blockChainTableName,
                        ContractID: contract/*,
                        TimeStamp: contract.TimeStampEpoch*/
                    });
                    
                    let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + `?${params}`; // Build the URL with query params

                    try {
                        // console.log("Makingr request... URL: ", url, " Headers: ", headers, " Params: ", params);
                        let response = await this.$http.get(url, { headers });
                        
                        // console.log("Items retrieved: ", response.length)
                        items = response.data.Items
                        // console.log("API Response: ", response)
                        
                    }
                    catch (error) {
                        console.error("Error fetching item: ", error);
                    }
                }
                else {
                    if (this.bcCache.length > 0) {
                        console.log("Using bcCache from parent");
                        items = this.bcCache;
                    }
                    else {
                        // console.log("Getting ALL items from API...")
                        do {
                            let params;
                            
                            //console.log("Looping... LAst evaluated key: ", lastEvaluatedKey)
                            if (!lastEvaluatedKey) params = new URLSearchParams({ TableName: blockChainTableName });
                            else params = new URLSearchParams({
                                TableName: blockChainTableName,
                                ExclusiveStartKey: JSON.stringify(lastEvaluatedKey)
                            });
                            
                            let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + `?${params}`; // Build the URL with query params

                            try {
                                // console.log("Makingr request... URL: ", url, " Headers: ", headers, " Params: ", params);
                                let response = await this.$http.get(url, { headers });
                                
                                // console.log("Items retrieved: ", response.length)
                                items = items.concat(response.data.Items);
                                lastEvaluatedKey = response.data.LastEvaluatedKey;
                            }
                            catch (error) {
                                console.error('Error fetching items:', error);
                                break; // Exit the loop if there's a critical error
                            }
                        } while (lastEvaluatedKey);

                    }
                }

                // Use the 'items' array for further processing or display in your Vue component
                //console.log('All items retrieved:', items);
                //console.log('All items retrieved (stringified):', JSON.stringify(items));
                // console.log('All items retrieved...', );

                return items;
            },
            async getBlockchain(type, fromSubprocessCompleted) {
                console.log("In 'getBlokcchain'... this.bcCache.length: ", this.bcCache.length)
                
                if(!fromSubprocessCompleted) {
                    this.loading = true;
                }

                this.currentPageAquacultureMalesFish = 1;
                this.currentPageAquacultureFemalesFish = 1;
                this.currentPageAquacultureFertilisation = 1;

                this.errorDetails = null;
                this.blockchain = [];
                this.blockchainInProgress = [];
                this.blockchainBovineBulls = [];
                this.blockchainBovineStackeds = [];
                this.blockchainCompleted = [];
                this.blockchainTemplates = [];
                this.aquacultureMasterMaleFish = [];
                this.aquacultureMasterFemaleFish = [];
                this.aquacultureFertilisationMasters = [];
                this.contractTemplateOptionsART = [{ text: 'Select Template', value: null}];
                this.contractTemplateOptionsCART = [{ text: 'Select Template', value: null}];

                this.fishMaleSummary = null;
                this.fishMaleInProgress = null;
                this.fishMaleCompleted = null;
                this.fishMaleSamples = null;
                this.fishMaleSamplesInProgress = null;
                this.fishMaleSamplesCompleted = null;
                this.fishMaleCryoBatches = null;
                this.fishMaleCryoBatchesInProgress = null;
                this.fishMaleCryoBatchesCompleted = null;
                this.fishMalePackages = null;
                this.fishMalePackagesInProgress = null;
                this.fishMalePackagesCompleted = null;

                this.fishFemaleSummary = null;
                this.fishFemaleInProgress = null;
                this.fishFemaleCompleted = null;
                this.fishFemaleEggBatches = null;
                this.fishFemaleEggBatchesInProgress = null;
                this.fishFemaleEggBatchesCompleted = null;

                console.log("Refreshing Blockchain...")
                try {
                    // Minor issue occurs when we switch between Aquaculture and other tabs, so need to refresh the Blockchain fully
                    // console.log(" Is first load in getBlokcchain: ", this.firstLoad)
                    if (!this.firstLoad && this.subtype == "Aquaculture") {
                        // console.log("Refreshing blokcchain duye to aqua refresh bug...");
                        this.firstLoad = true;
                        this.bcCache = [];
                        this.bcCache = await this.retrieveBlockchainFromAPI();
                    }
                    let tempBlockChain = await this.retrieveBlockchainFromAPI();
                    this.blockchain = JSON.parse(JSON.stringify(tempBlockChain)); // We want a clone/shallow copy to preserve original cache
                    // console.log("this.blockchain: ", this.blockchain)
                }
                catch (e) {
                    console.log("There was an error retrieving blockchain from the API: ", e);
                }
                
                console.log("Blockchain refreshed, building in progress, etc...")
                try {                    
                    // Initialise the 'World State' and keep it in memory
                    this.initialWorldState = this.blockchain;
                    this.initialAquacultureSamples = this.initialWorldState.filter((contractToFind) => contractToFind.TempData.TemplateID == this.aquacultureMiltSampleTemplateID && contractToFind.State == '1.1')

                    // Get Bovine Master (Bull) records
                    for (let mb = 0; mb < this.ssi_masterIDs.length; mb++) {
                        this.ssi_masterIDs[mb].stackedItems = this.blockchain.filter(item => item.TempData.TemplateID == '7a976520-bae3-478e-a397-784354f79970' && item.State == '1.1' && item.TempData.ProcessData !== undefined && item.TempData.ProcessData.bullID !== undefined && item.TempData.ProcessData.bullID == this.ssi_masterIDs[mb].value)//[0]
                    }
                    
                    // find latest entry for each asset (worldstate)
                    let worldState = [];

                    // find unqiue id's
                    for(let b = 0; b < this.blockchain.length; b++) {
                        if (b == 0) {
                            worldState.push(this.blockchain[b]);
                        } else {
                            let exists = false;
                            for(let w = 0; w < worldState.length; w++) {
                                if (this.blockchain[b].ID == worldState[w].ID) {
                                    exists = true;
                                }
                            }
                            if (!exists) {
                                worldState.push(this.blockchain[b]);
                            }
                        }
                    }
                    
                    // find latest transaction of each id
                    for(let a = 0; a < worldState.length; a++) {
                        for(let c = 0; c < this.blockchain.length; c++) {
                            if (this.blockchain[c].ID == worldState[a].ID) {
                                if (parseInt(this.blockchain[c].TimeStamp) > parseInt(worldState[a].TimeStamp)) {
                                    worldState[a] = this.blockchain[c];
                                }
                            }
                        }
                    }
                    this.blockchain = worldState;
                    
                    // filter blockchain
                    let temp = [];
                    let ts;
                    let tsa;

                    for (let i = 0; i < this.blockchain.length; i++) {
                        ts = new Date(parseInt(this.blockchain[i].TimeStamp));
                        this.blockchain[i].datetime = ts;
                        temp.push(this.blockchain[i])

                        if (this.blockchain[i].State == "TEMPLATE") {
                            this.blockchain[i].TimeStamp = this.convertBlockTimestamp(this.blockchain[i].TimeStamp);
                        } else {
                            let idt = this.blockchain[i].ID.toString().split(':');
                            this.blockchain[i].displayid = idt[0];
                            this.blockchain[i].TimeStamp = idt[1];
                            this.blockchain[i].TimeStampEpoch = idt[1];
                            
                            // SSI Packages are stacked, so include the master name
                            if (this.blockchain[i].TempData.TemplateID == "7a976520-bae3-478e-a397-784354f79975"){
                                this.blockchain[i].name = idt[2]+ ' ' + idt[3];
                            }
                            else {
                                this.blockchain[i].name = idt[2];
                            }
                            
                            ts = new Date(parseInt(this.blockchain[i].TimeStamp));
                            tsa = ts.toLocaleString('en-AU').toUpperCase();
                            let tsb = ts.toLocaleString('en-us', {  weekday: 'short' }) + ' ' + tsa;
                            this.blockchain[i].TimeStamp = tsb.replace(',', '');
                        }
                    }
                    
                    this.blockchain = temp;
                    // reorder devices by creation time
                    this.blockchain.sort(function(a, b){
                        if (a.TimeStampEpoch > b.TimeStampEpoch) { return -1; }
                        if (a.TimeStampEpoch < b.TimeStampEpoch) { return 1; }
                        return 0;
                    })

                    // split blockchain into "In Progress", "complete" and "Template"
                    for (let i = 0; i < this.blockchain.length; i++) {
                        if (this.blockchain[i].State != "TEMPLATE") {
                                this.blockchainInProgress.push(this.blockchain[i]);
                        } else {
                            this.blockchainTemplates.push(this.blockchain[i]);

                            let template = { text: this.blockchain[i].TempData.contract.name, value: this.blockchain[i].TempData.contract.id }
                            
                            if (this.blockchain[i].TempData.contract.application == "ART") { this.contractTemplateOptionsART.push(template); }
                            if (this.blockchain[i].TempData.contract.application == "CAR-T") { this.contractTemplateOptionsCART.push(template); }
                        }
                    }

                    // Identify current state, next state and progress
                    // -------------------------------------------------------------
                    // contracts (in progress)
                    for(let c = 0; c < this.blockchainInProgress.length; c++) {
                        
                        let processes = [];
                        let processesNames = [];
                        // templates
                        for(let t = 0; t < this.blockchainTemplates.length; t++) {
                            // find contract template
                            if (this.blockchainTemplates[t].TempData.contract.id == this.blockchainInProgress[c].TempData.TemplateID) {
                                // milestones 
                                for(let m = 0; m < this.blockchainTemplates[t].TempData.contract.milestones.length; m++) {
                                    // subprocesses (L1)
                                    for(let sl1 = 0; sl1 < this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses.length; sl1++) {
                                        processes.push(this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses[sl1].id);
                                        processesNames.push(this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses[sl1].name);
                                        // subprocesses (L2))
                                        for(let sl2 = 0; sl2 < this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses[sl1].subprocesses.length; sl2++) {
                                            processes.push(this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].id);
                                            processesNames.push(this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].name);
                                            // subprocesses (L3)
                                            for(let sl3 = 0; sl3 < this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].subprocesses.length; sl3++) {
                                                processes.push(this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].subprocesses[sl3].id);
                                                processesNames.push(this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].subprocesses[sl3].name);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        
                        let currentCount = 0;
                        let nextState = "unknown";
                        let nextStateName = "unknown";

                        // calculate next state
                        for(let p = 0; p < processes.length; p++) {
                            if (processes[p] == this.blockchainInProgress[c].State) {
                                currentCount = (p +1);
                                nextState = processes[p +1];
                                nextStateName = processesNames[p +1];
                            }
                        }

                        if (this.blockchainInProgress[c].State == 0) {
                            this.blockchainInProgress[c].nextState = '1.1';
                            this.blockchainInProgress[c].nextStateName = processesNames[0];
                        } else {
                            this.blockchainInProgress[c].nextState = nextState;
                            this.blockchainInProgress[c].nextStateName = nextStateName;
                        }                 

                        // calc percentage complete
                        this.blockchainInProgress[c].stateProgress = ((100/processes.length) * currentCount).toFixed(0);

                        // find completed contracts
                        if (this.blockchainInProgress[c].stateProgress == 100) {
                            this.blockchainInProgress[c].nextState = "Complete";
                            this.blockchainCompleted.push(this.blockchainInProgress[c]);
                        }

                        // debug
                        /*console.log("---------------");
                        console.log("PROCESS DETAILS");
                        console.log("contract = " + this.blockchainInProgress[c].name);
                        console.log("TimeStamp = " + this.blockchainInProgress[c].TimeStampEpoch);
                        console.log("total = " + processes.length);
                        console.log("current count = " + currentCount);
                        console.log("current state = " + this.blockchainInProgress[c].State);
                        console.log("next state = " + this.blockchainInProgress[c].nextState);
                        console.log("next state text = " + this.blockchainInProgress[c].nextStateName);
                        console.log("progress = " + this.blockchainInProgress[c].stateProgress + "%");*/

                        // ----------------------------------------------
                        // Split Human type further into Human and Bovine
                        // ----------------------------------------------
                        let q = 0;
                        let blockchainInProgressFiltered = [];
                        let blockchainCompletedFiltered = [];
                        let blockchainTemplatesFiltered = [];

                        // remove Human contracts for Bovine
                        if (this.subtype == "Bovine") {
                            // IN PROGRESS
                            for(q = 0; q < this.blockchainInProgress.length; q++) {
                                if(this.blockchainInProgress[q].TempData.TemplateID != "0e9f0c83-df43-40fb-ace9-01adacfeccaf" && // Assisted Reproductive Therapy (ART) - Template
                                    this.blockchainInProgress[q].TempData.TemplateID != "954b11cc-c469-4e4f-80e9-30376cff9d03" && // CAR-T (Chimeric Antigen Receptor T-Cell) Therapy - Template
                                    this.blockchainInProgress[q].TempData.TemplateID != "c2968cb9-20f1-4820-9d7c-07975b39e8f6") // Human Sperm - Template
                                    blockchainInProgressFiltered.push(this.blockchainInProgress[q]);
                            }
                            this.blockchainInProgress = blockchainInProgressFiltered;

                            // COMPLETED
                            for(q = 0; q < this.blockchainCompleted.length; q++) {
                                if(this.blockchainCompleted[q].TempData.TemplateID != "0e9f0c83-df43-40fb-ace9-01adacfeccaf" && // Assisted Reproductive Therapy (ART) - Template
                                    this.blockchainCompleted[q].TempData.TemplateID != "954b11cc-c469-4e4f-80e9-30376cff9d03" && // CAR-T (Chimeric Antigen Receptor T-Cell) Therapy - Template
                                    this.blockchainCompleted[q].TempData.TemplateID != "c2968cb9-20f1-4820-9d7c-07975b39e8f6") // Human Sperm - Template
                                    blockchainCompletedFiltered.push(this.blockchainCompleted[q]);
                            }
                            this.blockchainCompleted = blockchainCompletedFiltered;
                            
                            // TEMPLATES
                            for(q = 0; q < this.blockchainTemplates.length; q++) {
                                if(this.blockchainTemplates[q].TempData.contract.id != "0e9f0c83-df43-40fb-ace9-01adacfeccaf" && // Assisted Reproductive Therapy (ART) - Template
                                    this.blockchainTemplates[q].TempData.contract.id != "954b11cc-c469-4e4f-80e9-30376cff9d03" && // CAR-T (Chimeric Antigen Receptor T-Cell) Therapy - Template
                                    this.blockchainTemplates[q].TempData.contract.id != "c2968cb9-20f1-4820-9d7c-07975b39e8f6") // Human Sperm - Template
                                    blockchainTemplatesFiltered.push(this.blockchainTemplates[q]);
                            }
                            this.blockchainTemplates = blockchainTemplatesFiltered;                                
                        }
                        
                        // remove Bovine contracts for Human
                        if (this.subtype == "Human") {
                            // IN PROGRESS
                            for(let q = 0; q < this.blockchainInProgress.length; q++) {
                                if(this.blockchainInProgress[q].TempData.TemplateID != "7a976520-bae3-478e-a397-784354f79970" && // SSI Sample - Template
                                    this.blockchainInProgress[q].TempData.TemplateID != "7a976520-bae3-478e-a397-784354f79975") // SSI Package - Template
                                    blockchainInProgressFiltered.push(this.blockchainInProgress[q]);
                            }
                            this.blockchainInProgress = blockchainInProgressFiltered;

                            // COMPLETED
                            for(let q = 0; q < this.blockchainCompleted.length; q++) {
                                if(this.blockchainCompleted[q].TempData.TemplateID != "7a976520-bae3-478e-a397-784354f79970" && // SSI Sample - Template
                                    this.blockchainCompleted[q].TempData.TemplateID != "7a976520-bae3-478e-a397-784354f79975") // SSI Package - Template
                                    blockchainCompletedFiltered.push(this.blockchainCompleted[q]);
                            }
                            this.blockchainCompleted = blockchainCompletedFiltered;
                            
                            // TEMPLATES
                            for(let q = 0; q < this.blockchainTemplates.length; q++) {
                                if(this.blockchainTemplates[q].TempData.contract.id != "7a976520-bae3-478e-a397-784354f79970" && // SSI Sample - Template
                                    this.blockchainTemplates[q].TempData.contract.id != "7a976520-bae3-478e-a397-784354f79975") // SSI Package - Template
                                    blockchainTemplatesFiltered.push(this.blockchainTemplates[q]);
                            }
                            this.blockchainTemplates = blockchainTemplatesFiltered;       
                        }   
                        // ---
                        // END
                        // ---                        
                    }
                    
                    // set completed tab heading
                    this.blockchainCompletedCount = "Completed (" + this.blockchainCompleted.length + ")";

                    // remove "completed" contract from "in progress"
                    for(let i = 0; i < this.blockchainInProgress.length; i++) {
                        for(let x = 0; x < this.blockchainCompleted.length; x++) {
                            if (this.blockchainInProgress[i].ID == this.blockchainCompleted[x].ID){
                                this.blockchainInProgress.splice(i, 1);
                            }
                        }
                    }

                    this.blockchainInProgressCountText = "In Progress (" + this.blockchainInProgress.length + ")";
                    this.blockchainTemplatesCount = "Templates (" + this.blockchainTemplates.length + ")";
                    console.log("blockchainInProgress = " + this.blockchainInProgress.length);

                    // add updated field
                    for(let i = 0; i < this.blockchainInProgress.length; i++) {

                        const date = new Date(this.blockchainInProgress[i].datetime);

                        this.blockchainInProgress[i].TimeStampEpochUpdated = date.getTime();

                        // Days array to get the day of the week
                        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
                        const dayOfWeek = days[date.getDay()];

                        // Formatting month, day, year
                        const day = String(date.getDate()).padStart(2, '0');
                        const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
                        const year = date.getFullYear();

                        // Formatting hours, minutes, seconds for 12-hour format with AM/PM
                        let hours = date.getHours();
                        const ampm = hours >= 12 ? 'PM' : 'AM';
                        hours = hours % 12;
                        hours = hours ? hours : 12; // the hour '0' should be '12'
                        const minutes = String(date.getMinutes()).padStart(2, '0');
                        const seconds = String(date.getSeconds()).padStart(2, '0');

                        // Assembling the formatted date
                        const formattedDate = `${dayOfWeek} ${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;

                        this.blockchainInProgress[i].datetime = formattedDate;
                    }                    

                    // re-order blockchainInProgress by latest updated
                    this.blockchainInProgress.sort((a, b) => b.TimeStampEpochUpdated - a.TimeStampEpochUpdated);

                    // apply blockchain type filter
                    // ----------------------------
                    console.log("TYPE = " + type);


                    // blockchainInProgress
                    let blockchainInProgressHuman = [];
                    let blockchainInProgressAquaculture = [];
                    let blockchainInProgressBovine = [];

                    // split in progress contracts into Human, Bovine and Aquaculture
                    for(let i = 0; i < this.blockchainInProgress.length; i++) {
                        if (
                            this.blockchainInProgress[i].TempData.TemplateID == '11a584e8-c20b-4311-b62f-14a0f005ebc6' ||
                            this.blockchainInProgress[i].TempData.TemplateID == '18719e55-99bf-4137-b7bb-fefd373f60b3' ||
                            this.blockchainInProgress[i].TempData.TemplateID == '932f342a-0eeb-4c45-9bf4-816a72315278' ||
                            this.blockchainInProgress[i].TempData.TemplateID == '932f342a-0eeb-4c45-9bf4-816a72315280' ||
                            this.blockchainInProgress[i].TempData.TemplateID == '37ee37ea-1572-471c-a6d2-4ceb9d42fc15' ||
                            this.blockchainInProgress[i].TempData.TemplateID == this.aquacultureMasterFemaleTemplateID ||
                            this.blockchainInProgress[i].TempData.TemplateID == this.aquacultureEggBatchTemplateID ||
                            this.blockchainInProgress[i].TempData.TemplateID == this.aquacultureFertilisationTemplateID
                        ) {
                            blockchainInProgressAquaculture.push(this.blockchainInProgress[i]);
                        }
                        else if (this.blockchainInProgress[i].TempData.TemplateID == '7a976520-bae3-478e-a397-784354f79970' || this.blockchainInProgress[i].TempData.TemplateID == '7a976520-bae3-478e-a397-784354f79975') {
                            blockchainInProgressBovine.push(this.blockchainInProgress[i]);

                            // Now add the master to the master's list
                            if (
                                (this.blockchainInProgress[i].TempData.ProcessData != undefined && this.blockchainInProgress[i].TempData.ProcessData.bullID != undefined) && 
                                this.blockchainInProgress[i].TempData.TemplateID == '7a976520-bae3-478e-a397-784354f79970' && 
                                !this.checkIfItemExistsInArrray(this.blockchainBovineBulls, this.blockchainInProgress[i].TempData.ProcessData.bullID)
                            ) this.blockchainBovineBulls.push(this.blockchainInProgress[i])
                        }
                        else {                            
                            blockchainInProgressHuman.push(this.blockchainInProgress[i]);
                        }
                    }

                    
                    if (this.subtype == 'Human') {
                        this.blockchainInProgress = blockchainInProgressHuman;
                        this.blockchainInProgressCountText = "In Progress (" + this.blockchainInProgress.length + ")";
                    }
                    else if (this.subtype == 'Bovine') {
                        this.blockchainInProgress = blockchainInProgressBovine;
                        this.blockchainInProgressCountText = "In Progress (" + this.blockchainInProgress.length + ")";
                    }
                    else {
                        this.blockchainInProgress = blockchainInProgressAquaculture;
                        this.blockchainInProgressCountText = "In Progress (" + this.blockchainInProgress.length + ")";
                    }

                    // SSI Attach stacked contracts to master
                    for(let i = 0; i < this.blockchainInProgress.length; i++) {
                        if (this.blockchainInProgress[i].TempData.TemplateID == '7a976520-bae3-478e-a397-784354f79970') {
                            this.blockchainInProgress[i].stackedItems = this.getSSIStackedItems(this.blockchainInProgress[i].name)
                        }
                    }


                    if (this.subtype == "Aquaculture") {
                        /* Clear lists */

                        this.aquacultureMasterFemaleFish = [];
                        this.aquacultureMasterMaleFish = [];
                        this.aquacultureFertilisationMasters = [];

                        // Make sure the Device Batch data is loaded.
                        await this.getDeviceBatchData();

                        /* FEMALES */
                        // Get Huon Master (Fish) records
                        this.aquacultureMasterFemaleFish = this.blockchainInProgress.filter(contract => contract.TempData.TemplateID == this.aquacultureMasterFemaleTemplateID);
                        // this.aquacultureMasterFemaleFish.forEach(masterFishContract => {
                        for (let i = 0; i < this.aquacultureMasterFemaleFish.length; i++) {
                            let masterFishContract = this.aquacultureMasterFemaleFish[i];
                            if (masterFishContract.State != '0' && masterFishContract.State != '1.1') masterFishContract.TempData.ProcessData = this.bcCache.find(initialMasterContract => initialMasterContract.ID == masterFishContract.ID && initialMasterContract.State == '1.1').TempData.ProcessData
                        }
                        
                        // this.aquacultureMasterFemaleFish.forEach(masterFishContract => {
                        for (let i = 0; i < this.aquacultureMasterFemaleFish.length; i++) {
                            let masterFishContract = this.aquacultureMasterFemaleFish[i];
                            masterFishContract.stackedItems = [];
                            let initialItems = this.bcCache.filter(stackedItem => stackedItem.TempData.TemplateID == this.aquacultureEggBatchTemplateID && stackedItem.State == '1.1' && stackedItem.TempData.ProcessData.master_tag_id == (masterFishContract.TempData.ProcessData == undefined ? masterFishContract.name : masterFishContract.TempData.ProcessData.tag_id));
                            // initialItems.forEach(item => {
                            for (let j = 0; j < initialItems.length; j++) {
                                let item = initialItems[j];
                                if (item) {
                                    let foundEggContract = this.blockchainInProgress.find(eggBatchContract => eggBatchContract.ID == item.ID)
                                    if (foundEggContract) masterFishContract.stackedItems.push(this.blockchainInProgress.find(eggBatchContract => eggBatchContract.ID == item.ID))
                                }
                            }
                        }

                        console.log("Finding FEMALE row to pop into place")
                        // find the item in this.aquacultureMasterFemaleFish that matches ID 'NN Feb 2024' and make sure it's at the top of the list
                        let index = this.aquacultureMasterFemaleFish.findIndex(item => item.ID === 'c59e5785-48d1-4ad7-bccb-708a67fd127e:1723435143986:NN Feb 2024');
                        if (index !== -1) {
                            let item = this.aquacultureMasterFemaleFish.splice(index, 1)[0]; // remove the item from its current position
                            this.aquacultureMasterFemaleFish.unshift(item); // add it to the top of the list
                        }

                        /* MALES and NEOMALES */
                        // Get Huon Master (Fish) records
                        this.aquacultureMasterMaleFish = this.blockchainInProgress.filter(contract => contract.TempData.TemplateID == '932f342a-0eeb-4c45-9bf4-816a72315278');
                        // this.aquacultureMasterMaleFish.forEach(masterFishContract => {
                        for (let i = 0; i < this.aquacultureMasterMaleFish.length; i++) {
                            let masterFishContract = this.aquacultureMasterMaleFish[i];
                            if (masterFishContract.State != '0' && masterFishContract.State != '1.1') masterFishContract.TempData.ProcessData = this.initialWorldState.find(initialMasterContract => initialMasterContract.ID == masterFishContract.ID && initialMasterContract.State == '1.1').TempData.ProcessData
                        }

                        console.log("Finding MALE row to pop into place")
                        // find the item in this.aquacultureMasterFemaleFish that matches ID '5548231' and make sure it's at the top of the list
                        let index2 = this.aquacultureMasterMaleFish.findIndex(item => item.ID === 'f3999139-4720-4492-9d2e-04a29730bf9d:1717553190279:5548231');
                        if (index2 !== -1) {
                            let item = this.aquacultureMasterMaleFish.splice(index2, 1)[0]; // remove the item from its current position
                            this.aquacultureMasterMaleFish.unshift(item); // add it to the top of the list
                        }
                        
                        /* Get the Aquaculture Male Stacked Items (Samples) */
                        // this.aquacultureMasterMaleFish.forEach((contract) => {
                        for (let i = 0; i < this.aquacultureMasterMaleFish.length; i++) {
                            let contract = this.aquacultureMasterMaleFish[i];
                            if (contract) contract.stackedItems = []; // initialise stackedItems
                            const initialItems = this.initialWorldState.filter(stackedItem => stackedItem.TempData.TemplateID == '932f342a-0eeb-4c45-9bf4-816a72315280' && stackedItem.State == '1.1' && (contract.TempData.ProcessData != undefined && ((stackedItem.TempData.ProcessData.master_tag_id != undefined && contract.TempData.ProcessData.tag_id != undefined) && stackedItem.TempData.ProcessData.master_tag_id == contract.TempData.ProcessData.tag_id)))
                            // console.log("initialItems: ", initialItems)
                            // initialItems.forEach((item) => {
                            for (let j = 0; j < initialItems.length; j++) {
                                const item = initialItems[j];
                                if (item) 
                                {
                                    let foundSampleContract = this.blockchainInProgress.find(sampleContract => sampleContract.ID == item.ID)
                                    if (foundSampleContract) 
                                    {
                                        contract.stackedItems.push(foundSampleContract)
                                    }
                                }
                            }
                        
                        }

                        /* Get the Aquaculture Male Stacked Items (Batches) */
                        this.aquacultureMasterMaleFish.forEach((aquacultureMasterMaleFish) => {
                        // for (let i = 0; i < this.aquacultureMasterMaleFish.length; i++) {
                            // let aquacultureMasterMaleFish = this.aquacultureMasterMaleFish[i];
                            // aquacultureMasterMaleFish.stackedItems.forEach((aquacultureFishSample) => {
                            for (let j = 0; j < aquacultureMasterMaleFish.stackedItems.length; j++) {
                                let aquacultureFishSample = aquacultureMasterMaleFish.stackedItems[j];
                                if (aquacultureFishSample) aquacultureFishSample.stackedItems = [];
                                
                                let initialSampleID = this.initialWorldState.find((initialSampleContract) => initialSampleContract.ID == aquacultureFishSample.ID && initialSampleContract.State == '1.1')
                                
                                let batchItems = this.initialWorldState.filter((batchContract) => batchContract.TempData.TemplateID == this.cryopreservationBatchTemplateID && batchContract.State == '1.1' && batchContract.TempData.ProcessData.master_tag_id == initialSampleID.TempData.ProcessData.master_tag_id && batchContract.TempData.ProcessData.sample_id == initialSampleID.TempData.ProcessData.sample_id)

                                // batchItems.forEach((item) => {
                                for (let k = 0; k < batchItems.length; k++) {
                                    let item = batchItems[k];
                                    let foundBatchContract = this.blockchainInProgress.find((batchContract) => batchContract.ID == item.ID);
                                    let thisBatch = this.deviceBatchData.find(batch => batch.TableLoc == 'Aquaculture' && batch.DeviceName == item.TempData.ProcessData.device_id && batch.BatchID == item.TempData.ProcessData.batch_id)
                                    if (thisBatch) foundBatchContract.batchStart = (thisBatch.StartDateTime ? thisBatch.StartDateTime : '')
                                    if (thisBatch) foundBatchContract.batchEnd = (thisBatch.EndDateTime ? thisBatch.EndDateTime : '')
                                    aquacultureFishSample.stackedItems.push(foundBatchContract)
                                }
                            }
                        })
                        
                        /* Get the Aquaculture Male Stacked Items (Packages) */
                        // this.aquacultureMasterMaleFish.forEach(aquacultureMasterMaleFish => {
                        for (let i = 0; i < this.aquacultureMasterMaleFish.length; i++) {
                            let aquacultureMasterMaleFish = this.aquacultureMasterMaleFish[i];
                            // aquacultureMasterMaleFish.stackedItems.forEach(aquacultureFishSample => {
                            for (let j = 0; j < aquacultureMasterMaleFish.stackedItems.length; j++) {
                                let aquacultureFishSample = aquacultureMasterMaleFish.stackedItems[j];
                                // aquacultureFishSample.stackedItems.forEach(aquacultureFishSampleBatch => {
                                for (let k = 0; k < aquacultureFishSample.stackedItems.length; k++) {
                                    let aquacultureFishSampleBatch = aquacultureFishSample.stackedItems[k];
                                    if (aquacultureFishSampleBatch) aquacultureFishSampleBatch.stackedItems = []

                                    if (aquacultureFishSampleBatch.TempData != undefined && aquacultureFishSampleBatch.TempData.ProcessData != undefined && aquacultureFishSampleBatch.TempData.ProcessData.cryopreservedPackages != undefined) for (let l = 0; l < aquacultureFishSampleBatch.TempData.ProcessData.cryopreservedPackages.length; l++) {
                                        let cryopreservedPackage = aquacultureFishSampleBatch.TempData.ProcessData.cryopreservedPackages[l];
                                        aquacultureFishSampleBatch.stackedItems.push(this.blockchainInProgress.find(packageContract => packageContract.ID == cryopreservedPackage.ID))
                                    }
                                }
                            }
                        }

                        /* FERTILISATION */
                        // console.log("Building fertilisation contracts...")
                        let initialFertMasters = this.initialWorldState.filter(initialContract => initialContract.TempData.TemplateID == this.aquacultureFertilisationTemplateID && initialContract.State == '0')
                        for (let i = 0; i < initialFertMasters.length; i++) {
                            let initialContract = initialFertMasters[i];
                            let foundContract = this.blockchainInProgress.find(contract => contract.ID == initialContract.ID);
                            if (foundContract) {
                                if (foundContract.State != '0' && foundContract.State != '1.1') {
                                    foundContract.TempData.ProcessData = this.bcCache.find(initialMasterContract => initialMasterContract.ID == initialContract.ID && initialMasterContract.State == '1.1').TempData.ProcessData
                                }
                                this.aquacultureFertilisationMasters.push(foundContract)
                            }
                        }

                        console.log("Finding FERTILISATION row to pop into place")
                        // find the item in this.aquacultureMasterFemaleFish that matches ID 'Feb 2024 fert' and make sure it's at the top of the list
                        let index5 = this.aquacultureFertilisationMasters.findIndex(item => item.ID === 'cd3e8759-ec7c-48b1-9db4-bbefa2c6bfff:1723435573332:Feb 2024 fert');
                        if (index5 !== -1) {
                            let item = this.aquacultureFertilisationMasters.splice(index5, 1)[0]; // remove the item from its current position
                            console.log("Item found: ", item)
                            this.aquacultureFertilisationMasters.unshift(item); // add it to the top of the list
                        }
                        // console.log("Fish fertilisation runs: ", this.aquacultureFertilisationMasters)
                    } // Aquaculture Tree view processing
                    
                    //blockchainCompleted
                    let blockchainCompletedHuman = [];
                    let blockchainCompletedAquaculture = [];
                    let blockchainCompletedBovine = [];
                    
                    // split completed contracts into Human and Aquaculture
                    for(let i = 0; i < this.blockchainCompleted.length; i++) {
                        if (this.blockchainCompleted[i].TempData.TemplateID == '11a584e8-c20b-4311-b62f-14a0f005ebc6') {
                            blockchainCompletedAquaculture.push(this.blockchainCompleted[i]);
                        } else if (
                            this.blockchainCompleted[i].TempData.TemplateID == '18719e55-99bf-4137-b7bb-fefd373f60b3' ||
                            this.blockchainCompleted[i].TempData.TemplateID == '932f342a-0eeb-4c45-9bf4-816a72315278' ||
                            this.blockchainCompleted[i].TempData.TemplateID == this.aquacultureMasterFemaleTemplateID ||
                            this.blockchainCompleted[i].TempData.TemplateID == this.aquacultureFertilisationTemplateID ||
                            this.blockchainCompleted[i].TempData.TemplateID == '932f342a-0eeb-4c45-9bf4-816a72315280'
                        ) {
                            blockchainCompletedAquaculture.push(this.blockchainCompleted[i]);
                        } else if (
                            this.blockchainCompleted[i].TempData.TemplateID == '7a976520-bae3-478e-a397-784354f79970' || this.blockchainCompleted[i].TempData.TemplateID == '7a976520-bae3-478e-a397-784354f79975') {
                            blockchainCompletedBovine.push(this.blockchainCompleted[i]);
                        } else {
                            blockchainCompletedHuman.push(this.blockchainCompleted[i]);
                        }
                    }
                    
                    if (this.subtype == 'Human') {
                        this.blockchainCompleted = blockchainCompletedHuman;
                        this.blockchainCompletedCount = "Completed (" + blockchainCompletedHuman.length+ ")";
                    }
                    else if (this.subtype == 'Bovine'){
                        this.blockchainCompleted = blockchainCompletedBovine;
                        this.blockchainCompletedCount = "Completed (" + blockchainCompletedBovine.length+ ")";
                    }
                    else {
                        this.blockchainCompleted = blockchainCompletedAquaculture;
                        this.blockchainCompletedCount = "Completed (" + blockchainCompletedAquaculture.length+ ")";
                    }

                    //blockchainTemplates
                    let blockchainTemplatesHuman = [];
                    let blockchainTemplatesAquaculture = [];
                    
                    // split templates into Human and Aquaculture
                    for(let i = 0; i < this.blockchainTemplates.length; i++) {
                        if (this.blockchainTemplates[i].TempData.contract.name.substring(0,4) == 'Huon' || this.blockchainTemplates[i].TempData.contract.name == "Cryopreservation Batch - Template") {
                            blockchainTemplatesAquaculture.push(this.blockchainTemplates[i]);
                        } else {
                            blockchainTemplatesHuman.push(this.blockchainTemplates[i]);
                        }
                    }

                    // get template counts
                    if (type == 'Human') {
                        this.blockchainTemplates = blockchainTemplatesHuman;
                        this.blockchainTemplatesCount = "Templates (" + blockchainTemplatesHuman.length+ ")";
                    } else {
                        this.blockchainTemplates = blockchainTemplatesAquaculture;
                        this.blockchainTemplatesCount = "Templates (" + blockchainTemplatesAquaculture.length+ ")";
                    }
                    
                    // split ART templates for create new modal
                    let contractTemplateOptionsARTHuman = [];
                    let contractTemplateOptionsARTBovine = [];
                    let contractTemplateOptionsARTAquaculture = [];

                    for(let i = 0; i < this.contractTemplateOptionsART.length; i++) {
                        if (this.subtype == "Bovine") {
                            if (
                                this.contractTemplateOptionsART[i].value == '7a976520-bae3-478e-a397-784354f79970' ||
                                this.contractTemplateOptionsART[i].value == '7a976520-bae3-478e-a397-784354f79975'
                            ) contractTemplateOptionsARTBovine.push(this.contractTemplateOptionsART[i]);
                        }
                        else if (this.subtype == "Aquaculture") {
                            if (i == 0) {
                                contractTemplateOptionsARTAquaculture.push(this.contractTemplateOptionsART[i]);
                            } else {
                                if (this.contractTemplateOptionsART[i].value == '11a584e8-c20b-4311-b62f-14a0f005ebc6') {
                                    contractTemplateOptionsARTAquaculture.push(this.contractTemplateOptionsART[i]);
                                }
                                if (
                                    this.contractTemplateOptionsART[i].value == '18719e55-99bf-4137-b7bb-fefd373f60b3' ||
                                    this.contractTemplateOptionsART[i].value == '932f342a-0eeb-4c45-9bf4-816a72315278' ||
                                    this.contractTemplateOptionsART[i].value == this.aquacultureMasterFemaleTemplateID ||
                                    this.contractTemplateOptionsART[i].value == this.aquacultureFertilisationTemplateID ||
                                    this.contractTemplateOptionsART[i].value == '932f342a-0eeb-4c45-9bf4-816a72315280'
                                ) contractTemplateOptionsARTAquaculture.push(this.contractTemplateOptionsART[i]);                                
                            }                     
                        }
                        else {
                            if (
                                this.contractTemplateOptionsART[i].value != '11a584e8-c20b-4311-b62f-14a0f005ebc6' &&
                                this.contractTemplateOptionsART[i].value != '18719e55-99bf-4137-b7bb-fefd373f60b3' &&
                                this.contractTemplateOptionsART[i].value != '932f342a-0eeb-4c45-9bf4-816a72315278' &&
                                this.contractTemplateOptionsART[i].value != this.aquacultureMasterFemaleTemplateID &&
                                this.contractTemplateOptionsART[i].value != this.aquacultureMasterMaleTemplateID &&
                                this.contractTemplateOptionsART[i].value != this.aquacultureFertilisationTemplateID &&
                                this.contractTemplateOptionsART[i].value != '932f342a-0eeb-4c45-9bf4-816a72315280' &&
                                this.contractTemplateOptionsART[i].value != '7a976520-bae3-478e-a397-784354f79970' &&
                                this.contractTemplateOptionsART[i].value != '7a976520-bae3-478e-a397-784354f79975'
                                ) contractTemplateOptionsARTHuman.push(this.contractTemplateOptionsART[i]);
                        }
                    }

                    if (this.subtype == "Bovine") {
                        this.contractTemplateOptionsART = contractTemplateOptionsARTBovine;
                    } else if (this.subtype == "Aquaculture") {
                        this.contractTemplateOptionsART = contractTemplateOptionsARTAquaculture;
                    } else {
                        this.contractTemplateOptionsART = contractTemplateOptionsARTHuman;
                    }

                    // Add Batch ID and Fish ID to blockchainInProgress for AquaCulture
                    if (this.type == 'Aquaculture') {
                        console.log("YO 🤘");

                        for(let i = 0; i < this.blockchainInProgress.length; i++) {
                            // default
                            this.blockchainInProgress[i].batchID = 7;
                            this.blockchainInProgress[i].fishID = 5584231;

                            // update
                            if (this.blockchainInProgress[i].name == 'Package ID-0012') {
                                this.blockchainInProgress[i].batchID = 8;
                            }
                        }
                  
                    }

                    
                    /* Set the table row numbers */
                    this.totalRowsAquacultureMalesFish = this.aquacultureMasterMaleFish.length
                    this.totalRowsAquacultureFemalesFish = this.aquacultureMasterFemaleFish.length
                    this.totalRowsAquacultureFertilisation = this.aquacultureFertilisationMasters.length

                    this.loading = false;

                    // if this blockchain fetch is triggered from a subprocess being completed
                    if(fromSubprocessCompleted) {                        
                        // update cacheItem
                        for(let i = 0; i < this.blockchainInProgress.length; i++) {
                            if(this.blockchainInProgress[i].ID == this.completeSubprocess.cacheItem.ID) {
                                console.log("GOOD STUFF");
                                this.completeSubprocess.cacheItem = this.blockchainInProgress[i];
                            }
                        }
                        // reload milestone modal data
                        this.sendInfo(this.completeSubprocess.cacheItem);
                    }

                } catch (error) {
                    console.log(error);
                    this.loading = false;
                    this.error = true;
                    this.errorDetails = error;
                }

                if (this.subtype == 'Aquaculture') {
                    console.log("Setting ummary data...")
                    /* Set the Summary data */
                    this.fishMaleInProgress = this.incomingBlockchainCache.filter(contract => contract.State == "1.1" && contract.TempData.TemplateID == this.aquacultureMasterMaleTemplateID).length;
                    this.fishMaleCompleted = this.blockchainCompleted.filter(contract => contract.TempData.TemplateID == this.aquacultureMasterMaleTemplateID).length;
                    this.fishMaleSummary = this.fishMaleInProgress + this.fishMaleCompleted;
                    this.fishMaleSamplesInProgress = this.incomingBlockchainCache.filter(contract => contract.State == "1.1" && contract.TempData.TemplateID == this.aquacultureMiltSampleTemplateID).length;
                    this.fishMaleSamplesCompleted = this.blockchainCompleted.filter(contract => contract.TempData.TemplateID == this.aquacultureMiltSampleTemplateID).length;
                    this.fishMaleSamples = this.fishMaleSamplesInProgress + this.fishMaleSamplesCompleted;
                    this.fishMaleCryoBatchesInProgress = this.incomingBlockchainCache.filter(contract => contract.State == "1.1" && contract.TempData.TemplateID == this.cryopreservationBatchTemplateID).length;
                    this.fishMaleCryoBatchesCompleted = this.blockchainCompleted.filter(contract => contract.TempData.TemplateID == this.cryopreservationBatchTemplateID).length;
                    this.fishMaleCryoBatches = this.fishMaleCryoBatchesInProgress + this.fishMaleCryoBatchesCompleted;
                    this.fishMalePackagesInProgress = this.incomingBlockchainCache.filter(contract => contract.State == "1.1" && contract.TempData.TemplateID == this.aquaculturePackageTemplateID).length;
                    this.fishMalePackagesCompleted = this.blockchainCompleted.filter(contract => contract.TempData.TemplateID == this.aquaculturePackageTemplateID).length;
                    this.fishMalePackages = this.fishMalePackagesInProgress + this.fishMalePackagesCompleted;

                    this.fishFemaleInProgress = this.incomingBlockchainCache.filter(contract => contract.State == "1.1" && contract.TempData.TemplateID == this.aquacultureMasterFemaleTemplateID).length;
                    this.fishFemaleCompleted = this.blockchainCompleted.filter(contract => contract.TempData.TemplateID == this.aquacultureMasterFemaleTemplateID).length;
                    this.fishFemaleSummary = this.fishFemaleInProgress + this.fishFemaleCompleted;
                    this.fishFemaleEggBatchesInProgress = this.incomingBlockchainCache.filter(contract => contract.State == "1.1" && contract.TempData.TemplateID == this.aquacultureEggBatchTemplateID).length;
                    this.fishFemaleEggBatchesCompleted = this.blockchainCompleted.filter(contract => contract.TempData.TemplateID == this.aquacultureEggBatchTemplateID).length;
                    this.fishFemaleEggBatches = this.fishFemaleEggBatchesInProgress + this.fishFemaleEggBatchesCompleted;
                }
                // console.log("Final state of BLockchain In Progress: ", this.blockchainInProgress)
            },
            openNewContractModal: function() {
                // clear contractName
                this.contractName = '';
                this.contractApplication = null;
                this.contractTemplate = null;

                // clear validation
                this.contract_name_valid = null;
                this.contract_application_valid = null;
                this.contract_template_valid = null;

                this.newContractModalShow = true;
            },
            filterTemplates: function() {
                console.log("select change!");
                if (this.contractApplication == "ART") this.contractTemplateOptions = this.contractTemplateOptionsART;
                if (this.contractApplication == "CAR-T") this.contractTemplateOptions = this.contractTemplateOptionsCART;
                this.contractTemplate = null
            },
            P_4_2_changed: function() {
                if(this.P_4_2.removed == "accepted") {
                    this.completeSubprocess.buttonDisabled = false;
                } else {
                    this.completeSubprocess.buttonDisabled = true;
                }
            },
            createNewContract: function(e) {
                e.preventDefault()
                console.log('create new contract button clicked!');
                console.log('contractName = ' + this.contractName);
                console.log('contractApplication = ' + this.contractApplication);
                console.log('contractTemplate = ' + this.contractTemplate);
                
                // validation
                this.contract_name_valid = (this.contractName.length > 0)
                this.contract_application_valid = (this.contractApplication != null)
                this.contract_template_valid = (this.contractTemplate != null)
                // if (this.contractName.length > 0 ) { this.contract_name_valid = true; } else { this.contract_name_valid = false; }
                // if (this.contractApplication != null) { this.contract_application_valid = true; } else { this.contract_application_valid = false; }
                // if (this.contractTemplate != null) { this.contract_template_valid = true; } else { this.contract_template_valid = false; }


                // hide moddal
                if (this.contract_name_valid && this.contract_application_valid && this.contract_template_valid) {
                    this.newContractModalShow = false;
                    this.CreateAsset();
                }
            },
            async CreateAsset() {
                this.loading = true;
                let blockId = this.uuidv4();
                let timestamp = new Date().getTime();
                blockId = blockId + ":" + timestamp + ":" + this.contractName;

                // send to dynamoDB
                try {
                    let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + "";
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    let data = {
                        "TableName": this.aquacultureBlockChainTableName,
                        "Item": {
                            "ID": blockId,
                            "TimeStamp": timestamp.toString(),
                            "State": "0",
                            "Owner": "Vitrafy (version 4)",
                            "User": this.current_user,
                            "TemplateID": this.contractTemplate,
                            "TempData": {
                                "TemplateID": this.contractTemplate,
                                "Application": this.contractApplication,
                            }
                        }
                    };
                    
                    data = JSON.stringify(data);

                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    console.log(response.data);                    

                } catch (error) {
                    console.log(error);
                }

                // send to blockchain (if Human contract)
                if(this.subtype == "Human" ) {
                    let tempData = {
                        "TemplateID": this.contractTemplate,
                        "Application": this.contractApplication,
                    }
                    tempData = JSON.stringify(tempData);  


                    let bcdata = {
                        "ID": blockId,
                        "TimeStamp": timestamp.toString(),
                        "State": "0",
                        "Owner": "Vitrafy (version 2)",
                        "User": this.current_user,
                        "TemplateID": this.contractTemplate,
                        "TempData": tempData
                    };

                    bcdata = JSON.stringify(bcdata);

                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                    };

                    try {
                        const response = await this.$http.post(
                            "https://mcaloon.org/CreateAsset",
                            bcdata,
                            {headers: headers}
                        );
                        this.blockchain = response.data;
                        
                        console.log(this.blockchain);
                        this.getBlockchain();

                    } catch (error) {
                        console.log(error);
                    }   
                }

                /* Temp hack to retrieve only updated data for refresh */
                let newRowsFromDB;
                newRowsFromDB = await this.retrieveBlockchainFromAPI(blockId)

                // add any new rows 
                this.bcCache = this.bcCache.concat(newRowsFromDB);

                this.completeSubprocess.cacheItem = newRowsFromDB[0];
                console.log("New rows: ", newRowsFromDB, " new row in cache: ", this.bcCache.filter(contract => contract.ID == newRowsFromDB[0].ID))
                await this.getBlockchain(this.type, true);
            },
            blockchainStageComplete: async function(block) {
                // show loading spinner 
                this.loading = true;

                console.log('blockchainStageComplete button clicked!');  

                let newState = parseInt(block.State) + 1;

                try {
                    let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + "";
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    let data = {
                        "TableName": this.aquacultureBlockChainTableName,
                        "Item": {
                            "ID": block.ID,
                            "TimeStamp": (new Date().getTime()).toString(),
                            "State": newState,
                            "Owner": block.Owner,
                            "User": block.User,
                            "TemplateID": (block.TemplateID == undefined ? block.TempData.TemplateID : block.TemplateID),
                            "TempData": {
                                    "TemplateID": block.TempData.TemplateID,
                                    "Application": block.TempData.Application,
                                }
                            }
                    };
                    data = JSON.stringify(data);

                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    console.log(response.data);
                    
                    this.getBlockchain(this.type);
                } catch (error) {
                    console.log(error);
                }      
            },
            subprocessComplete: async function (subprocess) {
                console.log("--- subprocessComplete clicked! ---");
                console.log("id = " + subprocess.id);
                console.log("name = " + subprocess.name);
                console.log("status = " + subprocess.status);
                console.log("selectedBlock:");
                console.log("ID = " + this.selectedBlock.ID);
                console.log("Owner = " + this.selectedBlock.Owner);
                console.log("User = " + this.selectedBlock.User);
                console.log("TemplateID = " + this.selectedBlock.TempData.TemplateID);
                console.log("Application = " + this.selectedBlock.TempData.Application);
                console.log("-----------------------------------");

                // put complete process button in processing and disabled state
                this.completeSubprocess.buttonProcessing = true;
                this.completeSubprocess.buttonDisabled = true;

                // add subprocess specific data
                let processData = null;
                //console.log(processData);

                // Sperm Use Case Test 1.1 
                if (this.selectedBlock.TempData.TemplateID == 'c2968cb9-20f1-4820-9d7c-07975b39e8f6' && subprocess.id == '1.1') {
                    processData = this.spermUseCase;
                }
                
                // Sperm Use Case Test 1.2 (Apheresis Report)
                if (this.selectedBlock.TempData.TemplateID == this.cslContractTemplateID && subprocess.id == '1.2') {
                    processData = this.csl_1_2;
                }

                /* Huon Fish (Female) */
                if (this.selectedBlock.TempData.TemplateID == this.aquacultureMasterFemaleTemplateID)
                {
                    if (subprocess.id == '1.1') processData = this.huonFemaleMasterFish_1_1;
                    if (subprocess.id == '2.1') processData = this.huonFemaleMasterFish_2_1;
                    if (subprocess.id == '3.1') {
                        processData = this.huonFemaleMasterFish_3_1;
                        await this.createAquacultureEggBatch();
                    }
                }
                /* Huon Egg Batch */
                if (this.selectedBlock.TempData.TemplateID == this.aquacultureEggBatchTemplateID)
                {
                    if (subprocess.id == '1.1') processData = this.huonEggBatch_1_1;
                    if (subprocess.id == '2.1') processData = this.huonEggBatch_2_1
                    if (subprocess.id == '2.2') processData = this.huonEggBatch_2_2;
                    if (subprocess.id == '3.1') processData = this.huonEggBatch_3_1;                    
                }
                /* Huon Fertilisation */
                if (this.selectedBlock.TempData.TemplateID == this.aquacultureFertilisationTemplateID)
                {
                    if (subprocess.id == '1.1') processData = this.huonFertilisation_1_1;
                    if (subprocess.id == '2.1') {
                        await this.finaliseFertilisationSeason();
                        processData = this.huonFertilisation_2_1;
                    }
                    if (subprocess.id == '3.1') processData = this.huonFertilisation_3_1;
                    if (subprocess.id == '3.2') processData = this.huonFertilisation_3_2;
                    if (subprocess.id == '3.3') processData = this.huonFertilisation_3_3;
                    if (subprocess.id == '3.4') processData = this.huonFertilisation_3_4;
                    
                }
                /* Huon Fish (Male) */
                if (this.selectedBlock.TempData.TemplateID == '932f342a-0eeb-4c45-9bf4-816a72315278')
                {
                    if (subprocess.id == '1.1') processData = this.huonMaleMasterFish_1_1;
                    if (subprocess.id == '2.1') processData = this.huonMaleMasterFish_2_1;
                    if (subprocess.id == '3.1') {
                        processData = this.huonMaleMasterFish_3_1;
                        if (this.huonMaleMasterFish_3_1.fish_status == 'Milt Extracted') await this.createAqaucultureSample();
                    }
                    if (subprocess.id == '3.2') processData = this.huonMaleMasterFish_3_2;
                }
                /* Huon Sample */
                if (this.selectedBlock.TempData.TemplateID == '932f342a-0eeb-4c45-9bf4-816a72315280')
                {
                    if (subprocess.id == '1.1') processData = this.huonFishSample_1_1;
                    if (subprocess.id == '2.1') processData = this.huonFishSample_2_1;
                    if (subprocess.id == '3.1') processData = this.huonFishSample_3_1;
                    if (subprocess.id == '3.2') processData = this.huonFishSample_3_2;
                    if (subprocess.id == '4.1') processData = this.huonFishSample_4_1;
                    if (subprocess.id == '4.2') processData = this.huonFishSample_4_2;
                }

                /* Huon 2023 */
                if (this.selectedBlock.TempData.TemplateID == '18719e55-99bf-4137-b7bb-fefd373f60b3'){
                    // Huon 2023 1.1 
                    if (subprocess.id == '1.1') {
                        this.mintResult.tokenURI = this.tokenURI;
                        processData = this.mintResult;
                    }
                    // Huon 2023 1.2 
                    if (subprocess.id == '1.2') processData = this.P_1_2;
                    // Huon 2023 2.1 
                    if (subprocess.id == '2.1') processData = this.P_2_1;
                    // Huon 2023 2.2 
                    if (subprocess.id == '2.2') processData = this.P_2_2;
                    // Huon 2023 2.3 
                    if (subprocess.id == '2.3') processData = this.P_2_3;                    
                    // Huon 2023 2.4 
                    if (subprocess.id == '2.4') processData = this.P_2_4;
                    // Huon 2023 2.5 
                    if (subprocess.id == '2.5') processData = this.P_2_5;                    
                    // Huon 2023 3.1 
                    if (subprocess.id == '3.1') processData = this.P_3_1;
                    // Huon 2023 3.2
                    if (subprocess.id == '3.2') processData = this.P_3_2;
                    // Huon 2023 4.1
                    if (subprocess.id == '4.1') processData = this.P_4_1;
                    // Huon 2023 4.2
                    if (subprocess.id == '4.2') processData = this.P_4_2;
                    // Huon 2023 5.1
                    if (subprocess.id == '5.1') processData = this.P_5_1;
                    // Huon 2023 5.2
                    if (subprocess.id == '5.2') processData = this.P_5_2;
                    // Huon 2023 5.3
                    if (subprocess.id == '5.3') processData = this.P_5_3;
                    // Huon 2023 6.1
                    if (subprocess.id == '6.1') processData = this.P_6_1;
                    // Huon 2023 7.1
                    if (subprocess.id == '7.1') processData = this.P_7_1;
                }
                
                /* SSI Samples */
                if (this.selectedBlock.TempData.TemplateID == '7a976520-bae3-478e-a397-784354f79970') {
                    // SSI 1.1
                    if (subprocess.id == '1.1') processData = this.ssi_sample_1_1;
                    // SSI 2.1
                    if (subprocess.id == '2.1') processData = this.ssi_sample_2_1;
                    // SSI 3.1
                    if (subprocess.id == '3.1') processData = this.ssi_sample_3_1;
                    // SSI 3.2
                    if (subprocess.id == '3.2') processData = this.ssi_sample_3_2;
                    // SSI 3.3
                    if (subprocess.id == '3.3') processData = this.ssi_sample_3_3;
                    // SSI 3.4
                    if (subprocess.id == '3.4') { processData = this.ssi_sample_3_4; await this.createSplitPackagesSSI(); }
                    // SSI 3.5
                    if (subprocess.id == '3.5') processData = this.ssi_sample_3_5;
                }

                /* SSI Packages */
                if (this.selectedBlock.TempData.TemplateID == '7a976520-bae3-478e-a397-784354f79975'){
                    if (subprocess.id == '1.1') processData = this.ssi_package_1_1;                    
                    if (subprocess.id == '2.1') processData = this.ssi_package_2_1;
                    if (subprocess.id == '2.2'){
                        const moc = await this.getCryoPreservationSSIPacket(this.ssi_package_2_2.cryopreservation_device, this.ssi_package_2_2.batch_id);
                        this.ssi_package_2_2.moc = moc;
                        processData = this.ssi_package_2_2;
                    }
                    if (subprocess.id == '3.1') processData = this.ssi_package_3_1;
                    if (subprocess.id == '4.1') processData = this.ssi_package_4_1;
                    if (subprocess.id == '4.2') processData = this.ssi_package_4_2;
                    if (subprocess.id == '4.3') processData = this.ssi_package_4_3;
                    if (subprocess.id == '5.1') processData = this.ssi_package_5_1;
                    if (subprocess.id == '5.2') processData = this.ssi_package_5_2;
                }

                let newTimeStamp = (new Date().getTime()).toString();
                // send to DynamoDB
                try {
                    let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + "";
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    let data = {
                        "TableName": this.aquacultureBlockChainTableName,
                        "Item": {
                            "ID": this.selectedBlock.ID,
                            "TimeStamp": newTimeStamp,
                            "State": subprocess.id,
                            "Owner": this.selectedBlock.Owner,
                            "User": this.selectedBlock.User,
                            "TemplateID": (this.selectedBlock.TemplateID == undefined ? this.selectedBlock.TempData.TemplateID : this.selectedBlock.TemplateID),
                            "TempData": {
                                "TemplateID": this.selectedBlock.TempData.TemplateID,
                                "Application": this.selectedBlock.TempData.Application,
                                "ProcessData": processData
                            }
                        }
                    };
                    data = JSON.stringify(data);


                    // DEBUG
                    // console.log("sending data")
                    // console.log(data)
                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    console.log(response.data);

                } catch (error) {
                    console.log(error);
                }

                // send to blockchain (if Human contract)
                if(this.subtype == "Human" ) {
                    let tempData = {
                        "TemplateID": this.selectedBlock.TempData.TemplateID,
                        "Application": this.selectedBlock.TempData.Application,
                        "ProcessData": processData
                    }
                    tempData = JSON.stringify(tempData);  

                    let bcdata = {
                        "ID": this.selectedBlock.ID,
                        "TimeStamp": (new Date().getTime()).toString(),
                        "State": subprocess.id,
                        "Owner": this.selectedBlock.Owner,
                        "User": this.selectedBlock.User,
                        "TemplateID": (this.selectedBlock.TemplateID == undefined ? this.selectedBlock.TempData.TemplateID : this.selectedBlock.TemplateID),
                        "TempData": tempData
                    };

                    bcdata = JSON.stringify(bcdata);

                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                    };               

                    try {
                        const response = await this.$http.post(
                            "https://mcaloon.org/UpdateAsset",
                            bcdata,
                            {headers: headers}
                        );
                        this.blockchain = response.data;
                        
                        console.log(this.blockchain);
                    } catch (error) {
                        console.log(error);
                    }
                }
                
                /* Temp hack to retrieve only updated data for refresh */
                let newRowsFromDB;
                newRowsFromDB = await this.retrieveBlockchainFromAPI(this.selectedBlock.ID)
                //update the bcCache with all of the new data within the 'newRowsFromDB' array (update matching, and add new rows)
                newRowsFromDB.forEach(newContract => {
                    let cacheItem = this.bcCache.find(searchContract => searchContract.ID == newContract.ID && searchContract.TimeStamp == newContract.TimeStamp);
                    if (cacheItem) {
                        this.bcCache.splice(this.bcCache.indexOf(cacheItem), 1, newContract)
                    } else {
                        this.bcCache.push(newContract)
                    }
                    // this.bcCache.splice(this.bcCache.indexOf(this.bcCache.find(searchContract => searchContract.ID == newContract.ID && searchContract.TimeStamp == newContract.TimeStamp)), 1, newContract)
                    // newContract.saved = true;
                });

                // //add any rows not existing in the 'bcCache' from 'newRowsFromDB' that were not updated previously
                // this.bcCache = this.bcCache.concat(newRowsFromDB.filter(newContract => !newContract.saved));

                console.log("Added new row to cache. Now refreshing blockchain...")
                await this.getBlockchain(this.type, true);
            },
            async attachedFertilisationRunRowClicked(item, index, event){
                console.log("Item clicked... Attempting to open the modal... selectedBlock: ", this.selectedBlock);
                console.log("this.selectedBlock.TempData.ProcessData.incubators.find(incubator => incubator.eggs.includes(this.selectedBlock.ID)): ", this.selectedBlock.TempData.ProcessData.incubators.find(incubator => incubator.eggs.find(incubatorEgg => incubatorEgg.ID == this.selectedBlock.ID)));
                this.huonFertilisationSelectedIncubator = this.selectedBlock.TempData.ProcessData.incubators.find(incubator => incubator.eggs.find(incubatorEgg => incubatorEgg.ID == this.selectedBlock.ID));

                let tempBlock = JSON.parse(JSON.stringify(this.selectedBlock));
                console.log("this.huonFertilisationSelectedIncubator: ", this.huonFertilisationSelectedIncubator);
                if (this.huonFertilisationSelectedIncubator) {
                    // console.log("Getting fertilisation run data for ID: ", this.selectedBlock.TempData.ProcessData.fertilisation_run_id);
                    // await this.getAquacultureFertilisation(this.selectedBlock.TempData.ProcessData.fertilisation_run_id);
                    // console.log("huonFertilisation_2_1: ", this.huonFertilisation_2_1)
                    this.selectedBlock = this.blockchainInProgress.find(contract => contract.ID == this.selectedBlock.TempData.ProcessData.fertilisation_run_id);
                    console.log("Opening modals")
                    await this.contractsRowClicked(item, index, event);
                    
                    console.log("Getting fertilisation run data for ID: ", tempBlock.TempData.ProcessData.fertilisation_run_id);
                    await this.getAquacultureFertilisation(tempBlock.TempData.ProcessData.fertilisation_run_id);
                    console.log("huonFertilisation_2_1: ", this.huonFertilisation_2_1)
                    this.huonFertilisation_2_1.incubators.find(incubator => incubator.ID == this.huonFertilisationSelectedIncubator.ID).selected = true;
                    // let obj = {"name":"Active Fertilisation Tracking","isParallel":false,"subprocesses":[],"id":"3.1","status":"COMPLETED","timestamp":"timestamp data"}
                    // obj = JSON.parse(JSON.stringify(obj));
                    // console.log("Obj: ", obj)
                    // await this.sendInfo_subprocess(obj)
                    // //open the new fertilisation modal
                    // if (document.getElementById("subprocess-detals-modal")) document.getElementById("subprocess-detals-modal").style.display = 'block';
                    console.log("Checkikng ref: ", document.getElementById("add-new-incubator-modal"))
                    // if (document.getElementById("add-new-incubator-modal")) document.getElementById("add-new-incubator-modal").style.display = 'block';
                    // this.$refs['subprocess-detals-modal'].show();
                    // this.$refs['add-new-incubator-modal'].show();
                }
            },
            contractsRowClicked(item, index, event){
                // event.preventDefault();

                // console.log("Row clicked, event: ", event)
                                
                /* Clear inputs */
                this.deviceBatchData = [];                
                this.P_1_2 = { approved: "not_accepted" };
                this.P_2_1 = { cryoprotectant: null};
                this.P_2_2 = {
                    motility: null,
                    concentration: null,
                    grade: null
                };
                this.P_2_3 = {
                    packaging_cost: "55.00",
                    approved: "not_accepted"
                };
                this.P_2_4 = {
                    cryoprotectant_cost: "2.00",
                    approved: "not_accepted"
                };
                this.P_2_5 = {
                    preparation_cost: "0.00",
                    approved: "not_accepted"
                };
                this.P_3_1 = {algorithm: null, moc: { temp: null, flow: null, time: null }};
                this.P_3_2 = {
                    preservation_cost: "0.00",
                    device: null,
                    batch_id: null,
                    fish_id: null,
                    started: null,
                    finished: null,
                    code: null,
                    protocol: null,                                                                                                                               
                    processed_time: null,
                    start_temp: null,
                    end_temp: null,
                    min_temp: null,
                    max_temp: null,
                    start_flow: null,
                    end_flow: null,
                    min_flow: null,
                    max_flow: null,
                };
                this.P_4_1 = { dewar_id: null, cannister_number: null };
                this.P_4_2 = { removed: "not_accepted", removed_by: this.current_user };
                this.P_5_1 = {
                    identification_package_checked: "not_accepted",
                    identification_package_id: null
                };
                this.P_5_1_identification_package_id_ref = null;
                this.qr_result = null;
                this.P_5_2 = {algorithm: 'Vitrafy Aquaculture Bio-Thaw', moc: { temp: 25, flow: 30, time: 30 }};
                this.P_5_3 = {thawing_complete: 'not_accepted', thawing_device: null};
                this.P_6_1 = {
                    motility: null,
                    concentration: null,
                    grade: null
                };
                this.P_7_1 = { fertilisation_run_id: null };
                
                /* CSL */
                this.csl_1_2 = {reportURL: ''};

                /* Huon Female Fish (Master) */
                this.huonFemaleMasterFish_1_1 = { tag_id: null, year_class: null, facility: null, tank: null };
                this.huonFemaleMasterFish_2_1 = { comment: null, spawn_comment: null, new_comment: null, weight: null, ovaplant: null, culled: null };
                this.huonFemaleMasterFish_3_1 = { esky_id: null, egg_count: null };

                /* Huon Egg Batch */
                this.huonEggBatch_1_1 = { tag_id: null, esky_id: null, egg_count: null };
                this.huonEggBatch_2_1 = { transportDeviceID: null, tripID: null };
                this.huonEggBatch_2_2_pdf_URL = "";
                this.huonEggBatch_3_1 = { fertilisation_run_id: null, incubators: [] };

                /* Fertilisation */
                this.huonFertilisation_1_1 = { facility: null, date: null};
                this.huonFertilisation_2_1 = { milt: [], egg_batch: [], milt_search: '', egg_search: '', egg_count_search: '', incubators: [] };
                this.huonFertilisationSelectedIncubator = null;
                this.aquacultureFertAddingIncubator = false;
                this.searchingForMilt = false;
                this.searchingForEggs = false;
                this.huonFertilisation_3_1 = { result_comment: null };
                this.huonFertilisation_3_2 = { result_comment: null };
                this.huonFertilisation_3_3 = { result_comment: null };
                this.huonFertilisation_3_4 = { result_comment: null };
                

                /* Huon Female Fish (Master) */
                this.huonMaleMasterFish_1_1 = { tag_id: null, year_class: null, facility: null, tank: null, genetic_rank: null, is_neo: null };
                this.huonMaleMasterFish_2_1 = { comment: null, spawn_comment: null, new_comment: null, weight: null, ovaplant: null, culled: null };
                this.huonMaleMasterFish_3_1 = { fish_status: null };
                this.huonMaleMasterFish_3_2 = {};
                /* Huon Sample (Stacked) */
                this.huonFishSample_1_1 = { master_tag_id: null, sample_id: null };
                this.huonFishSample_2_1 = { motility: null, concentration: null, grade: null };
                this.huonFishSample_3_1 = { attachedPackages: [], packagesToFreeze: [], batches: [], cryopreserved_packages: [] };
                this.huonFishSample_3_2 = { };
                this.huonFishSample_4_1 = null;
                this.huonFishSample_4_2 = null;
                this.deviceSelected = null;
                this.deviceConnectionIntervalID = null;
                this.batchTrackingActive = false;
                this.finalisingAquacultureBatchAndPackages = false;
                this.finalisingAquacultureIncubator = false;
                this.batchResultsFound = false;
                this.batchTrackingLoaderText=  'Looking for Batch Details...';
                this.deviceBatchDetails = [];
                this.batchIDManualOverride = null;
                this.batchOverrideSearchTest = null;                
                this.isBatchRowSelected = false;
                this.batchDetectionProgressValue = null;
                this.packageToAttachToHuonSample = null;
                this.packageToAttachToHuonBatch = null;
                this.loadingSamplePackaging = false;
                this.exportingFishData = false;
                this.exportingFullFishData = false;
                this.package_checking_status_icon_class = 'fa-solid fa-qrcode';
                this.miltPackage_checking_status_icon_class = 'fa-solid fa-qrcode';
                this.egg_checking_status_icon_class = 'fa-solid fa-qrcode';
                
                /* SSI Smart Contract Template Props */
                this.ssi_sample_1_1 = {sampleID: null, masterID: null, breed: 'Holstein'};
                this.ssi_sample_2_1 = {transportDeviceID: null, tripID: null};
                this.ssi_sample_2_2 = {};
                this.ssi_sample_2_2_pdf_URL = null;
                this.ssi_sample_3_1 = {};
                this.ssi_sample_3_2 = {ssi_sperm_assessed: null, sperm_assessment: []};
                this.ssi_sample_3_2_pdf_URL = null;
                this.ssi_sample_3_3 = {ssi_extender_added: null};
                this.ssi_sample_3_4 = { _025_packagingQuantity: 0, _05_packagingQuantity: 0, smart_packagingQuantity: 0 };
                this.ssi_sample_3_5 = {packages_filled: null, packages_sealed: null};
                this.ssi_sample_4_1 = { stacked_packages: [], };

                this.ssi_package_1_1 = {sampleID: null, masterID: null, packageType: null};
                this.ssi_package_2_1 = {algorithm: null, moc: { temp: null, flow: null, time: null }};
                this.ssi_package_2_2 = { cryopreservation_completed: null, cryopreservation_device: null, batch_id: null, moc: {batch_id: null, flow: null, temp: null, start_time: null, end_time: null} };
                this.ssi_package_3_1 = { removed_from_storage: null, removed_from_storage_by: null };
                this.ssi_package_4_1 = {
                    identification_package_checked: "not_accepted",
                    identification_package_id: null
                };
                this.ssi_package_4_1_identification_package_id_ref = null;

                this.ssi_package_4_2 = {algorithm: 'Vitrafy Bovine Bio-Thaw', moc: { temp: 25, flow: 30, time: 30 } };
                this.ssi_package_4_3 = {thawing_complete: 'not_accepted', thawing_device: null};
                this.ssi_package_5_1 = {ssi_sperm_assessed: null, sperm_assessment: []};
                this.ssi_package_5_2 = {ssi_sperm_assessed: null, sperm_assessment: []};

                this.bovineStackedContractsTrackingSelectAll = false;
                if (index >= 0){
                    this.completeSubprocess.cacheItem = item;

                    this.sendInfo(item)
                    this.$refs.contractDetailsModal.show(event);
                }
            },
            rowHovered(item, index, event){
                // console.log("Row hovered: ", item, index, event)

                // console.log("event.target.classList: ", event.target.classList)

                event.target.classList.add('table-row-hovered')
            },
            rowUnHovered(item, index, event){
                // console.log("Row UN-hovered: ", item, index, event)

                // console.log("event.target.classList: ", event.target.classList)

                event.target.classList = [];
            },
            handleDownload(e){ console.log(e)},
            aquacultureMaleFishTableFiltered(filteredItems) {
                /* This ensures the pagination goes to the first page and has the correct number of rows */
                // console.log("Here, aquaculture table was filtered: ", filteredItems)
                this.currentPageAquacultureMalesFish = 1;
                this.totalRowsAquacultureMalesFish = filteredItems.length;
            },
            aquacultureFemaleTableFiltered(filteredItems) {
                /* This ensures the pagination goes to the first page and has the correct number of rows */
                // console.log("Here, aquaculture table was filtered: ", filteredItems)
                this.currentPageAquacultureFemalesFish = 1;
                this.totalRowsAquacultureFemalesFish = filteredItems.length;
            },
            aquacultureFertilisationTableFiltered(filteredItems) {
                /* This ensures the pagination goes to the first page and has the correct number of rows */
                // console.log("Here, aquaculture table was filtered: ", filteredItems)
                this.currentPageAquacultureFertilisation = 1;
                this.totalRowsAquacultureFertilisation = filteredItems.length;
            },
            async sendInfo(block) {
                // put complete process button in disabled state when subprocess modal opens
                this.completeSubprocess.buttonDisabled = (block.State == '5.1' || block.State == '5.2' ? false : true);
                this.completeSubprocess.buttonDisabled = (this.subtype == "Bovine" && block.State == '2.1' ? false : true)

                // enable sub process complete button if type is Human or Bovine
                if(this.subtype == "Human" || this.subtype == "Bovine") {
                    this.completeSubprocess.buttonDisabled = false;
                }
                
                if (block.TempData.TemplateID == '932f342a-0eeb-4c45-9bf4-816a72315278' || block.TempData.TemplateID == '932f342a-0eeb-4c45-9bf4-816a72315280') this.completeSubprocess.buttonDisabled = false;
                if (block.TempData.TemplateID == '932f342a-0eeb-4c45-9bf4-816a72315280' && block.State == '1.1') this.completeSubprocess.buttonDisabled = !this.huonFishSample_3_1.attachedPackages.length;

                // reset summary tab sections
                this.summary_sections.nft_expanded = false;
                this.summary_sections.contract_expanded = false;
                this.summary_sections.location_expanded = false;
                this.summary_sections.financial_expanded = false;
                this.finalisingAquacultureIncubator = false;
                this.searchingForMilt = false;
                this.huonFertilisation_2_1.milt_search = '';
                this.huonFertilisation_2_1.incubator_fert_batch_number_input = '';
                this.huonFertilisation_2_1.incubator_fert_batch_location_input = '';
                this.searchingForEggs = false;
                this.huonFertilisation_2_1.egg_search = '';
                this.huonFertilisation_2_1.egg_count_search = '';

                console.log("Inside sendinfo block")
                console.log(block);

                console.log("Template")
                console.log(this.template)

                let logged_in_user = this.current_user;

                if (this.P_4_2.removed_by == undefined) this.P_4_2.removed_by = logged_in_user;
                if (this.ssi_package_3_1.removed_from_storage_by == undefined) this.ssi_package_3_1.removed_from_storage_by = logged_in_user;
                if (block.TempData.TemplateID == '932f342a-0eeb-4c45-9bf4-816a72315278' && block.State == '0') this.huonMaleMasterFish_1_1.tag_id = block.name
                if (block.TempData.TemplateID == this.aquacultureMasterFemaleTemplateID && block.State == '0') this.huonFemaleMasterFish_1_1.tag_id = block.name

                // reset info boxes
                this.infoBoxClosed_1 = true;
                this.infoBoxClosed_2 = true;
                this.infoBoxClosed_3 = true;
                this.infoBoxClosed_4 = true;
                this.infoBoxClosed_5 = true;
                this.infoBoxClosed_6 = true;
                this.infoBoxClosed_7 = true;
                this.infoBoxClosed_8 = true;
                this.infoBoxClosed_9 = true;
                this.infoBoxClosed_10 = true;
                this.infoBoxClosed_11 = true;
                this.infoBoxClosed_12 = true;

                await this.ReadAssetHistory(block);
                
                this.selectedBlock = block;

                let processes = [];
                // milestones 
                for(let m = 0; m < this.template.TempData.contract.milestones.length; m++) {
                    processes.push({id: this.template.TempData.contract.milestones[m].id, status: "Not Started"});
                    // subprocesses (L1)
                    for(let sl1 = 0; sl1 < this.template.TempData.contract.milestones[m].subprocesses.length; sl1++) {
                        processes.push({id: this.template.TempData.contract.milestones[m].subprocesses[sl1].id, status: "Not Started"});
                        // subprocesses (L2)
                        for(let sl2 = 0; sl2 < this.template.TempData.contract.milestones[m].subprocesses[sl1].subprocesses.length; sl2++) {
                            processes.push({id: this.template.TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].id, status: "Not Started"});
                            // subprocesses (L3)
                            for(let sl3 = 0; sl3 < this.template.TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].subprocesses.length; sl3++) {
                                processes.push({id: this.template.TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].subprocesses[sl3].id, status: "Not Started"});
                            }
                        }
                    }
                }

                // set processes status
                let currentProcessFound = false;
                let currentMilestone = null;
                for(let i = 0; i < processes.length; i++) {
                    processes[i].timestamp = "timestamp data"; // HERE

                    if (this.selectedBlock.nextState != processes[i].id) {
                        if (!currentProcessFound) {
                            processes[i].status = "COMPLETED";
                            //console.log("processes[i].id = " + processes[i].id + " COMPLETED");
                        }
                    } else {
                        processes[i].status = "IN PROGRESS";
                        //console.log("processes[i].id = " + processes[i].id + " IN PROGRESS");
                        currentMilestone = processes[i].id.split(".")[0];
                        currentProcessFound = true;
                    }
                }

                // adjust to make milestone "IN PROGRESS" is not all subprocess are complete
                for(let i = 0; i < processes.length; i++) {
                    if (processes[i].id == currentMilestone) {
                        processes[i].status = "IN PROGRESS";
                    }
                    //console.log(processes[i].id + " " + processes[i].status);
                }

                // debug
                //console.log("currentMilestone = " + currentMilestone);
                //console.log("this.selectedBlock.nextState = " + this.selectedBlock.nextState);

                // Add transaction data to tempalte
                // --------------------------------
                // milestones 
                for(let m = 0; m < this.template.TempData.contract.milestones.length; m++) {
                    for(let p = 0; p < processes.length; p++) {
                        if (this.template.TempData.contract.milestones[m].id == processes[p].id) {
                            this.template.TempData.contract.milestones[m].status = processes[p].status;
                        }
                        // subprocesses (L1)
                        for(let sl1 = 0; sl1 < this.template.TempData.contract.milestones[m].subprocesses.length; sl1++) {
                            if (this.template.TempData.contract.milestones[m].subprocesses[sl1].id == processes[p].id) {
                                this.template.TempData.contract.milestones[m].subprocesses[sl1].status = processes[p].status;
                                this.template.TempData.contract.milestones[m].subprocesses[sl1].timestamp = processes[p].timestamp;
                            }
                            // subprocesses (L2)
                            for(let sl2 = 0; sl2 < this.template.TempData.contract.milestones[m].subprocesses[sl1].subprocesses.length; sl2++) {
                                if (this.template.TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].id == processes[p].id) {
                                    this.template.TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].status = processes[p].status;
                                }
                                // subprocesses (L3)
                                for(let sl3 = 0; sl3 < this.template.TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].subprocesses.length; sl3++) {
                                    if (this.template.TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].subprocesses[sl3].id == processes[p].id) {
                                        this.template.TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].subprocesses[sl3].status = processes[p].status;
                                    }
                                }
                            }
                        }
                    }
                }

                // find milestsone completion timestamp
                for(let m = 0; m < this.template.TempData.contract.milestones.length; m++) { 
                    if (this.template.TempData.contract.milestones[m].status == "COMPLETED") {
                        console.log(this.template.TempData.contract.milestones[m].id);
                        console.log(this.template.TempData.contract.milestones[m].status);
                        for(let i = 0; i < this.block_history.length; i++) { 
                            console.log(this.block_history[i].State[0]);
                            if (this.template.TempData.contract.milestones[m].id == this.block_history[i].State.split(".")[0]) {
                                console.log(this.block_history[i].TimeStamp);
                                this.template.TempData.contract.milestones[m].timestamp = this.block_history[i].TimeStamp;
                            }
                        }
                    }
                }


                if (document.getElementById("blockchain-data-loading-modal")) document.getElementById("blockchain-data-loading-modal").style.display = 'none';
                if (document.getElementById("blockchain-modal")) document.getElementById("blockchain-modal").style.display = 'block';

                // open active milestone 
                this.milestoneToggle(currentMilestone);

                // flag processing stopped and close subprocess modal
                this.$root.$emit('bv::hide::modal', 'subprocess-detals-modal');
                this.completeSubprocess.buttonProcessing = false;
            },
            sendInfo_subprocess(subprocess) {
                // console.log("Send info subprocess: ", subprocess)
                this.selectedSubprocess = subprocess;

                this.testLocationLoaded = false;
                this.process_location = "";
                this.infoBoxClosed_location = true;
                this.infoBoxClosed_patient = true;
                this.infoBoxClosed_doctor = true;
                this.infoBoxClosed_sample = true;
                this.infoBoxClosed_sample_checks = true;
                this.infoBoxClosed_sample_reg = true;
                this.infoBoxClosed_device = true;
                this.infoBoxClosed_process = true;

                // find transaction and add timestamp
                for(let i = 0; i < this.block_history.length; i++) {
                    if (this.block_history[i].State == subprocess.id) {
                        // console.log("FOUND! " + subprocess.id);
                        this.selectedSubprocess.timestamp = this.block_history[i].TimeStamp;
                    }
                }

                // TODO: this is a temporary fix to stop Huon users from being able to progress a subprocess
                this.completeSubprocess.buttonDisabled = (this.userInfo.user_additional_info.huon_user)
            },
            openTemplate(block) {
                console.log("opening template")
                console.log("block = " + block.ID);
                this.template = block;
                this.$refs['template-details-modal'].show();
                this.collapseAll();
            },
            async ReadAssetHistory(block) {
                
                try {

                    // filter on ID
                    let history = [];
                    let templateID = null;

                    let responseData = await this.retrieveBlockchainFromAPI(block.ID);
                    console.log("Response data:", responseData)

                    for(let i = 0; i < responseData.length; i++) {
                        if (block.ID == responseData[i].ID) {
                            if (responseData[i].State == "0") {
                                templateID = responseData[i].TempData.TemplateID
                            }
                            else {console.log("TEMPLATE ID NOT FOUND!")}
                            history.push(responseData[i]);
                        }
                    }

                    this.block_template_ID = templateID;
                    this.block_history = history;

                    // find template from template ID
                    for(let i = 0; i < this.blockchainTemplates.length; i++) {
                        if (this.blockchainTemplates[i].TempData.contract.id == this.block_template_ID) {
                            this.template = this.blockchainTemplates[i];
                        }
                    }
                    
                    // debug
                    console.log('--- Selected Block ---');
                    console.log("this.block_template_ID  = " + this.block_template_ID );

                    // convert TimeStamp to date Time
                    for(let i = 0; i < this.block_history.length; i++) {
                        this.block_history[i].TimeStamp = this.convertBlockTimestamp(this.block_history[i].TimeStamp);
                        this.block_history[i].Test = "test field";
                    }
                    console.log("Adding process names to block_history: ", this.block_history)
                    // add process names to block_history
                    for(let i = 0; i < this.block_history.length; i++) {
                        for(let m = 0; m < this.template.TempData.contract.milestones.length; m++) {
                            for(let sl1 = 0; sl1 < this.template.TempData.contract.milestones[m].subprocesses.length; sl1++) {
                                if (this.block_history[i].State == this.template.TempData.contract.milestones[m].subprocesses[sl1].id) {
                                    this.block_history[i].Name = this.template.TempData.contract.milestones[m].subprocesses[sl1].name;
                                }
                                for(let sl2 = 0; sl2 < this.template.TempData.contract.milestones[m].subprocesses[sl1].subprocesses.length; sl2++) {
                                    if (this.block_history[i].State == this.template.TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].id) {
                                        this.block_history[i].Name = this.template.TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].name;
                                    }
                                    for(let sl3 = 0; sl3 < this.template.TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].subprocesses.length; sl3++) {
                                        if (this.block_history[i].State == this.template.TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].subprocesses[sl3].id) {
                                            this.block_history[i].Name = this.template.TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].subprocesses[sl3].name;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    console.log("Added process names to block_history...")

                    // add process data to vue model
                    console.log("⭐⭐⭐");

                    // Sperm Use Case 1.1 - clear data
                    this.spermUseCase = { 
                        donor: {
                            surname: null,
                            firstname: null,
                            phone: null,
                        }
                    }

                    // Huon 2023 1.1 - clear data
                    this.mintResult = {
                        blockHash: null,
                        blockNumber: null,
                        from: null,
                        gasUsed: null,
                        to: null,
                        transactionHash: null,
                    }                    

                    // console.log("Block History: ", this.block_history)
                    if (this.type=="Aquaculture"){
                        await this.refreshAquaculturePackages();
                    }

                    // add data
                    for(let i = 0; i < this.block_history.length; i++) {

                        /* CSL */
                        if (this.block_history[i].TempData.TemplateID == this.cslContractTemplateID)
                        {
                            if (this.block_history[i].State == '1.1' || this.block_history[i].State == '1.2') {

                                //this.csl_1_2 = this.block_history[i].TempData.ProcessData;
                                // Get the PDF object URL for a specific file
                                /* TODO: Make this dynamic */
                                if (!this.csl_1_2.reportURL) this.getPdfUrl('Pr17 CofA.pdf', "nfttrackingreports")
                                    .then((url) => {
                                        this.csl_1_2.reportURL = url;
                                    })
                                    .catch((err) => {
                                        console.error(err);
                                    });
                            }
                        }

                        /* Huon Fish (Female) */
                        if (this.block_history[i].TempData.TemplateID == this.aquacultureMasterFemaleTemplateID)
                        {
                            if (this.block_history[i].State == '1.1') this.huonFemaleMasterFish_1_1 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '2.1') this.huonFemaleMasterFish_2_1 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '3.1') this.huonFemaleMasterFish_3_1 = this.block_history[i].TempData.ProcessData;
                        }

                        /* Huon Egg Batch */
                        if (this.block_history[i].TempData.TemplateID == this.aquacultureEggBatchTemplateID)
                        {
                            if (this.block_history[i].State == '1.1') this.huonEggBatch_1_1 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '2.1') this.huonEggBatch_2_1 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '2.2') {
                                this.huonEggBatch_2_2 = this.block_history[i].TempData.ProcessData;
                                // Get the PDF object URL for a specific file
                                /* TODO: Make this dynamic */
                                this.getPdfUrl('Transport Logistics Report - Bovine.pdf', "nfttrackingreports")
                                .then((url) => {
                                    this.huonEggBatch_2_2_pdf_URL= url;
                                })
                                .catch((err) => {
                                    console.error(err);
                                });
                            }
                            if (this.block_history[i].State == '3.1') {
                                this.huonEggBatch_3_1 = this.block_history[i].TempData.ProcessData;
                                this.huonEggBatch_3_1.fertilisation_run = [];
                                this.huonEggBatch_3_1.fertilisation_run.push(this.blockchainInProgress.find(fertilisationContract => fertilisationContract.ID == this.huonEggBatch_3_1.fertilisation_run_id))
                            }
                        }

                        /* Huon Fertilisation */
                        if (this.block_history[i].TempData.TemplateID == this.aquacultureFertilisationTemplateID)
                        {
                            if (this.block_history[i].State == '1.1') {
                                this.huonFertilisation_1_1 = this.block_history[i].TempData.ProcessData;
                                await this.getAquacultureFertilisation(block.ID);
                                if (this.huonFertilisation_2_1.incubators == undefined) await this.aquacultureFertCreateNewIncubator();                                
                            }
                            if (this.block_history[i].State == '2.1') this.huonFertilisation_2_1 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '3.1') this.huonFertilisation_3_1 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '3.2') this.huonFertilisation_3_2 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '3.3') this.huonFertilisation_3_3 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '3.4') this.huonFertilisation_3_4 = this.block_history[i].TempData.ProcessData;
                        }
                        
                        /* Huon Fish (Male) */
                        if (this.block_history[i].TempData.TemplateID == '932f342a-0eeb-4c45-9bf4-816a72315278')
                        {
                            if (this.block_history[i].State == '1.1') this.huonMaleMasterFish_1_1 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '2.1') this.huonMaleMasterFish_2_1 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '3.1') this.huonMaleMasterFish_3_1 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '3.2') this.huonMaleMasterFish_3_2 = this.block_history[i].TempData.ProcessData;
                        }

                        /* Huon Sample */
                        if (this.block_history[i].TempData.TemplateID == '932f342a-0eeb-4c45-9bf4-816a72315280')
                        {
                            if (this.block_history[i].State == '1.1') this.huonFishSample_1_1 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '2.1') {
                                this.huonFishSample_2_1 = this.block_history[i].TempData.ProcessData;
                                await this.refreshAquaculturePackages(this.block_history[i].ID);

                            }
                            if (this.block_history[i].State == '3.1') this.huonFishSample_3_1 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '3.2') this.huonFishSample_3_2 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '4.1') this.huonFishSample_4_1 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '4.2') this.huonFishSample_4_2 = this.block_history[i].TempData.ProcessData;

                        }

                        /* Huon 2023 */
                        else if (this.block_history[i].TempData.TemplateID == '18719e55-99bf-4137-b7bb-fefd373f60b3') {

                            // Huon 2023 1.1
                            if (this.block_history[i].State == '1.1') {
                                this.mintResult = this.block_history[i].TempData.ProcessData;
                                this.mintResult.transactionHashMini = this.mintResult.transactionHash.substring(0,19);

                                //get NFT JSON Data
                                this.mintResult.JSON = await this.getNFT(this.mintResult.tokenURI, "stacked");

                                //get master NFT JSON Data
                                //this.mintResultMaster.JSON = await this.getNFT(this.mintResult.JSON.fishID, "master");
                            }

                            // Huon 2023 1.2
                            if (this.block_history[i].State == '1.2') this.P_1_2 = this.block_history[i].TempData.ProcessData;
                            // Huon 2023 2.1
                            if (this.block_history[i].State == '2.1') this.P_2_1 = this.block_history[i].TempData.ProcessData;
                            // Huon 2023 2.2
                            if (this.block_history[i].State == '2.2') this.P_2_2 = this.block_history[i].TempData.ProcessData;
                            // Huon 2023 2.3
                            if (this.block_history[i].State == '2.3') this.P_2_3 = this.block_history[i].TempData.ProcessData;
                            // Huon 2023 2.4
                            if (this.block_history[i].State == '2.4') this.P_2_4 = this.block_history[i].TempData.ProcessData;
                            // Huon 2023 2.5
                            if (this.block_history[i].State == '2.5') this.P_2_5 = this.block_history[i].TempData.ProcessData;
                            // Huon 2023 3.1
                            if (this.block_history[i].State == '3.1') this.P_3_1 = this.block_history[i].TempData.ProcessData;
                            // Huon 2023 3.2
                            if (this.block_history[i].State == '3.2') this.P_3_2 = this.block_history[i].TempData.ProcessData;
                            // Huon 2023 4.1
                            if (this.block_history[i].State == '4.1') this.P_4_1 = this.block_history[i].TempData.ProcessData;
                            // Huon 2023 4.2
                            if (this.block_history[i].State == '4.2') this.P_4_2 = this.block_history[i].TempData.ProcessData;
                            // Huon 2023 5.1
                            if (this.block_history[i].State == '5.1') this.P_5_1 = this.block_history[i].TempData.ProcessData;
                            // Huon 2023 5.2
                            if (this.block_history[i].State == '5.2') this.P_5_2 = this.block_history[i].TempData.ProcessData;
                            // Huon 2023 5.3
                            if (this.block_history[i].State == '5.3') this.P_5_3 = this.block_history[i].TempData.ProcessData;
                            // Huon 2023 6.1
                            if (this.block_history[i].State == '6.1') this.P_6_1 = this.block_history[i].TempData.ProcessData;
                            // Huon 2023 7.1
                            if (this.block_history[i].State == '7.1') {
                                this.P_7_1 = this.block_history[i].TempData.ProcessData;
                                this.P_7_1.fertilisation_run = [];
                                this.P_7_1.fertilisation_run.push(this.blockchainInProgress.find(fertilisationContract => fertilisationContract.ID == this.P_7_1.fertilisation_run_id))
                            }
                        }
                        /* End Huon 2023 */

                        /* SSI Packages */
                        else if (this.block_history[i].TempData.TemplateID == '7a976520-bae3-478e-a397-784354f79975') {
                            if (this.block_history[i].State == '1.1') this.ssi_package_1_1 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '2.1') this.ssi_package_2_1 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '2.2') this.ssi_package_2_2 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '3.1') this.ssi_package_3_1 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '4.1') this.ssi_package_4_1 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '4.2') this.ssi_package_4_2 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '4.3') this.ssi_package_4_3 = this.block_history[i].TempData.ProcessData;
                            if (this.block_history[i].State == '5.1') {
                                this.ssi_package_5_1 = this.block_history[i].TempData.ProcessData;
                                
                                // TODO: Make this retrieve the correct values for the specific sample
                                this.ssi_sample_3_2.sperm_assessment = await this.getSSISpermAssessment();
                                this.ssi_package_5_1.sperm_assessment = await this.getSSISpermAssessment();
                            }
                            if (this.block_history[i].State == '5.2') {
                                this.ssi_package_5_2 = this.block_history[i].TempData.ProcessData;
                                
                                // TODO: Make this retrieve the correct values for the specific sample
                                this.ssi_sample_3_2.sperm_assessment = await this.getSSISpermAssessment();
                                this.ssi_package_5_1.sperm_assessment = await this.getSSISpermAssessment();
                                this.ssi_package_5_2.sperm_assessment = await this.getSSISpermAssessment();
                            }
                        }
                        /* SSI Samples */
                        else if (this.block_history[i].TempData.TemplateID == '7a976520-bae3-478e-a397-784354f79970') {
                            // SSI 1.1
                            if (this.block_history[i].State == '1.1') this.ssi_sample_1_1 = this.block_history[i].TempData.ProcessData;                            
                            // SSI 2.1
                            if (this.block_history[i].State == '2.1') this.ssi_sample_2_1 = this.block_history[i].TempData.ProcessData;
                            // SSI 2.2
                            if (this.block_history[i].State == '2.2') {
                                this.ssi_sample_2_2 = this.block_history[i].TempData.ProcessData;

                                // Get the PDF object URL for a specific file
                                /* TODO: Make this dynamic */
                                this.getPdfUrl('Transport Logistics Report - Bovine.pdf', "nfttrackingreports")
                                .then((url) => {
                                    this.ssi_sample_2_2_pdf_URL = url;
                                })
                                .catch((err) => {
                                    console.error(err);
                                });
                            }
                            // SSI 3.1
                            if (this.block_history[i].State == '3.1') this.ssi_sample_3_1 = this.block_history[i].TempData.ProcessData;
                            // SSI 3.2
                            if (this.block_history[i].State == '3.2') {
                                this.ssi_sample_3_2 = this.block_history[i].TempData.ProcessData;

                                // TODO: Make this retrieve the correct values for the specific sample
                                this.ssi_sample_3_2.sperm_assessment = await this.getSSISpermAssessment();

                                // Get the PDF object URL for a specific file
                                /* TODO: Make this dynamic */
                                this.getPdfUrl('Holstein A FRESH.pdf', "textract-ocr-processed-files")
                                .then((url) => {
                                    this.ssi_sample_3_2_pdf_URL = url;
                                })
                                .catch((err) => {
                                    console.error(err);
                                });

                                // console.log("Sperm Assessment URL: ", this.ssi_sample_3_2_pdf_URL)
                            }
                            // SSI 3.3
                            if (this.block_history[i].State == '3.3') this.ssi_sample_3_3 = this.block_history[i].TempData.ProcessData;
                            // SSI 3.4
                            if (this.block_history[i].State == '3.4') this.ssi_sample_3_4 = this.block_history[i].TempData.ProcessData;
                            // SSI 3.5
                            if (this.block_history[i].State == '3.5') this.ssi_sample_3_5 = this.block_history[i].TempData.ProcessData;
                        }
                        /* End SSI */

                        // Sperm Use Case 1.1 
                        else {
                            if (this.block_history[i].State == '1.1') {
                                this.spermUseCase = this.block_history[i].TempData.ProcessData;
                            }
                        }
                        
                    }

                    console.log("⭐⭐⭐");

                    this.collapseAll();
                } catch (error) {
                    console.log(error);
                }
                
            },
            async getNFT(tokenURI, type) {
                if (type == "stacked") {
                    tokenURI = "/" + tokenURI.split("/")[3];
                    console.log(tokenURI);
                }
                if (type == "master") {
                    tokenURI = "/" + tokenURI + ".json";
                    console.log(tokenURI);
                }


                try {
                    let url = process.env.VUE_APP_NFT_API_URI;
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    let data = {
                        "api": "fetchNFT",
                        "path": tokenURI
                    }
                    data = JSON.stringify(data);

                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    console.log(response.data);
                    console.log(tokenURI);
                    return response.data;
                    
                } catch (error) {
                    console.log(error);
                }    
            },
            getTemplateName(templateID)
            {
                const data = this.blockchainTemplates
                for (const item of data) {
                    const subItem = item.TempData.contract;
                    if (subItem && subItem.id === templateID) {
                        return subItem.name;
                    }
                }
                return null; // Return null if the ID is not found
            },
            checkIfItemExistsInArrray(array, item){
                if (array.includes(item)) return true;
            },
            /* Checks to see if a timestamp sent is newer than 1 day ago */
            isNewRow(timestamp) {                
                const today = new Date();
                const twentyFourHoursAgo = new Date(today).setHours(today.getHours() - 24);
                const itemDate = new Date(timestamp)

                return (itemDate > twentyFourHoursAgo && itemDate <= today)
            },
            convertBlockTimestamp: function(timestamp) {
                let ts = new Date(parseInt(timestamp));     
                let tsa = ts.toLocaleString('en-AU').toUpperCase();
                let tsb = ts.toLocaleString('en-us', {  weekday: 'short' }) + ' ' + tsa;
                ts = tsb.replace(',', '');
                return ts;
            },
            selectedMilestone(milstoneText, milestoneID, milestoneType, milestoneTimestamp, inprogress) {
                // reset input fields
                this.locationMotSet = true;
                this.detectingLocation = false,
                this.process_location_description = null;
                this.process_location = null;
                this.process_doctor_name = null;
                this.process_doctor_title = null;
                this.process_doctor_surname = null;
                this.process_doctor_firstname = null;
                this.process_doctor_phone = null;
                this.process_doctor_email = null;
                this.process_doctor_profession = null;
                this.process_doctor_reg_number = null;
                this.process_doctor_reg_status = null;
                
                // check if process is in progress
                if (inprogress) {
                    this.processInProgress = true;
                } else {
                    this.processInProgress = false;
                }
                
                // close any expanded dropdowns
                this.infoBoxClosed_location = true;
                this.infoBoxClosed_patient = true;
                this.infoBoxClosed_doctor = true;
                this.infoBoxClosed_sample = true;
                this.infoBoxClosed_sample_checks = true;
                this.infoBoxClosed_sample_reg = true;
                this.infoBoxClosed_device = true;
                this.infoBoxClosed_process = true;

                // load selected data into modal
                this.selectedMilestoneText = milstoneText;
                this.selectedMilestoneID = milestoneID;
                this.selectedMilestoneType = "Subprocess"; // overriddden
                this.selectedMilestoneTimestamp = milestoneTimestamp;
            },
            detectLocation() {
                console.log("detectLocation clicked");
                this.detectingLocation = true;  

                setTimeout(() => {
                    this.detectingLocation = false;    
                    this.locationMotSet = false;
                    this.testLocationLoaded = true;
                    this.process_location = "45 Selkirk Drive, Wendouree VIC 3355 Australia"                    
                }, 1000);
            },
            processCommitToBlockchain() {
                console.log("processCommitToBlockchain clicked");
            },
            milestoneToggle(id) {
                if (this.template.TempData.contract.milestones[(id -1)].expanded) {
                    this.template.TempData.contract.milestones[(id -1)].expanded = false;
                } else {
                    this.template.TempData.contract.milestones[(id -1)].expanded = true;
                }
            },
            expandAll() {
                for(let i = 0; i < this.template.TempData.contract.milestones.length; i++) {
                    this.template.TempData.contract.milestones[i].expanded = true;
                }
                this.contractAllExpanded = true;
            },
            collapseAll() {
                for(let i = 0; i < this.template.TempData.contract.milestones.length; i++) {
                    this.template.TempData.contract.milestones[i].expanded = false;
                }
                this.contractAllExpanded = false;
            },
            NFT_wizard_button(movement) {
                console.log("NFT_wizard_butto clicked 🤘" + movement);

                // 3 second delay
                this.NFT_wizard_loading = true;
                let delay = 0;

                if (movement == 'forward' && !this.NFT_wizard_complete) {
                    delay = 500;
                }

                setTimeout(() => {
                    // show loading spinner
                    this.NFT_wizard_loading = false;

                    // find current step
                    let current = null;

                    for(let i = 0; i < this.NFT_wizard_steps.length; i++) {
                        if (this.NFT_wizard_steps[i].active) {
                            current = i+1;
                        }
                    }

                    // find movement direction
                    if (movement == 'forward') {
                        this.NFT_wizard_steps[current -1].complete = true;
                        if (current < this.NFT_wizard_steps.length) {
                            current = current +1;
                        }
                    } else {
                        current = current -1;
                    }

                    console.log("current " + current);

                    this.current_NFT_wizard_step = current;

                    // flag as complete and add NFT to wallet
                    if (this.NFT_wizard_steps[this.NFT_wizard_steps.length -1].complete && !this.NFT_wizard_complete) {
                        // this.subprocessComplete(this.selectedSubprocess);
                        this.subprocessCompleteFromWizard();
                        this.NFT_wizard_complete = true;
                        this.$parent.showNFT = true;
                    }                

                    // move
                    if (current > 0 && current < this.NFT_wizard_steps.length +1) {
                        current = current -1;
                        for(let i = 0; i < this.NFT_wizard_steps.length; i++) {
                            if (i == current) {
                                this.NFT_wizard_steps[i].active = true;
                            } else {
                                this.NFT_wizard_steps[i].active = false;
                            }
                        }
                    }

                    console.log("-----------");
                    console.log("current_NFT_wizard_step " + this.current_NFT_wizard_step);
                    console.log("NFT_wizard_complete " + this.NFT_wizard_complete);
                    console.log("-----------");

                }, delay);
            },
            async getHuonLocations(){
                try {
                    const response = await this.$http.post(
                        process.env.VUE_APP_AQUACULTURE_CRUD_API_URI,
                        {"TableName": "aquaculture_sites"},
                        { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken }}
                    );
                    
                    this.huonHatcheries = response.data;
                } catch (error) {
                    console.log(error);
                }
            },
            async getDeviceBatchData(){
                this.deviceBatchData = [];

                let url = process.env.VUE_APP_MULE_PROXY_API_URI;

                let data = {
                    "endpoint": "/api/batches"
                };

                data = JSON.stringify(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };          

                try {
                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    for(let i = 0; i < response.data.length; i++) {
                        // add id for table
                        response.data[i].id = i + 1;

                        let options = { hour12: false };
                        // format dates
                        if(response.data[i].Started  != null) {
                            response.data[i]['Processed'] = moment(response.data[i].Started).fromNow();
                            response.data[i].Started = new Date(response.data[i].Started).toLocaleString('en-AU', options);
                        }
                        if(response.data[i].Finished  != null) {
                            response.data[i].Finished = new Date(response.data[i].Finished).toLocaleString('en-AU', options);
                        }

                        // adjusting field names
                        response.data[i]['Temp Setpoint'] = response.data[i]['Temp. Setpoint'];
                        response.data[i]['Temp Tolerance'] = response.data[i]['Temp. Tolerance'];
                        response.data[i]['Start Temp'] = response.data[i]['Start Temp.'];
                        response.data[i]['End Temp'] = response.data[i]['End Temp.'];
                        response.data[i]['Min Temp'] = response.data[i]['Min Temp.'];
                        response.data[i]['Max Temp'] = response.data[i]['Max Temp.'];

                    }

                    this.deviceBatchData = response.data;
                    
                } catch (error) {
                    console.log(error);
                }
            },
            showNFTTest() {
                console.log("showNFTTest clicked 🤘");
                this.$parent.showNFT = true;
            },
            getAquacultureMasterRows() {
                let blockchainInProgressMastersAquaculture = [];
                const aquaMasters = this.filterBlockchainInProgressByTemplate("932f342a-0eeb-4c45-9bf4-816a72315278");
                for (const aquaMaster of aquaMasters) { blockchainInProgressMastersAquaculture.push(aquaMaster); }
                
                return blockchainInProgressMastersAquaculture;
            },
            getBovineMasterRows() {
                let blockchainInProgressMastersBovine = [];
                const ssiMasters = this.filterBlockchainInProgressByTemplate("7a976520-bae3-478e-a397-784354f79970");
                for (const ssiMaster of ssiMasters) { blockchainInProgressMastersBovine.push(ssiMaster); }
                
                return blockchainInProgressMastersBovine;
            },
            getHumanMasterRows() {
                let blockchainInProgressMastersHuman = [];
                const artMasters = this.filterBlockchainInProgressByTemplate("0e9f0c83-df43-40fb-ace9-01adacfeccaf");
                for (const artMaster of artMasters) { blockchainInProgressMastersHuman.push(artMaster); }
                const cartMasters = this.filterBlockchainInProgressByTemplate("954b11cc-c469-4e4f-80e9-30376cff9d03");
                for (const cartMaster of cartMasters) { blockchainInProgressMastersHuman.push(cartMaster); }
                const humanSpermMasters = this.filterBlockchainInProgressByTemplate("c2968cb9-20f1-4820-9d7c-07975b39e8f6");
                for (const humanSpermMaster of humanSpermMasters) { blockchainInProgressMastersHuman.push(humanSpermMaster); }
                const CSLMasters = this.filterBlockchainInProgressByTemplate(this.cslContractTemplateID);
                for (const CSLMaster of CSLMasters) { blockchainInProgressMastersHuman.push(CSLMaster); }                
                
                return blockchainInProgressMastersHuman;
            },
            getSSIStackedItems(masterName){
                let ssiStackedItems = [];
                for (const item of this.filterBlockchainInProgressByTemplate("7a976520-bae3-478e-a397-784354f79975")) {
                    if(item.name.substring(0, masterName.length) == masterName)
                    {
                        ssiStackedItems.push(item);
                        this.blockchainBovineStackeds.push(item);
                    }
                }

                return ssiStackedItems;
            },
            async getSSISpermAssessment() {

                let sperm_assessment = [];

                let url = process.env.VUE_APP_MULE_PROXY_API_URI;

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };

                let data = {
                    "endpoint": "/api/AquacultureOCR/Results"
                };

                data = JSON.stringify(data);

                try {
                    const response = await this.$http.post(
                        url,
                        data,
                        { headers: headers }
                    );

                    let element = response.data[0]

                    sperm_assessment.push(element)

                } catch (error) {
                    console.log(error);
                }
                
                return sperm_assessment;
            },
            // Generates an 'Egg Batch' contract for a specific fish - from subprocess
            async createAquacultureEggBatch(){
                let newTimeStamp = new Date().getTime().toString()
                let today = moment(new Date()).format("YYYY-MM-DD");
                let newID = this.selectedBlock.name + "_" + today;
                let newGUID = this.uuidv4();
                let newBlockID = newGUID + ":" + newTimeStamp + ":" + newID;

                try {
                    let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + "";
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    let data = {
                        "TableName": this.aquacultureBlockChainTableName,
                        "Item": {
                            "ID": newBlockID,
                            "TimeStamp": newTimeStamp,
                            "State": "0",
                            "Owner": "Vitrafy (version 4)",
                            "User": this.current_user,
                            "TemplateID": this.aquacultureEggBatchTemplateID,
                            "TempData": {
                                "TemplateID": this.aquacultureEggBatchTemplateID,
                                "Application": "ART"
                            }
                        }
                    };
                    data = JSON.stringify(data);

                    /*const newBlockHeaderInsertResponse = */await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    data = {
                        "TableName": this.aquacultureBlockChainTableName,
                        "Item": {
                            "ID": newBlockID,
                            "TimeStamp": (new Date().getTime()).toString(),
                            "State": '1.1',
                            "Owner": this.selectedBlock.Owner,
                            "User": this.selectedBlock.User,
                            "TemplateID": this.aquacultureEggBatchTemplateID,
                            "TempData": {
                                "TemplateID": this.aquacultureEggBatchTemplateID,
                                "Application": "ART",
                                "ProcessData": { master_tag_id : this.selectedBlock.name, egg_batch_id: today, year_class: this.bcCache.find(cacheContract => cacheContract.ID == this.selectedBlock.ID && cacheContract.State == "1.1").TempData.ProcessData.year_class, egg_count: this.huonFemaleMasterFish_3_1.egg_count, esky_id: this.huonFemaleMasterFish_3_1.esky_id}
                            }
                        }
                    };
                    data = JSON.stringify(data);

                    await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                } catch (error) {
                    console.log(error);
                }

                /* Temp hack to retrieve only updated data for refresh */
                let newRowsFromDB;
                newRowsFromDB = await this.retrieveBlockchainFromAPI(newBlockID)
                //update the bcCache with all of the new data within the 'newRowsFromDB' array (update matching, and add new rows)
                newRowsFromDB.forEach(newContract => {
                    let cacheItem = this.bcCache.find(searchContract => searchContract.ID == newContract.ID && searchContract.TimeStamp == newContract.TimeStamp);
                    if (cacheItem) {
                        this.bcCache.splice(this.bcCache.indexOf(cacheItem), 1, newContract)
                    } else {
                        this.bcCache.push(newContract)
                    }
                });

                await this.getBlockchain(this.type, true);
            },
            // Generates a 'Sample' contract for a specific fish
            async createAqaucultureSample() {

                const newTimeStamp = (new Date().getTime()).toString()
                const today = moment(new Date()).format("YYYY-MM-DD");
                const newID = this.selectedBlock.name + "_" + today;
                const newGUID = this.uuidv4();
                const newBlockID = newGUID + ":" + newTimeStamp + ":" + newID;

                try {
                    let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + "";
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    let data = {
                        "TableName": this.aquacultureBlockChainTableName,
                        "Item": {
                            "ID": newBlockID,
                            "TimeStamp": newTimeStamp,
                            "State": "0",
                            "Owner": "Vitrafy (version 4)",
                            "User": this.current_user,
                            "TemplateID": this.aquacultureMiltSampleTemplateID,
                            "TempData": {
                                "TemplateID": this.aquacultureMiltSampleTemplateID,
                                "Application": "ART"
                            }
                        }
                    };
                    data = JSON.stringify(data);

                    /*const newBlockHeaderInsertResponse = */await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    data = {
                        "TableName": this.aquacultureBlockChainTableName,
                        "Item": {
                            "ID": newBlockID,
                            "TimeStamp": (new Date().getTime()).toString(),
                            "State": '1.1',
                            "Owner": this.selectedBlock.Owner,
                            "User": this.selectedBlock.User,
                            "TemplateID": this.aquacultureMiltSampleTemplateID,
                            "TempData": {
                                "TemplateID": this.aquacultureMiltSampleTemplateID,
                                "Application": "ART",
                                "ProcessData": { master_tag_id : this.selectedBlock.name, sample_id: today }
                            }
                        }
                    };
                    data = JSON.stringify(data);

                    await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                } catch (error) {
                    console.log(error);
                }

                /* Temp hack to retrieve only updated data for refresh */
                let newRowsFromDB;
                newRowsFromDB = await this.retrieveBlockchainFromAPI(newBlockID)
                //update the bcCache with all of the new data within the 'newRowsFromDB' array (update matching, and add new rows)
                newRowsFromDB.forEach(newContract => {
                    let cacheItem = this.bcCache.find(searchContract => searchContract.ID == newContract.ID && searchContract.TimeStamp == newContract.TimeStamp);
                    if (cacheItem) {
                        this.bcCache.splice(this.bcCache.indexOf(cacheItem), 1, newContract)
                    } else {
                        this.bcCache.push(newContract)
                    }
                });

                await this.getBlockchain(this.type, true);
            },
            async saveAquaculturePackageSample() {
                try {
                    let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + "";
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    let data = {
                        "TableName": process.env.VUE_APP_BLOCKCHAIN_DB_PACKAGES_TABLE_NAME,
                        "Item": {
                            "ID": this.selectedBlock.ID,
                            "TimeStamp": this.selectedBlock.TimeStampEpoch,
                            "State": "3.1",
                            "Owner": "Vitrafy (version 4)",
                            "User": this.current_user,
                            "TemplateID": (this.selectedBlock.TemplateID == undefined ? this.selectedBlock.TempData.TemplateID : this.selectedBlock.TemplateID),
                            "TempData": {
                                "TemplateID": this.selectedBlock.TempData.TemplateID,
                                "Application": "ART",
                                "ProcessData": this.huonFishSample_3_1
                            }
                        }
                    };
                    data = JSON.stringify(data);
                    await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );


                } catch (error) {
                    console.log(error);
                }
            },
            async refreshAquaculturePackages(contractID = null){
                let url = `${process.env.VUE_APP_BLOCKCHAIN_API_URI}?TableName=${process.env.VUE_APP_BLOCKCHAIN_DB_PACKAGES_TABLE_NAME}&Limit=1000`;
                
                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };

                try {
                    const response = await this.$http.get(
                        url,
                        {headers: headers}
                    );

                    // Make sure the response is in JSON format
                    const responseItems = /*JSON.parse(*/response.data.Items/*)*/;
                    this.huonFishSample_3_1 = responseItems.find(contract => contract.ID == (contractID ? contractID : this.selectedBlock.ID) && contract.State == '3.1').TempData.ProcessData
                } catch (error) {
                    console.log(error);
                }
            },
            async attachAquaculturePackageToSample(){
                this.loadingSamplePackaging = true;
                this.package_checking_status_icon_class = "fa-solid fa-spinner fa-spin info-icon";
                
                if (this.packageToAttachToHuonSample.includes("ID-")) {this.packageToAttachToHuonSample =  "Package " + this.packageToAttachToHuonSample; console.log("here")}
                else this.packageToAttachToHuonSample = "Package ID-" + this.packageToAttachToHuonSample;

                const searchID = this.packageToAttachToHuonSample
                console.log("Searching for package: ", searchID)
                setTimeout(() => {
                    const foundPackage = this.blockchainInProgress.find((contract) => contract.TempData.TemplateID == '18719e55-99bf-4137-b7bb-fefd373f60b3' && contract.ID.substring(contract.ID.indexOf('Package ID-'), contract.ID.length) == searchID)
                    
                    if(foundPackage && this.huonFishSample_3_1.attachedPackages.find((searchPackage) => searchPackage == foundPackage) == undefined) {
                        this.package_checking_status_icon_class = "fa-solid fa-circle-check success-icon";
                        this.huonFishSample_3_1.attachedPackages.push(foundPackage);
                        // Also add it to the DB list
                        this.saveAquaculturePackageSample();
                    }
                    else this.package_checking_status_icon_class = "fa-solid fa-circle-xmark warn-icon";
                }, 200);
                
                
                // Clear the input and set the focus (ready for next input)
                this.packageToAttachToHuonSample = '';
                this.$refs['sample-package-id-input'].focus();

                this.completeSubprocess.buttonDisabled = !this.huonFishSample_3_1.attachedPackages.length
                this.loadingSamplePackaging = false;
            },
            detachAquaculturePackageFromSample(id) {
                this.loadingSamplePackaging = true;
                this.huonFishSample_3_1.attachedPackages.splice(this.huonFishSample_3_1.attachedPackages.indexOf(this.huonFishSample_3_1.attachedPackages.find((searchPackage) => searchPackage.ID == id)), 1)

                // Also remove it from the DB list
                this.saveAquaculturePackageSample();

                // Clear the input and set the focus (ready for next input)
                this.packageToAttachToHuonSample = '';
                this.$refs['sample-package-id-input'].focus();
                this.package_checking_status_icon_class = "fa-solid fa-qrcode";
                
                this.completeSubprocess.buttonDisabled = !this.huonFishSample_3_1.attachedPackages.length
                this.loadingSamplePackaging = false;
            },
            async attachAquaculturePackageToBatch(){
                this.loadingSamplePackaging = true;
                this.package_checking_status_icon_class = "fa-solid fa-spinner fa-spin info-icon";

                // Find the package
                const foundPackage = this.huonFishSample_3_1.attachedPackages.find((contract) => contract.ID.split(":")[2].replace("Package ID-", "") == this.packageToAttachToHuonBatch.replace("ID-", ""))
                if (foundPackage && this.huonFishSample_3_1.packagesToFreeze.find((searchPackage) => searchPackage == foundPackage) == undefined) {
                    // Add the package to the list of 'packages to freeze'
                    this.package_checking_status_icon_class = "fa-solid fa-circle-check success-icon";
                    this.huonFishSample_3_1.packagesToFreeze.push(foundPackage)
                    foundPackage.locked = true;
                    this.saveAquaculturePackageSample();                   
                }
                else {
                    // Do a refresh of the 'Available packages' list
                    await this.refreshAquaculturePackages();

                    const foundPackageAfterRefresh = this.huonFishSample_3_1.attachedPackages.find((contract) => contract.ID.split(":")[2].replace("Package ID-", "") == this.packageToAttachToHuonBatch.replace("ID-", ""))
                    if(foundPackageAfterRefresh && this.huonFishSample_3_1.packagesToFreeze.find((searchPackage) => searchPackage == foundPackageAfterRefresh) == undefined) {
                        // Add the package to the list of 'packages to freeze'
                        this.package_checking_status_icon_class = "fa-solid fa-circle-check success-icon";
                        this.huonFishSample_3_1.packagesToFreeze.push(foundPackageAfterRefresh)
                        foundPackageAfterRefresh.locked = true;
                        
                        this.saveAquaculturePackageSample();
                    }
                    else this.package_checking_status_icon_class = "fa-solid fa-circle-xmark warn-icon";
                }
                
                // Clear the input and set the focus (ready for next input)
                this.packageToAttachToHuonBatch = '';
                this.$refs['batch-package-id-input'].focus();

                this.loadingSamplePackaging = false;
            },
            detachAquaculturePackageFromBatch(detachPackage) {
                this.loadingSamplePackaging = true;
                // Find the package
                const foundPackage = this.huonFishSample_3_1.packagesToFreeze.find((contract) => contract.ID == detachPackage.ID)
                if(foundPackage) {
                    // Now remove the package from the 'packages to freeze' list
                    const spliceIndex = this.huonFishSample_3_1.packagesToFreeze.indexOf(this.huonFishSample_3_1.packagesToFreeze.find(indexPackage => indexPackage.ID == foundPackage.ID))
                    this.huonFishSample_3_1.packagesToFreeze.splice(spliceIndex, 1)
                    detachPackage.locked = false;
                }

                // Clear the input and set the focus (ready for next input)
                this.packageToAttachToHuonBatch = '';
                this.$refs['batch-package-id-input'].focus();
                this.package_checking_status_icon_class = "fa-solid fa-qrcode";

                this.loadingSamplePackaging = false;
            },
            async startTrackingDeviceBatch(){
                this.batchTrackingActive = true;
                this.batchResultsFound = false;
                this.isBatchRowSelected = false;
                this.batchIDManualOverride = null;
                this.batchOverrideSearchTest = null;
                this.batchTrackingLoaderText = 'Looking for Batch Details...'
                this.batchDetectionProgressValue = 0;
                this.package_checking_status_icon_class = "fa-solid fa-qrcode";

                const me=this;

                try {
                    setTimeout(async () => {
                        this.batchTrackingLoaderText = 'Connecting to Device...'
                        this.batchDetectionProgressValue = 25;
                        setTimeout(async () => {
                            this.batchTrackingLoaderText = 'Checking Device data...'
                            this.batchDetectionProgressValue = 50;
                            setTimeout(async () => {
                                this.batchTrackingLoaderText = 'Finding the Batch details...'
                                this.batchDetectionProgressValue = 75;
                                setTimeout(async () => {
                                    this.batchTrackingLoaderText = 'Loading Batch Details...'
                                    this.batchDetectionProgressValue = 100;
                                    setTimeout(async () => {
                                        await this.getBatchDetails(false, 1);
                                        /* Priodically refresh data (currently set to every 5 seconds) */
                                        this.deviceConnectionIntervalID = window.setInterval(async function () {
                                            await me.getBatchDetails(false, null);
                                        }, 3000)
                                    }, 1000);
                                }, 1500)
                            }, 1500)
                        }, 1500)
                    }, 1500)
                }
                catch (error) {
                    console.log("Caught Error EHRERE ER HERE: ", error);
                    this.batchTrackingActive = false;
                    this.deviceConnectionIntervalID = null;
                    this.batchResultsFound = false;
                    this.isBatchRowSelected = false;
                    this.batchIDManualOverride = null;
                    this.batchOverrideSearchTest = null;
                    this.batchTrackingLoaderText = 'Looking for Batch Details...'
                    this.batchDetectionProgressValue = 0;
                    clearInterval(this.deviceConnectionIntervalID);
                }
            },
            async getBatchDetails(stale = false, x = 1) {
                console.log("Getting batch data at: ", new Date(), " Using Stale: ", stale, " x: ", x)
                if (x >= 3) {
                    console.log("Retried 3 times, quitting...");
                    this.batchTrackingActive = false;
                    this.deviceConnectionIntervalID = null;
                    this.batchResultsFound = true;
                    this.isBatchRowSelected = false;
                    this.batchIDManualOverride = null;
                    this.batchOverrideSearchTest = null;
                    this.batchTrackingLoaderText = 'Looking for Batch Details...'
                    this.batchDetectionProgressValue = 0;
                    clearInterval(this.deviceConnectionIntervalID);
                    return;
                }
                const deviceID = this.vitrafyCryopreservationDevices.find(device => device.value == this.deviceSelected).text
                let url = process.env.VUE_APP_MULE_PROXY_API_URI;

                let responseData = [];
                let data = { "endpoint": "/api/batches/live?deviceName=" + deviceID + "&stale=" + stale };

                data = JSON.stringify(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };          

                try {
                    console.log("attempting live data...", data)
                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    let newBatch;
                    console.log("Response: ", response)
                    if (response.data.length > 0) {
                        let batch = response.data[0];
                        // console.log("Batch from DB: ", response)
                        if (batch) {
                            newBatch = {
                                device_id: deviceID,
                                batch_id: batch.BatchID,
                                protocol: batch.ProtocolOEMCode,
                                label: batch.ProtocolOEMDescription,
                                start_time: (batch.StartDateTime ? batch.StartDateTime : ''),
                                end_time: (batch.EndDateTime ? batch.EndDateTime : ''),
                                set_temp: (batch.Temperature ? batch.Temperature : ''),
                                set_flow: (batch.Flow ? batch.Flow : ''),
                                process_time: (batch.ProcessTime ? batch.ProcessTime : ''),
                                start_temp: (batch.StartTemp ? batch.StartTemp.toFixed(1) : ''),
                                end_temp: (batch.EndTemp ? batch.EndTemp.toFixed(1) : ''),
                                min_temp: (batch.MinTemp ? batch.MinTemp.toFixed(1) : ''),
                                max_temp: (batch.MaxTemp ? batch.MaxTemp.toFixed(1) : ''),
                                min_flow: (batch.MinFlow ? batch.MinFlow.toFixed(1) : ''),
                                max_flow: (batch.MaxFlow ? batch.MaxFlow.toFixed(1) : ''),
                                end_flow: (batch.EndFlow ? batch.EndFlow.toFixed(1) : '')
                            }
                        }
                        if (!this.deviceBatchDetails.find(batch => batch.device_id == deviceID && batch.batch_id == newBatch.batch_id)) this.deviceBatchDetails.push( newBatch );
                        
                        this.batchResultsFound = true;
                    }
                } catch (error) {
                    console.log("CAught erorr HERE: ", error);
                    this.batchTrackingActive = false;
                    this.deviceConnectionIntervalID = null;
                    this.batchResultsFound = false;
                    this.isBatchRowSelected = false;
                    this.batchIDManualOverride = null;
                    this.batchOverrideSearchTest = null;
                    this.batchTrackingLoaderText = 'Looking for Batch Details...'
                    this.batchDetectionProgressValue = 0;
                    clearInterval(this.deviceConnectionIntervalID);
                    this.getBatchDetails(true, ++x);
                }

                // console.log("Batch from DB: ", response)
                responseData.forEach(batchItem => {
                    console.log("Batch Item: ", batchItem)
                    let newBatch = {
                        device_id: deviceID,
                        batch_id: batchItem.BatchID,
                        protocol: (batchItem.ProtocolOEMCode ? batchItem.ProtocolOEMCode : ''),
                        label: (batchItem.ProtocolOEMDescription ? batchItem.ProtocolOEMDescription : ''),
                        start_time: (batchItem.StartDateTime ? batchItem.StartDateTime : ''),
                        end_time: (batchItem.EndDateTime ? batchItem.EndDateTime : ''),
                        set_temp: (batchItem.Temperature ? batchItem.Temperature : ''),
                        set_flow: (batchItem.Flow ? batchItem.Flow : ''),
                        process_time: (batchItem.ProcessTime ? batchItem.ProcessTime : ''),
                        start_temp: (batchItem.StartTemp ? batchItem.StartTemp.toFixed(1) : ''),
                        end_temp: (batchItem.EndTemp ? batchItem.EndTemp.toFixed(1) : ''),
                        min_temp: (batchItem.MinTemp ? batchItem.MinTemp.toFixed(1) : ''),
                        max_temp: (batchItem.MaxTemp ? batchItem.MaxTemp.toFixed(1) : ''),
                        min_flow: (batchItem.MinFlow ? batchItem.MinFlow.toFixed(1) : ''),
                        max_flow: (batchItem.MaxFlow ? batchItem.MaxFlow.toFixed(1) : ''),
                        end_flow: (batchItem.EndFlow ? batchItem.EndFlow.toFixed(1) : '')
                    }
                    if (parseInt(newBatch.batch_id) < 50 && !this.deviceBatchDetails.find(batch => batch.device_id == deviceID && batch.batch_id == newBatch.batch_id)) this.deviceBatchDetails.push( newBatch );
                });
            },
            batchRowWasSelected(){
                this.isBatchRowSelected = this.$refs['deviceBatchDetails'].selectableHasSelection;
            },
            async finaliseBatchAndPackages(){
                // console.log("Finalising batch and packages...")
                this.finalisingAquacultureBatchAndPackages = true;
                clearInterval(this.deviceConnectionIntervalID);
                let packagesToFreeze = this.huonFishSample_3_1.packagesToFreeze;
                let i = 0;
                // console.log("Packages to freeze: ", packagesToFreeze)
                // await this.deviceBatchDetails.forEach(batch => {    
                
                if (!this.batchIDManualOverride) {
                    // console.log("Looping through the device batch details...")
                    for (let batch of this.deviceBatchDetails) {
                        if (this.$refs['deviceBatchDetails'].isRowSelected(i)) {
                            // console.log("Saving to DB...")
                            await this.setPackagesToBatch(batch, packagesToFreeze);
                            // console.log("Saved to DB...")
                            setTimeout(() =>{
                                this.batchTrackingActive = false;
                                this.deviceConnectionIntervalID = null;
                                this.batchResultsFound = false;
                                this.isBatchRowSelected = false;
                                this.batchIDManualOverride = null;
                                this.batchOverrideSearchTest = null;
                                this.finalisingAquacultureBatchAndPackages = false;
                                this.huonFishSample_3_1.packagesToFreeze = [];
                                this.batchTrackingLoaderText = 'Looking for Batch Details...'
                                this.batchDetectionProgressValue = 0;
                                // console.log("Finalised batch and packages...")
                            }, 1000);
                            // console.log("Saved to DB...")
                        }
                        i++;
                    }
                }
                else {
                    console.log("manualBatchOverrideProvided. DEvice: ", this.deviceSelected, " Batch ID: ", this.batchIDManualOverride)
                    let batches;
                    console.log("Finalising with manual override...")
                    let url = process.env.VUE_APP_MULE_PROXY_API_URI;
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    const deviceID = this.vitrafyCryopreservationDevices.find(device => device.value == this.deviceSelected).text
                    let data = { "endpoint": "/api/batches/live?deviceName=" + deviceID + "&stale=" + true };
                    console.log("Getting stale batches: ", data)
                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    console.log("Response from Stale (via Batch Override): ", response)
                    batches = response.data;
                    console.log("Batches: ", batches)
                    let batchItem = batches.find(batch => batch.DeviceID == this.deviceSelected && parseInt(batch.BatchID) == parseInt(this.batchIDManualOverride));
                    if (!batchItem) {
                        console.log("Batch not found, retrying with stale data...")
                        this.batchOverrideSearchTest = 'Batch not found, please search again...';
                        this.batchTrackingActive = false;
                        this.deviceConnectionIntervalID = null;
                        this.batchResultsFound = false;
                        this.isBatchRowSelected = false;
                        this.batchIDManualOverride = null;
                        this.finalisingAquacultureBatchAndPackages = false;
                        this.huonFishSample_3_1.packagesToFreeze = [];
                        this.batchTrackingLoaderText = 'Looking for Batch Details...'
                        this.batchDetectionProgressValue = 0;
                    }
                    else
                    {
                        let newBatch = {
                            device_id: deviceID,
                            batch_id: batchItem.BatchID,
                            protocol: (batchItem.ProtocolOEMCode ? batchItem.ProtocolOEMCode : ''),
                            label: (batchItem.ProtocolOEMDescription ? batchItem.ProtocolOEMDescription : ''),
                            start_time: (batchItem.StartDateTime ? batchItem.StartDateTime : ''),
                            end_time: (batchItem.EndDateTime ? batchItem.EndDateTime : ''),
                            set_temp: (batchItem.Temperature ? batchItem.Temperature : ''),
                            set_flow: (batchItem.Flow ? batchItem.Flow : ''),
                            process_time: (batchItem.ProcessTime ? batchItem.ProcessTime : ''),
                            start_temp: (batchItem.StartTemp ? batchItem.StartTemp.toFixed(1) : ''),
                            end_temp: (batchItem.EndTemp ? batchItem.EndTemp.toFixed(1) : ''),
                            min_temp: (batchItem.MinTemp ? batchItem.MinTemp.toFixed(1) : ''),
                            max_temp: (batchItem.MaxTemp ? batchItem.MaxTemp.toFixed(1) : ''),
                            min_flow: (batchItem.MinFlow ? batchItem.MinFlow.toFixed(1) : ''),
                            max_flow: (batchItem.MaxFlow ? batchItem.MaxFlow.toFixed(1) : ''),
                            end_flow: (batchItem.EndFlow ? batchItem.EndFlow.toFixed(1) : '')
                        }
                        console.log("Found Batch from Stale: ", newBatch)
                        await this.setPackagesToBatch(newBatch, packagesToFreeze);
                        // console.log("Saved to DB...")
                        setTimeout(() =>{
                            this.batchTrackingActive = false;
                            this.deviceConnectionIntervalID = null;
                            this.batchResultsFound = false;
                            this.isBatchRowSelected = false;
                            this.batchIDManualOverride = null;
                            this.batchOverrideSearchTest = null;
                            this.finalisingAquacultureBatchAndPackages = false;
                            this.huonFishSample_3_1.packagesToFreeze = [];
                            this.batchTrackingLoaderText = 'Looking for Batch Details...'
                            this.batchDetectionProgressValue = 0;
                            // console.log("Finalised batch and packages...")
                        }, 1000);
                        // console.log("Saved to DB...")
                    }
                }

                console.log("Finalised batch and packages...")
            },
            async setPackagesToBatch(batch, packagesToFreeze) {
                // console.log("Saving batch...", batch)
                // Create a new 'Cryopreservation Batch' contract
                const newTimeStamp = (new Date().getTime()).toString()
                const deviceID = await this.vitrafyCryopreservationDevices.find(device => device.value == this.deviceSelected).text;

                // console.log("Device ID: ", deviceID, " this.selectedBlock: ", this.selectedBlock)
                // console.log("Initial Samples: ", this.initialAquacultureSamples)
                const masterContract = this.initialAquacultureSamples.find((contractToFind) => contractToFind.ID == this.selectedBlock.ID)
                // console.log("Master contract: ", masterContract)
                const masterFishID = (masterContract.TempData.ProcessData.master_tag_id != undefined ? masterContract.TempData.ProcessData.master_tag_id : '');
                const sampleID = masterContract.TempData.ProcessData.sample_id;

                console.log("Found master fish ID: ", masterFishID)
                const newID = this.selectedBlock.name + "_" + deviceID + "_" + batch.batch_id;
                const newGUID = this.uuidv4();
                const newBlockID = newGUID + ":" + newTimeStamp + ":" + newID;

                const url = process.env.VUE_APP_BLOCKCHAIN_API_URI + "";
                const headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };

                console.log("saving batch header...")
                try {
                    // Save the batch 'header' (State = 0) row
                    let data = {
                        "TableName": this.aquacultureBlockChainTableName,
                        "Item": {
                            "ID": newBlockID,
                            "TimeStamp": newTimeStamp,
                            "State": "0",
                            "Owner": "Vitrafy (version 4)",
                            "User": this.current_user,
                            "TemplateID": this.cryopreservationBatchTemplateID,
                            "TempData": {
                                "TemplateID": this.cryopreservationBatchTemplateID,
                                "Application": "ART"
                            }
                        }
                    };
                    console.log("Saving batch header row...", data)
                    data = JSON.stringify(data);

                    let newBatchHeaderInsertResponse = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    console.log("newBatchHeaderInsertResponse: ", newBatchHeaderInsertResponse)

                    // Save the batch details (State = 1.1) row
                    data = {
                        "TableName": this.aquacultureBlockChainTableName,
                        "Item": {
                            "ID": newBlockID,
                            "TimeStamp": (new Date().getTime()).toString(),
                            "State": '1.1',
                            "Owner": this.selectedBlock.Owner,
                            "User": this.current_user,
                            "TemplateID": this.cryopreservationBatchTemplateID,
                            "TempData": {
                                "TemplateID": this.cryopreservationBatchTemplateID,
                                "Application": "ART",
                                "ProcessData": {master_tag_id : masterFishID, sample_id: sampleID, device_id: deviceID, batch_id: batch.batch_id, cryopreservedPackages: packagesToFreeze}
                            }
                        }
                    };
                    
                    console.log("Saving batch details row...", data)
                    data = JSON.stringify(data);

                    let newBatchDetailsInsertResponse = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );
                    
                    console.log("newBatchDetailsInsertResponse: ", newBatchDetailsInsertResponse)
                } catch (error) {
                    console.log(error);
                }

                console.log("Processing packages: ", packagesToFreeze)
                await packagesToFreeze.forEach((cryopreservedPackage) => {
                    console.log("Saving package: ", cryopreservedPackage)
                    try {                    
                        // Save the Package Machine Operating Conditions row
                        let data = {
                            "TableName": this.aquacultureBlockChainTableName,
                            "Item": {
                                "ID": cryopreservedPackage.ID,
                                "TimeStamp": (new Date().getTime()).toString(),
                                "Owner": "Vitrafy (version 4)",
                                "State": "3.1",
                                "TemplateID": this.aquaculturePackageTemplateID,
                                "TempData": {
                                    "Application": "ART",
                                    "ProcessData": {
                                        "algorithm": "Vitrafy Aquaculture Process",
                                        "moc": {
                                            "flow": "60",
                                            "temp": "-50",
                                            "time": "90"
                                        }
                                    },
                                    "TemplateID": this.aquaculturePackageTemplateID
                                },
                                "User": this.current_user
                            }
                        };
                        console.log("Package MOC data: ", data)
                        data = JSON.stringify(data);


                        let newPackageMOCDetailsInsertResponse = this.$http.post(
                            url,
                            data,
                            {headers: headers}
                        );
                        
                        console.log("newPackageMOCDetailsInsertResponse: ", newPackageMOCDetailsInsertResponse)
                        // Save the Package Batch Details row
                        data = {
                            "TableName": this.aquacultureBlockChainTableName,
                            "Item": {
                                "ID": cryopreservedPackage.ID,
                                "TimeStamp": (new Date().getTime() +1).toString(),
                                "Owner": "Vitrafy (version 4)",
                                "State": "3.2",
                                "TemplateID": this.aquaculturePackageTemplateID,
                                "TempData": {
                                    "Application": "ART",
                                    "ProcessData": {
                                        "batch_id": batch.batch_id,
                                        "code": batch.protocol,
                                        "device": batch.device_id,
                                        "set_flow": batch.set_flow,
                                        "set_temp": batch.set_temp,
                                        "end_flow": batch.end_flow,
                                        "end_temp": batch.end_temp,
                                        "finished": batch.end_time,
                                        "max_flow": batch.max_flow,
                                        "max_temp": batch.max_temp,
                                        "min_flow": batch.min_flow,
                                        "min_temp": batch.min_temp,
                                        "protocol": batch.protocol,
                                        "started": batch.start_time,
                                        "start_flow": batch.start_flow,
                                        "start_temp": batch.end_flow
                                    },
                                    "TemplateID": this.aquaculturePackageTemplateID
                                },
                                "User": this.current_user
                            }
                        };
                        console.log("package batchj data: ", data)
                        data = JSON.stringify(data);
    
                        let newPackageCryoDetailsInsertResponse = this.$http.post(
                            url,
                            data,
                            {headers: headers}
                        );
                        
                        console.log("newPackageCryoDetailsInsertResponse: ", newPackageCryoDetailsInsertResponse)
                        // console.log("Removing package from list...")
                        this.huonFishSample_3_1.cryopreserved_packages.push(this.huonFishSample_3_1.attachedPackages.find((searchPackage) => searchPackage.ID == cryopreservedPackage.ID));
                        this.huonFishSample_3_1.attachedPackages.splice(this.huonFishSample_3_1.attachedPackages.indexOf(this.huonFishSample_3_1.attachedPackages.find((searchPackage) => searchPackage.ID == cryopreservedPackage.ID)), 1);
                    } catch (error) {
                        console.log(error);
                    }
                });

                this.huonFishSample_3_1.packagesToFreeze = [];
                // Save the package state
                await this.saveAquaculturePackageSample();
                
                // sleep for .5 second
                await new Promise(resolve => setTimeout(resolve, 500));

                /* Temp hack to retrieve only updated data for refresh */
                let newRowsFromDB;
                newRowsFromDB = await this.retrieveBlockchainFromAPI(newBlockID)
                //update the bcCache with all of the new data within the 'newRowsFromDB' array (update matching, and add new rows)
                newRowsFromDB.forEach(newContract => {
                    let cacheItem = this.bcCache.find(searchContract => searchContract.ID == newContract.ID && searchContract.TimeStamp == newContract.TimeStamp);
                    if (cacheItem) {
                        this.bcCache.splice(this.bcCache.indexOf(cacheItem), 1, newContract)
                    } else {
                        this.bcCache.push(newContract)
                    }
                });

                // sleep for .5 second
                console.log("Sleeping for .5 seconds before refreshing BlockChain...")
                await new Promise(resolve => setTimeout(resolve, 500));
                await this.getBlockchain(this.type, true);
                
                console.log("Saved batch...")
            },
            async prepareAquaculturePackageForFertilisation(contract){
                console.log("Preparing package for fertilisation... Contract: ", contract)
                let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + "";
                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };
                let currentTimeStamp = (new Date().getTime()).toString();
                let data = {
                    "TableName": this.aquacultureBlockChainTableName,
                    "Item": {
                        "ID": contract.ID,
                        "TimeStamp": currentTimeStamp,
                        "Owner": contract.Owner,
                        "State": "4.2",
                        "TempData": {
                            "Application": contract.TempData.Application,
                                "ProcessData": {
                                "removed": "accepted",
                                "removed_by": this.current_user
                            },
                            "TemplateID": contract.TempData.TemplateID
                        },
                        "TemplateID": contract.TemplateID,
                        "User": this.current_user
                    }
                };
                data = JSON.stringify(data);

                console.log("Setting step 4.2... Data: ", data)

                await this.$http.post(
                    url,
                    data,
                    {headers: headers}
                );

                data = {
                    "TableName": this.aquacultureBlockChainTableName,
                    "Item": {
                        "ID": contract.ID,
                        "TimeStamp": (parseInt(currentTimeStamp) + 1).toString(),
                        "Owner": contract.Owner,
                        "State": "5.1",
                        "TempData": {
                            "Application": contract.TempData.Application,
                            "ProcessData": {
                                    "identification_package_checked": "accepted",
                                    "identification_package_id": contract.name.replace("Package", "").replace("ID-", "").trim(),
                                },
                            "TemplateID": contract.TempData.TemplateID
                        },
                        "TemplateID": contract.TemplateID,
                        "User": this.current_user
                    }
                };
                data = JSON.stringify(data);
                console.log("Setting step 5.1... Data: ", data)

                await this.$http.post(
                    url,
                    data,
                    {headers: headers}
                );
                
                data = {
                    "TableName": this.aquacultureBlockChainTableName,
                    "Item": {
                        "ID": contract.ID,
                        "TimeStamp": (parseInt(currentTimeStamp) + 2).toString(),
                        "Owner": contract.Owner,
                        "State": "5.2",
                        "TempData": {
                            "Application": contract.TempData.Application,
                            "ProcessData": {
                                "algorithm": "Vitrafy Aquaculture Bio-Thaw",
                                "moc": {
                                    "flow": 30,
                                    "temp": 25,
                                    "time": 30
                                }
                            },
                            "TemplateID": contract.TempData.TemplateID
                        },
                        "TemplateID": contract.TemplateID,
                        "User": this.current_user
                    }
                };
                data = JSON.stringify(data);
                console.log("Setting step 5.2... Data: ", data)

                await this.$http.post(
                    url,
                    data,
                    {headers: headers}
                );

                data = {
                    "TableName": this.aquacultureBlockChainTableName,
                    "Item": {
                        "ID": contract.ID,
                        "TimeStamp": (parseInt(currentTimeStamp) + 3).toString(),
                        "Owner": contract.Owner,
                        "State": "5.3",
                        "TempData": {
                            "Application": contract.TempData.Application,
                            "ProcessData": {
                                "thawing_complete": "not_accepted",
                                "thawing_completed": "accepted",
                                "thawing_device": "BioThaw-00001"
                                },
                                "TemplateID": contract.TempData.TemplateID
                            },
                        "TemplateID": contract.TemplateID,
                        "User": this.current_user
                    }
                };
                data = JSON.stringify(data);
                console.log("Setting step 5.3... Data: ", data)

                await this.$http.post(
                    url,
                    data,
                    {headers: headers}
                );
                
                data = {
                    "TableName": this.aquacultureBlockChainTableName,
                    "Item": {
                        "ID": contract.ID,
                        "TimeStamp": (parseInt(currentTimeStamp) + 4).toString(),
                        "Owner": contract.Owner,
                        "State": "6.1",
                        "TempData": {
                            "Application": "ART",
                            "ProcessData": {
                                "concentration": null,
                                "grade": null,
                                "motility": null
                            },
                            "TemplateID": contract.TempData.TemplateID
                        },
                        "TemplateID": contract.TemplateID,
                        "User": this.current_user
                    }
                };
                data = JSON.stringify(data);
                console.log("Setting step 6.1... Data: ", data)

                await this.$http.post(
                    url,
                    data,
                    {headers: headers}
                );

                // temp hack to refresh the data
                let newRowsFromDB;
                newRowsFromDB = await this.retrieveBlockchainFromAPI(contract.ID)                
                
                // filter blockchain
                let temp = [];
                let ts;
                let tsa;

                for (let i = 0; i < newRowsFromDB.length; i++) {
                    let row = newRowsFromDB[i];
                    ts = new Date(parseInt(row.TimeStamp));
                    row.datetime = ts;
                    temp.push(row)

                    let idt = row.ID.toString().split(':');
                    row.displayid = idt[0];
                    row.TimeStamp = idt[1];
                    row.TimeStampEpoch = idt[1];
                    row.name = idt[2];
                    
                    ts = new Date(parseInt(row.TimeStamp));
                    tsa = ts.toLocaleString('en-AU').toUpperCase();
                    let tsb = ts.toLocaleString('en-us', {  weekday: 'short' }) + ' ' + tsa;
                    row.TimeStamp = tsb.replace(',', '');
                }

                // add updated field
                for (let i = 0; i < newRowsFromDB.length; i++) {
                    let row = newRowsFromDB[i];

                    let date = new Date(row.datetime);

                    row.TimeStampEpochUpdated = date.getTime();

                    // Days array to get the day of the week
                    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
                    let dayOfWeek = days[date.getDay()];

                    // Formatting month, day, year
                    let day = String(date.getDate()).padStart(2, '0');
                    let month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
                    let year = date.getFullYear();

                    // Formatting hours, minutes, seconds for 12-hour format with AM/PM
                    let hours = date.getHours();
                    let ampm = hours >= 12 ? 'PM' : 'AM';
                    hours = hours % 12;
                    hours = hours ? hours : 12; // the hour '0' should be '12'
                    let minutes = String(date.getMinutes()).padStart(2, '0');
                    let seconds = String(date.getSeconds()).padStart(2, '0');

                    // Assembling the formatted date
                    let formattedDate = `${dayOfWeek} ${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;

                    row.datetime = formattedDate;
                }

                newRowsFromDB = temp;

                // Identify current state, next state and progress
                // -------------------------------------------------------------
                // contracts (in progress)
                for(let c = 0; c < newRowsFromDB.length; c++) {
                    
                    let processes = [];
                    let processesNames = [];
                    // templates
                    for(let t = 0; t < this.blockchainTemplates.length; t++) {
                        // find contract template
                        if (this.blockchainTemplates[t].TempData.contract.id == newRowsFromDB[c].TempData.TemplateID) {
                            // milestones 
                            for(let m = 0; m < this.blockchainTemplates[t].TempData.contract.milestones.length; m++) {
                                // subprocesses (L1)
                                for(let sl1 = 0; sl1 < this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses.length; sl1++) {
                                    processes.push(this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses[sl1].id);
                                    processesNames.push(this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses[sl1].name);
                                    // subprocesses (L2))
                                    for(let sl2 = 0; sl2 < this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses[sl1].subprocesses.length; sl2++) {
                                        processes.push(this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].id);
                                        processesNames.push(this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].name);
                                        // subprocesses (L3)
                                        for(let sl3 = 0; sl3 < this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].subprocesses.length; sl3++) {
                                            processes.push(this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].subprocesses[sl3].id);
                                            processesNames.push(this.blockchainTemplates[t].TempData.contract.milestones[m].subprocesses[sl1].subprocesses[sl2].subprocesses[sl3].name);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    
                    let currentCount = 0;
                    let nextState = "unknown";
                    let nextStateName = "unknown";

                    // calculate next state
                    for(let p = 0; p < processes.length; p++) {
                        if (processes[p] == newRowsFromDB[c].State) {
                            currentCount = (p +1);
                            nextState = processes[p +1];
                            nextStateName = processesNames[p +1];
                        }
                    }

                    if (newRowsFromDB[c].State == 0) {
                        newRowsFromDB[c].nextState = '1.1';
                        newRowsFromDB[c].nextStateName = processesNames[0];
                    } else {
                        newRowsFromDB[c].nextState = nextState;
                        newRowsFromDB[c].nextStateName = nextStateName;
                    }                 

                    // calc percentage complete
                    newRowsFromDB[c].stateProgress = ((100/processes.length) * currentCount).toFixed(0);
                }

                //update the bcCache with all of the new data within the 'newRowsFromDB' array (update matching, and add new rows)
                newRowsFromDB.forEach(newContract => {
                    let cacheItem = this.bcCache.find(searchContract => searchContract.ID == newContract.ID && searchContract.TimeStamp == newContract.TimeStamp);
                    if (cacheItem) {
                        this.bcCache.splice(this.bcCache.indexOf(cacheItem), 1, newContract)
                    } else {
                        this.bcCache.push(newContract)
                    }
                });

                console.log("Refresing complete, new rows: ", newRowsFromDB)
                let latestRefreshedContract = newRowsFromDB[newRowsFromDB.length - 1];

                console.log("Latest refreshed contract: ", latestRefreshedContract)
                let inProgressItem = this.blockchainInProgress.find(searchContract => searchContract.ID == contract.ID);
                console.log("inProgressItem: ", inProgressItem)
                this.blockchainInProgress.splice(this.blockchainInProgress.indexOf(inProgressItem), 1, latestRefreshedContract);

                return JSON.parse(JSON.stringify(latestRefreshedContract));
            },
            async aquacultureFertSearchForMilt(){
                if (this.huonFertilisation_2_1.milt_search == undefined || this.huonFertilisation_2_1.milt_search == '') return;

                console.log("here: ", this.bcCache.length)
                console.log("setting icon stuff...")
                this.searchingForMilt = true;
                
                this.miltPackage_checking_status_icon_class = "fa-solid fa-ellipsis fa-fade info-icon";
            
                let searchID;

                if (this.huonFertilisation_2_1.milt_search.includes("ID")) searchID = "Package " + this.huonFertilisation_2_1.milt_search;
                else searchID = "Package ID-" + this.huonFertilisation_2_1.milt_search;

                console.log("Searching for the package...")
                let foundContract = this.blockchainInProgress.find((contract) => 
                    contract.TempData.TemplateID == this.aquaculturePackageTemplateID &&
                    contract.ID.substring(contract.ID.indexOf('Package ID-'), contract.ID.length) == searchID /*&&
                    contract.State == "6.1" */
                )
                console.log("Search complete, foundContract: ", foundContract)
                if (foundContract){
                    console.log("Checking state...")
                    if (foundContract.State == "4.1") foundContract = await this.prepareAquaculturePackageForFertilisation(foundContract);
                    /* TODO: This process is really slow, it'll need to be optimised */
                    // console.log("Package found... Finding parent batch...")
                    // let parentBatchContract = this.bcCache.find(cacheContract => cacheContract.TemplateID == this.cryopreservationBatchTemplateID && cacheContract.State == "1.1" && cacheContract.TempData.ProcessData.cryopreservedPackages.length > 0 && cacheContract.TempData.ProcessData.cryopreservedPackages.find(cryoPackage => cryoPackage.ID == foundContract.ID))
                    
                    // console.log("Batch found... Finding parent sample...")
                    // let parentSampleContract = this.bcCache.find(cacheContract => cacheContract.ID == this.bcCache.find(findBatchContract => findBatch0Contract.ID == parentBatchContract.ID && findBatch0Contract.State == "0").ParentID && cacheContract.State == "1.1");

                    // console.log("Setting YC....")
                    // foundContract.year_class = parentSampleContract.TempData.ProcessData.year_class;
                    // console.log("Package found and added to list... Checking YC...")
                    this.huonFertilisationSelectedIncubator.milt.push(foundContract);
                    
                    // this.huonFertilisationSelectedIncubator.milt_yc = [];
                    // this.huonFertilisationSelectedIncubator.milt.forEach(miltContract => {
                    //     if (!this.huonFertilisationSelectedIncubator.milt_yc.includes(miltContract.year_class)) this.huonFertilisationSelectedIncubator.milt_yc.push(miltContract.year_class.slice(-2));
                    // })
                    
                    console.log("Saving package...")
                    await this.saveAquacultureFertilisation();
                    console.log("Setting icon")
                    this.miltPackage_checking_status_icon_class = "fa-solid fa-circle-check success-icon";
                }
                else this.miltPackage_checking_status_icon_class = "fa-solid fa-circle-xmark warn-icon";

                this.huonFertilisation_2_1.milt_search = '';
                this.searchingForMilt = false;
                document.getElementById('fertilisation-milt-search').focus();
            },
            async aquacultureDetachMiltFromIncubator(item) {
                this.huonFertilisationSelectedIncubator.milt.splice(this.huonFertilisationSelectedIncubator.milt.indexOf(this.huonFertilisationSelectedIncubator.milt.find(milt => milt.ID == item.ID)), 1)
                this.huonFertilisationSelectedIncubator.milt_yc = [];
                this.huonFertilisationSelectedIncubator.milt.forEach(miltContract => {
                    if (!this.huonFertilisationSelectedIncubator.milt_yc.includes(miltContract.year_class)) this.huonFertilisationSelectedIncubator.milt_yc.push(miltContract.year_class.slice(-2));
                })

                await this.saveAquacultureFertilisation();
            },
            getPackageProcessedDate(date){ 
                // console.log("HERE... date: ", date, " Type: ", typeof date)  
                // console.log("Formatted date: ", new Date(date).format("YYYY-MM-DD"))
                // if (!date || date == "" || date == undefined) return "";
                let formattedDate = "";

                try {
                    formattedDate = moment(new Date(date.timestamp)).format("YYYY-MM-DD");
                }
                catch (error){console.log("Invalid date...")}

                return formattedDate;
            },
            getAquacultureYearClassOptions(){
                const currentYear = new Date().getFullYear();
                const startYear = currentYear - 4;

                return Array.from({ length: 5 }, (_, i) => (startYear + i).toString().slice(-2));
            },
            async aquacultureFertSearchForEggs(){
                this.searchingForEggs = true;
                this.egg_checking_status_icon_class = "fa-solid fa-ellipsis fa-fade info-icon info-icon";
                if (this.huonFertilisation_2_1.egg_search == '' || this.huonFertilisation_2_1.egg_count_search <= 0) return; // TODO: add validation
                
                let eggsCount = parseFloat(this.huonFertilisation_2_1.egg_count_search);
                let foundContract = this.blockchainInProgress.find(contract => 
                    (contract.TemplateID == undefined ? contract.TempData.TemplateID : contract.TemplateID) == this.aquacultureEggBatchTemplateID &&
                    contract.ID.split(":")[2] == this.huonFertilisation_2_1.egg_search
                )

                if(foundContract){
                    foundContract = JSON.parse(JSON.stringify(foundContract));
                    foundContract.volume = eggsCount;
                    foundContract.ordinanceID = this.uuidv4();
                    this.huonFertilisationSelectedIncubator.eggs.push(foundContract);
                    this.huonFertilisationSelectedIncubator.egg_count = parseFloat(parseFloat(this.huonFertilisationSelectedIncubator.egg_count) + parseFloat(foundContract.volume));
                    
                    if (!this.huonFertilisationSelectedIncubator.eggs_yc || this.huonFertilisationSelectedIncubator.eggs_yc == "" || this.huonFertilisationSelectedIncubator.eggs_yc == undefined) {
                        let eggContract_0 = this.bcCache.find(cacheContract => cacheContract.ID == foundContract.ID && cacheContract.State == "1.1")
                        let masterContract = this.bcCache.find(masterFemaleContract => masterFemaleContract.TemplateID == this.aquacultureMasterFemaleTemplateID && masterFemaleContract.State == "1.1" && masterFemaleContract.TempData.ProcessData.tag_id == eggContract_0.TempData.ProcessData.master_tag_id)
                        this.huonFertilisationSelectedIncubator.eggs_yc = masterContract.TempData.ProcessData.year_class
                    }

                    await this.saveAquacultureFertilisation();
                    this.egg_checking_status_icon_class = "fa-solid fa-circle-check success-icon";
                }
                else this.egg_checking_status_icon_class = "fa-solid fa-circle-xmark warn-icon";

                this.huonFertilisation_2_1.egg_search = '';
                this.huonFertilisation_2_1.egg_count_search = '';
                this.searchingForEggs = false;
                document.getElementById('fertilisation-egg-search').focus();
            },
            async aquacultureDetachEggsFromIncubator(item) {
                // console.log("Item: ", item)
                let oldEggCount = parseFloat(this.huonFertilisationSelectedIncubator.egg_count);
                let incomingEggCount = parseFloat(item.volume);
                let newEggCount = parseFloat(oldEggCount - incomingEggCount);
                // console.log("Old Egg Count: ", oldEggCount, "Incoming Egg Count: ", incomingEggCount, "New Egg Count: ", newEggCount)

                // console.log("Index of: ", this.huonFertilisationSelectedIncubator.eggs.indexOf(this.huonFertilisationSelectedIncubator.eggs.find(egg => egg.ID == item.ID && egg.ordinanceID == item.ordinanceID)))
                this.huonFertilisationSelectedIncubator.eggs.splice(this.huonFertilisationSelectedIncubator.eggs.indexOf(this.huonFertilisationSelectedIncubator.eggs.find(egg => egg.ordinanceID == item.ordinanceID)), 1);
                this.huonFertilisationSelectedIncubator.egg_count = newEggCount;

                if (this.huonFertilisationSelectedIncubator.eggs.length == 0) {
                    this.huonFertilisationSelectedIncubator.eggs_yc = '';
                    this.huonFertilisationSelectedIncubator.egg_count = 0;
                }
                await this.saveAquacultureFertilisation();
            },
            async saveAquacultureFertilisation(){
                try {
                    /*const response =*/ await this.$http.put(
                        process.env.VUE_APP_AQUACULTURE_CRUD_API_URI,
                        {
                            "TableName": "aquaculture-fertilisation-incubators",
                            "Item": this.huonFertilisation_2_1
                        },
                        { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                    );
                    //console.log("Response: ", response)
                } catch (error) {
                    console.log(error);
                }
            },
            async getAquacultureFertilisation(id){
                try {
                    const response = await this.$http.post(
                        process.env.VUE_APP_AQUACULTURE_CRUD_API_URI + "/" + id,
                        { "TableName": "aquaculture-fertilisation-incubators", },
                        { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                    );
                    if (response.data != undefined) {
                        // console.log("Data from DB: ", response)
                        this.huonFertilisation_2_1 = response.data;
                        // console.log("this.huonFertilisation_2_1: ", JSON.stringify(this.huonFertilisation_2_1))
                        for (let i = 0; i < this.huonFertilisation_2_1.incubators.length; i++) {
                            let incubatorEgg = this.huonFertilisation_2_1.incubators[i].eggs;
                            console.log("incubatorEgg: ", incubatorEgg)
                            // for (let j = 0; j < incubatorEgg.length; j++) {
                            //     console.log("Egg Before: ", incubatorEgg[j])
                            //     incubatorEgg[j] = incubatorEgg[j].ID;
                            //     console.log("Egg After: ", incubatorEgg[j])
                            // }
                            // if (incubatorEgg.incubators != undefined) {
                            //     console.log("Hass incubators...")
                            //     for (let j = 0; j < incubatorEgg.incubators.length; j++) {
                            //         // let incubator = incubatorEgg.incubators[i].ID;
                            //         // incubator.selected = false;
                            //         console.log("Incubator: ", incubatorEgg.incubators[j])
                            //     }
                            // }
                            // let incubatorMilt = this.huonFertilisation_2_1.incubators[i].milt;
                            // for (let j = 0; j < incubatorMilt.length; j++) {
                            //     console.log("Milt Before: ", incubatorMilt[j])
                            //     incubatorMilt[j] = incubatorMilt[j].ID;
                            //     console.log("Milt After: ", incubatorMilt[j])
                            // }
                        }
                        // await this.saveAquacultureFertilisation();
                        this.huonFertilisationSelectedIncubator = this.huonFertilisation_2_1.incubators.find(incubator => incubator.selected);
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            getFertilisationTotalMales(incubators) {
                let totalMaleCount = 0;
                let distinctMales = [];
                incubators.forEach(incubator => {
                    for (let i = 0; i < incubator.milt.length; i++) {
                        let maleMasterID = this.bcCache.find(cacheContract => cacheContract.ID == incubator.milt[i].ID && cacheContract.State == "1.1");
                        if (maleMasterID && !distinctMales.includes(maleMasterID.ParentID)) distinctMales.push(maleMasterID.ParentID);
                    }
                });
                totalMaleCount = distinctMales.length;
                return totalMaleCount;
            },
            getFertilisationTotalFemales(incubators) {
                let totalFemaleCount = 0;
                let distinctFemales = [];
                incubators.forEach(incubator => {
                    for (let i = 0; i < incubator.eggs.length; i++) {
                        let femaleMasterID = this.bcCache.find(cacheContract => cacheContract.ID == incubator.eggs[i].ID && cacheContract.State == "1.1");
                        if (femaleMasterID && !distinctFemales.includes(femaleMasterID.ParentID)) distinctFemales.push(femaleMasterID.ParentID);
                        // if (!distinctFemales.includes(incubator.eggs[i].ID)) distinctFemales.push(incubator.eggs[i].ID);
                    }
                });
                totalFemaleCount = distinctFemales.length;
                return totalFemaleCount;
            },
            getFertilisationTotalEggCount(incubators) {
                let totalEggCount = 0;

                incubators.forEach(incubator => {
                    if (parseFloat(incubator.egg_count)) totalEggCount += parseFloat(incubator.egg_count);
                });
                return totalEggCount;
            },
            getFertilisationTotalMiltVolume(incubators) {
                let totalMiltCount = 0;
                
                incubators.forEach(incubator => {
                    if (parseFloat(incubator.milt_volume)) totalMiltCount += parseFloat(incubator.milt_volume);
                });
                return totalMiltCount;
            },
            getFertilisationFemaleYearClasses(incubators) {
                let distinctYearClasses = [];
                incubators.forEach(incubator => {
                    if (incubator.eggs_yc != undefined && !distinctYearClasses.includes(incubator.eggs_yc.slice(-2))) distinctYearClasses.push(incubator.eggs_yc.slice(-2));
                });

                return distinctYearClasses.toString();
            },
            getFertilisationMaleYearClasses(incubators) {
                let distinctYearClasses = [];
                incubators.forEach(incubator => {
                    try {
                        if (incubator.milt_yc && incubator.milt_yc.length > 0 && typeof incubator.milt_yc != 'string') incubator.milt_yc.forEach(miltYearClass => {
                            if (!distinctYearClasses.includes(miltYearClass)) distinctYearClasses.push(miltYearClass);
                        });
                    }
                    catch (error) {
                        console.log("Error: ", error)
                    }
                });

                return distinctYearClasses.toString();
            },
            openIncubator(incubator){
                // console.log("Opening incubator...", incubator)
                this.huonFertilisationSelectedIncubator = null;
                // this.huonFertilisation_2_1.incubators.forEach(incubator => {incubator.selected = false}); // Deselect all other incubators...
                incubator.selected = true;
                this.huonFertilisationSelectedIncubator = JSON.parse(JSON.stringify(incubator));
                // console.log("Incubator opened...", this.huonFertilisationSelectedIncubator);
                this.$refs['add-new-incubator-modal'].show();
            },
            async newIncubatorModalClosed() {
                console.log("Incubator Modal closed...")
                this.huonFertilisation_2_1.milt_search = '';
                this.huonFertilisation_2_1.egg_search = '';
                this.huonFertilisation_2_1.egg_count_search = '';
                for (let i = 0; i < this.huonFertilisation_2_1.incubators.length; i++) {
                    this.huonFertilisation_2_1.incubators[i].selected = false;
                }
                // save the progress, if needed
                if (!this.huonFertilisationSelectedIncubator.finalised || !this.huonFertilisationSelectedIncubator.results_finalised){
                    this.saveAquacultureFertilisation();
                    
                    // this.huonFertilisation_2_1 = null;
                    // this.getAquacultureFertilisation(this.selectedBlock.ID);
                }
                
                this.huonFertilisationSelectedIncubator = null;
                if (this.$refs['add-new-incubator-modal']) this.$refs['add-new-incubator-modal'].hide();
            },
            async aquacultureFertCreateNewIncubator(){
                console.log("Creating new incubator...")
                this.aquacultureFertAddingIncubator = true;
                if (this.huonFertilisation_2_1.id == undefined) {
                    console.log("Creating new fertilisation...")
                    this.huonFertilisation_2_1 = { milt: [], egg_batch: [], milt_search: '', egg_search: '', incubators: [] };
                    this.huonFertilisation_2_1.id = this.selectedBlock.ID;
                    this.huonFertilisation_2_1.Organisation = 'Huon';
                }
                
                console.log("Checking incubators...")
                if (this.huonFertilisation_2_1.incubators == undefined || !this.huonFertilisation_2_1.incubators || this.huonFertilisation_2_1.incubators.length < 1) 
                {
                    console.log("Creating new incubators...")
                    for (let i = 1; i <= 30; i++) {
                        this.huonFertilisation_2_1.incubators.push(
                            {
                                ID: this.uuidv4(),
                                incubator_number: i,
                                finalised: false,
                                results_finalised: false,
                                selected: false,
                                freshMilt: true,
                                milt: [],
                                eggs: [],
                                milt_yc: [],
                                egg_yc: null,
                                egg_count: 0,
                                incubator_fert_batch_location: '',
                                incubator_fert_batch_number: '',
                                milt_volume: '',
                                activator: '',
                                _24Hour_result_comment: '',
                                early_result_comment: '',
                                eyed_eggs_result_comment: '',
                            }
                        );
                    }
                }

                if (this.huonFertilisation_2_1.incubators.find(incubator => incubator.selected)) {
                    this.huonFertilisationSelectedIncubator = this.huonFertilisation_2_1.incubators.find(incubator => incubator.selected);
                    this.$refs['add-new-incubator-modal'].show();
                    return;
                }
                else
                {
                    this.huonFertilisation_2_1.incubators.forEach(incubator => {incubator.selected = false}); // Deselect all other incubators...
                    this.huonFertilisationSelectedIncubator = null;
                }
                
                await this.saveAquacultureFertilisation();
            },
            async finaliseFertilisationSeason(){
                this.huonFertilisation_2_1.incubators.filter(incubator => incubator.finalised).forEach(incubator => {
                    incubator.finalised = true;
                    incubator.results_finalised = true;
                });

                await this.saveAquacultureFertilisation();
            },
            async aquacultureFinaliseIncubator() {
                console.log("Finalising Incubator... Incubator: ", this.huonFertilisationSelectedIncubator)

                this.finalisingAquacultureIncubator = true;
                if (this.huonFertilisationSelectedIncubator.finalised) {
                    console.log("Finaliseing results...")
                    this.huonFertilisationSelectedIncubator.results_finalised = true;
                }
                else
                {
                    this.huonFertilisationSelectedIncubator.finalised = true;

                    console.log("Saving incubator setting to Egg and Milt...")
                    await this.saveFertilisationToEggsAndMiltContracts();
                    console.log("Saved incubator setting to Egg and Milt...")
                }

                this.huonFertilisation_2_1.incubators.forEach(incubator => {incubator.selected = false}); // Deselect all incubators...

                console.log("Saving incubator setting... 2_1: ", this.huonFertilisation_2_1)
                await this.saveAquacultureFertilisation();
                console.log("Saved incubator setting...")

                console.log("Refreshing blockchain from finalise incubator...")
                await this.getBlockchain(this.type, true);
                console.log("Refreshed blockchain from finalise incubator...")
                
                this.aquacultureFertAddingIncubator = false;
                this.huonFertilisationSelectedIncubator = null;
                this.huonFertilisation_2_1.fertilisation_day = null;
                this.huonFertilisation_2_1.milt_search = null;
                this.huonFertilisation_2_1.egg_search = null;
                this.huonFertilisation_2_1.egg_count_search = null;
                this.finalisingAquacultureIncubator = false;

                // if (this.$refs['add-new-incubator-modal']) this.$refs['add-new-incubator-modal'].hide();
            },
            aquacultureFertilisationIncubatorClicked(incubator){
                // if (incubator.selected) this.aquacultureFertCreateNewIncubator();
                // else {
                this.huonFertilisation_2_1.incubators.forEach(incubator => {incubator.selected = false}); // Deselect all other incubators...
                incubator.selected = true;
                this.huonFertilisationSelectedIncubator = incubator;
                this.aquacultureFertAddingIncubator = true;
                this.$refs['add-new-incubator-modal'].show();
            },
            aquacultureFinaliseIncubatorButttonDisabled()
            {
                if (this.finalisingAquacultureIncubator ) return true; // Buttong should be disabled if we're currently in teh process of finalising the incubator
                if (!this.huonFertilisationSelectedIncubator) return true; // Button should be disabled if no incubator is selected
                
                if (
                        this.huonFertilisationSelectedIncubator.finalised != undefined &&
                        this.huonFertilisationSelectedIncubator.finalised &&
                        this.huonFertilisationSelectedIncubator.results_finalised != undefined &&
                        this.huonFertilisationSelectedIncubator.results_finalised
                ) return true; // Button should be disabled if the incubator has already been finalised

                if (this.huonFertilisationSelectedIncubator.freshMilt)
                    if (
                        this.huonFertilisationSelectedIncubator.milt.milt_processed_date == undefined ||
                        this.huonFertilisationSelectedIncubator.milt.milt_processed_date == "" ||
                        this.huonFertilisationSelectedIncubator.milt.master_fish_id == undefined ||
                        this.huonFertilisationSelectedIncubator.milt.master_fish_id == ""
                    ) return false; // Button should be enabled if the incubator is fresh and the milt details is entered
                    else return true; // Button should be disabled if the incubator is fresh and the milt details is not entered
                else if
                (
                    this.huonFertilisationSelectedIncubator.eggs.length <= 0 || 
                    this.huonFertilisationSelectedIncubator.milt.length <= 0 ||
                    this.huonFertilisationSelectedIncubator.egg_count <= 0 ||
                    this.huonFertilisationSelectedIncubator.milt_volume <= 0 ||
                    this.huonFertilisationSelectedIncubator.incubator_fert_batch_location == '' ||
                    this.huonFertilisationSelectedIncubator.incubator_fert_batch_number == '' ||
                    this.huonFertilisationSelectedIncubator.activator == '' ||
                    (
                        this.huonFertilisationSelectedIncubator.finalised != undefined &&
                        this.huonFertilisationSelectedIncubator.finalised &&
                        this.huonFertilisationSelectedIncubator.results_finalised
                    )
                ) return true; // Button should be disabled if the incubator is not fresh and the details are not entered
                else return false; // Button should be enabled if the incubator is not fresh and the details are entered
            },
            async saveFertilisationToEggsAndMiltContracts(){
                // console.log("Saving: ", this.huonFertilisation_2_1, " this.huonFertilisationSelectedIncubator: ", this.huonFertilisationSelectedIncubator)
                let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + "";
                let headers = { 'Content-Type': 'application/json;charset=utf-8', 'authorization': localStorage.idtoken };

                // Attach the incubator details to the Fish Eggs
                for (let incubatorEgg of this.huonFertilisationSelectedIncubator.eggs){
                    // console.log("incubatorEgg: ", incubatorEgg)
                    if (incubatorEgg.TemplateID == undefined) incubatorEgg.TemplateID = incubatorEgg.TempData.TemplateID;
                    
                    let newTimeStamp = (new Date().getTime()).toString();
                    let data = {
                        "TableName": this.aquacultureBlockChainTableName,
                        "Item": {
                            "ID": incubatorEgg.ID,
                            "TimeStamp": newTimeStamp,
                            "State": "3.1",
                            "Owner": "Vitrafy (version 4)",
                            "User": this.current_user,
                            "TemplateID": incubatorEgg.TemplateID,
                            "TempData": {
                                "TemplateID": incubatorEgg.TemplateID,
                                "Application": incubatorEgg.TempData.Application,
                                "ProcessData": {"fertilisation_run_id": this.huonFertilisation_2_1.id, "incubators": this.huonFertilisation_2_1.incubators.filter(incubator => incubator.ID == incubatorEgg.ordinanceID).map(incubator => incubator.ID) }
                            }
                        }
                    };
                    data = JSON.stringify(data);

                    console.log("Data: ", data)
                    await this.$http.post( url, data, {headers: headers} );

                    let newRowsFromDB = await this.retrieveBlockchainFromAPI(incubatorEgg.ID);
                    // console.log("Updating blockchain...")
                    //update the bcCache with all of the new data within the 'newRowsFromDB' array (update matching, and add new rows)
                    newRowsFromDB.forEach(newContract => {
                        let cacheItem = this.bcCache.find(searchContract => searchContract.ID == newContract.ID && searchContract.TimeStamp == newContract.TimeStamp);
                        if (cacheItem) {
                            this.bcCache.splice(this.bcCache.indexOf(cacheItem), 1, newContract)
                        } else {
                            this.bcCache.push(newContract)
                        }
                    });
                }

                console.log("Saved eggs, now saving Milt...")
                // Attach the incubator details to the Fish Milt/Packages
                // await this.huonFertilisationSelectedIncubator.milt.forEach(incubatorMilt =>{
                for (let incubatorMilt of this.huonFertilisationSelectedIncubator.milt){
                    // console.log("incubatorMilt: ", incubatorMilt)
                    if (incubatorMilt.TemplateID == undefined) incubatorMilt.TemplateID = incubatorMilt.TempData.TemplateID

                    let newTimeStamp = (new Date().getTime()).toString();
                    let data = {
                        "TableName": this.aquacultureBlockChainTableName,
                        "Item": {
                            "ID": incubatorMilt.ID,
                            "TimeStamp": newTimeStamp,
                            "State": "7.1",
                            "Owner": "Vitrafy (version 4)",
                            "User": this.current_user,
                            "TemplateID": incubatorMilt.TemplateID,
                            "TempData": {
                                "TemplateID": incubatorMilt.TemplateID,
                                "Application": incubatorMilt.TempData.Application,
                                "ProcessData": {"fertilisation_run_id": this.huonFertilisation_2_1.id, "incubators": this.huonFertilisation_2_1.incubators.find(incubator => incubator.ID == incubatorMilt.ordinanceID).map(incubator => incubator.ID) }
                            }
                        }
                    };
                    data = JSON.stringify(data);
                    
                    await this.$http.post( url, data, {headers: headers} );

                    // Do this synchronously, as we'll need the data to add to our original cache
                    let newRowsFromDB = await this.retrieveBlockchainFromAPI(incubatorMilt.ID);
                    
                    // console.log("Updating blockchain...")
                    //update the bcCache with all of the new data within the 'newRowsFromDB' array (update matching, and add new rows)
                    newRowsFromDB.forEach(newContract => {
                        // console.log("newContract): ", newContract)
                        let cacheItem = this.bcCache.find(searchContract => searchContract.ID == newContract.ID && searchContract.TimeStamp == newContract.TimeStamp);
                        if (cacheItem) {
                            this.bcCache.splice(this.bcCache.indexOf(cacheItem), 1, newContract)
                        } else {
                            this.bcCache.push(newContract)
                        }
                    });
                }
            },
            // Creates new Smart Contracts x number of times based on how many packages a sample should be split into (frpom the master)
            async createSplitPackagesSSI(){
                const ssiPackageContractTemplateID = '7a976520-bae3-478e-a397-784354f79975'
                const ssiContractApplication = 'ART'
                const newTimeStamp = (new Date().getTime()).toString()
                const newID = this.uuidv4();
                
                let allPackets = [];
                for (let _25Loop = 0; _25Loop < this.ssi_sample_3_4._025_packagingQuantity; _25Loop ++) allPackets.push(this.ssi_packaging_types[0])
                for (let _5Loop = 0; _5Loop < this.ssi_sample_3_4._05_packagingQuantity; _5Loop ++) allPackets.push(this.ssi_packaging_types[1])
                for (let smartPackagingLoop = 0; smartPackagingLoop < this.ssi_sample_3_4.smart_packagingQuantity; smartPackagingLoop ++) allPackets.push(this.ssi_packaging_types[2])
                
                for (let i = 1; i <= allPackets.length; i++){
                    let newBlockID = newID + ":" + newTimeStamp +":" + this.selectedBlock.name + ":Package ID-" + i;          
                    
                    try {
                        let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + "";
                        let headers = {
                            'Content-Type': 'application/json;charset=utf-8',
                            'authorization': localStorage.idtoken
                        };
                        let data = {
                            "TableName": this.aquacultureBlockChainTableName,
                            "Item": {
                                "ID": newBlockID,
                                "TimeStamp": newTimeStamp,
                                "State": "0",
                                "Owner": "Vitrafy (version 4)",
                                "User": this.current_user,
                                "TemplateID": ssiPackageContractTemplateID,
                                "TempData": {
                                    "TemplateID": ssiPackageContractTemplateID,
                                    "Application": ssiContractApplication,
                                }
                            }
                        };
                        data = JSON.stringify(data);

                        /*const newBlockHeaderInsertResponse = */await this.$http.post(
                            url,
                            data,
                            {headers: headers}
                        );

                        data = {
                            "TableName": this.aquacultureBlockChainTableName,
                            "Item": {
                                "ID": newBlockID,
                                "TimeStamp": (new Date().getTime()).toString(),
                                "State": '1.1',
                                "Owner": this.selectedBlock.Owner,
                                "User": this.selectedBlock.User,
                                "TemplateID": ssiPackageContractTemplateID,
                                "TempData": {
                                    "TemplateID": ssiPackageContractTemplateID,
                                    "Application": ssiContractApplication,
                                    "ProcessData": {masterID: this.selectedBlock.ID, packageID: this.selectedBlock.name + ":Package ID-" + i, packageType: allPackets[i -1]}
                                }
                            }
                        };
                        data = JSON.stringify(data);

                        /*const idGenerationBlockResponse = */await this.$http.post(
                            url,
                            data,
                            {headers: headers}
                        );

                        data = {
                            "TableName": this.aquacultureBlockChainTableName,
                            "Item": {
                                "ID": newBlockID,
                                "TimeStamp": (new Date().getTime()).toString(),
                                "State": '2.1',
                                "Owner": this.selectedBlock.Owner,
                                "User": this.selectedBlock.User,
                                "TemplateID": ssiPackageContractTemplateID,
                                "TempData": {
                                    "TemplateID": ssiPackageContractTemplateID,
                                    "Application": ssiContractApplication,
                                    "ProcessData": {algorithm: 'Vitrafy Bovine', moc: { temp: -30, flow: 30, time: 60 }},
                                }
                            }
                        };
                        data = JSON.stringify(data);

                        /*const setMOCResponse = */await this.$http.post(
                            url,
                            data,
                            {headers: headers}
                        );

                    } catch (error) {
                        console.log(error);
                    }
                    

                    /* Temp hack to retrieve only updated data for refresh */
                    let newRowsFromDB;
                    newRowsFromDB = await this.retrieveBlockchainFromAPI(newBlockID)
                    //update the bcCache with all of the new data within the 'newRowsFromDB' array (update matching, and add new rows)
                    newRowsFromDB.forEach(newContract => {
                        let cacheItem = this.bcCache.find(searchContract => searchContract.ID == newContract.ID && searchContract.TimeStamp == newContract.TimeStamp);
                        if (cacheItem) {
                            this.bcCache.splice(this.bcCache.indexOf(cacheItem), 1, newContract)
                        } else {
                            this.bcCache.push(newContract)
                        }
                    });
                }

                this.contractName = '';
                this.contractApplication = '';
                this.contractTemplate = '';

                // Now refresh the Blockchain
                await this.getBlockchain(this.type, true);
            },
            async getCryoPreservationSSIPacket(deviceID, batchID){
                let batchDetails = null;
                console.log("Getting batch details for package. Device ID: ", deviceID, " BatchID: ", batchID)

                let url = process.env.VUE_APP_MULE_PROXY_API_URI;

                let data = {
                    "endpoint": "/api/devices/" + deviceID + "/data/batches/" + batchID
                };

                data = JSON.stringify(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };          

                try {
                    console.log("Attempting API call: ", data)
                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    batchDetails = response.data[0];
                    // Clean-up field names
                    batchDetails.tempSetpoint   = batchDetails['Temp. Setpoint'];
                    batchDetails.tempTolerance  = batchDetails['Temp. Tolerance'];
                    batchDetails.startTemp      = batchDetails['Start Temp.'];
                    batchDetails.endTemp        = batchDetails['End Temp.'];
                    batchDetails.minTemp        = batchDetails['Min Temp.'];
                    batchDetails.maxTemp        = batchDetails['Max Temp.'];
                    batchDetails.flowSetpoint   = batchDetails['Flow Setpoint'];
                    batchDetails.flowTolerance  = batchDetails['Flow Tolerance'];
                    batchDetails.startFlow      = batchDetails['Start Flow'];
                    batchDetails.endFlow        = batchDetails['End Flow'];
                    batchDetails.minFlow        = batchDetails['Min Flow'];
                    batchDetails.maxFlow        = batchDetails['Max Flow'];
                } catch (error) {
                    console.log(error);
                }  

                console.log("Batch deails: ", batchDetails)
                return batchDetails;
            },
            async completeCryoPreservedSelectedStackedPackets(){
                // for each of the stackeds, set the 'MoC' from the Batches table from the machine
                for (const stacked in this.selectedBlock.stackedItems) {
                    if (this.selectedBlock.stackedItems[stacked].selected) await this.completeCryoPreservationSSIPacket(this.selectedBlock.stackedItems[stacked])
                }

                await this.getBlockchain(this.type, true);
                this.$refs['bovine-cryo-stacked-packets-modal'].hide();
            },
            async completeCryoPreservationSSIPacket(stacked) {
                const ssiPackageContractTemplateID = '7a976520-bae3-478e-a397-784354f79975'
                const ssiContractApplication = 'ART'
                this.ssi_package_2_2.moc = await this.getCryoPreservationSSIPacket(this.ssi_package_2_2.cryopreservation_device, this.ssi_package_2_2.batch_id);
                try {
                    let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + "";
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    let data = {
                        "TableName": this.aquacultureBlockChainTableName,
                        "Item": {
                            "ID": stacked.ID,
                            "TimeStamp": (new Date().getTime()).toString(),
                            "State": "2.2",
                            "Owner": "Vitrafy (version 4)",
                            "User": this.current_user,
                            "TemplateID": ssiPackageContractTemplateID,
                            "TempData": {
                                "TemplateID": ssiPackageContractTemplateID,
                                "Application": ssiContractApplication,
                                "ProcessData": this.ssi_package_2_2
                            }
                        }
                    };
                    data = JSON.stringify(data);

                    /*const newBlockHeaderInsertResponse = */await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                } catch (error) {
                    console.log(error);
                }

                                
                /* Temp hack to retrieve only updated data for refresh */
                let newRowsFromDB;
                newRowsFromDB = await this.retrieveBlockchainFromAPI(stacked.ID)
                //update the bcCache with all of the new data within the 'newRowsFromDB' array (update matching, and add new rows)
                newRowsFromDB.forEach(newContract => {
                    let cacheItem = this.bcCache.find(searchContract => searchContract.ID == newContract.ID && searchContract.TimeStamp == newContract.TimeStamp);
                    if (cacheItem) {
                        this.bcCache.splice(this.bcCache.indexOf(cacheItem), 1, newContract)
                    } else {
                        this.bcCache.push(newContract)
                    }
                });

                // Now refresh the Blockchain also
                await this.getBlockchain(this.type, true);
            },
            async setSSI_AllStackedPackets_MOC(){
                const block = this.selectedBlock;
                const ssiPackageContractTemplateID = '7a976520-bae3-478e-a397-784354f79975'
                const ssiContractApplication = 'ART'

                // Get all the stackeds for this master.
                const stackeds = [];

                /* Search the active Blockchains and match them to this master */
                for (const item of this.filterBlockchainInProgressByTemplate("7a976520-bae3-478e-a397-784354f79975")) {
                    if (item.State == "1.1" && item.TempData.ProcessData.bullID == block.ID) stackeds.push(item);
                }
                // for each of the stackeds, set the 'MoC' from the master
                for (const stacked of stackeds) {
                    try {
                        // console.log("stacked: ", stacked)
                        let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + "";
                        let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                        };
                        let data = {
                            "TableName": this.aquacultureBlockChainTableName,
                            "Item": {
                                "ID": stacked.ID,
                                "TimeStamp": (new Date().getTime()).toString(),
                                "State": "2.1",
                                "Owner": "Vitrafy (version 4)",
                                "User": this.current_user,
                                "TemplateID": ssiPackageContractTemplateID,
                                "TempData": {
                                    "TemplateID": ssiPackageContractTemplateID,
                                    "Application": ssiContractApplication,
                                    "ProcessData": this.ssi_sample_4_1
                                }
                            }
                        };
                        data = JSON.stringify(data);

                        /*const newBlockHeaderInsertResponse = */await this.$http.post(
                            url,
                            data,
                            {headers: headers}
                        );

                        /* Temp hack to retrieve only updated data for refresh */
                        let newRowsFromDB;
                        newRowsFromDB = await this.retrieveBlockchainFromAPI(stacked.ID)
                        //update the bcCache with all of the new data within the 'newRowsFromDB' array (update matching, and add new rows)
                        newRowsFromDB.forEach(newContract => {
                            let cacheItem = this.bcCache.find(searchContract => searchContract.ID == newContract.ID && searchContract.TimeStamp == newContract.TimeStamp);
                            if (cacheItem) {
                                this.bcCache.splice(this.bcCache.indexOf(cacheItem), 1, newContract)
                            } else {
                                this.bcCache.push(newContract)
                            }
                        });

                    } catch (error) {
                        console.log(error);
                    } 
                }
                
                // Now refresh the Blockchain also 
                await this.getBlockchain(this.type, true);
            },
            showBovineCryoPacketsModal() {
                this.$refs['bovine-cryo-stacked-packets-modal'].show();
            },
            filterBlockchainInProgressByTemplate(templateID){
                return this.blockchainInProgress.filter(item => item.TempData.TemplateID === templateID);
            },
            subprocessCompleteFromWizard: async function() {
                let processData = null;

                try {
                    let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + "";
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    let data = {
                        "TableName": this.aquacultureBlockChainTableName,
                        "Item": {
                            "ID": this.selectedBlock.ID,
                            "TimeStamp": (new Date().getTime()).toString(),
                            "State": this.selectedSubprocess.id,
                            "Owner": this.selectedBlock.Owner,
                            "User": this.selectedBlock.User,
                            "TemplateID": (this.selectedBlock.TemplateID == undefined ? this.selectedBlock.TempData.TemplateID : this.selectedBlock.TemplateID),
                            "TempData": {
                                "TemplateID": this.selectedBlock.TempData.TemplateID,
                                "Application": this.selectedBlock.TempData.Application,
                                "ProcessData": processData
                            }
                        }
                    };
                    data = JSON.stringify(data);

                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    console.log(response.data);
                    
                
                    /* Temp hack to retrieve only updated data for refresh */
                    let newRowsFromDB;
                    newRowsFromDB = await this.retrieveBlockchainFromAPI(this.selectedBlock.ID)
                    //update the bcCache with all of the new data within the 'newRowsFromDB' array (update matching, and add new rows)
                    newRowsFromDB.forEach(newContract => {
                        let cacheItem = this.bcCache.find(searchContract => searchContract.ID == newContract.ID && searchContract.TimeStamp == newContract.TimeStamp);
                        if (cacheItem) {
                            this.bcCache.splice(this.bcCache.indexOf(cacheItem), 1, newContract)
                        } else {
                            this.bcCache.push(newContract)
                        }
                    });

                    // Now refresh the Blockchain also
                    await this.getBlockchain(this.type, true);

                    // mark subprocess as complete 
                    // this.template.TempData.contract.milestones[0].subprocesses[1].status = 'COMPLETED' -- fix this
                } catch (error) {
                    console.log(error);
                }
            },
            ssiCheckSelectValue(){
                if (event.target) this.completeSubprocess.buttonDisabled = false;
            },
            checkIdentificationPackageAquaculture() { 
                // console.log("Caught change in text. Event: ", event)
                if (event.target.value == this.selectedBlock.name.replace('Package ID-', '') || event.target.value == this.selectedBlock.name.replace('Package ', '')){
                    document.getElementById('P_5_1_identification_package_checked').checked = true;
                    this.P_5_1.identification_package_checked = 'accepted';
                    this.completeSubprocess.buttonDisabled = false;
                }
                else {
                    document.getElementById('P_5_1_identification_package_checked').checked = false;
                    this.P_5_1.identification_package_checked = 'not_accepted';
                    this.completeSubprocess.buttonDisabled = true;
                }
            },
            checkIdentificationPackageBovine() { 
                // console.log("Caught change in text. Event: ", event, " Value entered: ", event.target.value, " Name to match: ", this.selectedBlock.name.substring(this.selectedBlock.name.indexOf('Package ID-') + 11, this.selectedBlock.name.length))
                if (event.target.value == this.selectedBlock.name.substring(this.selectedBlock.name.indexOf('Package ID-') + 11, this.selectedBlock.name.length)){
                    // console.log("MAtched")
                    document.getElementById('ssi_package_4_1_identification_package_checked').checked = true;
                    this.ssi_package_4_1.identification_package_checked = 'accepted';
                    this.completeSubprocess.buttonDisabled = false;
                }
                else {
                    // console.log("Didnt match")
                    document.getElementById('ssi_package_4_1_identification_package_checked').checked = false;
                    this.ssi_package_4_1.identification_package_checked = 'not_accepted';
                    this.completeSubprocess.buttonDisabled = true;
                }
            },
            toggleDetails(row) {
                if (row.item.stackedItems != undefined && row.item.stackedItems.length > 0) row.toggleDetails();
            },
            setTimePickerAvailableDates(date){
                return date.getDay() !== 1; // Disable all dates except Mondays
            },
            validate_P_6_1() {
                const motility = document.getElementById('input-P_6_1.motility').value
                const concentration = document.getElementById('input-P_6_1.concentration').value
                const grade = document.getElementById('input-P_6_1.grade').value
                if (motility && concentration && grade){
                    this.completeSubprocess.buttonDisabled = false;
                }
                else {
                    this.completeSubprocess.buttonDisabled = true;
                }
            },
            P_4_1_valueChanged(event){
                if (event.target.value) this.completeSubprocess.buttonDisabled = false;
                if (this.P_4_1.dewar_id == '' && this.P_4_1.cannister_number == '') this.completeSubprocess.buttonDisabled = true;
            },
            huonFishSample_2_1_valueChanged(event){
                if (event.target.value) this.completeSubprocess.buttonDisabled = false;
                if (this.huonFishSample_2_1.motility == '' && this.huonFishSample_2_1.concentration == '' && this.huonFishSample_2_1.grade == '') this.completeSubprocess.buttonDisabled = true;
            },
            tableSortChanged(newCriteria) {
                // The newCriteria object has two properties: sortBy and sortDesc
                let { sortBy, sortDesc } = newCriteria;

                // The table field names are different to the underlying Array field names
                //             Table field name              Array field name
                if (sortBy == 'contractname')       sortBy   = 'name';
                if (sortBy == 'contractcreated')    sortBy   = 'TimeStampEpoch';
                if (sortBy == 'contractstate')      sortBy   = 'datetime';
                if (sortBy == 'contractdatetime')   sortBy   = 'TimeStampEpochUpdated';
                
                // Sort the items in the array based on the criteria
                this.blockchainInProgress.sort((a, b) => {
                    if (sortBy == 'TimeStamp') {
                        /* Timestamps need to be treated as actual 'Date' objects */
                        if (new Date(a[sortBy]) < new Date(b[sortBy])) return sortDesc ? 1 : -1;
                        if (new Date(a[sortBy]) > new Date(b[sortBy])) return sortDesc ? -1 : 1;
                    }
                    else {
                        if (a[sortBy] < b[sortBy]) return sortDesc ? 1 : -1;
                        if (a[sortBy] > b[sortBy]) return sortDesc ? -1 : 1;
                    }
                    return 0;
                });
            },
            async getAquacultureFertilisationForReport(id){
                // console.log("Getting fertilisation data for report... ID: ", id)
                try {
                    const response = await this.$http.post(
                        process.env.VUE_APP_AQUACULTURE_CRUD_API_URI + "/" + id,
                        { "TableName": "aquaculture-fertilisation-incubators", },
                        { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                    );
                    if (response.data != undefined) {
                        // console.log("Data from DB: ", response)
                        return response.data;
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            async downloadFullFishData() {
                this.exportingFullFishData = true;
                const now = new Date();

                let dataToExport = [];

                console.log("Exporting full fish data...")
                // console.log("this.bcCache: ", this.bcCache)

                // console.log("this.aquacultureFertilisationTemplateID: ", this.bcCache.filter(contract => contract.TemplateID == this.aquacultureFertilisationTemplateID))

                let fertilisationData = [];
                let fertContracts = [];
                
                this.bcCache.filter(contract => contract.TemplateID == this.aquacultureFertilisationTemplateID).forEach(contract => {
                    //if the contract ID doesn';t exist in the 'fertilisationData' list, add it
                    if (!fertilisationData.find(fertContract => fertContract.ID == contract.ID)) fertilisationData.push(contract);
                });

                // console.log("fertilisationData: ", fertilisationData)
                await Promise.all(fertilisationData.map(async (contract) => {
                    fertContracts.push(await this.getAquacultureFertilisationForReport(contract.ID));
                }));
                // console.log("fertContracts before: ", fertContracts)
                if (fertContracts.length === 1 && (fertContracts[0] === '' || fertContracts[0] === '""')) {
                    // console.log("Fert contracts broken... Fixing...");
                    fertContracts = [];
                }

                // console.log("fertContracts after: ", fertContracts)
                // console.log("Fish '652846' exists?: ", this.blockchainInProgress.filter(contract => contract.TemplateID == this.aquacultureMasterMaleTemplateID).filter(fishContract => fishContract.ID == '9ca817d7-4e0e-46e0-8e96-ab6341160288:1747804267903:652846'));
                this.blockchainInProgress.filter(contract => contract.TemplateID == this.aquacultureMasterMaleTemplateID).forEach((fishContract) => {
                    // console.log("fishContract: ", fishContract)
                    fishContract.stackedItems.forEach(async (sampleContract) => {
                        // console.log("sampleContract: ", sampleContract)
                        let sampleCompleteContract = await this.retrieveBlockchainFromAPI(sampleContract.ID);
                            sampleContract.stackedItems.forEach((batchContract) => {
                                // console.log("batchContract: ", batchContract)
                                batchContract.stackedItems.forEach((packageContract) =>{
                                    // console.log("packageContract: ", packageContract)
                                    let thawed = false;
                                    let fertilised = false;
                                    let fertID = '';
                                    let discarded = false;
                                    let storageContract = this.bcCache.find(contract => contract.ID == packageContract.ID && contract.State == "4.1");
                                    let thawedContract = this.bcCache.find(contract => contract.ID == packageContract.ID && contract.State == "6.1");
                                    if (thawedContract) {
                    
                                        // console.log("Contract was thawed, checking if fertilised. Contract ID: ", packageContract.ID)
                                        thawed = true;
                                        if (fertContracts.length > 0) {
                                            // console.log("Processing fertilisation contracts: ", fertContracts)
                                            fertContracts.forEach(fertContract => {
                                                // console.log("fertContract: ", fertContract)
                                                if (fertContract.incubators && fertContract.incubators.length > 0){
                                                    fertContract.incubators.forEach(incubator => {
                                                        // console.log("incubator: ", incubator)
                                                        // fertilised = incubator.milt.filter(milt => milt = packageContract.ID).length > 0;
                                                        if (incubator.milt && incubator.milt.length > 0) {
                                                            incubator.milt.forEach(milt => {
                                                                //  console.log("milt: ", milt)
                                                                if (milt == packageContract.ID || milt.ID == packageContract.ID  || milt == packageContract) {
                                                                    fertilised = true;
                                                                    //  console.log("fertContract.id: ", fertContract.id)
                                                                    fertID = fertContract.id.split(':')[2];
                                                                }
                                                            })
                                                        }
                                                    });
                                                }
                                            })
                                            discarded = !fertilised
                                        }
                                        else {
                                            discarded = false;
                                            fertilised = false;
                                            fertID = '';
                                        }
                                    }
                                    let preThawedPackageContract = this.bcCache.find(contract => contract.ID == packageContract.ID && contract.State == '2.1' && contract.TempData.ProcessData != 'System.Collections.Hashtable');
                                    let thawedPackageContract = (!thawed ? [] : this.bcCache.find(contract => contract.ID == packageContract.ID && contract.State == '6.1'));
                                    let packageThawingContract = this.bcCache.find(contract => contract.ID == packageContract.ID && contract.State == '5.2');
                                    let cryoPreparationContract = this.bcCache.find(contract => contract.ID == packageContract.ID && contract.State == '3.1');
                                    let cryoPreservationContract = this.bcCache.find(contract => contract.ID == packageContract.ID && contract.State == '3.2');
                                    let cryoPreservationDuration = '';
                                    if (cryoPreservationContract && cryoPreparationContract.TempData && cryoPreparationContract.TempData.ProcessData ){
                                        if (parseInt(
                                            ((cryoPreservationContract.TempData.ProcessData.finished.timestamp - cryoPreservationContract.TempData.ProcessData.started.timestamp) / 1000))
                                        ) {
                                            cryoPreservationDuration = parseInt((cryoPreservationContract.TempData.ProcessData.finished.timestamp - cryoPreservationContract.TempData.ProcessData.started.timestamp) / 1000);
                                        } else {
                                            cryoPreservationDuration = '';
                                        }
                                    }
                                    
                                    dataToExport.push(
                                        {
                                            tag_id: (fishContract && fishContract.TempData && fishContract.TempData.ProcessData && fishContract.TempData.ProcessData.tag_id ? fishContract.TempData.ProcessData.tag_id : ''),
                                            facility: (fishContract && fishContract.TempData && fishContract.TempData.ProcessData && fishContract.TempData.ProcessData.facility ? fishContract.TempData.ProcessData.facility : ''),
                                            year_class: (fishContract && fishContract.TempData && fishContract.TempData.ProcessData && fishContract.TempData.ProcessData.year_class ? fishContract.TempData.ProcessData.year_class : ''),
                                            genetic_rank: (fishContract && fishContract.TempData && fishContract.TempData.ProcessData && fishContract.TempData.ProcessData.genetic_rank ? fishContract.TempData.ProcessData.genetic_rank : ''),
                                            tank: (fishContract && fishContract.TempData && fishContract.TempData.ProcessData && fishContract.TempData.ProcessData.tank ? fishContract.TempData.ProcessData.tank : ''),
                                            sample_id: (sampleCompleteContract.find(contract => contract.State == '1.1').TempData.ProcessData.sample_id ? sampleCompleteContract.find(contract => contract.State == '1.1').TempData.ProcessData.sample_id : ''),
                                            grade: (sampleCompleteContract.find(contract => contract.State == '2.1').TempData.ProcessData.grade ? sampleCompleteContract.find(contract => contract.State == '2.1').TempData.ProcessData.grade : ''),
                                            concentration: (sampleCompleteContract.find(contract => contract.State == '2.1').TempData.ProcessData.concentration ? sampleCompleteContract.find(contract => contract.State == '2.1').TempData.ProcessData.concentration : ''),
                                            motility: (sampleCompleteContract.find(contract => contract.State == '2.1').TempData.ProcessData.motility ? sampleCompleteContract.find(contract => contract.State == '2.1').TempData.ProcessData.motility : ''),
                                            cryoprotectant_used: (preThawedPackageContract ? preThawedPackageContract.TempData.ProcessData.cryoprotectant : ''),
                                            cryo_algorithm: (cryoPreparationContract && cryoPreparationContract.TempData && cryoPreparationContract.TempData.ProcessData ? cryoPreparationContract.TempData.ProcessData.algorithm : ''),
                                            cryo_algorithm_temp: (cryoPreparationContract && cryoPreparationContract.TempData && cryoPreparationContract.TempData.ProcessData ? cryoPreparationContract.TempData.ProcessData.moc.temp : ''),
                                            cryo_algorithm_flow: (cryoPreparationContract && cryoPreparationContract.TempData && cryoPreparationContract.TempData.ProcessData ? cryoPreparationContract.TempData.ProcessData.moc.flow : ''),
                                            cryo_algorithm_time: (cryoPreparationContract && cryoPreparationContract.TempData && cryoPreparationContract.TempData.ProcessData ? cryoPreparationContract.TempData.ProcessData.moc.time : ''),
                                            device_id: (batchContract.TempData.ProcessData.device_id ? batchContract.TempData.ProcessData.device_id : ''),
                                            batch_id: (batchContract.TempData.ProcessData.batch_id ? batchContract.TempData.ProcessData.batch_id : ''),
                                            cryo_preservation_duration: cryoPreservationDuration,
                                            cryo_preservation_start_temp: (cryoPreservationContract && cryoPreservationContract.TempData && cryoPreservationContract.TempData.ProcessData ? cryoPreservationContract.TempData.ProcessData.start_temp : ''),
                                            cryo_preservation_end_temp: (cryoPreservationContract && cryoPreservationContract.TempData && cryoPreservationContract.TempData.ProcessData ? cryoPreservationContract.TempData.ProcessData.end_temp : ''),
                                            cryo_preservation_min_temp: (cryoPreservationContract && cryoPreservationContract.TempData && cryoPreservationContract.TempData.ProcessData ? cryoPreservationContract.TempData.ProcessData.min_temp : ''),
                                            cryo_preservation_max_temp: (cryoPreservationContract && cryoPreservationContract.TempData && cryoPreservationContract.TempData.ProcessData ? cryoPreservationContract.TempData.ProcessData.max_temp : ''),
                                            cryo_preservation_start_flow: (cryoPreservationContract && cryoPreservationContract.TempData && cryoPreservationContract.TempData.ProcessData ? cryoPreservationContract.TempData.ProcessData.start_flow : ''),
                                            cryo_preservation_end_flow: (cryoPreservationContract && cryoPreservationContract.TempData && cryoPreservationContract.TempData.ProcessData ? cryoPreservationContract.TempData.ProcessData.end_flow : ''),
                                            cryo_preservation_min_flow: (cryoPreservationContract && cryoPreservationContract.TempData && cryoPreservationContract.TempData.ProcessData ? cryoPreservationContract.TempData.ProcessData.min_flow : ''),
                                            cryo_preservation_max_flow: (cryoPreservationContract && cryoPreservationContract.TempData && cryoPreservationContract.TempData.ProcessData ? cryoPreservationContract.TempData.ProcessData.max_flow : ''),
                                            thawing_algorithm_used: (packageThawingContract ? packageThawingContract.TempData.ProcessData.algorithm : ''),
                                            thawing_moc_temp: (packageThawingContract && packageThawingContract.TempData && packageThawingContract.TempData.ProcessData && packageThawingContract.TempData.ProcessData.moc ? packageThawingContract.TempData.ProcessData.moc.temp : ''),
                                            thawing_moc_flow: (packageThawingContract && packageThawingContract.TempData && packageThawingContract.TempData.ProcessData && packageThawingContract.TempData.ProcessData.moc ? packageThawingContract.TempData.ProcessData.moc.flow : ''),
                                            thawing_moc_time: (packageThawingContract && packageThawingContract.TempData && packageThawingContract.TempData.ProcessData && packageThawingContract.TempData.ProcessData.moc ? packageThawingContract.TempData.ProcessData.moc.time : ''),
                                            post_thaw_grade: (thawed ? (thawedPackageContract.TempData.ProcessData.grade ? thawedPackageContract.TempData.ProcessData.grade : '') : ''),
                                            post_thaw_concentration: (thawed ? (thawedPackageContract.TempData.ProcessData.concentration ? thawedPackageContract.TempData.ProcessData.concentration : '') : ''),
                                            post_thaw_motility: (thawed ? (thawedPackageContract.TempData.ProcessData.motility ? thawedPackageContract.TempData.ProcessData.motility : '') : ''),
                                            package_id: (packageContract.name ? packageContract.name : ''),
                                            dewar_id: (storageContract ? storageContract.TempData.ProcessData.dewar_id : ''),
                                            cannister_number: (storageContract ? storageContract.TempData.ProcessData.cannister_number : ''),
                                            thawed: (thawed ? "Y" : "N"),
                                            discarded: (thawed ? (discarded ? "Y" : "N") : ''),
                                            used_in_fert: (thawed ? (fertilised ? "Y" : "N") : ''),
                                            fertID: fertID
                                        }
                                    );
                            });
                    
                        });
                    });
                });

                setTimeout(() => {
                    saveExcel({
                        data: dataToExport,
                        fileName: "aquaculture-full-fish-data_" + moment(now).format("YYYY-MM-DD"),
                        columns: [
                            { field: 'tag_id', title: 'Tag ID' },
                            { field: 'facility', title: 'Facility' },
                            { field: 'year_class', title: 'Year Class' },
                            { field: 'genetic_rank', title: 'Genetic Rank' },
                            { field: 'tank', title: 'Tank' },
                            { field: 'sample_id', title: 'Sample ID' },
                            { field: 'package_id', title: 'Package ID' },
                            { field: 'grade', title: 'Grading' },
                            { field: 'concentration', title: 'Concentration' },
                            { field: 'motility', title: 'Motility' },
                            { field: 'cryoprotectant_used', title: 'Cryoprotectant Used' },
                            { field: 'cryo_algorithm', title: 'Cryopreservation Algorithm' },
                            { field: 'cryo_algorithm_temp', title: 'Cryopreservation Algorithm Set Temp (°C)' },
                            { field: 'cryo_algorithm_flow', title: 'Cryopreservation Algorithm Set Flow (L/min)' },
                            { field: 'cryo_algorithm_time', title: 'Cryopreservation Algorithm Set Time (s)' },
                            { field: 'device_id', title: 'Cryopreservation Device' },
                            { field: 'batch_id', title: 'Batch ID' },
                            { field: 'cryo_preservation_duration', title: 'Cryo Preservation Duration (s)' },
                            { field: 'cryo_preservation_start_temp', title: 'Cryo Preservation Start Temp (°C)' },
                            { field: 'cryo_preservation_end_temp', title: 'Cryo Preservation End Temp (°C)' },
                            { field: 'cryo_preservation_min_temp', title: 'Cryo Preservation Min Temp (°C)' },
                            { field: 'cryo_preservation_max_temp', title: 'Cryo Preservation Max Temp (°C)' },
                            { field: 'cryo_preservation_start_flow', title: 'Cryo Preservation Start Flow (L/min)' },
                            { field: 'cryo_preservation_end_flow', title: 'Cryo Preservation End Flow (L/min)' },
                            { field: 'cryo_preservation_min_flow', title: 'Cryo Preservation Min Flow (L/min)' },
                            { field: 'cryo_preservation_max_flow', title: 'Cryo Preservation Max Flow (L/min)' },
                            { field: 'thawing_algorithm_used', title: 'Thawing Algorithm Used' },
                            { field: 'thawing_moc_temp', title: 'Thawing MoC Temp (°C)' },
                            { field: 'thawing_moc_flow', title: 'Thawing MoC Flow (L/min)' },
                            { field: 'thawing_moc_time', title: 'Thawing MoC Time (s)' },
                            { field: 'post_thaw_grade', title: 'Post Thaw Grading' },
                            { field: 'post_thaw_concentration', title: 'Post Thaw Concentration' },
                            { field: 'post_thaw_motility', title: 'Post Thaw Motility' },
                            { field: 'dewar_id', title: 'Dewar ID' },
                            { field: 'cannister_number', title: 'Cannister Number' },
                            { field: 'thawed', title: 'Thawed' },
                            { field: 'discarded', title: 'Discarded' },
                            { field: 'used_in_fert', title: 'Used In Fert' },
                            { field: 'fertID', title: 'Fertilisation' },
                        ],
                    });
                    this.exportingFullFishData = false;
                }, 5000);

                console.log("Exporting full fish data completed...");

            },
            async downloadFishData(){
                this.exportingFishData = true;
                const now = new Date();

                let dataToExport = [];

                console.log("Exporting fish data...")
                // console.log("this.bcCache: ", this.bcCache)

                // console.log("this.aquacultureFertilisationTemplateID: ", this.bcCache.filter(contract => contract.TemplateID == this.aquacultureFertilisationTemplateID))

                let fertilisationData = [];
                let fertContracts = [];
                
                this.bcCache.filter(contract => contract.TemplateID == this.aquacultureFertilisationTemplateID).forEach(contract => {
                    //if the contract ID doesn';t exist in the 'fertilisationData' list, add it
                    if (!fertilisationData.find(fertContract => fertContract.ID == contract.ID)) fertilisationData.push(contract);
                });

                // console.log("fertilisationData: ", fertilisationData)
                await Promise.all(fertilisationData.map(async (contract) => {
                    fertContracts.push(await this.getAquacultureFertilisationForReport(contract.ID));
                }));
                // console.log("fertContracts before: ", fertContracts)
                if (fertContracts.length === 1 && (fertContracts[0] === '' || fertContracts[0] === '""')) {
                    // console.log("Fert contracts broken... Fixing...");
                    fertContracts = [];
                }

                // console.log("fertContracts after: ", fertContracts)
                // console.log("Fish '652846' exists?: ", this.blockchainInProgress.filter(contract => contract.TemplateID == this.aquacultureMasterMaleTemplateID).filter(fishContract => fishContract.ID == '9ca817d7-4e0e-46e0-8e96-ab6341160288:1747804267903:652846'));
                this.blockchainInProgress.filter(contract => contract.TemplateID == this.aquacultureMasterMaleTemplateID).forEach((fishContract) => {
                    // console.log("fishContract: ", fishContract)
                    fishContract.stackedItems.forEach(async (sampleContract) => {
                        // console.log("sampleContract: ", sampleContract)
                        let sampleCompleteContract = await this.retrieveBlockchainFromAPI(sampleContract.ID);
                            sampleContract.stackedItems.forEach((batchContract) => {
                                // console.log("batchContract: ", batchContract)
                                batchContract.stackedItems.forEach((packageContract) =>{
                                    // console.log("packageContract: ", packageContract)
                                    let thawed = false;
                                    let fertilised = false;
                                    let fertID = '';
                                    let discarded = false;
                                    let storageContract = this.bcCache.find(contract => contract.ID == packageContract.ID && contract.State == "4.1");
                                    let thawedContract = this.bcCache.find(contract => contract.ID == packageContract.ID && contract.State == "6.1");
                                    if (thawedContract) {
                    
                                        // console.log("Contract was thawed, checking if fertilised. Contract ID: ", packageContract.ID)
                                        thawed = true;
                                        if (fertContracts.length > 0) {
                                            // console.log("Processing fertilisation contracts: ", fertContracts)
                                            fertContracts.forEach(fertContract => {
                                                // console.log("fertContract: ", fertContract)
                                                if (fertContract.incubators && fertContract.incubators.length > 0){
                                                    fertContract.incubators.forEach(incubator => {
                                                        // console.log("incubator: ", incubator)
                                                        // fertilised = incubator.milt.filter(milt => milt = packageContract.ID).length > 0;
                                                        if (incubator.milt && incubator.milt.length > 0) {
                                                            incubator.milt.forEach(milt => {
                                                                //  console.log("milt: ", milt)
                                                                if (milt == packageContract.ID || milt.ID == packageContract.ID  || milt == packageContract) {
                                                                    fertilised = true;
                                                                    //  console.log("fertContract.id: ", fertContract.id)
                                                                    fertID = fertContract.id.split(':')[2];
                                                                }
                                                            })
                                                        }
                                                    });
                                                }
                                            })
                                            discarded = !fertilised
                                        }
                                        else {
                                            discarded = false;
                                            fertilised = false;
                                            fertID = '';
                                        }
                                    }
                                    // console.log('fishContract: ', fishContract);
                                    // console.log("thawed: ", thawed, " packageContract.ID: ", packageContract.ID)
                                    let thawedPackageContract = (!thawed ? [] : this.bcCache.find(contract => contract.ID == packageContract.ID && contract.State == '6.1'));
                                    // console.log("thawedPackageContract: ", thawedPackageContract)
                                    dataToExport.push(
                                        {
                                            tag_id: (fishContract && fishContract.TempData && fishContract.TempData.ProcessData && fishContract.TempData.ProcessData.tag_id ? fishContract.TempData.ProcessData.tag_id : ''),
                                            facility: (fishContract && fishContract.TempData && fishContract.TempData.ProcessData && fishContract.TempData.ProcessData.facility ? fishContract.TempData.ProcessData.facility : ''),
                                            year_class: (fishContract && fishContract.TempData && fishContract.TempData.ProcessData && fishContract.TempData.ProcessData.year_class ? fishContract.TempData.ProcessData.year_class : ''),
                                            genetic_rank: (fishContract && fishContract.TempData && fishContract.TempData.ProcessData && fishContract.TempData.ProcessData.genetic_rank ? fishContract.TempData.ProcessData.genetic_rank : ''),
                                            tank: (fishContract && fishContract.TempData && fishContract.TempData.ProcessData && fishContract.TempData.ProcessData.tank ? fishContract.TempData.ProcessData.tank : ''),
                                            sample_id: (sampleCompleteContract.find(contract => contract.State == '1.1').TempData.ProcessData.sample_id ? sampleCompleteContract.find(contract => contract.State == '1.1').TempData.ProcessData.sample_id : ''),
                                            grade: (sampleCompleteContract.find(contract => contract.State == '2.1').TempData.ProcessData.grade ? sampleCompleteContract.find(contract => contract.State == '2.1').TempData.ProcessData.grade : ''),
                                            concentration: (sampleCompleteContract.find(contract => contract.State == '2.1').TempData.ProcessData.concentration ? sampleCompleteContract.find(contract => contract.State == '2.1').TempData.ProcessData.concentration : ''),
                                            motility: (sampleCompleteContract.find(contract => contract.State == '2.1').TempData.ProcessData.motility ? sampleCompleteContract.find(contract => contract.State == '2.1').TempData.ProcessData.motility : ''),
                                            device_id: (batchContract.TempData.ProcessData.device_id ? batchContract.TempData.ProcessData.device_id : ''),
                                            batch_id: (batchContract.TempData.ProcessData.batch_id ? batchContract.TempData.ProcessData.batch_id : ''),
                                            post_thaw_grade: (thawed ? (thawedPackageContract.TempData.ProcessData.grade ? thawedPackageContract.TempData.ProcessData.grade : '') : ''),
                                            post_thaw_concentration: (thawed ? (thawedPackageContract.TempData.ProcessData.concentration ? thawedPackageContract.TempData.ProcessData.concentration : '') : ''),
                                            post_thaw_motility: (thawed ? (thawedPackageContract.TempData.ProcessData.motility ? thawedPackageContract.TempData.ProcessData.motility : '') : ''),
                                            package_id: (packageContract.name ? packageContract.name : ''),
                                            dewar_id: (storageContract ? storageContract.TempData.ProcessData.dewar_id : ''),
                                            cannister_number: (storageContract ? storageContract.TempData.ProcessData.cannister_number : ''),
                                            thawed: (thawed ? "Y" : "N"),
                                            discarded: (thawed ? (discarded ? "Y" : "N") : ''),
                                            used_in_fert: (thawed ? (fertilised ? "Y" : "N") : ''),
                                            fertID: fertID
                                        }
                                    );
                            });
                    
                        });
                    });
                });

                
                // console.log("Fish '652846': ", dataToExport.filter(item => item.tag_id == '652846'));
                // console.log("Data to export: ", dataToExport);

                // console.log("Built the export data: ", JSON.stringify(dataToExport));
                setTimeout(() => {

                    saveExcel({
                        data: dataToExport,
                        fileName: "aquaculture-fish-data_" + moment(now).format("YYYY-MM-DD"),
                        columns: [
                            { field: 'tag_id', title: 'Tag ID' },
                            { field: 'facility', title: 'Facility' },
                            { field: 'year_class', title: 'Year Class' },
                            { field: 'genetic_rank', title: 'Genetic Rank' },
                            { field: 'tank', title: 'Tank' },
                            { field: 'sample_id', title: 'Sample ID' },
                            { field: 'grade', title: 'Grading' },
                            { field: 'concentration', title: 'Concentration' },
                            { field: 'motility', title: 'Motility' },
                            { field: 'device_id', title: 'Cryopreservation Device' },
                            { field: 'batch_id', title: 'Batch' },
                            { field: 'post_thaw_grade', title: 'Post Thaw Grading' },
                            { field: 'post_thaw_concentration', title: 'Post Thaw Concentration' },
                            { field: 'post_thaw_motility', title: 'Post Thaw Motility' },
                            { field: 'package_id', title: 'Package ID' },
                            { field: 'dewar_id', title: 'Dewar ID' },
                            { field: 'cannister_number', title: 'Cannister Number' },
                            { field: 'thawed', title: 'Thawed' },
                            { field: 'discarded', title: 'Discarded' },
                            { field: 'used_in_fert', title: 'Used In Fert' },
                            { field: 'fertID', title: 'Fertilisation' },
                        ],
                    });
                    this.exportingFishData = false;
                }, 2000);
                
                console.log("Exporting fish data completed...")
            },
            // onDecodeQR(text){
            //     // console.log("qr text: ", text)
            //     // console.log("Selected block: ", this.selectedBlock)
            //     // this.P_5_1.identification_package_id = text;

            //     // console.log("Dispatching event for ref: ", this.$refs.P_5_1_identification_package_id_ref)
            //     // this.$refs.P_5_1_identification_package_id_ref.dispatchEvent(new Event('change'));

            //     // this.qr_result = text;
            // },
            // onLoadedQR(){
            //     console.log("Ready to scan QR")
            // },
            uuidv4() {
                return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            )},
            getFormattedDate(date){
                // console.log("date: ", date, " new date: ", new Date(date), " moment: ", moment(date), " moment formatted: ", moment(date).format('YYYY-MM-DD HH:mm:ss'))
                return moment(new Date(date)).format('YYYY-MM-DD HH:mm:ss')
            },
            getRelativeDate(date) {
                if (parseInt(date)) return moment(new Date(parseInt(date))).fromNow();
                else return moment(new Date(date)).fromNow();
            },
            updateLoadingText(){
                // Function that picks a random line and returns a promise
                const loadingTextPromise = new Promise((resolve) =>{
                    resolve(this.getRandomLoadingText(this.loadingTextPhrases));
                })

                loadingTextPromise.then((text) => { this.loadingText = text; });
            },
            getRandomLoadingText(arr) {
                // Ensure the array is not empty
                if (arr.length === 0) {
                    throw new Error('Array is empty');
                }

                // Get a random index from the array
                const randomIndex = Math.floor(Math.random() * arr.length);

                // Return the element at the random index
                return arr[randomIndex];
            },
            async getBlockchain_ByTemplate(templateID, lastEvaluatedID = null) {
                const blockChainTableName = this.aquacultureBlockChainTableName;
                const headers = { 'Content-Type': 'application/json;charset=utf-8', 'authorization': localStorage.idtoken };

                let items = [];
                let params;
                if (lastEvaluatedID == null) {
                    params = new URLSearchParams({
                        TableName: blockChainTableName,
                        TemplateID: templateID
                    });
                }
                else {
                    params = new URLSearchParams({
                        TableName: blockChainTableName,
                        TemplateID: templateID,
                        LastEvaluatedKey: lastEvaluatedID
                    });
                }
                    
                let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + `?${params}`; // Build the URL with query params

                try {
                    console.log("Looking for items with template ID... URL: ", url, " Headers: ", headers, " Params: ", params);
                    let response = await this.$http.get(url, { headers });
                    
                    console.log("Items retrieved: ", response.length)
                    items = response.data.Items
                    console.log("API Response: ", response)
                    
                }
                catch (error) {
                    console.error("Error fetching item: ", error);
                }

                return items;
            },
            async getBlockchain_ByParentID(parentID) {
                const blockChainTableName = this.aquacultureBlockChainTableName;
                const headers = { 'Content-Type': 'application/json;charset=utf-8', 'authorization': localStorage.idtoken };

                let items = [];
                let params = new URLSearchParams({
                    TableName: blockChainTableName,
                    ParentID: parentID
                });
                    
                let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + `?${params}`; // Build the URL with query params

                try {
                    console.log("Looking for items with parent... URL: ", url, " Headers: ", headers, " Params: ", params);
                    let response = await this.$http.get(url, { headers });
                    
                    console.log("Items retrieved: ", response.length)
                    items = response.data.Items
                    console.log("API Response: ", response)
                }
                catch (error) {
                    console.error("Error fetching item: ", error);
                }

                return items;
            },
            async getBlockchain_ByState(state) {
                const blockChainTableName = this.aquacultureBlockChainTableName;
                const headers = { 'Content-Type': 'application/json;charset=utf-8', 'authorization': localStorage.idtoken };

                let items = [];
                let params = new URLSearchParams({
                    TableName: blockChainTableName,
                    State: state
                });
                    
                let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + `?${params}`; // Build the URL with query params

                try {
                    console.log("Looking for items with state... URL: ", url, " Headers: ", headers, " Params: ", params);
                    let response = await this.$http.get(url, { headers });
                    
                    console.log("Items retrieved: ", response.length)
                    items = response.data.Items
                    console.log("API Response: ", response)
                }
                catch (error) {
                    console.error("Error fetching item: ", error);
                }

                return items;
            },
            async buildAquacultureTree(){
                console.log("Getting a fresh read on the blockchain...")
                await this.getBlockchain(this.type);
                console.log("Building aquaculture data with bcCache: ", this.bcCache)
                /* Clear lists */

                this.aquacultureMasterFemaleFish = [];
                this.aquacultureMasterMaleFish = [];
                this.aquacultureFertilisationMasters = [];

                // Make sure the Device Batch data is loaded.
                await this.getDeviceBatchData();

                /* FEMALES */
                // Get Huon Master (Fish) records
                this.aquacultureMasterFemaleFish = this.blockchainInProgress.filter(contract => contract.TempData.TemplateID == this.aquacultureMasterFemaleTemplateID);
                this.aquacultureMasterFemaleFish.forEach(masterFishContract => {
                    if (masterFishContract.State != '0' && masterFishContract.State != '1.1') masterFishContract.TempData.ProcessData = this.bcCache.find(initialMasterContract => initialMasterContract.ID == masterFishContract.ID && initialMasterContract.State == '1.1').TempData.ProcessData
                });

                for (let masterFemaleStackedItemsLoop = 0; masterFemaleStackedItemsLoop < this.aquacultureMasterFemaleFish.length; masterFemaleStackedItemsLoop++) {
                    console.log("Finding stacked items for parent: ", this.aquacultureMasterFemaleFish[masterFemaleStackedItemsLoop].ID)
                    this.bcCache = this.bcCache.concat(await this.getBlockchain_ByParentID(this.aquacultureMasterFemaleFish[masterFemaleStackedItemsLoop].ID))
                }
                console.log("Refreshing blockchain for the female's stacked items...")
                await this.getBlockchain(this.type);
                
                this.aquacultureMasterFemaleFish.forEach(masterFishContract => {
                    masterFishContract.stackedItems = [];
                    let initialItems = this.bcCache.filter(stackedItem => stackedItem.TempData.TemplateID == this.aquacultureEggBatchTemplateID && stackedItem.State == '1.1' && stackedItem.TempData.ProcessData.master_tag_id == (masterFishContract.TempData.ProcessData == undefined ? masterFishContract.name : masterFishContract.TempData.ProcessData.tag_id));
                    initialItems.forEach(item => {
                        if (item) {
                            let foundEggContract = this.blockchainInProgress.find(eggBatchContract => eggBatchContract.ID == item.ID)
                            if (foundEggContract) masterFishContract.stackedItems.push(this.blockchainInProgress.find(eggBatchContract => eggBatchContract.ID == item.ID))
                        }
                    })
                });
                

                console.log("aquacultureMasterFemaleFish: ", this.aquacultureMasterFemaleFish)

                /* MALES and NEOMALES */
                // Get Huon Master (Fish) records
                this.aquacultureMasterMaleFish = this.blockchainInProgress.filter(contract => contract.TempData.TemplateID == '932f342a-0eeb-4c45-9bf4-816a72315278');
                this.aquacultureMasterMaleFish.forEach(masterFishContract => {
                    if (masterFishContract.State != '0' && masterFishContract.State != '1.1') masterFishContract.TempData.ProcessData = this.initialWorldState.find(initialMasterContract => initialMasterContract.ID == masterFishContract.ID && initialMasterContract.State == '1.1').TempData.ProcessData
                });
                
                /* Get the Aquaculture Male Stacked Items (Samples) */
                this.aquacultureMasterMaleFish.forEach((contract) => {
                    if (contract) contract.stackedItems = [];
                    let initialItems = this.initialWorldState.filter(stackedItem => stackedItem.TempData.TemplateID == '932f342a-0eeb-4c45-9bf4-816a72315280' && stackedItem.State == '1.1' && (contract.TempData.ProcessData != undefined && ((stackedItem.TempData.ProcessData.master_tag_id != undefined && contract.TempData.ProcessData.tag_id != undefined) && stackedItem.TempData.ProcessData.master_tag_id == contract.TempData.ProcessData.tag_id)))
                    initialItems.forEach((item) => {
                        if (item) contract.stackedItems.push(this.blockchainInProgress.find(sampleContract => sampleContract.ID == item.ID))
                    });
                });
                
                /* Get the Aquaculture Male Stacked Items (Batches) */
                this.aquacultureMasterMaleFish.forEach((aquacultureMasterMaleFish) => {
                    aquacultureMasterMaleFish.stackedItems.forEach((aquacultureFishSample) => {
                        if (aquacultureFishSample) aquacultureFishSample.stackedItems = [];
                        let initialSampleID = this.initialWorldState.find((initialSampleContract) => initialSampleContract.ID == aquacultureFishSample.ID && initialSampleContract.State == '1.1')
                        
                        let batchItems = this.initialWorldState.filter((batchContract) => batchContract.TempData.TemplateID == this.cryopreservationBatchTemplateID && batchContract.State == '1.1' && batchContract.TempData.ProcessData.master_tag_id == initialSampleID.TempData.ProcessData.master_tag_id && batchContract.TempData.ProcessData.sample_id == initialSampleID.TempData.ProcessData.sample_id)

                        batchItems.forEach((item) => {
                            let foundBatchContract = this.blockchainInProgress.find((batchContract) => batchContract.ID == item.ID);
                            let thisBatch = this.deviceBatchData.find(batch => batch.TableLoc == 'Aquaculture' && batch.DeviceName == item.TempData.ProcessData.device_id && batch.BatchID == item.TempData.ProcessData.batch_id)
                            if(thisBatch) foundBatchContract.batchStart = (thisBatch.StartDateTime ? thisBatch.StartDateTime : '');
                            if(thisBatch) foundBatchContract.batchEnd = (thisBatch.EndDateTime ? thisBatch.EndDateTime : '');
                            aquacultureFishSample.stackedItems.push(foundBatchContract)
                        });
                    });
                });
                
                /* Get the Aquaculture Male Stacked Items (Packages) */
                this.aquacultureMasterMaleFish.forEach(aquacultureMasterMaleFish => {
                    aquacultureMasterMaleFish.stackedItems.forEach(aquacultureFishSample => {
                        aquacultureFishSample.stackedItems.forEach(aquacultureFishSampleBatch => {
                            if (aquacultureFishSampleBatch) aquacultureFishSampleBatch.stackedItems = []
                            if (aquacultureFishSampleBatch.TempData != undefined && aquacultureFishSampleBatch.TempData.ProcessData != undefined && aquacultureFishSampleBatch.TempData.ProcessData.cryopreservedPackages != undefined) aquacultureFishSampleBatch.TempData.ProcessData.cryopreservedPackages.forEach((cryopreservedPackage) => {
                                aquacultureFishSampleBatch.stackedItems.push(this.blockchainInProgress.find(packageContract => packageContract.ID == cryopreservedPackage.ID))
                            });
                        });
                    });
                });

                /* FERTILISATION */
                console.log("Building fertilisation")
                let initialFertMasters = this.initialWorldState.filter(initialContract => initialContract.TempData.TemplateID == this.aquacultureFertilisationTemplateID && initialContract.State == '0')
                initialFertMasters.forEach(initialContract => {
                    this.aquacultureFertilisationMasters.push(this.blockchainInProgress.find(contract => contract.ID == initialContract.ID))
                });
                console.log("Fish fertilisation runs: ", this.aquacultureFertilisationMasters)
            },
            async getInitialBlockchainLazyLoad() {
                // aquacultureMasterMaleTemplateID: '932f342a-0eeb-4c45-9bf4-816a72315278',
                // aquacultureMiltSampleTemplateID: '932f342a-0eeb-4c45-9bf4-816a72315280',
                // aquaculturePackageTemplateID: '18719e55-99bf-4137-b7bb-fefd373f60b3',
                // aquacultureMasterFemaleTemplateID: '932f342a-0eeb-5d69-9bf4-816a72315278',
                // aquacultureEggBatchTemplateID: 'd6af0b83-0a59-48e4-84e0-5801e879acb9',
                // aquacultureFertilisationTemplateID: '2fffff11-51f4-4fa8-980f-c9015e00aba4',
                // cryopreservationBatchTemplateID: '37ee37ea-1572-471c-a6d2-4ceb9d42fc15',

                // bovineMasterTemplateID: '',
                // bovineSamplesTemplateID: '7a976520-bae3-478e-a397-784354f79970',
                // bovinePackagesTemplateID: '7a976520-bae3-478e-a397-784354f79975',
                console.log("Getting initial blockchain lazy load...")

                // let tempData = [];

                console.log("Loading templates...")
                let tempData = await this.getBlockchain_ByState("TEMPLATE");
                console.log("Templates: ", tempData)
                console.log("Loaded templates...")
                
                
                let maleMasters = await this.getBlockchain_ByTemplate(this.aquacultureMasterMaleTemplateID);
                // maleMasters = maleMasters.filter(contract => contract.State == "0")
                //tempData = tempData.concat(maleMasters);
                console.log("maleMasters: ", maleMasters)
                for (let i = 0; i < maleMasters.length; i++) {
                    tempData = tempData.concat(await this.retrieveBlockchainFromAPI(maleMasters[i].ID))
                    // let children = await this.getBlockchain_ByParentID(maleMasters[i].ID)
                    // for (let j = 0; j < children.length; j++){
                    //     tempData = tempData.concat(await this.retrieveBlockchainFromAPI(children[j].ID))
                    // }
                }

                let femaleMasters = await this.getBlockchain_ByTemplate(this.aquacultureMasterFemaleTemplateID);
                // femaleMasters = femaleMasters.filter(contract => contract.State == "0")
                for (let i = 0; i < femaleMasters.length; i++) {
                    tempData = tempData.concat(await this.retrieveBlockchainFromAPI(femaleMasters[i].ID))
                    // let children = await this.getBlockchain_ByParentID(femaleMasters[i].ID)
                    // for (let j = 0; j < children.length; j++){
                    //     tempData = tempData.concat(await this.retrieveBlockchainFromAPI(children[j].ID))
                    // }
                }

                let fertilisationMasters = await this.getBlockchain_ByTemplate(this.aquacultureFertilisationTemplateID);
                // fertilisationMasters = fertilisationMasters.filter(contract => contract.State == "0")
                for (let i = 0; i < fertilisationMasters.length; i++) {
                    tempData = tempData.concat(await this.retrieveBlockchainFromAPI(fertilisationMasters[i].ID))
                    // let children = await this.getBlockchain_ByParentID(fertilisationMasters[i].ID)
                    // for (let j = 0; j < children.length; j++){
                    //     tempData = tempData.concat(await this.retrieveBlockchainFromAPI(children[j].ID))
                    // }
                }
                
                console.log("tempData: ", tempData)

                this.bcCache = tempData;
                console.log("Male parents: ", this.bcCache.filter(contract => contract.TemplateID == this.aquacultureMasterMaleTemplateID))
                console.log("nitial blockchain lazy load completed... bcCahce: ", this.bcCache)
            },
        },
        created: async function() {
            clearInterval(this.deviceConnectionIntervalID);
            
            // dynamic loading text
            this.loadingText = await this.updateLoadingText();
            console.log("This year: ", this.year)

            // Load the blockchain results
            if (this.incomingBlockchainCache != undefined || this.incomingBlockchainCache && this.incomingBlockchainCache.length >= 0) {
                /* We want a shallow copy so that we don't mess with the initial cache as we're processing stuff */
                let tempBlockChainFromParent;
                tempBlockChainFromParent = await JSON.parse(JSON.stringify(this.incomingBlockchainCache))
                this.bcCache = tempBlockChainFromParent; // Shallow copy
            }
            else {
                this.bcCache = await this.retrieveInitialBlockchainFromDynamo();
            }
        },
        mounted: async function () {
            // dynamic loading text
            this.loadingText = await this.updateLoadingText();

            this.aquacultureBlockChainTableName = `${process.env.VUE_APP_BLOCKCHAIN_AQUACULTURE_DB_TABLE_NAME}_${this.year}`;

            clearInterval(this.deviceConnectionIntervalID);
            console.log("TYPE = ", this.type, " SUB TYPE = ", this.subtype);
            
            // Load Device Batch Data
            await this.getDeviceBatchData();

            if (this.subtype == "Aquaculture") await this.getHuonLocations();

            // Set the username from the master (take into account the 'level' we're in)
            this.current_user = (this.$parent.userInfo == undefined ? this.$parent.$parent.$parent.userInfo.username : this.$parent.userInfo.username);

            // await this.getInitialBlockchainLazyLoad();
            await this.getBlockchain(this.type);
        },
        beforeDestroy() {
            clearInterval(this.deviceConnectionIntervalID);
        },
    }
</script>

<style>
    .tdnowrap {
        position: relative;
        white-space: nowrap;
    }

    td.tableExpand {
        padding: 0px !important;
    }

    td.sampleExpand {
        padding: 0px !important;
    }    

    .table.b-table > tbody > tr.b-table-details > td {
        padding: 0px !important;
    }
</style>

<style scoped>
i.warn-icon { color:#ffc107; }
i.success-icon { color:#28a745; }
i.info-icon { color:grey; }

#transparentLoadingDiv {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

#blockchain-container {
    overflow-y: auto; 
    overflow-x: auto;
}

#blockchain-header-container {
    float: left; 
    width: 100%; 
    margin-bottom: 10px;
}

#blockchain-heading {
    float: left;
}

.blockchain-info-table {
    margin-bottom: 0px;
}

#blockchain-button-container {
    float: right;
}

.end-of-chain, .modal-footer {
    background-color: #fff;
    z-index: 99;
}

/* template css */
#template-container {
    position: relative;
}

#hide-end-of-line {
    position: absolute;
    bottom: -10px;
    left: 36px;
    height: 10px;
    width: 10px;
    background: white;
}    

#template-container:before {
    position: absolute;
    top: 9px;
    left: 36px;
    display: block;
    content: "";
    width: 3px;
    height: 100%;
    background-color: red;
    display: none;
}

.milestone-container:before {
    position: absolute;
    top: 0;
    left: 36px;
    display: block;
    content: "";
    width: 3px;
    height: 100%;
    background-color: grey;
}

.milestone {
    position: relative;
    width: 100%;
    height: 70px;
    padding: 10px;
    border-top: 1px solid #e6ebf1;
    display: flex;
    align-items: center;
    justify-content: left;
}

.milestone-link-end {
    position: absolute;
    width: 11px;
    height: 9px;
    background: white;
    top: 61px;
    left: 32px;   
}

.milestone:hover {
    cursor: pointer;
}

/* milestone links */
.milestone-link {
    position: absolute; 
    top: 60px; 
    left: 35px; 
    border-left: 3px solid #00ad5b; 
    width: 3px; 
    height: 18px; 
    z-index: 1;
}

.subprocess-section {
    position: relative;
    background: white;
}

.milestone-link-top {
    z-index: 2;
    position: absolute;
    top: -11px;
    left: 35px;
    display: block;
    content: "";
    width: 60px;
    height: 47px;
    /* background-color: white; */
    border-left: 3px dashed lightgrey;
    border-bottom: 3px dashed lightgrey;
}

.milestone-link-top-complete {
    border-left: 3px solid rgb(0, 173, 91);
    border-bottom: 3px solid rgb(0, 173, 91);
}

.milestone-link-top-inprogress {
    border-left: 3px solid red;
    border-bottom: 3px solid red;
}    

.milestone-link-bottom {
    position: absolute;
    bottom: -29px;
    left: 35px;
    display: block;
    content: "";
    width: 60px;
    height: 66px;
    /* background-color: white; */
    border-left: 3px dashed lightgrey;
    border-top: 3px dashed lightgrey;
    z-index: 1;
}

.milestone-link-bottom-complete {
    border-left: 3px solid rgb(0, 173, 91);
    border-top: 3px solid rgb(0, 173, 91);
}    

/* subprocess links */
.subprocess-area {
    position: relative;
}

.subprocess-link-top {
    position: absolute;
    top: -20px;
    left: 180px;
    display: block;
    width: 103px;
    height: 57px;
    background-color: white;
    border-left: 3px dashed lightgrey;
    border-bottom: 3px dashed lightgrey;
}

.subprocess-link-top-complete{
    border-left: 3px solid rgb(0, 173, 91);
    border-bottom: 3px solid rgb(0, 173, 91);
    z-index: 1;
}    


.subprocess-link-bottom {
    position: absolute;
    bottom: -20px;
    left: 180px;
    display: block;
    width: 103px;
    height: 57px;
    background-color: white;
    border-left: 3px dashed lightgrey;
    border-top: 3px dashed lightgrey;
}

.subprocess-link-bottom-complete {
    border-left: 3px solid rgb(0, 173, 91);
    border-top: 3px solid rgb(0, 173, 91);
}    

.subprocess-link-back-to-milestone {
    position: absolute;
    bottom: -20px;
    left: 95px;
    display: block;
    width: 188px;
    height: 57px;
    background-color: white;
    border-top: 3px dashed lightgrey;
}

.subprocess-link-back-to-milestone-complete {
    border-top: 3px solid rgb(0, 173, 91);
}    

.subprocesses-parallel-link {
    position: absolute;
    top: 37px;
    left: 180px;
    display: block;
    width: 3px;
    height: 86px;
    border-left: 3px dashed lightgrey;
}

.subprocesses-parallel-link-complete {
    border-left: 3px solid rgb(0, 173, 91);
}    

.subprocesses-subprocess-parallel-link {
    position: absolute;
    top: 37px;
    left: 368px;
    display: block;
    width: 3px;
    height: 86px;
    border-left: 3px dashed lightgray;
}

.subprocesses-subprocess-parallel-link-complete {
    border-left: 3px solid rgb(0, 173, 91);
}        

/* subprocess subprocess links */
.subprocess-subprocess-link-top {
    position: absolute;
    top: 0px;
    left: 368px;
    display: block;
    width: 103px;
    height: 37px;
    background-color: white;
    border-left: 3px dashed lightgrey;
    border-bottom: 3px dashed lightgrey;
}

.subprocess-subprocess-link-top-complete {
    top: -20px;
    height: 57px;
    border-left: 3px solid rgb(0, 173, 91);
    border-bottom: 3px solid rgb(0, 173, 91);
}

.subprocess-subprocess-link-bottom {
    position: absolute;
    bottom: -20px;
    left: 368px;
    display: block;
    width: 103px;
    height: 57px;
    background-color: white;
    border-left: 3px dashed lightgrey;
    border-top: 3px dashed lightgrey;
}

.subprocess-subprocess-link-bottom-complete {
    border-left: 3px solid rgb(0, 173, 91);
    border-top: 3px solid rgb(0, 173, 91);
}    

/* subprocess bottom links */
.subprocess-bottom-link {
    position: absolute;
    bottom: -22px;
    left: 84px;
    display: block;
    content: "";
    width: 3px;
    height: 21px;
    border-right: 3px dashed lightgrey;
}

.subprocess-bottom-link-complete {
    border-right: 3px solid rgb(0, 173, 91);
}

.subprocess-bottom-link-blank {
    position: absolute;
    bottom: -21px;
    left: 180px;
    display: block;
    content: "";
    width: 3px;
    height: 21px;
    background-color: white;
}    

.subprocess-subprocess-bottom-link-blank {
    position: absolute;
    bottom: -21px;
    left: 368px;
    display: block;
    content: "";
    width: 3px;
    height: 21px;
    background-color: white;
}     

.subprocess-subprocess-subprocess-bottom-link-blank {
    position: absolute;
    bottom: -21px;
    left: 556px;
    display: block;
    content: "";
    width: 3px;
    height: 21px;
    background-color: white;
}         

.aquaculture-summary-board {
    float: left !important; top: 0px; left: 0px !important; padding-bottom:20px;
}

/* milestones */
.milestone i {
    float: right;
    font-size: 18px;
}

.milestone-image {
    width: 53px;
    border: 3px solid #00ad5b;
    border-radius: 50%;
    position: relative;
    z-index: 3;
}

    .contractImageNotActioned {
        filter: grayscale(100%) brightness(90%);
        border: 3px solid #e6ebf1;
    }

    .contractImageInProgress {
        z-index: 4 !important;
        filter: none !important;
        border: 3px solid #0a58ca !important;
        box-shadow: 0px 0px 8px 1px #0a58ca !important;
    }

.milestone-label {
    padding-left: 20px;
    width: 100%;
}

.template-process {
    position: relative;
    height: 70px;
    width: 178px;
    border: 1px solid grey;
    color: grey;
    padding: 10px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    margin-left: 5px;
    margin-right: 5px;
    background: white;
    z-index: 1;
}

.blank-process {
    border: none;
    background: none;
}

.first-coloum-process {
    width: 85px;
}

.InProgress {
    border: 1px solid blue;
    color: initial;
}

.Complete {
    border: 1px solid green;
    color: initial;
}

.expandCollapse {
    text-align: right;
    margin-bottom: 15px;
}

.expandCollapse span {
    padding-left: 10px;
}

.template-process-complete {
    border: 1px solid #196240;
    background-color: #44ab88;
    color: #fff;
}

.template-process-in-progress {
    box-shadow: 0px 0px 8px 1px #0a58ca;
    color: white;
    background-color: #3978d3;
    border: 1px solid #033276;

}

.hover-table:hover {
    background: #f5f5f5;
    cursor: pointer;
}

/* 1.2 Master NFT Creation */
.process-wizard-container {
    width: 100%; 
    float: left; 
    padding: 20px; 
    padding-top: 10px;
    padding-bottom: 0;
    padding-right: 0;
}

.process-wizard-steps {
    width: 25%; 
    float: left; 
    padding: 20px; 
    border-right: 1px solid #C7C8C9;
}

.process-wizard-step-padding {
    padding-bottom: 20px;
}

.process-wizard-step-icon-container {
    position: relative;
    vertical-align: top;
    font-size: 20px;
}

.process-wizard-step-icon {
    position: absolute;
    z-index: 1;
}

.process-wizard-summary-link {
    position: absolute;
    top: 7px;
    left: 9px;
    width: 3px;
    height: 100%;
    border-right: 3px solid lightgrey;
}    

.process-wizard-step-label {
    padding-top: 3px;
    padding-left: 34px;
}

.process-wizard-step-label-active {
    font-weight: 700;
}

.process-wizard-step-details {
    width: 75%; 
    float: left; 
    padding: 20px;
    padding-bottom: 0;
    padding-right: 0;
}

.process-wizard-step-details h5 {
    margin-bottom: 20px;
}    

.process-wizard-step-step {
    min-height: 310px;
}

.process-wizard-footer {
    float: left;
    width: 100%;
}

.hideAction {
    display: none;
}

/* master nft structure */
.nft-row {
    width: 100%;
    float: left;
}

.nft-master-image-container {
    float: left;    
}

.nft-master-label-container {
    float: left;
    margin-left: 15px;
    margin-top: 5px;        
}

.nft-sub-label {
    font-size: 11px;
    color: grey;        
}

.nft-stacked-link-container {
    position: relative;
    float: left;
}

.nft-stacked-link {
    float: left;
    position: absolute;
    width: 40px; 
    height: 35px; 
    border-left: 1px solid grey; 
    border-bottom: 1px solid grey; 
    top: 0; 
    left: 25px;
}

.nft-stacked-link-down {
    float: left;
    position: absolute;
    width: 40px; 
    height: 25px; 
    border-left: 1px solid grey; 
    top: 35px; 
    left: 25px;
}    

.nft-stacked-image-container {
    float: left;
    margin-left: 65px;
    margin-top: 10px;
}

.nft-stacked-label-container {
    float: left;
    margin-left: 15px;
    margin-top: 24px;        
}

.nft-not-selected {
    color: grey;
}

/* NFT cost data */
.nft-cost-data-key {
    width: 90px;
}

.nft-cost-data-currency {
    /* padding-left: 20px; */
    padding-right: 0;
}    

.nft-cost-data-currency-value {
    width: 55px; 
    text-align: right;
    padding-left: 0;
}

.nft-cost-data-bottom-border {
    border-bottom: 1px solid #000;
}

.nft-cost-data-bottom-border-thick {
    border-bottom: 2px solid #000;
}         

.section-label {
    position: relative;
    /* padding-bottom: 16px; */
    /* height: 50px; */
    padding-top: 10px;
    border-top: 1px solid #e6ebf1;
    /* padding-left: 40px; */
}

.section-label-last {
    border-bottom: 1px solid #e6ebf1;
}    

.section-label-details {
    /* position: absolute; */
    /* top: 0;
    left: 30px; */
    padding-left: 40px;
    padding-bottom: 10px;
}

.section-icon {
    position: absolute;
    top: 12px;
    left: 0;
    font-size: 25px;
}

.section-chevron {
    position: absolute;
    right: 0;
    top: 0;
    padding-right: 15px;
    padding-top: 20px;
    font-size: 18px;
    margin-top: -3px;
}

.collapse-section-container:hover {
    cursor: default;
}

.collapse-section-container {
    padding-bottom: 15px;
    /* padding-left: 40px; */
}    

.section-hr { margin-top: 0px; }

.financial-section-heading { padding-bottom: 10px; }

.summary-data-container { float: left; }

.table-search {
    display: flex;
    justify-content: flex-end;
    position: relative; float: right; min-width: 64%; margin-bottom: 30px;
}

.pagination-table {
    display: flex !important;
    float: right;
    padding-left: 10px;
}

.pagination-element { position: relative; float: right; min-width: 40%; }

.humanSubItemsTable:table { max-width: 95%; display: flex; justify-content: center; }

.clickable { cursor: pointer; }

.b-table > tbody > tr.table-row-hovered td,
.b-table > tbody > tr.table-row-hovered th {
    text-decoration: underline;
}

.bovineItemsTable { margin-top: -22px; }
.bovineStackedItemsTable { margin-top: -9px; }

.incubator-details-container {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    padding: 10px;
}

.incubator-circle-container {
    display: grid;
    grid-template-columns: repeat(5, 1fr); /* Repeat 5 columns */
    grid-gap: 10px; /* Gap between circles */
    grid-template-rows: repeat(3, auto); /* Add rows for 3x4 grid */
    /* padding: 10px; */
    padding-right: 30px;
    max-height: 600px;
    overflow: scroll;
}

.incubator-container-single {
    overflow: hidden !important;
}

.incubator-circle {
    border-radius: 50%; /* Set circle shape */
    width: 120px; /* Adjust size as needed */
    height: 120px;
    background-color: transparent; /* Transparent background */
    border: 2px solid #ccc; /* Grey border */
    display: flex; /* Allow stacking sections vertically */
    flex-direction: column;
    overflow: hidden; /* Clip overflowing content */
}

.incubator-circle-icon {
    position: relative;
    top: 25px;
    left: 73%;
    font-size: 1.2em;
    color: #156ff7;
}

.incubator-circle-icon-group {
    position: relative;
    left: 5px;
    font-size: 1.2em;
    color: #156ff7;
    z-index: 100;
}

.incubator-circle-section {
    flex: 1; /* Sections share remaining space equally */
    text-align: center; /* Center label text */
    line-height: 28px; /* Match section height for vertical centering */
    border-bottom: 1px solid #9b9b9b; /* Grey line between sections */
    font-size:.9em;
}

.incubator-circle-section:last-child {
    border-bottom: none; /* Remove bottom line for last section */
    vertical-align: top;
}

.incubator-circle-section:hover {
    background-color: #eee; /* Highlight on hover */
    cursor: default;
}

.incubator-selected {
    border: 2px solid rgba(29, 179, 134, 0.85);
    /* animation: pulse 2s infinite; */
}

.content-row {
    align-items: center;
    align-content: center;
    padding: 3px;
    margin-right: 80px;
}

/* Transition for the divs */
.fade-enter-active, .fade-leave-active { transition: opacity 0.5s ease; }

.fade-enter, .fade-leave-to { opacity: 0; }

@media (max-width: 767px) {
    
    .d-block {
        height: auto !important;
        max-height: calc(100vh - 135px) !important;
        overflow-y: scroll;
    }
    .content-row {
        align-items: center;
        align-content: center;
        padding: 3px;
        margin-right: 10px;
    }

    .aquaculture-summary-board {
        float: left !important; top: 0px; left: 0px !important; padding-bottom:20px;
    }

    .table-search {
        float: left;
        min-width: 100%;
        font-size: .5em;
        /*justify-content: space-between;*/
    }

    .summary-data-container {
        position: relative !important;
        float: right !important;
        top: -380px !important;
    }

    .nft-summary {
        padding-top: 15px;
        width: 100% !important;
    }
}

/* For small tablets (iPad mini, etc) */
@media (max-width: 768px) {
    .nft-summary {
        padding-top: 15px;
        width: 100% !important;
    }
}

/* For Medium tablets (iPad, etc) */
@media (max-width: 820px) {
    .nft-summary {
        padding-top: 25px;
        width: 100% !important;
    }
}

/* For larger tablets (Surface Pro, etc) */
@media (max-width: 912px) {
    .nft-summary {
        padding-top: 25px;
        width: 100% !important;
    }
}
</style>
